export const values = {
    aumico_reports_side_bar_feedback: 'Feedback',
    aumico_admin_navigation_feedback: 'Feedback',
    aumico_alert_duplicate_prior_year_title: '<strong>Wichtig: Vorjahresdaten fehlen für doppelte Konten</strong>',
    aumico_alert_duplicate_prior_year_main_warning:
        'Wir haben festgestellt, dass Ihre Datei Konten enthält, die im Vorjahr dupliziert wurden (gleiche Nummer/gleicher Name) und nicht eindeutig einem Vorjahreswert zugeordnet werden können.',
    aumico_alert_duplicate_prior_year_action_integrity:
        'Um sicherzustellen, dass diese Konten den korrekten Vorjahreswert erhalten und die Datenintegrität gewahrt bleibt, benötigen wir eine <strong>explizite Übereinstimmung</strong> für diesen Wert.',
    aumico_alert_duplicate_prior_year_action_required:
        '<strong>Erforderliche Massnahme:</strong> Bitte fügen Sie Ihrer Upload-Datei eine separate Spalte hinzu, die die korrekten Vorjahreswerte für diese spezifischen Konten enthält. Dies ist der einzige Weg, um eine genaue Zuordnung zu gewährleisten. Bitte korrigieren Sie dies und starten Sie den Upload erneut.',
    aumico_alert_fixed_balance_sheet:
        'Korrigiert mit Spalte <strong>{{priorYearUnmatchableAccountsDetectedBalanceFixedColNo}}</strong> für die <strong>Bilanz</strong>.',
    aumico_alert_fixed_income_statement:
        'Korrigiert mit Spalte <strong>{{priorYearUnmatchableAccountsDetectedIncomeFixedColNo}}</strong> für die <strong>Erfolgsrechnung</strong>.',
    aumico_templates_account_mapping_child_form_summarize_error_mapped_account:
        'Konten können nicht zusammengefasst werden, da mindestens ein Konto mit derselben Kontonummer bereits zugeordnet ist. Löschen Sie diese Zuordnung und versuchen Sie es erneut.',
    aumico_release_slide_1_html: `
        <h2>Abacus und Business Central Integration</h2>
        <p>Mit den nativen Integrationen für Abacus und Microsoft Dynamics 365 Business Central importierst du das Buchungsjournal deiner Mandanten direkt in aumico. Kein manueller CSV-Export, kein Umweg über Excel. Die Verbindung richtest du einmal ein, danach bleibt sie aktiv.</p>
        <ul>
            <li><strong>Einmalige Verbindung</strong> — Verbindung pro Mandant einmalig einrichten, danach läuft der Import automatisch</li>
            <li><strong>Automatischer Datenimport</strong> — Buchungsjournal, Kontensaldi, Bilanz und Erfolgsrechnung werden direkt in aumico aufgebaut</li>
            <li><strong>Keine Medienbrüche</strong> — Kein manueller Export aus Abacus oder Business Central, kein Aufbereiten in Excel</li>
        </ul>
    `,

    aumico_release_slide_2_html: `
        <h2>Mehrjahresvergleich</h2>
        <p>Im neuen Analytics-Tab im Firmenprofil vergleichst du die Zahlen eines Mandanten über beliebig viele Jahre. aumico legt die aktuellste Berichtsstruktur über alle historischen Jahre. So bleiben die Reihen konsistent, auch wenn sich Bilanz oder Erfolgsrechnung zwischenzeitlich verändert haben.</p>
        <ul>
            <li><strong>Beliebig viele Jahre</strong> — Du bestimmst den Zeitraum, drei, fünf oder mehr Jahre</li>
            <li><strong>Harmonisierte Struktur</strong> — Die aktuellste Gliederung ist der Master, ältere Strukturen werden automatisch darauf gemappt</li>
            <li><strong>Ohne Zusatzaufwand</strong> — Basiert auf den Daten, die bereits in aumico liegen. Keine Nacherfassung, kein Excel</li>
        </ul>
    `,

    aumico_release_slide_3_html: `
        <h2>Umgliederungen direkt im Kontenmapping</h2>
        <p>Umgliederungen erfasst du ab sofort direkt im Kontenmapping im Tab Umgliederung / Umbenennen. Klick auf den Betrag, Zielkonto wählen, Betrag setzen. aumico bucht die Gegenseite automatisch. Handelsrechtliche Umgliederungen sind damit klar von den steuerlichen stillen Reserven getrennt.</p>
        <ul>
            <li><strong>Immer im Gleichgewicht</strong> — Jede Umgliederung hat Quell- und Zielkonto, unausgeglichene Buchungen sind ausgeschlossen</li>
            <li><strong>Aktuelles Jahr und Vorjahr</strong> — Beide Perioden im selben Tabellenbild, gleiche Logik</li>
            <li><strong>Zielkonto direkt anlegen</strong> — Fehlt das Konto, erstellst du es im Dialog, ohne die Umgliederung abzubrechen</li>
            <li><strong>Alle Berichte rechnen sofort neu</strong> — Die umgegliederten Beträge fliessen automatisch in Geldflussrechnung, Anhang, Gewinnverwendung, Eigenkapitalnachweis und Anlagespiegel</li>
        </ul>
    `,

    aumico_release_slide_4_html: `
        <h2>Alle Berichtskomponenten im Zwischenabschluss</h2>
        <p>Quartals-, Monats- und individuelle Berichte bieten dir ab sofort denselben Komponentenumfang wie der Jahresbericht. Bilanz, Erfolgsrechnung, Anhang und alle weiteren Elemente stehen zur Auswahl. Gleiche Vorlagen, unabhängig vom Berichtstyp.</p>
        <ul>
            <li><strong>Voller Komponentenumfang</strong> — Anhang und alle weiteren Elemente auch im Zwischenabschluss</li>
            <li><strong>Gleiche Vorlagen</strong> — Die gewählte Vorlage liefert in jedem Berichtstyp genau das, was sie ausweist</li>
        </ul>
    `,
    aumico_annual_report_print_options_show_grouped_and_masked: 'Gruppierung & Maskierung anwenden',
    aumico_reports_annualreport_navigation_import_grouping_masking: 'Umgliedern / Gruppieren',
    aumico_grouping_masking_assets: '(Aktiven)',
    aumico_grouping_masking_liabilities: '(Passiven)',
    aumico_grouping_masking_splitted: 'Aufgeteilt',
    aumico_grouping_masking_edit_group_name: 'Gruppennamen bearbeiten',
    aumico_grouping_masking_define_bsa: 'Als Wechselkonto definieren',
    aumico_grouping_masking_remove_bsa: 'Wechselkonto entfernen',
    aumico_grouping_masking_ungroup: 'Gruppierung aufheben',
    aumico_grouping_masking_remove_from_group: 'Konto aus Gruppe entfernen',
    aumico_grouping_masking_remove_original_name: 'Originalname: {{value}}',
    aumico_grouping_masking_rename_modal_title: 'Kontonamen maskieren',
    aumico_grouping_masking_rename_modal_text:
        'Gib einen neuen Anzeigenamen für die ausgewählten Konten ein. Diese Änderung ist rein visuell und hat keinen Einfluss auf das Kontomapping.',
    aumico_grouping_masking_rename_modal_label_original: 'Originalkonto',
    aumico_grouping_masking_rename_modal_label_new: 'Neuer Anzeigename',
    aumico_grouping_masking_rename_modal_label_placeholder: 'Neuen Anzeigenamen eingeben',
    aumico_grouping_masking_rename_modal_label_delete: 'Maskierung löschen',
    aumico_grouping_masking_modal_apply: 'Anwenden',
    aumico_grouping_masking_modal_cancel: 'Abbrechen',
    aumico_grouping_masking_grouping_modal_title: 'Konten gruppieren',
    aumico_grouping_masking_grouping_modal_text: 'Gruppenname',
    aumico_grouping_masking_grouping_modal_label_placeholder: 'Gruppennamen eingeben',
    aumico_grouping_masking_split_modal_title: 'Konten wechseln',
    aumico_grouping_masking_split_modal_title_start: 'AUSGANGSLAGE',
    aumico_grouping_masking_split_modal_title_output: 'VORSCHAU ERGEBNIS',
    aumico_grouping_masking_split_modal_title_counterpart: 'Wo möchtest du das Konto zuweisen?',
    aumico_grouping_masking_split_modal_title_counterpart_placeholder: 'Bilanzposten wählen',
    aumico_grouping_masking_modal_confirm: 'Ja, ich bin sicher',
    aumico_grouping_masking_modal_dismiss: 'Nein, abbrechen',
    aumico_grouping_masking_bulk_action_group: 'Gruppieren',
    aumico_grouping_masking_bulk_action_rename: 'Umbenennen',
    aumico_grouping_masking_bulk_action_delete: 'Löschen',
    aumico_grouping_masking_bulk_action_accounts_selected: 'Konten ausgewählt',
    aumico_grouping_masking_confirm_ungroup_text:
        'Bist du sicher, dass du die Gruppierung der Konten aus Gruppe {{value}} aufheben möchtest?',
    aumico_grouping_masking_confirm_unsplitt_text:
        'Bist du sicher, dass du die Aufteilung des gruppierten Kontos {{value}} rückgängig machen möchtest?',

    // REV-20899: Reclassification feature
    aumico_grouping_masking_reclass_column_header_cy: 'Umgliederung AJ',
    aumico_grouping_masking_reclass_column_header_py: 'Umgliederung VJ',
    aumico_grouping_masking_reclass_py_lock_tooltip: 'Umgliederungen Vorjahr sperren',
    aumico_grouping_masking_reclass_py_unlock_tooltip: 'Umgliederungen Vorjahr entsperren',
    aumico_grouping_masking_reclass_py_lock_state_locked: 'Gesperrt',
    aumico_grouping_masking_reclass_py_lock_state_editable: 'Bearbeitbar',
    aumico_grouping_masking_reclass_modal_title: 'Umgliederung',
    aumico_grouping_masking_reclass_modal_subtitle_source: 'Quellkonto',
    aumico_grouping_masking_reclass_modal_subtitle_balance: 'Saldo',
    aumico_grouping_masking_reclass_modal_period_cy: 'Aktuelles Jahr',
    aumico_grouping_masking_reclass_modal_period_py: 'Vorjahr',
    aumico_grouping_masking_reclass_modal_incoming_section: 'Eingehende Umgliederungen',
    aumico_grouping_masking_reclass_modal_outgoing_section: 'Ausgehende Umgliederungen',
    aumico_grouping_masking_reclass_modal_amount_label: 'Betrag',
    aumico_grouping_masking_reclass_modal_amount_placeholder: '0.00',
    aumico_grouping_masking_reclass_modal_target_label: 'Zielkonto',
    aumico_grouping_masking_reclass_modal_target_placeholder: 'Konto wählen...',
    aumico_grouping_masking_reclass_account_badge_tooltip: 'Umgliederungskonto',
    aumico_grouping_masking_reclass_generated_account_name_prefix: 'Umgliederung aus',
    aumico_grouping_masking_reclass_generated_account_name_to: 'nach',
    aumico_grouping_masking_reclass_delete_account_confirm_text:
        'Auf diesem Konto bestehen Umgliederungen. Möchtest du das Konto inklusive aller zugewiesenen Umgliederungen wirklich löschen?',
    aumico_grouping_masking_reclass_delete_account_confirm_action: 'Konto & Umgliederungen löschen',
    aumico_grouping_masking_reclass_modal_description_label: 'Begründung',
    aumico_grouping_masking_reclass_modal_description_optional: 'optional',
    aumico_grouping_masking_reclass_modal_description_placeholder: 'z.B. Reklassifikation gemäß Revisionsauflage',
    aumico_grouping_masking_reclass_modal_add_entry: 'Neue Umgliederung hinzufügen',
    aumico_grouping_masking_reclass_modal_delete_entry: 'Löschen',
    aumico_grouping_masking_reclass_modal_new_account_button: 'Neues Konto erstellen',
    aumico_grouping_masking_reclass_validation_amount_required:
        'Bitte einen Betrag ungleich 0 eingeben. Negative Beträge sind zulässig.',
    aumico_grouping_masking_reclass_validation_target_required: 'Bitte ein Zielkonto wählen.',
    aumico_grouping_masking_reclass_validation_exceeds_balance:
        '⚠ Gesamtbetrag überschreitet den Kontosaldo. Das Quellkonto wird einen negativen Saldo ausweisen.',
    aumico_grouping_masking_reclass_validation_cross_side:
        '⚠ Umgliederung zwischen Aktiven und Passiven. Bitte prüfen, ob dies eine Umgliederung oder eine Umbuchung ist.',
    aumico_grouping_masking_reclass_validation_duplicate_target: 'Mehrere Umgliederungen auf dasselbe Zielkonto.',
    aumico_grouping_masking_reclass_new_account_modal_title: 'Neues Konto erstellen',
    aumico_grouping_masking_reclass_new_account_number_label: 'Kontonummer',
    aumico_grouping_masking_reclass_new_account_number_placeholder: 'z.B. 1099',
    aumico_grouping_masking_reclass_new_account_name_label: 'Kontoname',
    aumico_grouping_masking_reclass_new_account_name_placeholder: 'z.B. Transferkonto',
    aumico_grouping_masking_reclass_new_account_fli_label: 'FLI auswählen',
    aumico_grouping_masking_reclass_new_account_fli_placeholder: 'FLI wählen...',
    aumico_grouping_masking_reclass_new_account_save: 'Erstellen',
    aumico_grouping_masking_reclass_new_account_number_required: 'Bitte Kontonummer eingeben.',
    aumico_grouping_masking_reclass_new_account_number_duplicate: 'Ein Konto mit dieser Nummer existiert bereits.',
    aumico_grouping_masking_reclass_new_account_name_required: 'Bitte Kontonamen eingeben.',
    aumico_grouping_masking_reclass_new_account_fli_required: 'Bitte FLI wählen.',
    aumico_grouping_masking_reclass_new_target_choice_title: 'Neues Umgliederungsziel',
    aumico_grouping_masking_reclass_new_target_choice_prompt: 'Was möchtest du erstellen?',
    aumico_grouping_masking_reclass_new_target_choice_account: 'Konto erstellen',
    aumico_grouping_masking_reclass_new_target_choice_group: 'Gruppe erstellen',
    aumico_grouping_masking_reclass_new_group_modal_title: 'Neue Gruppe erstellen',
    aumico_grouping_masking_reclass_new_group_name_label: 'Gruppenname',
    aumico_grouping_masking_reclass_new_group_name_placeholder: 'z.B. Übrige Verbindlichkeiten',
    aumico_grouping_masking_reclass_new_group_fli_label: 'FLI auswählen',
    aumico_grouping_masking_reclass_new_group_fli_placeholder: 'FLI wählen...',
    aumico_grouping_masking_reclass_new_group_save: 'Erstellen',
    aumico_grouping_masking_reclass_new_group_name_required: 'Bitte Gruppennamen eingeben.',
    aumico_grouping_masking_reclass_new_group_fli_required: 'Bitte FLI wählen.',
    aumico_grouping_masking_reclass_new_group_option_suffix: '(neue Gruppe)',
    aumico_grouping_masking_reclass_new_group_name_exists:
        'In dieser Position existiert bereits eine Gruppe mit diesem Namen. Die Umgliederung wird dieser Gruppe zugewiesen.',
    aumico_grouping_masking_reclass_conflicts_banner:
        'Es gibt {{count}} ungelösten Konflikt(e) bei Umgliederungen. Klicke hier, um sie zu beheben.',
    aumico_grouping_masking_reclass_conflicts_show: 'Konflikte anzeigen',
    aumico_grouping_masking_reclass_conflicts_title: 'Konflikte',
    aumico_grouping_masking_reclass_conflicts_description:
        'Die folgenden Konten wurden gelöscht oder geändert, haben aber noch offene Umgliederungen.',
    aumico_grouping_masking_reclass_conflicts_delete: 'Löschen',
    aumico_grouping_masking_reclass_conflicts_reassign: 'Neu zuweisen',
    aumico_grouping_masking_reclass_preview_button: 'Umgliederungsspiegel',
    aumico_grouping_masking_reclass_preview_title: 'Umgliederungsspiegel',
    aumico_grouping_masking_reclass_preview_col_from: 'VON KONTO',
    aumico_grouping_masking_reclass_preview_col_to: 'NACH KONTO',
    aumico_grouping_masking_reclass_preview_col_cy: 'AJ ({{currency}})',
    aumico_grouping_masking_reclass_preview_col_py: 'VJ ({{currency}})',
    aumico_grouping_masking_reclass_preview_col_description: 'BESCHREIBUNG',
    aumico_grouping_masking_reclass_preview_section_bs: 'Bilanz',
    aumico_grouping_masking_reclass_preview_section_is: 'Erfolgsrechnung',
    aumico_grouping_masking_reclass_preview_footer_note: 'Alle aktiven Umgliederungen für diesen Jahresabschluss',
    aumico_grouping_masking_reclass_preview_close: 'Schließen',
    aumico_grouping_masking_reclass_preview_export_pdf: 'PDF exportieren',
    aumico_grouping_masking_reclass_preview_empty: 'Keine Umgliederungen vorhanden.',
    aumico_grouping_masking_reclass_conflicts_back: 'Zurück zur Tabelle',
    aumico_grouping_masking_reclass_conflicts_transactions: 'Umgliederung(en)',
    aumico_grouping_masking_reclass_conflicts_total: 'Gesamtbetrag',
    aumico_grouping_masking_reclass_conflicts_cy: 'AJ',
    aumico_grouping_masking_reclass_conflicts_py: 'VJ',
    aumico_grouping_masking_reclass_conflicts_table_amount: 'Betrag',
    aumico_grouping_masking_reclass_conflicts_table_source: 'Quelle',
    aumico_grouping_masking_reclass_conflicts_table_target: 'Ziel',
    aumico_grouping_masking_reclass_conflicts_confirm_delete:
        'Alle Umgliederungen dieses Kontos werden dauerhaft gelöscht. Dieser Vorgang kann nicht rückgängig gemacht werden. Fortfahren?',
    aumico_grouping_masking_reclass_tab_indicator_tooltip: '{{count}} ungelöste Konflikt(e) bei Umgliederungen',
    aumico_grouping_masking_disambiguation_modal_title: 'Konto auswählen',
    aumico_grouping_masking_disambiguation_modal_description:
        'Das Konto {{accountNumber}} «{{accountName}}» kommt mehrfach in den Finanzdaten vor. Bitte wähle die gewünschte Instanz aus.',
    aumico_grouping_masking_disambiguation_modal_fli_label: 'FLI',
    aumico_grouping_masking_disambiguation_modal_row_no: 'Zeile',
    aumico_grouping_masking_disambiguation_modal_closing_balance: 'Schlusssaldo',
    aumico_grouping_masking_disambiguation_modal_opening_balance: 'Anfangssaldo',
    aumico_grouping_masking_disambiguation_modal_select_button: 'Auswählen',
    aumico_templates_summarized_accounts_unmapped_tooltip_undo: 'Klick hier, um zusammengefasste Konten zu trennen',
    aumico_templates_summarized_accounts_unmapped_tooltip:
        'Klick hier, um Konten zu einem zusammengefassten Konto zu vereinigen',
    aumico_templates_summarized_accounts_undo_question:
        'Bist du sicher, dass du die Zusammenfassung dieses Kontos rückgängig machen möchtest?',
    aumico_templates_summarized_accounts_undo_yes_button: 'Zusammenfassung rückgängig machen',
    aumico_templates_summarized_accounts_mapped_tooltip:
        'Nachdem du die Zuordnung aufgehoben hast, kannst du die zusammengefassten Konten ändern',
    aumico_templates_summarized_accounts_modal_title: 'Ausgewählte Konten zusammenfassen',
    aumico_templates_summarized_accounts_modal_title_save_button: 'Konten zusammenfassen',
    aumico_templates_summarized_accounts_modal_title_cancel_button: 'Getrennt halten',
    aumico_templates_summarized_accounts_modal_table_raw_accounts: 'KONTEN',
    aumico_templates_summarized_accounts_modal_table_sum_account: 'ZUSAMMENGEFASSTES KONTO',
    aumico_alert_new_shareholder_account_title: '<strong>Neues Gesellschafterkonto erkannt</strong>',
    aumico_alert_new_shareholder_account_main_warning:
        'Wir haben ein neues Gesellschafterkonto erkannt, das im Vorjahr nicht vorhanden war. Bitte überprüfen Sie die untenstehenden Details.',
    aumico_lib_annualreport_shareholder: 'Gesellschafter',
    aumico_alert_duplicate_prior_year_processed_without_fix:
        'Ohne Korrektur fortfahren. Ich werde diese Konten manuell überprüfen.',
    aumico_components_subscription_tiers_section_title: 'Entdecke unsere Pakete und ihre Vorteile',
    aumico_components_subscription_tiers_current_package: 'Aktuelles Paket',
    aumico_components_subscription_tiers_most_popular: 'Am beliebtesten',
    aumico_components_subscription_tiers_switch_to: 'Wechseln zu {{tierName}}',
    aumico_components_subscription_tiers_tier_light: 'aumico Light',
    aumico_components_subscription_tiers_tier_standard: 'aumico',
    aumico_components_subscription_tiers_tier_pro: 'aumico Pro',
    aumico_components_subscription_tiers_feature_report_generation: 'Report-Erstellung',
    aumico_components_subscription_tiers_feature_mandate_task_management: 'Mandats- & Aufgabenverwaltung',
    aumico_components_subscription_tiers_feature_financial_closing_workflow: 'Finanzabschluss-Workflow',
    aumico_components_subscription_tiers_feature_interim_statements: 'Zwischenabschlüsse',
    aumico_components_subscription_tiers_feature_individual_reporting_templates: 'Individuelle Reporting-Vorlagen',
    aumico_components_subscription_tiers_feature_employee_training: 'Mitarbeiterschulung',
    aumico_components_subscription_tiers_feature_dedicated_customer_success_manager:
        'Persönlicher Customer Success Manager',
    aumico_components_subscription_tiers_help_title: 'Kannst du dich nicht für das beste Paket entscheiden?',
    aumico_components_subscription_tiers_help_description: 'Wir helfen dir, den richtigen Plan zu wählen',
    aumico_components_subscription_tiers_contact_sales: 'Vertrieb kontaktieren',
    aumico_reports_registration_welcome_privacy_policy_error: 'Du musst der Datenschutzerklärung zustimmen',
    aumico_companies_delete_dialog_text_1: 'Löschung bestätigen',
    aumico_companies_inactivate_button: 'Deaktivieren',
    aumico_companies_inactivate_dialog_ok: 'Ja, deaktivieren',
    aumico_companies_inactivate_banner_text:
        'Dieses Mandat ist inaktiv. Es ist nicht möglich, neue Projekte hinzuzufügen.',
    aumico_companies_inactivate_dialog_cancel: 'Nein, abbrechen',
    aumico_companies_inactivate_dialog_text_1: 'Deaktivierung bestätigen',
    aumico_companies_inactivate_dialog_text_2:
        'Bist du sicher, dass du dieses Unternehmen deaktivieren möchtest? Diese Aktion kann nicht rückgängig gemacht werden.',
    aumico_users_registration_sub_title:
        '<ul> <li> Keine Kreditkarte und keine Installation erforderlich <li> Kostenloser Support während der Testphase <li> Unverbindlich - Ihr Konto wird nach 10 Tagen automatisch deaktiviert </ul>',
    aumico_templates_switch_accounts_tooltip_1: 'Wechselkonto definieren',
    aumico_templates_switch_accounts_tooltip_2: 'Als Wechselkonto klassifiziert.',
    aumico_reports_companies_upload_file_upload_error_format: 'Bitte lade das Logo im .png-Format hoch',
    aumico_admin_menu_item_activate_cpmm: 'CPMM aktivieren',
    aumico_admin_menu_item_deactivate_cpmm: 'CPMM deaktivieren',
    aumico_errors_password_not_match: 'Passwörter stimmen nicht überein',
    aumico_ui_not_applicable: 'N/A',
    aumico_ui_documents: 'Dokumente',
    aumico_ui_annotations: 'Anmerkungen',
    aumico_ui_new_task: 'Neue Aufgabe',
    aumico_ui_export_docs_as_zip: 'Dokumente als ZIP exportieren',
    aumico_ui_export: 'Exportieren',
    aumico_ui_view_all: 'Alle anzeigen',
    aumico_ui_view_less: 'Weniger anzeigen',
    aumico_ui_select: 'Auswählen',
    aumico_pm_tasks_rename_task: 'Umbenennen',
    aumico_pm_tasks_not_applicable: 'Nicht anwendbar',
    aumico_pm_tasks_mark_applicable: 'Als anwendbar markieren',
    aumico_pm_tasks_delete: 'Löschen',
    aumico_cpmm_task_create_success_title: 'Aufgabe erfolgreich erstellt',
    aumico_cpmm_task_create_success_description: 'Die neue Aufgabe wurde erfolgreich erstellt.',
    aumico_cpmm_task_create_failure_title: 'Fehler beim Erstellen der Aufgabe',
    aumico_cpmm_task_create_failure_description: 'Die Aufgabe konnte nicht erstellt werden. Bitte versuche es erneut.',
    aumico_cpmm_task_update_success_title: 'Aufgabe erfolgreich aktualisiert',
    aumico_cpmm_task_update_success_description: 'Die Aufgabe wurde erfolgreich aktualisiert.',
    aumico_cpmm_task_update_failure_title: 'Fehler beim Aktualisieren der Aufgabe',
    aumico_cpmm_task_update_failure_description:
        'Die Aufgabe konnte nicht aktualisiert werden. Bitte versuche es erneut.',
    aumico_cpmm_task_delete_success_title: 'Aufgabe erfolgreich gelöscht',
    aumico_cpmm_task_bulk_delete_success_title: 'Aufgaben erfolgreich gelöscht',
    aumico_cpmm_task_delete_success_description: 'Die Aufgabe wurde erfolgreich gelöscht.',
    aumico_cpmm_task_bulk_delete_success_description: 'Die Aufgaben wurden erfolgreich gelöscht.',
    aumico_cpmm_task_delete_failure_title: 'Fehler beim Löschen der Aufgabe',
    aumico_cpmm_task_bulk_delete_failure_title: 'Fehler beim Löschen der Aufgaben',
    aumico_cpmm_task_delete_failure_description: 'Die Aufgabe konnte nicht gelöscht werden.',
    aumico_cpmm_task_bulk_delete_failure_description: 'Die Aufgaben konnten nicht gelöscht werden.',
    aumico_cpmm_annotation_create_success_title: 'Anmerkung erstellt',
    aumico_cpmm_annotation_create_success_description: 'Die Anmerkung wurde erfolgreich erstellt.',
    aumico_cpmm_annotation_create_failure_title: 'Anmerkung nicht erstellt',
    aumico_cpmm_annotation_create_failure_description: 'Die Anmerkung konnte nicht erstellt werden.',
    aumico_cpmm_annotation_update_success_title: 'Anmerkung aktualisiert',
    aumico_cpmm_annotation_update_success_description: 'Die Anmerkung wurde erfolgreich aktualisiert.',
    aumico_cpmm_annotation_update_failure_title: 'Anmerkung nicht aktualisiert',
    aumico_cpmm_annotation_update_failure_description: 'Die Anmerkung konnte nicht aktualisiert werden.',
    aumico_cpmm_annotation_delete_success_title: 'Anmerkung gelöscht',
    aumico_cpmm_annotation_delete_success_description: 'Die Anmerkung wurde erfolgreich gelöscht.',
    aumico_cpmm_annotation_delete_failure_title: 'Anmerkung nicht gelöscht',
    aumico_cpmm_annotation_delete_failure_description: 'Die Anmerkung konnte nicht gelöscht werden.',
    aumico_reports_annualreport_import_structure_dialog_title: 'Neue Taxonomie erkannt',
    aumico_reports_annualreport_import_structure_dialog_text: 'Willst du die Taxonomie aktualisieren?',
    aumico_reports_annualreport_import_structure_dialog_action_button: 'Ja, neue Taxonomie importieren.',
    aumico_legacy_reclasses_autofill_warning_title: 'Wichtiger Hinweis zur Datenübernahme',
    aumico_legacy_reclasses_autofill_warning_text:
        'Der Vorjahresbericht enthält Umgliederungen aus unserem alten System. Diese können nicht automatisch in die neue Maske „Umgliedern & Gruppieren“ übertragen werden. Bitte erfasse die Umgliederungen aus dem Vorjahr in diesem Bericht einmalig neu als Vorjahrestransaktionen. Danach werden die Daten in den Folgejahren wieder automatisch fortgeschrieben.',
    aumico_legacy_reclasses_autofill_warning_ok: 'OK',
    aumico_annual_report_mapping_help_text_select_fli: 'Wähle einen Finanzposten aus',
    aumico_annual_report_mapping_transfer_profit_fli_change_help_text:
        'Hier kannst du die Finanzpositionen ändern wohin der Bilanzgewinn übertragen werden soll.',
    aumico_annual_report_mapping_transfer_surplus_fli_change_help_text:
        'Hier kannst du die Finanzpositionen ändern wohin der Jahresüberschuss übertragen werden soll.',
    aumico_annual_report_mapping_uncovered_shortfall_assets_fli_help_text:
        'Hier kannst du die Finanzposition wählen, in der der ungedeckte Fehlbetrag auf der Aktivseite ausgewiesen werden soll.',
    aumico_annual_report_mapping_uncovered_shortfall_liabilities_fli_help_text:
        'Hier kannst du die Finanzposition wählen, in der der ungedeckte Fehlbetrag auf der Passivseite ausgewiesen werden soll.',
    aumico_annual_report_mapping_settings_section: 'Einstellungen',
    aumico_annual_report_execute_button: 'Ausführen',
    aumico_annual_report_cancel_button: 'Abbrechen',
    aumico_annual_report_mapping_reset_fli_button: 'Texte Zurücksetzen',
    aumico_annual_report_mapping_reset_fli_warning:
        'Drücke den Button "Texte zurücksetzen", wenn die Gruppen und Kontengruppen in einer anderen Sprache angezeigt werden als der Rest des Reports. Durch das Anwenden dieser Funktion, werden die Gruppen und Kontengruppen in deiner aktuellen Profilsprache neu geladen. Selber hinzugefügte Gruppen, Kontengruppen oder Kontenuntergruppen müssen nochmals eingetragen werden.',
    aumico_annual_report_mapping_reset_fli_dialog_content:
        'Diese Aktion kann nach dem Speichern nicht rückgängig gemacht werden. Bitte prüfe die Struktur von Bilanz und GuV sorgfältig, nachdem diese Funktion verwendet wurde. Du kannst die Gruppen und Kontengruppen jederzeit in deiner aktuellen Profilsprache neu laden.',
    aumico_admin_add_user_button: 'Benutzer hinzufügen',
    aumico_admin_change_password_current_password_error: 'Aktuelles Passwort ist falsch',
    aumico_admin_change_password_password_length_error: 'Die Länge des Passwörter muss 12 oder mehr Zeichen betragen',
    aumico_admin_confirm_password: 'Passwort bestätigen',
    aumico_admin_current_password: 'Aktuelles Passwort',
    aumico_admin_edit_localization: 'Übersetzung bearbeiten',
    aumico_admin_login_errorMessage: 'Benutzername oder Passwort ist nicht korrekt!',
    aumico_admin_login_title: 'Login DE',
    aumico_admin_manageUsers_role: 'Rolle',
    aumico_admin_manageUsers_userName: 'Benutzername',
    aumico_admin_new_password: 'Neues Passwort',
    aumico_admin_password: 'Passwort',
    aumico_admin_password_changed_successfully: 'Das Passwort wurde erfolgreich geändert',
    aumico_admin_passwords_doesnot_match: '"Passwort" und "Passwort bestätigen" stimmt nicht überrein',
    aumico_admin_templates_balance: 'Bilanz',
    aumico_admin_templates_income: 'Gewinn- und Verlustrechnung',
    aumico_admin_user_created_successfully: 'Neuer Nutzer wurde erfolgreich erstellt',
    aumico_admin_weak_password_error:
        'Das Passwort muss folgende Kriterien erfüllen: Mindestens 12 Zeichen, Gross- und Kleinbuchstaben, Symbole und Zahlen. Leerzeichen sind nicht erlaubt',
    aumico_admin_filter_translation_by_name: ' bersetzungen filtern',
    aumico_annual_report_file_preview: 'Dateivorschau',
    aumico_annual_report_general_information_autofill_btn_text: 'Firmendaten automatisch ausfüllen',
    aumico_annual_report_general_information_balance_sheet_date: 'Bilanzstichtag',
    aumico_annual_report_general_information_balance_sheet_date_error:
        'Bilanzstichtag muss grösser als Vorjahresstichtag sein',
    aumico_annual_report_general_information_basis_of_accounting: 'Rechnungslegungsstandard',
    aumico_annual_report_general_information_create_new_company_btn_text: 'Neue Firma anlegen',
    aumico_reports_annualreport_navigation_import_fx: 'Funktionalwährung',
    aumico_annual_report_fx_rates_dropzone: 'Excel-Datei hier ablegen oder klicken',
    aumico_annual_report_fx_rates_dropzone_format: 'Excel mit den Spalten «Date» und «Actual Rate» · Kurs in {{display}} für 1 {{functional}}',
    aumico_annual_report_fx_table_step: 'Umrechnungstabelle',
    aumico_annual_report_fx_table_tab_kontrolle: 'Kontrolle',
    aumico_annual_report_fx_table_kontrolle_placeholder: 'Die Kontrollen (Aktiven = Passiven, Bilanz- = Erfolgsrechnungsergebnis) werden in einem nächsten Schritt ergänzt.',
    aumico_annual_report_fx_table_position: 'Position',
    aumico_annual_report_fx_table_kurstyp: 'Kurstyp',
    aumico_annual_report_fx_table_method_closing: 'Stichtag',
    aumico_annual_report_fx_table_method_average: 'Ø-Kurs',
    aumico_annual_report_fx_table_reserve: 'Umrechnungsreserve',
    aumico_annual_report_fx_proof_mixed: 'Gemischt',
    aumico_annual_report_fx_proof_rate_effective: 'Kurs effektiv',
    aumico_annual_report_fx_proof_contribution: 'Beitrag',
    aumico_annual_report_fx_proof_at_closing: 'zu Stichtag',
    aumico_annual_report_fx_proof_sum: 'Summe Beiträge',
    aumico_annual_report_fx_proof_rounding: 'Rundungsdifferenz',
    aumico_annual_report_fx_proof_rounding_hint: 'in der Umrechnungsreserve enthalten',
    aumico_annual_report_fx_proof_imbalance: 'Bilanz in Funktionalwährung nicht ausgeglichen',
    aumico_annual_report_fx_proof_imbalance_banner: 'Die Bilanz geht in Funktionalwährung nicht auf. Die Umrechnung kann erst stimmen, wenn das behoben ist.',
    aumico_annual_report_fx_proof_check_balance: 'Aktiven = Passiven',
    aumico_annual_report_fx_proof_check_result: 'Ergebnis Bilanz = Ergebnis Erfolgsrechnung',
    aumico_annual_report_fx_proof_reason_open: 'Umrechnung noch nicht abgeschlossen, offene Positionen',
    aumico_annual_report_fx_proof_reason_imbalance: 'Bilanz in Funktionalwährung nicht ausgeglichen um',
    aumico_annual_report_fx_proof_reason_result: 'Ergebnisse weichen bereits in Funktionalwährung ab',
    aumico_annual_report_fx_rounding_assign: 'Rundungsdifferenz zuordnen',
    aumico_annual_report_fx_rounding_change: 'Zuordnung ändern',
    aumico_annual_report_fx_rounding_too_large: 'Die Differenz beträgt {{tolerance}} {{currency}} oder mehr — das ist keine Rundung und kann keinem Konto zugeordnet werden.',
    aumico_annual_report_fx_rounding_account_missing: 'Das zugeordnete Konto ist nicht mehr verfügbar (umgegliedert, gelöscht oder nicht mehr zum Durchschnittskurs). Bitte neu zuordnen.',
    aumico_annual_report_fx_rounding_booked: 'Enthält {{amount}} Rundungsdifferenz auf {{account}}',
    aumico_annual_report_fx_rounding_cell_hint: 'Enthält die zugeordnete Rundungsdifferenz (Kontrolle):',
    aumico_annual_report_fx_rounding_dialog_title: 'Rundungsdifferenz zuordnen',
    aumico_annual_report_fx_rounding_dialog_body: 'Jedes Konto wird einzeln umgerechnet und auf Cent gerundet, das Jahresergebnis in der Bilanz dagegen nur einmal. Deshalb weichen die beiden Ergebnisse um wenige Cent ab. Ordnen Sie die Differenz einem Konto der Erfolgsrechnung zu: Sein Betrag wird um die Differenz korrigiert, sein Kurs bleibt unverändert.',
    aumico_annual_report_fx_rounding_dialog_difference: 'Differenz {{date}}',
    aumico_annual_report_fx_rounding_dialog_account: 'Konto der Erfolgsrechnung (zum Durchschnittskurs)',
    aumico_annual_report_fx_rounding_dialog_assign: 'Zuordnen',
    aumico_annual_report_fx_rounding_dialog_remove: 'Zuordnung entfernen',
    aumico_annual_report_fx_rounding_dialog_locked: 'Das Vorjahr ist gesperrt — die Zuordnung stammt aus dem Vorjahresabschluss.',
    aumico_annual_report_fx_table_year_result: 'Jahresergebnis',
    aumico_annual_report_fx_table_method_historical: 'Historisch',
    aumico_annual_report_fx_table_hist_add_movement: 'Bewegung erfassen',
    aumico_annual_report_fx_table_hist_open: 'offen',
    aumico_annual_report_fx_table_hist_blocked_hint: 'Zuerst den Vorjahreskurs erfassen.',
    aumico_annual_report_fx_table_hist_provisional_hint: 'Enthält Positionen mit noch nicht erfassten historischen Kursen — der Betrag steht noch nicht fest.',
    aumico_annual_report_fx_table_hist_py_rate_missing: 'Kurs erfassen',
    aumico_annual_report_fx_hist_modal_save: 'Übernehmen',
    aumico_annual_report_fx_hist_modal_cancel: 'Abbrechen',
    aumico_annual_report_fx_hist_modal_opening: 'Bestand Vorjahr',
    aumico_annual_report_fx_hist_modal_closing: 'Bestand laufendes Jahr',
    aumico_annual_report_fx_hist_modal_delta: 'Zu erklärende Veränderung',
    aumico_annual_report_fx_hist_modal_explained: 'Erklärt',
    aumico_annual_report_fx_hist_modal_description: 'Bezeichnung',
    aumico_annual_report_fx_hist_modal_date: 'Datum',
    aumico_annual_report_fx_hist_modal_date_placeholder: 'TT.MM.JJJJ',
    aumico_annual_report_fx_hist_modal_functional: 'Betrag',
    aumico_annual_report_fx_hist_modal_display: 'Betrag',
    aumico_annual_report_fx_hist_modal_rate: 'Kurs',
    aumico_annual_report_fx_hist_modal_delete: 'Löschen',
    aumico_annual_report_fx_hist_modal_title: 'Historische Umrechnung',
    aumico_annual_report_fx_hist_modal_title_previous: 'Vorjahreskurs erfassen',
    aumico_annual_report_fx_hist_modal_movements: 'Bewegungen',
    aumico_annual_report_fx_hist_modal_history: 'Verlauf',
    aumico_annual_report_fx_hist_modal_history_opening: 'Anfangsbestand',
    aumico_annual_report_fx_hist_modal_history_closing: 'Schlussbestand',
    aumico_annual_report_fx_hist_modal_history_more: 'Alle Jahre anzeigen',
    aumico_annual_report_fx_hist_modal_history_less: 'Weniger anzeigen',
    aumico_annual_report_fx_hist_modal_history_count_one: '{{count}} abgeschlossenes Jahr',
    aumico_annual_report_fx_hist_modal_history_count_other: '{{count}} abgeschlossene Jahre',
    aumico_annual_report_fx_hist_modal_year: 'Geschäftsjahr',
    aumico_annual_report_fx_hist_modal_weighted: 'gewichtet',
    aumico_annual_report_fx_hist_modal_previous_required: 'Zuerst den Vorjahreskurs erfassen — die Bewegungen bauen auf dem Vorjahresbestand auf.',
    aumico_annual_report_fx_hist_modal_locked_note: 'Das Vorjahr ist gesperrt. Zum Bearbeiten im Schritt „Stichtags- / Periodenkurse“ beim Vorjahr entsperren.',
    aumico_annual_report_fx_hist_modal_rate_hint: 'Kurs oder Betrag erfassen — der jeweils andere Wert wird berechnet.',
    aumico_annual_report_fx_rates_step_period: 'Stichtags- / Periodenkurse',
    aumico_annual_report_fx_rates_estv_hint: 'Offizielle Stichtags- und Jahresmittelkurse aller Währungen:',
    aumico_annual_report_fx_rates_estv_link: 'ESTV-Kursliste (ictax.admin.ch)',
    aumico_annual_report_fx_rates_current_year: 'Aktuelles Jahr',
    aumico_annual_report_fx_rates_previous_year: 'Vorjahr',
    aumico_annual_report_fx_rates_closing_rate: 'Stichtagskurs',
    aumico_annual_report_fx_rates_average_rate: 'Durchschnittskurs',
    aumico_annual_report_fx_rates_locked: 'Gesperrt',
    aumico_annual_report_fx_rates_unlocked: 'Entsperrt',
    aumico_annual_report_fx_rates_lock_scope: 'Die Sperre gilt für das gesamte Vorjahr: für die Kurse hier und für die historischen Kurse pro Konto in der Umrechnungstabelle.',
    aumico_annual_report_fx_rates_import_label: 'ODER automatisch aus Kursliste berechnen:',
    aumico_annual_report_fx_rates_import_error: 'Die Datei konnte nicht gelesen werden. Es wurden keine Kurse übernommen.',
    aumico_annual_report_fx_rates_import_error_columns: 'Die Datei enthält keine Spalten «Date» und «Actual Rate». Es wurden keine Kurse übernommen.',
    aumico_annual_report_fx_rates_import_error_period: 'Die Kursliste enthält keine Kurse für {{year}} — sie reicht vom {{from}} bis {{to}}. Es wurden keine Kurse übernommen.',
    aumico_annual_report_fx_rates_import_error_rows: 'Die Spalten «Date» und «Actual Rate» enthalten keine lesbaren Werte. Es wurden keine Kurse übernommen.',
    aumico_annual_report_fx_rates_import_confirm_title: 'Kurse übernehmen?',
    aumico_annual_report_fx_rates_import_confirm_body: 'Bitte prüfen Sie die berechneten Kurse, bevor sie übernommen werden.',
    aumico_annual_report_fx_rates_import_confirm_action: 'Übernehmen',
    aumico_annual_report_fx_rates_import_no_closing: 'Kein Stichtagskurs gefunden — die Kursliste endet nicht am Bilanzstichtag. Bitte manuell erfassen.',
    aumico_annual_report_fx_rates_import_closing_last_business_day: 'Der Bilanzstichtag fällt auf ein Wochenende — übernommen wird der Kurs vom {{date}}, dem letzten Werktag davor.',
    aumico_annual_report_fx_rates_guide_open: 'Wie muss die Excel aussehen?',
    aumico_annual_report_fx_rates_guide_title: 'Kursliste aus Excel',
    aumico_annual_report_fx_rates_guide_headline: 'Kurse direkt aus Ihrer Kursliste übernehmen',
    aumico_annual_report_fx_rates_guide_lead: 'Laden Sie den Kursexport Ihrer Bank oder Ihres Systems hoch. aumico liest daraus Datum und Kurs und berechnet Stichtags- und Durchschnittskurs automatisch.',
    aumico_annual_report_fx_rates_guide_callout_date: 'Datum',
    aumico_annual_report_fx_rates_guide_callout_rate: 'Kurs',
    aumico_annual_report_fx_rates_guide_legend_read: 'wird gelesen',
    aumico_annual_report_fx_rates_guide_legend_ignored: 'wird ignoriert',
    aumico_annual_report_fx_rates_guide_point_file_title: 'Eine Excel-Datei',
    aumico_annual_report_fx_rates_guide_point_file_text: 'Format .xlsx oder .xls, mit einer Kopfzeile. Sie darf auch weiter unten im Blatt stehen.',
    aumico_annual_report_fx_rates_guide_point_columns_title: 'Zwei Spalten zählen',
    aumico_annual_report_fx_rates_guide_point_columns_text: '«Date» und «Actual Rate» — an beliebiger Stelle. Alle anderen Spalten werden ignoriert.',
    aumico_annual_report_fx_rates_guide_point_direction_title: 'Kurs in {{display}} für 1 {{functional}}',
    aumico_annual_report_fx_rates_guide_point_direction_text: '0.79270 bedeutet: 1 {{functional}} = 0.79270 {{display}}.',
    aumico_annual_report_fx_rates_guide_calc_title: 'So wird gerechnet',
    aumico_annual_report_fx_rates_guide_calc_closing: 'Stichtagskurs = Kurs am Bilanzstichtag. Fällt dieser auf ein Wochenende, gilt der Kurs des letzten Werktags davor.',
    aumico_annual_report_fx_rates_guide_calc_average: 'Durchschnittskurs = Mittelwert aller Kurse des Jahres. Kurse anderer Jahre in derselben Datei werden nicht berücksichtigt.',
    aumico_annual_report_fx_rates_guide_close: 'Verstanden',
    aumico_annual_report_fx_rates_unlock_confirm_title: 'Vorjahreskurse entsperren?',
    aumico_annual_report_fx_rates_unlock_confirm_body: 'Die Vorjahreskurse stammen aus dem Vorjahresabschluss. Nach dem Entsperren können sie geändert werden.',
    aumico_annual_report_fx_rates_unlock_confirm_action: 'Entsperren',
    aumico_annual_report_general_information_currency: 'Währung',
    aumico_annual_report_general_information_functional_currency: 'Funktionalwährung',
    aumico_annual_report_general_information_display_currency: 'Darstellungswährung',
    aumico_annual_report_general_information_please_determine_display_currency: 'Bitte Darstellungswährung wählen',
    aumico_annual_report_general_information_previous_sheet_date_error:
        'Vorheriges Datum muss kleiner sein als Bilanzdatum',
    aumico_annual_report_general_information_previous_year_reporting_date: 'Vorjahresstichtag',
    aumico_annual_report_general_information_revision_type: 'Revisionstyp',
    aumico_annual_report_general_information_select_company: 'Unternehmen auswählen',
    aumico_annual_report_general_information_set_specification: 'Allgemeine Abschlussinformationen',
    aumico_annual_report_import_definition_click_cell:
        'Bitte klicken Sie in der Dateivorschau auf die entsprechende Zelle.',
    aumico_annual_report_import_definition_click_corresponding_sheet:
        'Bitte klicken Sie in der Dateivorschau auf die entsprechende Zelle.',
    aumico_annual_report_import_definition_fill_manually: 'Manuell ausfüllen für',
    aumico_annual_report_import_definition_specify_titles_line_1: 'Bitte geben Sie die Nummer für die Titelzeile an.',
    aumico_annual_report_import_definition_specify_titles_line_2: 'Tabelle',
    aumico_annual_report_import_definition_transfer_entries: 'Bilanzselektionen übernehmen für',
    aumico_annual_report_import_definition_which_spreadsheet_1: 'In welchem Excelsheet wird die',
    aumico_annual_report_import_definition_which_spreadsheet_2: 'angezeigt?',
    aumico_annual_report_import_form_balance_title: 'Bilanz',
    aumico_annual_report_import_form_balance_instruction_label: 'Bilanz hochladen',
    aumico_annual_report_import_form_income_title: 'Gewinn- und Verlustrechnung',
    aumico_annual_report_import_form_income_instruction_label: 'Gewinn- und Verlustrechnung hochladen',
    aumico_annual_report_import_form_input_placeholder: 'Bitte eintragen',
    aumico_annual_report_import_form_upload_label: 'Bitte importieren Sie die Kontensalden.',
    aumico_annual_report_import_form_uploaded_label: 'Bitte importieren Sie die Kontensalden.',
    aumico_annual_report_import_form_version_label: 'Versionsname',
    aumico_annual_report_import_indicate_account_names_column:
        'Geben Sie die Spalte an, in der die Kontobezeichnungen festgelegt sind.',
    aumico_annual_report_import_indicate_account_numbers_column:
        'Geben Sie die Spalte an, in der die Kontonummern festgelegt sind.',
    aumico_annual_report_import_indicate_balance_column: 'Geben Sie die Spalte der Berichtsperiode an.',
    aumico_annual_report_import_indicate_previous_year_column: 'Geben Sie die Spalte der Vergleichsperiode an.',
    aumico_annual_report_interpretation_account_name: 'Kontobezeichnung',
    aumico_annual_report_interpretation_account_number: 'Länge der Kto.-Nr. (Bsp.: 4-5 oder 5-5)',
    aumico_annual_report_interpretation_active: 'Aktiva',
    aumico_annual_report_interpretation_closing_value: 'Schlusswert',
    aumico_annual_report_interpretation_excluded_word: 'Ausgeschlossenes Wort',
    aumico_annual_report_interpretation_expense: 'Aufwand',
    aumico_annual_report_interpretation_included_word: 'Enthaltenes Wort',
    aumico_annual_report_interpretation_income: 'Ertrag',
    aumico_annual_report_interpretation_negative: 'Negativ',
    aumico_annual_report_interpretation_opening_value: 'Eröffnungswert',
    aumico_annual_report_interpretation_passive: 'Passiva',
    aumico_annual_report_interpretation_positive: 'Positiv',
    aumico_annual_report_interpretation_select_signs:
        'Bitte definieren Sie in welcher Form die Salden aus Ihrem System kommen.',
    aumico_annual_report_interpretation_specify_excluded_word:
        'Bitte geben Sie ein Wort an, das in der Kontobezeichnung nicht vorkommen darf. \nZ.B. Summe',
    aumico_annual_report_interpretation_specify_included_word:
        'Bitte geben Sie ein Wort an, das im Kontonamen inkludiert werden muss.',
    aumico_annual_report_interpretation_specify_number_of_characters: 'Optionale Filterkriterien',
    aumico_annual_report_interpretation_title: 'Zahleninterpretation',
    aumico_annual_report_mandatory_field_error: 'Diese Eingabe ist obligatorisch',
    aumico_annual_report_not_found_error: 'Nicht gefunden',
    aumico_annual_report_print_options_add_metadata: 'Metadaten hinzufügen',
    aumico_annual_report_print_options_caption: '-',
    aumico_annual_report_print_options_collective_signature: 'Kollektive Unterschrift',
    aumico_annual_report_print_options_custom_page_numbers: 'Benutzerdef. Seitenzahlen',
    aumico_annual_report_print_options_dont_show_name: 'Namen nicht anzeigen (kann manuell eingegeben werden)',
    aumico_annual_report_print_options_show_decimal_places: 'Dezimalstellen',
    aumico_annual_report_print_options_place_of_signing: 'Ort der Unterzeichnung',
    aumico_annual_report_print_options_print: 'Drucken',
    aumico_annual_report_print_options_print_only_greyscale: 'Nur in Graustufen drucken',
    aumico_annual_report_print_options_show_empty_lines: 'Leere Zeilen anzeigen',
    aumico_annual_report_print_options_show_company_info: 'Organisationsname',
    aumico_annual_report_print_options_show_cover_sheet: 'Deckblatt',
    aumico_annual_report_print_options_show_table_of_contents: 'Inhaltsverzeichnis',
    aumico_annual_report_print_options_show_uid: 'Steuernummer auf Deckblatt',
    aumico_annual_report_print_options_signatory_1: 'Unterzeichner 1',
    aumico_annual_report_print_options_signatory_2: 'Unterzeichner 2',
    aumico_annual_report_print_options_signature: 'Unterschrift',
    aumico_annual_report_print_options_title: 'Druckoptionen',
    aumico_annual_report_print_preview_aop: 'Gewinnverwendung',
    aumico_annual_report_print_preview_attachement: 'Anhang zum Jahresabschluss',
    aumico_annual_report_print_preview_balance: 'Bilanz',
    aumico_annual_report_print_preview_income: 'Gewinn- und Verlustrechnung',
    aumico_annual_report_profit_calculation_annual_profit: 'Jahresgewinn',
    aumico_annual_report_profit_calculation_annual_result: 'Jahresergebnis',
    aumico_annual_report_profit_calculation_annual_loss: 'Jahresverlust',
    aumico_annual_report_profit_calculation_header: 'Verfügbares Bilanzergebnis',
    aumico_annual_report_profit_calculation_header_profit: 'Verfügbarer Bilanzgewinn',
    aumico_annual_report_profit_calculation_header_loss: 'Verfügbarer Bilanzverlust',
    aumico_annual_report_proposal_add_new_item: 'Neue Zeile hinzufügen',
    aumico_annual_report_proposal_available_retained_earnings: 'Summe Bilanzergebnis',
    aumico_annual_report_proposal_available_retained_earnings_profit: 'Summe Bilanzgewinn',
    aumico_annual_report_proposal_available_retained_earnings_loss: 'Summe Bilanzverlust',
    aumico_annual_report_proposal_carried_forward_to_new_account: 'Vortrag auf neue Rechnung',
    aumico_annual_report_proposal_carried_forward_to_new_account_profit: 'Gewinnvortrag auf neue Rechnung',
    aumico_annual_report_proposal_carried_forward_to_new_account_loss: 'Verlustvortrag auf neue Rechnung',
    aumico_annual_report_table_label_accounting_basis: 'Rechnungslegungsstandard',
    aumico_annual_report_table_label_company: 'Firma',
    aumico_annual_report_table_label_created_on: 'Erstellt am',
    aumico_annual_report_table_label_language: 'Sprache',
    aumico_annual_report_table_label_currency: 'Währung',
    aumico_annual_report_table_label_last_change: 'Letzte Änderung',
    aumico_button_cancel: 'Abbrechen',
    aumico_button_companies_form_cancel: 'Abbrechen',
    aumico_button_companies_form_save: 'Speichern und weiter',
    aumico_button_confirm: 'Bestätigen',
    aumico_button_delete: 'Löschen',
    aumico_button_download: 'Herunterladen',
    aumico_button_edit: 'Bearbeiten',
    aumico_button_copy: 'Kopieren',
    aumico_button_preview: 'Vorschau',
    aumico_button_save: 'Speichern',
    aumico_button_submit: 'Absenden',
    aumico_button_update: 'Update',
    aumico_button_add: 'Weitere hinzufügen',
    aumico_companies_form_label_addition_to_address: 'Adresszusatz (z.B. Postfach oder c/o Adresse)',
    aumico_companies_form_label_address: 'Adresse',
    aumico_tags_box_title: 'Tag',
    aumico_companies_form_section_linked_persons: 'Verknüpfte Personen',
    aumico_tags_box_new_tag_placeholder: 'Neuen Tag anlegen',
    aumico_tags_box_create: 'Anlegen',
    aumico_tags_box_cancel: 'Abbrechen',
    aumico_tags_box_delete: 'Löschen',
    aumico_tags_box_delete_warning: 'wird bei {{companies}} Firmen und {{persons}} Personen verwendet und dort entfernt. Wirklich löschen?',
    aumico_tags_box_delete_aria: 'Tag löschen',
    aumico_persons_form_details_text: 'Personenangaben',
    aumico_persons_form_section_personal: 'Personalien',
    aumico_persons_form_first_name: 'Vorname',
    aumico_persons_form_last_name: 'Nachname',
    aumico_persons_form_assignee: 'Mandatsleiter',
    aumico_persons_form_clerk: 'Sachbearbeiter',
    aumico_persons_form_search: 'Suchen',
    aumico_persons_form_placeholder: 'Bitte eingeben',
    aumico_persons_form_section_address: 'Adresse',
    aumico_persons_form_street: 'Strasse und Hausnummer',
    aumico_persons_form_addition_to_address: 'Adresszusatz',
    aumico_persons_form_zip: 'PLZ',
    aumico_persons_form_city: 'Ort',
    aumico_persons_form_section_contact: 'Kontaktdaten',
    aumico_persons_form_email: 'E-Mail',
    aumico_persons_form_phone: 'Telefon',
    aumico_persons_form_email_invalid: 'Ungültige E-Mail-Adresse',
    aumico_persons_form_add_contact: 'Kontakt hinzufügen',
    aumico_persons_form_remove_contact_aria: 'Kontakt entfernen',
    aumico_persons_form_section_companies: 'Verknüpfte Firmen',
    aumico_persons_form_company: 'Firma',
    aumico_persons_form_role: 'Rolle',
    aumico_persons_form_please_choose: 'Bitte wählen',
    aumico_persons_form_link: 'Verknüpfen',
    aumico_persons_form_unlink_aria: 'Verknüpfung entfernen',
    aumico_persons_form_company_deleted: 'Firma gelöscht',
    aumico_persons_form_role_OWNER: 'Inhaber/in',
    aumico_persons_form_role_SHAREHOLDER: 'Aktionär/in',
    aumico_persons_form_role_MANAGING_DIRECTOR: 'Geschäftsführer/in',
    aumico_persons_form_role_BOARD_MEMBER: 'Verwaltungsrat',
    aumico_persons_form_role_OTHER: 'Andere',
    aumico_persons_form_save: 'Speichern',
    aumico_persons_form_delete: 'Löschen',
    aumico_persons_form_deactivate: 'Deaktivieren',
    aumico_persons_form_activate: 'Aktivieren',
    aumico_persons_form_dialog_cancel: 'Abbrechen',
    aumico_person_delete_failed_title: 'Fehler beim Löschen der Person',
    aumico_person_delete_failed_has_projects_message:
        'Person hat noch Projekte. Du musst zuerst die bestehenden Projekte dieser Person löschen.',
    aumico_persons_form_clerk_change_dialog_text:
        'Du ersetzt den aktuellen Sachbearbeiter für diese Person. Was soll mit den bestehenden Aufgaben passieren?',
    aumico_persons_form_delete_dialog_title: 'Person löschen?',
    aumico_persons_form_delete_dialog_text: 'Die Person wird endgültig gelöscht. Das kann nicht rückgängig gemacht werden.',
    aumico_persons_overview_tab_active: 'Aktiv',
    aumico_persons_overview_tab_inactive: 'Inaktiv',
    aumico_persons_overview_search: 'Suchen',
    aumico_persons_overview_filter_assignee: 'Mandatsleiter',
    aumico_persons_overview_filter_clerk: 'Sachbearbeiter',
    aumico_persons_overview_filter_tag: 'Tag',
    // REV-22155 — person projects
    aumico_projects_toggle_companies: 'Firmen',
    aumico_projects_toggle_persons: 'Personen',
    aumico_person_projects_filter_person: 'Person',
    aumico_person_projects_filter_period: 'Periode',
    aumico_person_projects_filter_tag: 'Tag',
    aumico_person_projects_col_person: 'Person',
    aumico_person_projects_col_period: 'Periode',
    aumico_person_projects_col_tag: 'Tag',
    cpmm_projects_overview_col_tag: 'Tag',
    aumico_projects_overview_filter_tag: 'Tag',
    aumico_person_projects_tax_period: 'Steuerperiode {{year}}',
    aumico_person_projects_empty: 'Noch keine Personen-Projekte',
    aumico_person_projects_empty_instructions: 'Erstelle ein Projekt für eine Person, um ihre Mandatsverwaltung zu starten.',
    aumico_person_projects_create_failure_title: 'Projekt nicht erstellt',
    aumico_person_projects_create_failure_description: 'Das Projekt konnte nicht erstellt werden. Bitte versuche es erneut.',
    aumico_person_projects_create_failure_inactive: 'Dieses Mandat ist inaktiv. Es ist nicht möglich, neue Projekte hinzuzufügen.',
    aumico_create_person_project_dialog_select_person_title: 'Person wählen',
    aumico_create_person_project_dialog_select_person_description: 'Für welche Person soll das Projekt erstellt werden?',
    aumico_create_person_project_dialog_select_person_input_title: 'Person',
    aumico_create_person_project_dialog_select_person_input_placeholder: 'Person suchen',
    aumico_create_person_project_dialog_select_period_title: 'Periode wählen',
    aumico_create_person_project_dialog_select_period_description: 'Für welche Periode soll das Projekt erstellt werden?',
    aumico_create_person_project_dialog_select_period_input_label: 'Periode',
    aumico_create_person_project_dialog_select_period_input_placeholder: 'Periode wählen',
    aumico_pm_tasks_type_filter_label: 'Typ',
    aumico_pm_tasks_type_company: 'Firma',
    aumico_pm_tasks_type_person: 'Person',
    aumico_tasks_col_mandant: 'Mandant',
    aumico_person_projects_next_year_reason_inactive: 'Inaktiv – keine neuen Projekte möglich',
    aumico_person_projects_next_year_reason_no_project: 'Noch kein Projekt',
    aumico_person_projects_next_year_reason_not_found: 'Person nicht gefunden',
    aumico_persons_overview_export: 'Export XLS',
    aumico_persons_overview_new: 'Neue Person',
    aumico_persons_overview_col_name: 'Name',
    aumico_persons_overview_col_street: 'Strasse und Hausnummer',
    aumico_persons_overview_col_zip: 'PLZ',
    aumico_persons_overview_col_city: 'Ort',
    aumico_persons_overview_col_tag: 'Tag',
    aumico_persons_overview_col_assignee: 'Mandatsleiter',
    aumico_persons_overview_col_clerk: 'Sachbearbeiter',
    aumico_persons_overview_empty_text1: 'Noch keine Personen erfasst',
    aumico_persons_overview_empty_text2: 'Erfasse die erste Person mit „Neue Person“.',
    aumico_persons_overview_bulk_assignee: 'Mandatsleiter ändern',
    aumico_persons_overview_bulk_clerk: 'Sachbearbeiter ändern',
    aumico_persons_overview_bulk_next_financial_year: 'Nächstes Geschäftsjahr erstellen',
    aumico_persons_overview_bulk_deactivate: 'Personen deaktivieren',
    aumico_persons_overview_bulk_deactivate_confirm: 'Bist du sicher, dass du {{count}} Personen deaktivieren möchtest?',
    aumico_persons_overview_bulk_selected: 'ausgewählt',
    aumico_persons_overview_bulk_assignee_title: 'Mandatsleiter für {{count}} Personen ändern?',
    aumico_persons_overview_bulk_clerk_title: 'Sachbearbeiter für {{count}} Personen ändern?',
    aumico_persons_overview_cancel: 'Abbrechen',
    aumico_persons_overview_save: 'Speichern',
    aumico_persons_overview_please_choose: 'Bitte wählen',
    aumico_companies_form_label_city: 'Ort',
    aumico_companies_form_label_country: 'Land',

    aumico_companies_form_label_email: 'E-Mail',
    aumico_companies_form_label_first_name: 'First Name',
    aumico_companies_form_label_last_name: 'Last Name',
    aumico_companies_form_label_legal_form: 'Rechtsform',
    aumico_companies_form_label_name: 'Firmenname',
    aumico_companies_form_label_phone: 'Telefon Nr.',
    aumico_companies_form_label_street_and_number: 'Strasse und Hausnummer',
    aumico_companies_form_label_uid_number: 'Steuernummer',
    aumico_companies_form_label_zip_code: 'PLZ',
    aumico_companies_form_placeholder_optional: 'Optional',
    aumico_companies_form_placeholder_please_enter: 'Bitte eintragen',
    aumico_companies_form_placeholder_please_select: 'Bitte auswählen',
    aumico_companies_form_section_name_contact_details: 'Kontaktdaten',
    aumico_companies_form_section_name_legal_information: 'Rechtliche Information',
    aumico_companies_fx_section_title: 'Funktionalwährung',
    aumico_companies_fx_inactive_hint:
        'Für Mandanten mit Buchführung in Fremdwährung. Nach der Aktivierung kann bei neuen Abschlüssen eine Funktionalwährung erfasst werden.',
    aumico_companies_fx_activate_button: 'Aktivieren',
    aumico_companies_fx_deactivate_button: 'Funktionalwährung deaktivieren',
    aumico_companies_fx_pending_chip: 'Vorgemerkt',
    aumico_companies_fx_pending_hint: 'Wird aktiviert, sobald das Unternehmen gespeichert ist.',
    aumico_companies_fx_pending_cancel: 'Vormerkung aufheben',
    aumico_companies_fx_active_chip: 'Aktiv',
    aumico_companies_fx_activated_on: 'Aktiviert am',
    aumico_companies_fx_minimum_term_until: 'Mindestlaufzeit bis',
    aumico_companies_fx_no_permission_hint:
        'Die Funktionalwährung kann nur von einem Organisations-Administrator aktiviert werden.',
    aumico_companies_fx_modal_title: 'Funktionalwährung aktivieren',
    aumico_companies_fx_modal_intro:
        'Die Funktionalwährung ist eine kostenpflichtige Zusatzfunktion. Sie steht danach für neu erstellte Abschlüsse zur Verfügung; bestehende Abschlüsse bleiben unverändert.',
    aumico_companies_fx_modal_price: 'Zusatzkosten',
    aumico_companies_fx_modal_per_year: 'Jahr',
    aumico_companies_fx_modal_term: 'Mindestlaufzeit',
    aumico_companies_fx_modal_months: 'Monate',
    aumico_companies_fx_modal_consent_checkbox:
        'Ich bestätige, dass mir die Zusatzkosten und die Mindestlaufzeit bekannt sind.',
    aumico_companies_fx_modal_confirm: 'Bestätigen & aktivieren',
    aumico_companies_fx_modal_cancel: 'Abbrechen',
    aumico_companies_fx_deactivate_confirm_title: 'Funktionalwährung deaktivieren',
    aumico_companies_fx_deactivate_confirm_body:
        'Neue Abschlüsse können danach keine Funktionalwährung mehr verwenden. Bereits erstellte Abschlüsse bleiben unverändert. Die Mindestlaufzeit läuft weiter.',
    aumico_companies_form_validation_email_invalid: 'Ungültige E-Mail Adresse',
    aumico_companies_form_validation_enter_company_name_exists: 'Firmenname bereits vergeben',
    aumico_companies_form_validation_enter_company_name_required: 'Bitte Firmenname eintragen',
    aumico_companies_form_validation_legal_form_required: 'Bitte Rechtsform auswählen',
    aumico_companies_toast_error_something_went_wrong: 'Es ist ein Fehler aufgetreten',
    aumico_core_form_invalid_error: 'Diese Eingabe ist ungültig',
    aumico_core_form_mandatory_error: 'Dieses Feld ist obligatorisch',
    aumico_core_search: 'Suchen',
    aumico_core_search_not_found: 'Nicht gefunden',
    aumico_errors_server_error: 'Server Fehler',
    aumico_no_read_permission: 'Sie haben keine Leseberechtigung',
    aumico_notes_component_options_add_more: 'Weitere hinzufügen',
    aumico_notes_component_options_current_value_title_1: 'Aktueller Wert Titel 1',
    aumico_notes_component_options_current_value_title_2: 'Aktueller Wert Titel 2',
    aumico_notes_component_options_previous_value_title_1: 'Vorheriger Wert Titel 1',
    aumico_notes_component_options_previous_value_title_2: 'Vorheriger Wert Titel 2',
    aumico_notes_component_options_selection_option: 'Bitte wählen',
    aumico_notes_component_options_text_title: 'Text Titel',
    aumico_notes_equity: 'Eigenkapital',
    aumico_notes_fli: 'Finanzposition',
    aumico_notes_fli_component_add_more: 'Weitere hinzufügen finanzposition',
    aumico_notes_free_table_with_amounts: 'Freie Tabelle',
    aumico_notes_information_dialog_title: 'Allgemeine Informationen',
    aumico_notes_mandatory_error: 'Dieses Feld ist obligatorisch',
    aumico_notes_name_exist_error: 'Dieser Name wurde bereits vergeben',
    aumico_notes_notespage_notes_not_found:
        'Für diese Rechtsform und Rechnungslegungsstandard wurden keine Anhangsangaben gefunden.',
    aumico_notes_notestemplate_form_legal_form_and_accounting_basis_combination_exist:
        'Diese Kombination aus ausgewählter Rechtsform und Kontobasis existiert schon',
    aumico_notes_notestemplate_list_add_new: 'Neue Anhangsvorlage hinzufügen',
    aumico_notes_notestype_form_components: 'Komponenten',
    aumico_notes_notestype_form_information: 'Information',
    aumico_notes_notestype_form_min_length_error: 'Die Mindestlänge beträgt 5 Zeichen',
    aumico_notes_notestype_form_name: 'Name',
    aumico_notes_notestype_form_title: 'Titel des Abschnitts',
    aumico_notes_notestype_list_add_new: 'Neuen Anhangs-Typ hinzufügen',
    aumico_notes_options: 'Optionen',
    aumico_notes_preview: 'Vorschau',
    aumico_notes_rich_text: 'Texteingabe',
    aumico_notes_select: 'Select',
    aumico_notes_server_error: 'Interner Serverfehler',
    aumico_notes_table_with_form_add_new_item: 'Neue Zeile hinzufügen',
    aumico_notes_table_with_form_no_formfield_defined: 'Kein Formfeld definiert',
    aumico_notes_table_with_form_no_properties_defined: 'Keine Eigenschaften definiert',
    aumico_notes_table_with_form_no_properties_error: 'Keine Eigenschaften definiert',
    aumico_notes_table_with_form_total: 'Summe',
    aumico_notes_template: 'Anhang Vorlage',
    aumico_notes_testing_procedure: 'Testverfahren',
    aumico_notes_testing_procedure_comment: 'Kommentar',
    aumico_notes_testing_procedure_flis: 'Flis',
    aumico_notes_testing_procedure_references: 'Referenzen',
    aumico_notes_text: 'Text',
    aumico_notes_total_row: 'Summe Reihe',
    aumico_notes_types: 'Anhang Typ',
    aumico_reporting_contentBlocks_addNew: 'Neuen Inhaltsblock hinzufügen',
    aumico_reporting_contentBlocks_options_content: 'Inhalt blockiert Inhalt',
    aumico_reporting_contentBlocks_options_owner: 'Eigentümer des Inhaltsblocks',
    aumico_reporting_contentBlocks_options_properties: 'Eigenschaften von Inhaltsblöcken',
    aumico_reporting_report_content: 'Inhalt',
    aumico_reporting_report_edit_addNewContent: 'Neuen Inhalt hinzufügen',
    aumico_reporting_report_edit_addNewFooter: 'Neue Fusszeile hinzufügen',
    aumico_reporting_report_edit_addNewHeader: 'Neuen Header hinzufügen',
    aumico_reporting_report_footer: 'Fusszeile',
    aumico_reporting_report_header: 'Kopfzeile',
    aumico_reporting_report_name: 'Name des Reports',
    aumico_reporting_settings_options_name: 'Name',
    aumico_reporting_settings_options_owner: 'Inhaber',
    aumico_reporting_templatesPreview_show: 'Vorschau anzeigen',
    aumico_reporting_templates_addNew: 'Neue Berichtsvorlage erstellen',
    aumico_reporting_templates_edit: 'Berichtsvorlage bearbeiten',
    aumico_reporting_templates_livePreview: 'Live Vorschau',
    aumico_reporting_templates_options_accountingBasis: 'Rechnungslegungsstandard',
    aumico_reporting_templates_options_legalForm: 'Rechtsform',
    aumico_reporting_variables_addNew: 'Fügen Sie eine neue Berichtsvariable hinzu',
    aumico_reporting_variables_edit: 'Berichtsvariable bearbeiten',
    aumico_reporting_variables_options_currentVersion: 'Aktuelle Version',
    aumico_reporting_variables_options_identifier: 'Kennung',
    aumico_reporting_variables_options_property: 'Eigentum',
    aumico_reporting_variables_title: 'Variablen',
    aumico_reports_fs_notes_instruction: 'Arbeitsanweisung',
    aumico_reports_input_please_enter_placeholder: 'Bitte eingeben',
    aumico_reports_intro_side_text: 'Bring deine Jahresabschlussprozesse auf das nächste Level!',
    aumico_reports_login_bottom_button_of_question_register: 'Jetzt registrieren',
    aumico_reports_login_bottom_question: 'Noch kein Konto?',
    aumico_reports_login_credentials_error: 'Benutzername oder Passwort ist inkorrekt!',
    aumico_reports_login_credentials_toomany_requests_error:
        'Der Zugriff auf dieses Konto wurde aufgrund zahlreicher fehlgeschlagener Anmeldeversuche vorübergehend deaktiviert. Sie können es sofort wiederherstellen, indem Sie Ihr Passwort zurücksetzen, oder Sie können es später noch einmal versuchen.',
    aumico_reports_login_credentials_network_request_failed: 'Netzwerkfehler',
    aumico_reports_login_invalid_role_error: 'Ihr Konto hat keine gültige Rolle, um auf diese Anwendung zuzugreifen.',
    aumico_reports_login_forgot_password: 'Passwort vergessen',
    aumico_reports_login_introduction: '',
    aumico_reports_login_login_button: 'Anmelden',
    aumico_reports_login_title: 'Anmeldung',
    aumico_reports_page_not_found: 'Seite nicht gefunden',
    aumico_reports_password: 'Passwort',
    aumico_reports_placeholder_needs_implementation: 'Platzhalterseite muss implementiert werden...',
    aumico_reports_registration_bottom_button_of_question_login: 'Jetzt einloggen',
    aumico_reports_registration_bottom_question: 'Du hast bereits ein Konto?',
    aumico_reports_registration_confirmation_bottom_question: 'Keine E-Mail erhalten?',
    aumico_reports_registration_confirmation_bottom_question_button: 'E-Mail erneut zusenden',
    aumico_reports_registration_confirmation_introduction: 'Kurze Einführung und Anleitung',
    aumico_reports_registration_confirmation_title: 'Bitte bestätige deine E-Mail-Adresse',
    aumico_reports_registration_create_account_button: 'Benutzerkonto erstellen',
    aumico_reports_registration_introduction:
        'Willkommen! Registrieren Sie sich und erstellen Sie Jahresabschlüsse für Ihr eigenes Unternehmen und Ihre Kunden.',
    aumico_reports_registration_welcome_button_login_go_dashboard: 'Anmelden und weiter zum Dashboard',
    aumico_reports_registration_welcome_company_name_error: 'Firmenname ist erforderlich',
    aumico_reports_registration_welcome_company_name_label: 'Firmenname',
    aumico_reports_registration_welcome_first_name_error: 'Vorname ist erforderlich',
    aumico_reports_registration_welcome_first_name_label: 'Vorname',
    aumico_reports_registration_welcome_last_name_error: 'Nachname ist erforderlich',
    aumico_reports_registration_welcome_last_name_label: 'Nachname',
    aumico_reports_registration_welcome_market_communication_subscription:
        'Ich möchte Neuigkeiten zu Produkten, Services und Events von aumico erhalten.',
    aumico_reports_registration_welcome_password_error: 'Passwort erforderlich',
    aumico_reports_registration_welcome_password_label: 'Passwort',
    aumico_reports_registration_welcome_password_match_error: 'Passwörter müssen übereinstimmen',
    aumico_reports_registration_welcome_password_rules:
        'Mindestens acht Zeichen, ein Grossbuchstaben, ein kleinbuchstaben, eine Nummer und ein Sonderzeichen. (@$!%*?&._)',
    aumico_reports_registration_welcome_password_validation_error: 'Passwort entspricht nicht den Regeln.',
    aumico_reports_registration_welcome_privacy_policy:
        'Ich habe die Datenschutz-Bestimmungen auf der Website gelesen und stimme diesen zu*',
    aumico_reports_registration_welcome_repeat_password_error: 'Passwort wiederholen ist erforderlich',
    aumico_reports_registration_welcome_repeat_password_label: 'Passwort wiederholen',
    aumico_reports_reset_password_credentials_error: 'Benutzername oder E-Mail ist falsch!',
    aumico_reports_reset_password_forgot_email_username: 'E-Mail / Benutzername',
    aumico_reports_reset_password_forgot_password_title: 'Passwort vergessen?',
    aumico_reports_reset_password_forgot_send_instruction_button: 'Senden Sie mir eine Anleitung per E-Mail',
    aumico_reports_reset_password_introduction:
        'Nach der Eingabe deiner Mailadresse senden wir dir Anweisungen zum Zurücksetzen deines Passworts zu.',
    aumico_reports_signup_title: 'Neuen Account erstellen',
    aumico_reports_welcome_page_footer_about: 'AGB',
    aumico_reports_welcome_page_footer_imprint: 'Impressum',
    aumico_reports_welcome_page_footer_privacy_policy: 'Datenschutz',
    aumico_reports_write_permission_error: 'Sie haben leider keine Schreibrechte.',
    aumico_reports_referral_invite_title: 'Referral',
    aumico_reports_referral_invite_text: 'aumico weiterempfehlen',
    aumico_reports_referral_invite_invite_button: 'Jetzt einladen',
    aumico_reports_referral_invite_dialog_title: 'aumico weiterempfehlen',
    aumico_reports_referral_invite_dialog_content: 'Erzähle einem Freund von aumico',
    aumico_reports_referral_invite_dialog_input_label: 'E-Mail-Adresse hinzufügen',
    aumico_reports_referral_invite_dialog_input_placeholder: 'Bitte geben Sie E-Mail-Adressen ein',
    aumico_reports_referral_invite_dialog_save_button: 'Einladen',
    aumico_settings_accountingBasis: 'Rechnungslegungsstandard',
    aumico_settings_accountingbasis_id: 'ID',
    aumico_settings_accountingbasis_name: 'Name',
    aumico_settings_accountingbasis_owner: 'Eigentümer',
    aumico_settings_accountingbasis_text: 'Text',
    aumico_settings_accountingbasis_version: 'Version',
    aumico_settings_currency_id: 'TBD: ID',
    aumico_settings_currency_name: 'Name',
    aumico_settings_currency_owner: 'Eigentümer',
    aumico_settings_currency_text: 'Text',
    aumico_settings_currency_version: 'Version',
    aumico_settings_financialLineItem: 'Finanzposition',
    aumico_settings_financialLineItem_cashflow: 'Geldfluss',
    aumico_settings_financialLineItem_description: 'Beschreibung',
    aumico_settings_financialLineItem_id: 'ID',
    aumico_settings_financialLineItem_invalidText: "Bitte geben Sie Zahlen ab 1'000 ein",
    aumico_settings_financialLineItem_name: 'Name',
    aumico_settings_financialLineItem_owner: 'Eigentümer',
    aumico_settings_financialLineItem_position: 'Position',
    aumico_settings_financialLineItem_text: 'Text',
    aumico_settings_financialLineItem_type: 'Typ',
    aumico_settings_financialLineItem_version: 'Version',
    aumico_settings_legalForm_id: 'TBD: ID',
    aumico_settings_legalForm_name: 'Name',
    aumico_settings_legalForm_owner: 'Eigentümer',
    aumico_settings_legalForm_text: 'Text',
    aumico_settings_legalForm_version: 'Version',
    aumico_templates_cancel: 'Abbrechen',
    aumico_templates_combination_exist_error:
        'Die Kombination aus Rechtsform und Rechnungslegungsstandard existiert bereits',
    aumico_templates_description: 'Beschreibung',
    aumico_templates_form_account_basis: 'Rechnungslegungsstandard',
    aumico_templates_form_back_to_templates_list: 'Zurück zur Vorlagen Liste',
    aumico_templates_form_cash_and_cash_equivalents: 'Flüssige Mittel',
    aumico_templates_form_create_template: 'Vorlage erstellen',
    aumico_templates_form_enter_template_name_error: 'Bitte geben Sie den Name der Vorlage ein',
    aumico_templates_form_legal_form: 'Rechtsform',
    aumico_templates_form_profit_of_the_year: 'Jahresgewinn',
    aumico_templates_form_select_account_basis_error: 'Bitte wählen Sie den Rechnungslegungsstandard',
    aumico_templates_form_select_legal_form_error: 'Bitte wählen Sie die Rechtsform',
    aumico_templates_form_template_name_exists_error: 'Die Bezeichnung der Vorlage existiert bereits',
    aumico_templates_form_update_template: 'Vorlage aktualisieren',
    aumico_templates_group_form_allow_groups: 'Gruppen erlauben',
    aumico_templates_group_form_allow_items: 'Eintrag erlauben',
    aumico_templates_group_form_create_group: 'Gruppe erstellen',
    aumico_templates_group_form_enter_group_description_error: 'Please enter group description',
    aumico_templates_group_form_enter_group_name_error: 'Bitte geben Sie einen Gruppennamen ein',
    aumico_templates_group_form_hide_total: 'Summe ausblenden',
    aumico_templates_group_form_name_already_exists_error: 'Gruppenname existiert bereits',
    aumico_templates_group_form_select_option: 'Wählen Sie mindestens eine Option:',
    aumico_templates_group_form_update_group: 'Gruppe aktualisieren',
    aumico_templates_group_list_new_group: 'Neue Gruppe',
    aumico_templates_group_view_add_fli: 'hinzufügen',
    aumico_templates_group_view_add_group: 'Gruppe',
    aumico_templates_group_view_add_subtotal: 'Zwischensumme hinzufügen',
    aumico_templates_list_edit: 'Bearbeiten',
    aumico_templates_list_new: 'Neu',
    aumico_templates_list_new_template: 'Neue Vorlage',
    aumico_templates_name: 'Name',
    aumico_templates_save: 'Speichern',
    aumico_templates_subtotal_form_enter_subtotal_description_error:
        'Bitte geben Sie eine Bezeichnung für das Zwischentotal ein',
    aumico_templates_subtotal_form_enter_subtotal_name_error:
        'Bitte geben Sie eine Bezeichnung für das Zwischentotal ein',
    aumico_templates_subtotal_form_name_already_exists_error: 'Gruppenelementname existiert bereits',
    aumico_templates_subtotal_form_subtotal_name: 'Bezeichnung Zwischensumme',
    mocked_data: 'Abgeänderte Daten',
    mocked_data_1: 'Abgeänderte Daten',
    aumico_reports_annualreport_fcp_input_data_has_changed_notification_title: 'Daten aktualisierung',
    aumico_reports_annualreport_fcp_input_data_has_changed_notification_text:
        'Die Saldobilanzdaten wurden aktualisert.',
    aumico_reports_annualreport_fcp_input_data_has_changed_dialog_title: 'Mapping Daten geändert?',
    aumico_reports_annualreport_fcp_input_data_has_changed_dialog_text: 'Willst du die Daten aktualisieren?',
    aumico_reports_annualreport_fcp_input_data_has_changed_dialog_action_button: 'Ja',
    aumico_reports_annualreport_navigation_fcp: 'Prozessdokumentation1',
    aumico_reports_annualreport_navigation_aop: 'Gewinnverwendung',
    aumico_reports_annualreport_navigation_generalinformation: 'Allgemeine Informationen',
    aumico_reports_annualreport_navigation_finish_and_print: 'Abschluss & Druck',
    aumico_reports_annualreport_navigation_import: 'Kontensalden importieren',
    aumico_reports_annualreport_navigation_import_upload: 'Kontensalden importieren',
    aumico_reports_annualreport_navigation_import_mapping: 'Kontenzuordnung',
    aumico_reports_annualreport_navigation_notes: 'Anhang',
    aumico_reports_annualreport_navigation_notes_and_aop: 'Geldflussrechnung | Anhang | GV',
    aumico_reports_main_navigation_company: 'Organisation',
    aumico_reports_main_navigation_financialstatements: 'Jahresabschluss',
    aumico_reports_main_navigation_logout: 'Abmelden',
    aumico_reports_profile_navigation_security: 'Sicherheit',
    aumico_reports_profile_navigation_generalinformation: 'Allgemeine Informationen',
    aumico_annual_report_general_information_please_determine_currency: 'Währung auswählen',
    aumico_annual_report_general_information_please_determine_previous_year_date: 'Datum eingeben',
    aumico_annual_report_general_information_please_determine_date: 'Datum eingeben',
    aumico_annual_report_general_information_please_select_company: 'Firma auswählen',
    aumico_annual_report_general_information_select_revision_type: 'Revisionsart auswählen',
    aumico_annual_report_general_information_select_accounting_basis: 'Rechnungslegungsstandart auswählen',
    aumico_annual_report_import_please_select: 'Bitte auswählen',
    aumico_annual_report_interpretation_enter_excluded_word: 'Bitte eintragen',
    aumico_annual_report_interpretation_enter_included_word: 'Bitte eintragen',
    aumico_annual_report_print_options_date_of_signing: 'Datum der Unterzeichnung',
    aumico_annual_report_print_options_place_of_signing_placeholder: 'Ort der Unterzeichnung',
    aumico_annual_report_print_options_start_at_page: 'Start bei Seite',
    aumico_annual_report_print_page_content_preview: 'Inhaltsvorschau',
    aumico_annual_report_profit_calculation_enter_text: 'Text / Betrag eintragen',
    aumico_annual_report_proposal_enter_text: 'Text / Betrag eingeben',
    aumico_annual_report_print_options_show_aop: 'Gewinnverwendung',
    aumico_annual_report_print_options_show_Fcp: 'Prozessdokumentation',
    aumico_annual_report_proposal_description: 'Vorschlag zur Verwendung des Bilanzergebnisses',
    aumico_annual_report_proposal_description_profit: 'Vorschlag zur Verwendung des Bilanzgewinns',
    aumico_annual_report_proposal_description_loss: 'Vorschlag zur Verwendung des Bilanzverlusts',
    aumico_annual_report_label_cover_page: 'Deckblatt Leitfaden Titel (wird im pdf nicht sichtbar sein)',
    aumico_annual_report_print_preview_cashflow: 'Geldflussrechnung',
    aumico_annual_report_label_table_of_contents: 'Inhaltsverzeichnis',
    aumico_annual_report_table_label_previous_year_date: 'Vorjahresstichtag',
    aumico_core_data_grid_accounts: 'Konten',
    aumico_annual_report_table_label_current_year_date: 'Bilanzstichtag',
    aumico_core_data_grid_all: 'alle',
    aumico_core_data_grid_remove: 'Alle Konten entfernen',
    aumico_core_data_grid_search_placeholder: 'Suchen...',
    aumico_core_empty_data_grid_assigned_all_accounts: 'Fantastisch, Sie haben alle Konten zugewiesen!',
    aumico_core_empty_data_grid_information_text: '-',
    aumico_core_empty_data_grid_information_title: '-',
    aumico_core_file_upload_extension_error: 'Bitte laden Sie entweder eine xlsx- oder eine xls-Datei hoch',
    aumico_core_file_upload_instruction_text: 'Drag & Drop',
    aumico_core_file_upload_instruction_label: 'Finanzdaten hochladen',
    aumico_core_form_min_length_error: 'Die minimale Länge für diesen Input ist',
    aumico_core_file_upload_title: 'Finanzdaten hochladen',
    aumico_reports_action_bar_footer_back_to: 'Zurück zu',
    aumico_reports_action_bar_footer_proceed_to: 'Speichern und weiter zu',
    aumico_reports_annualreport_toc_label_balance_sheet: 'Bilanz',
    aumico_reports_annualreport_toc_label_cash_flow_statement: 'Geldflussrechnung',
    aumico_reports_annualreport_toc_label_notes_to_the_financial_statement: 'Anhang',
    aumico_reports_annualreport_toc_label_income_statement: 'Gewinn',
    aumico_reports_annualreport_cover_annual_label_title_prefix: 'Jahresabschluss für die Periode',
    aumico_reports_annualreport_cover_quarterly_label_title_prefix: 'Quartalsabschluss für die Periode',
    aumico_reports_annualreport_cover_monthly_label_title_prefix: 'Monatsabschluss für die Periode',
    aumico_reports_annualreport_cover_custom_label_title_prefix: 'Abschluss für die Periode',
    aumico_templates_account_mapping_child_form_name: 'Name',
    aumico_templates_account_mapping_form_balance: 'Bilanz',
    aumico_templates_sub_fli_form_fli: 'Finanzposten auswählen',
    aumico_templates_account_mapping_child_form_number: 'Nr.',
    aumico_templates_template_account_mapping_form_expand_all: 'Alle erweitern',
    aumico_users_edit_user_company_general_information_city: 'Ortschaft',
    aumico_users_edit_user_company_general_information_enter_no: 'Nr. eintragen',
    aumico_users_edit_user_company_general_information_street: 'Strasse',
    aumico_users_edit_user_company_general_information_address_addition: 'Adresszusatz',
    aumico_users_edit_user_general_information_enter_email_address: 'Eintragen',
    aumico_reports_annualreport_toc_label_table_of_contents: 'Inhaltsverzeichnis',
    aumico_reports_annualreport_print_date_from: 'vom',
    aumico_reports_annualreport_print_date_to: 'bis',
    aumico_reports_annualreport_print_date_of: 'zum',
    aumico_users_edit_user_general_information_name: 'Vorname',
    aumico_users_edit_user_company_general_information_enter_city: 'Ortschaft auswählen',
    aumico_users_edit_user_general_information_surname: 'Nachname',
    aumico_users_edit_user_company_general_information_name: 'Firmenname',
    aumico_users_edit_user_security_enable_two_factor_authentication: '2-Faktor Authentifizierung aktivieren',
    aumico_users_edit_user_general_information_edit_your_profile: 'Profil bearbeiten',
    aumico_templates_template_account_mapping_form_collapse_all: 'Alle reduzieren',
    aumico_users_edit_user_general_information_enter_surname: 'Nachname',
    aumico_templates_caption: 'Bezeichnung',
    aumico_templates_subtotal_name: 'Bezeichnung Zwischensumme',
    aumico_templates_subtotal_scope: 'Gruppe wählen',
    aumico_templates_subtotal_position_after: 'Position davor wählen',
    aumico_templates_subtotal_select_position: 'position wählen',
    aumico_templates_subtotal_select_position_as_first_element: 'Erstes Element',
    aumico_users_edit_user_general_information_select_salutation: 'Auswählen',
    aumico_users_edit_user_company_general_information_choose_country: 'Land auswählen',
    aumico_users_edit_user_security_confirm_new_password: 'Eintragen',
    aumico_users_aumico_form_error: 'aumico Formfehler',
    aumico_users_edit_user_security_new_password: 'Neues Passwort',
    aumico_users_edit_user_company_general_information_enter_name: 'Firmenname',
    aumico_users_edit_user_company_general_information_edit_your_profile: 'Profil bearbeiten',
    aumico_users_edit_user_company_general_information_no: 'Nr.',
    aumico_users_edit_user_company_general_information_enter_zip: 'PLZ',
    aumico_users_edit_user_general_information_email_address: 'E-Mail Adresse',
    aumico_users_edit_user_general_information_choose_language: 'Auswählen',
    aumico_users_edit_user_general_information_langugage: 'Sprache',
    aumico_users_edit_user_general_information_enter_phone_number: 'Eintragen',
    aumico_users_edit_user_general_information_settings: 'Einstellungen',
    aumico_users_edit_user_general_information_salutation: 'Ansprache',
    aumico_users_edit_user_security_current_password: 'Aktuelles Passwort',
    aumico_users_edit_user_security_change_password: 'Passwort ändern',
    aumico_users_edit_user_security_repeat_new_password: 'Neues Passwort wiederholen',
    aumico_reports_annualreport_toc_label_proposal_for_the_appropriation_of_profit: 'Gewinnverwendung',
    aumico_users_edit_user_security_enter_new_password: 'Geben Sie ein neues Passwort ein',
    aumico_templates_account_mapping_form_income: 'Gewinn- und Verlustrechnung',
    aumico_templates_template_account_mapping_form_mapped_accounts: 'Zugewiesene Konten',
    aumico_users_edit_user_company_general_information_country: 'Land',
    aumico_users_edit_user_company_general_information_enter_street: 'Strasse eintragen',
    aumico_users_edit_user_company_general_information_zip: 'PLZ',
    aumico_users_edit_user_general_information_enter_name: 'Vorname',
    aumico_users_edit_user_general_information_phone: 'Telefon Nr.',
    aumico_users_edit_user_security_authentication: 'Authentifizierung',
    aumico_users_edit_user_security_enter_current_password: 'Eintragen',
    aumico_templates_account_mapping_form_map_sme_account_plan: 'Auto Mapping',
    aumico_templates_account_mapping_form_datev_format_mismatch_warning:
        'Die importierte Postenstruktur erwartet Kontenzwecke, die hochgeladene Datei trägt keine — die bestehende Zuordnung bleibt unverändert.',
    aumico_templates_account_mapping_form_datev_unknown_purpose_warning: 'Unbekannter Kontenzweck: {{key}}',
    aumico_templates_account_mapping_form_datev_purpose_shaped_value_warning:
        'Zweck-förmiger Wert im Kontonummer-Pfad: {{key}}',
    aumico_templates_account_mapping_form_datev_no_candidate_warning: 'Konto {{key}}: Die DATEV-Datei lässt keinen eindeutigen Posten zu. Bitte ordne es manuell zu.',
    aumico_templates_account_mapping_form_datev_ambiguous_candidates_warning:
        'Konto {{key}}: Die DATEV-Datei ordnet es mehreren Posten zu ({{candidates}}). Bitte ordne es manuell zu.',
    aumico_templates_account_mapping_form_datev_warnings_dismiss: 'Meldung schließen',
    aumico_templates_account_mapping_form_datev_unknown_format_warning:
        'Unbekanntes Zuordnungsformat der Vorlage, Kontonummer-Pfad verwendet: {{key}}',
    aumico_annual_report_import_form_balance_end: 'Bitte geben Sie die letzte Zeile der Bilanz an',
    aumico_annual_report_import_form_error_invalid_row_input: 'Ungültige Zeileneingabe',
    aumico_annual_report_import_form_balance_start: 'Bitte geben Sie die erste Zeile der Bilanz an',
    aumico_annual_report_import_form_error_overlapping: 'Bereiche für Bilanz- und Ertragskonten überschneiden sich',
    aumico_annual_report_import_form_income_end: 'Bitte geben Sie die letzte Zeile der GuV an',
    aumico_annual_report_import_form_income_start: 'Bitte geben Sie die erste Zeile der GuV an',
    aumico_annualreport_aop_word_before_currency: 'in',
    aumico_core_form_submit: 'Speichern',
    aumico_notes_word_in: 'in',
    aumico_reports_annualreport_cover_annual_label_title_1st_prefix: 'Jahresabschluss',
    aumico_reports_annualreport_cover_quarterly_label_title_1st_prefix: 'Quartalsabschluss',
    aumico_reports_annualreport_cover_monthly_label_title_1st_prefix: 'Monatsabschluss',
    aumico_reports_annualreport_cover_custom_label_title_1st_prefix: 'Abschluss',
    aumico_reports_annualreport_page_print_account_mapping_label_total: 'Summe',
    aumico_reports_annualreport_page_print_account_mapping_label_word_before_currency: 'in',
    aumico_reports_annualreport_page_print_account_mapping_label_notes: 'Anhang',
    aumico_users_edit_user_general_information_salutations_mr: 'Herr',
    aumico_users_edit_user_general_information_salutations_mrs: 'Frau',
    aumico_users_edit_user_general_information_languages_english_us: 'Englisch (US)',
    aumico_users_edit_user_general_information_languages_german_switzerland: 'Deutsch (Schweiz)',
    aumico_users_edit_user_general_information_languages_german_germany: 'Deutsch (Deutschland)',
    aumico_users_edit_user_general_information_languages_italian_switzerland: 'Italienisch (Schweiz)',
    aumico_users_edit_user_general_information_languages_french_switzerland: 'Französisch (Schweiz)',
    aumico_templates_group_account_mapping_create_subfli: 'Unterposten',

    aumico_reports_annualreport_cover_label_title_2nd_prefix: 'für die Periode vom',
    aumico_templates_sub_fli_form_fli_options_label: 'Finanzposten auswählen',
    aumico_annual_report_table_menu_option_archive: 'Archivieren',
    aumico_annual_report_table_menu_option_display_active: 'Aktiv anzeigen',
    aumico_annual_report_table_menu_option_delete: 'Löschen',
    aumico_annual_report_table_menu_option_restore: 'Wiederherstellen',
    aumico_notes_fli_selection_placeholder: 'Wählen Sie die Position',
    aumico_notes_fli_drag_disabled_tooltip: 'Alle Positionen müssen zuerst ausgewählt werden, bevor Sie per Drag-and-Drop verschieben können',
    aumico_annual_report_table_menu_option_display_archived: 'Archivierte anzeigen',
    aumico_notes_rich_text_placeholder: 'Texteingabe',
    aumico_reports_bexio_error:
        'Entweder haben Sie es abgelehnt, die erforderlichen Berechtigungen zu erteilen, oder es ist ein Fehler bei der Bearbeitung Ihrer Anfrage aufgetreten',
    aumico_reports_unsaved_changes_warning_dialog_cancel: 'Abbrechen',
    aumico_notes_table_with_form_enter_placeholder: 'Eingabe',
    aumico_reports_unsaved_changes_warning_dialog_content:
        'Sie haben ungespeicherte Änderungen. Möchten Sie Ihre Daten speichern?',
    aumico_reports_unsaved_changes_warning_dialog_discard: 'Änderungen verwerfen',
    aumico_reports_unsaved_changes_warning_dialog_save: 'Speichern',
    aumico_reports_unsaved_changes_warning_dialog_save_unsuccessful: 'Speichern ist nicht erfolgreich',
    aumico_annual_report_cash_flow_add_new_item: 'Zeile hinzufügen (verschieben per Drag & Drop)',
    aumico_annual_report_cash_flow_financing_activities_title: 'Geldfluss aus Finanzierungstätigkeit',
    aumico_annual_report_cash_flow_button_recalculate_flis: 'Zurücksetzen',
    aumico_annual_report_cash_flow_investing_activities_disinvestments: 'Desinvestitionen',
    aumico_annual_report_cash_flow_investing_activities_title: 'Geldfluss aus Investitionstätigkeit',
    aumico_annual_report_cash_flow_investing_activities_investments: 'Investitionen',
    aumico_annual_report_cash_flow_operating_activities_title: 'Geldfluss aus Geschäftstätigkeit',
    aumico_annual_report_cash_flow_total: 'Total Veränderung flüssige Mittel',
    aumico_annual_report_cash_flow_total_operating_activities:
        'Total Veränderung flüssige Mittel aus Geschäftstätigkeit',
    aumico_annual_report_cash_flow_total_investing_activities:
        'Total Veränderung flüssige Mittel aus Investitionstätigkeit',
    aumico_annual_report_cash_flow_total_financing_activities:
        'Total Veränderung flüssige Mittel aus Finanzierungstätigkeit',
    aumico_annual_report_cash_flow_total_cashAndCashEnd: 'Flüssige Mittel am Ende der Periode',
    aumico_annual_report_cash_flow_total_cashAndCashStart: 'Flüssige Mittel zu Beginn der Periode',
    aumico_annual_report_cash_flow_total_total1_name: 'Total Veränderung flüssige Mittel',
    aumico_annual_report_cash_flow_total_total2: 'Total Veränderung flüssige Mittel',
    aumico_annual_report_print_options_label_show_reclasses_in_sums: 'inklusive Umgliederungen',
    aumico_annual_report_print_options_mainTitle: 'Titel',
    aumico_annual_report_cash_flow_total_total1: 'Total Veränderung flüssige Mittel',
    aumico_notes_component_options_movementschedule_column2: 'Column 2',
    aumico_notes_component_options_movementschedule_column3: 'Column 3',
    aumico_annual_report_print_options_date: 'Zeitraum',
    aumico_reports_annualreport_navigation_cfs: 'Geldflussrechnung',
    aumico_reports_annualreport_navigation_label_balance: 'Bilanz',
    aumico_templates_reclass_label_adjustment: 'Stille Reserven',
    aumico_annual_report_cash_flow_total_recapitulation: 'Rekapitulation',
    aumico_annual_report_interpretation_remove_account_with_zero_balance: 'Konten mit Nullsaldo entfernen',
    aumico_annual_report_print_options_show_cfs: 'Geldflussrechnung',
    aumico_templates_reclass_label_change_in_adjustment: '△ Stille Reserven',
    aumico_notes_component_options_movementschedule_column4: 'Column 4',
    aumico_templates_reclass_label_reclass: 'Umglied.',
    aumico_reports_annualreport_navigation_label_income: 'Gewinn- und Verlustrechnung',
    aumico_annual_report_print_options_subTitle: 'Untertitel',
    aumico_templates_reclass_label_in: 'in',
    aumico_notes_preview_attention:
        'Attention: This section to show only how the component looks like and any change in it will not reflect on the saved data',
    aumico_templates_reclass_label_total: 'Total Umgliederungen',
    aumico_annual_report_cash_flow_total_total2_name: 'Summe Veränderung flüssige Mittel',
    aumico_reports_annualreport_page_adjustments_label_account_number: 'Kontonummer',
    aumico_annual_report_print_options_label_show_adjustments_in_sums: 'Intern (inkl. stille Reserven)',
    aumico_templates_reclass_label_income: 'ER',
    aumico_notes_component_options_movementschedule_column1: 'Spalte 1',
    aumico_reports_annualreport_navigation_adjustments_and_reclasses: 'Umgliederungen & Stille Reserven',
    aumico_templates_reclass_label_account_number: 'Kontonummer',
    aumico_templates_reclass_label_internal: 'Intern',
    aumico_annual_report_cash_flow_print_preview_notes: 'Anhang',
    aumico_annual_report_print_options_decimal_and_empty_lines_title: 'Dezimal und leere Zeilen',
    aumico_annual_report_print_options_reclasses_and_internal_title: 'Werte und Verhältniskennzahlen',
    aumico_annual_report_print_options_design_settings_title: 'Design Einstellungen',
    aumico_annual_report_print_options_show_company_logo: 'Firmenlogo',
    aumico_annual_report_print_options_show_organization_logo: 'Briefpapier Organisation',
    aumico_annual_report_print_options_show_components_title: 'Bestandteile',
    aumico_annual_report_print_options_show_accounts: 'Konten anzeigen',
    aumico_annual_report_print_options_hide_previous_year: 'Vorjahr ausblenden',
    aumico_annual_report_print_options_show_notes: 'Anhang',
    aumico_companies_table_label_company_legal_status: 'Rechtsform',
    aumico_companies_table_label_status: 'Status',
    aumico_companies_table_new_button: 'Neue Firma',
    aumico_companies_table_search_button: 'Suchen',
    aumico_companies_table_label_company_badge_active: 'Aktiv',
    aumico_companies_table_label_company_badge_inactive: 'Inaktiv',
    aumico_companies_delete_dialog_ok: 'Löschen',
    aumico_companies_delete_dialog_cancel: 'Abbrechen',
    aumico_companies_delete_dialog_text_2: 'Diese Aktion kann nicht rückgängig gemacht werden.',
    aumico_companies_activate_button: 'Aktivieren',
    aumico_companies_activate_state: 'Aktiv',
    aumico_companies_inactivate_state: 'Inaktiv',
    aumico_companies_changes_saved_successfully_dialog: 'Die Firma wurde erfolgreich aktualisiert.',
    aumico_companies_table_label_company_location: 'Ort',
    aumico_companies_table_label_company_name: 'Firmenname',
    aumico_companies_table_label_company_street_and_number: 'Strasse und Hausnummer',
    aumico_reports_main_navigation_company_list: 'Firmen',
    aumico_reports_print_highlight_color_1: 'Hintergrund 1',
    aumico_reports_print_highlight_color_2: 'Hintergrund 2',
    aumico_companies_table_label_company_postal_code: 'PLZ',
    aumico_templates_adjustmentAndReclassed_group_form_tooltip: 'Anpassung an Erfolgskonten en-us\nsenden',
    aumico_templates_income_selection_popup_done_btn: 'Erledigt',
    aumico_users_edit_user_company_general_information_upload_logo_label: 'Briefpapier hochladen',
    aumico_templates_income_selection_popup_title: 'GuV-Konten',
    aumico_users_edit_user_company_general_information_upload_logo_text:
        'Ziehen Sie ein PDF mit dem Briefpapier hierher',
    aumico_reports_print_text_color: 'Text',
    aumico_users_edit_user_company_general_information_company_logo: 'Vorlage Briefpapier für Deckblatt',
    aumico_reports_main_navigation_edit_company: 'Firma erstellen / bearbeiten',
    aumico_reports_print_title_color: 'Titel',
    aumico_reports_print_table_header_color: 'Tabellenkopf',
    aumico_reports_print_table_footer_color: 'Tabellenfuss',
    aumico_reports_design_settings_select_colors_title: 'Farben auswählen',
    aumico_reports_design_settings_preview_title: 'Vorschau',
    aumico_reports_design_settings_save_button: 'Einstellungen Speichern',
    aumico_reports_design_settings_example_normal_row: 'Das ist eine normale Zeile',
    aumico_reports_design_settings_example_footer_row: 'Das ist eine Beispiel Fusszeile',
    aumico_users_edit_user_company_general_information_upload_logo_extension_error: 'pdf Datei hochladen',
    aumico_annual_report_import_balance_and_income_from_separate_files_option: 'Bilanz und GuV separat hochladen',
    aumico_annual_report_import_definition_specify_data_start_line_1:
        'Geben Sie die Zeilennummer an, ab welcher die Konten beginnen',
    aumico_annual_report_import_definition_specify_data_start_line_2: 'Tabelle',
    aumico_annual_report_import_form_balance_instruction_text: 'Ziehen Sie die Datei Bilanz hierher',
    aumico_annual_report_import_form_income_instruction_text: 'Ziehen sie die Datei GuV hierher',
    aumico_annual_report_import_optional_settings_title: 'Zusätzliche Einstellungen',
    aumico_annual_report_aop_accounts_placeholder: 'Konto auswählen',
    aumico_annual_report_general_information_autofill_from_list_btn_text: 'Jahresbericht für Datenübernahme auswählen',
    aumico_annual_report_general_information_autofill_from_previous_year_btn_text: 'Autofill Jahresbericht vom Vorjahr',
    aumico_annual_report_general_information_balance_sheet: 'Bilanz',
    aumico_annual_report_general_information_current_year: 'Aktuelles Jahr',
    aumico_annual_report_general_information_date_from: 'Von',
    aumico_annual_report_general_information_date_to: 'Bis',
    aumico_annual_report_general_information_income_current_date_from_error: 'aktuelles ',
    aumico_annual_report_general_information_income_current_date_to_error: 'Enddatum liegt vor dem Anfangsdatum',
    aumico_annual_report_general_information_income_previous_date_from_error: 'vorheriges ',
    aumico_annual_report_general_information_income_previous_date_to_error: 'vorheriges ',
    aumico_annual_report_general_information_income_statement: 'Gewinn- und Verlustrechnung',
    aumico_annual_report_general_information_no_previous_data: 'Keine Vorjahresdaten (Gründung)',
    aumico_annual_report_general_information_optional_or: 'oder',
    aumico_annual_report_general_information_options: 'Optionen',
    aumico_annual_report_general_information_please_determine_income_date: 'Aktuelle Periode',
    aumico_annual_report_general_information_previous_period: 'Vorherige Periode',
    aumico_annual_report_general_information_take_autofill_from_previous_annual_report:
        'Konfiguration aus dem Vorjahr übernehmen (Postenstruktur, Kontenzuordnung)',
    aumico_annual_report_general_information_take_previous_data_from_annual_report: 'Vorjahresdaten übernehmen',
    aumico_annual_report_import_choose_annual_report_for_autofill_and_mapping_button: 'Jahresbericht auswählen',
    aumico_annual_report_import_select_annual_report_for_autofill_and_mapping:
        'Upload-Konfiguration und Kontenmapping von bestehendem Jahresbericht übernehmen',
    aumico_annual_report_selection_list_accounting_basis: 'Rechnungslegungsstandard',
    aumico_annual_report_selection_list_company: 'Firma',
    aumico_annual_report_selection_list_current_year_date: 'Aktuelles Jahr',
    aumico_annual_report_selection_list_legal_form: 'Rechtsform',
    aumico_new_button: 'Neu',
    aumico_reports_annualreport_page_financial_statement_general_information_label_general_information:
        'Allgemeine Informationen',
    aumico_reports_print_page_adjustments_reclasses_warning:
        'Bitte beachten Sie, dass manuell vorgenommene Änderungen in der Geldflussrechnung durch interne Werte überschrieben werden können.',
    aumico_reports_print_title_establishment: 'Gründungsdatum',
    aumico_reports_warning_popup_warning_title: 'Warnung',
    aumico_search_placeholder: 'Suchen... ',
    aumico_templates_account_mapping_form_map_income_total: 'Bilanzergebnis aus GuV übertragen',
    aumico_templates_account_mapping_form_transferred_profit_account_name: 'Bilanzgewinn /-verlust',

    aumico_annual_report_print_options_disable_balance_sheet_page_break: 'Bilanz auf einer Seite',
    aumico_annual_report_print_options_place_signature_after_aop: 'Nach Gewinnverwendung',
    aumico_core_data_grid_items: 'Konten',
    aumico_core_pagination_action_bar_range_text: 'von',
    aumico_core_accordion_Information_dialog_title: 'Information',
    aumico_core_table_filter_placeholder: 'Filter',
    aumico_users_company_profile_general_information_side_margins: 'Seitenränder: 1,5cm von allen Seiten',
    aumico_admin_navigation_accounting_basis: 'Accounting Basis',
    aumico_admin_navigation_change_password: 'Change Password',
    aumico_admin_navigation_aumico_users: 'aumico Users',
    aumico_admin_navigation_home: 'Home',
    aumico_admin_navigation_legal_form: 'Legal Form',
    aumico_admin_navigation_financial_line_item: 'Financial Line Item',
    aumico_admin_navigation_localization: 'Localization',
    aumico_admin_navigation_logout: 'Logout',
    aumico_admin_navigation_manage: 'Manage',
    aumico_admin_navigation_login: 'Login',
    aumico_admin_navigation_notes: 'Notes',
    aumico_admin_navigation_settings: 'Settings',
    aumico_admin_navigation_signup: 'Sign up',
    aumico_admin_navigation_templates: 'Templates',
    aumico_admin_navigation_user_management: 'User Management',
    aumico_admin_navigation_types: 'Types',
    aumico_annual_report_cash_flow_mandatory_field: 'Das folgende Feld ist ein Pflichtfeld',
    aumico_admin_user_already_exists: 'Dieser User existiert bereits',
    aumico_admin_form_language: 'Language',
    aumico_settings_financialLineItem_form_name_already_exists_error:
        'Es existiert bereits ein FLI mit dieser Bezeichnung',
    aumico_settings_accountingbasis_form_name_already_exists_error:
        'Es existiert bereits ein Rechnungslegungsstandard mit dieser Bezeichnung',
    aumico_settings_legalForm_form_name_already_exists_error:
        'Es existiert bereits eine Rechtsform mit dieser Bezeichnung',
    aumico_annual_report_general_information_company: 'Firma',
    aumico_reports_main_navigation_user_profile: 'Profil anpassen',
    aumico_annual_report_print_options_show_fli_total: 'Summentotale',
    aumico_reports_internal_mapping_changes_warning:
        'Das System hat einige Zuordnungen im Kontenmapping vorgenommen.\nBitte speichern, wenn Sie diese beibehalten wollen.',
    aumico_annual_report_interpretation_account_number_invalid_input:
        'Nur positive Zahlen oder Bereiche (z. B. 3 oder 3-5) sind zulässig',
    aumico_reports_welcome_page_footer_about_link: 'https://aumico.io/agb/',
    aumico_reports_welcome_page_footer_impressum_link: 'https://aumico.io/impressum/',
    aumico_reports_welcome_page_footer_privacy_policy_link: 'https://aumico.io/datenschutz/',
    aumico_templates_group_account_mapping_unallowed:
        'Die Zuordnung der ausgewählten Konten zum gewünschten Posten ist nicht möglich, da es einen oder mehrere Unterposten enthält.',
    aumico_information_dialog_title: 'Information',
    aumico_reports_equality_check_dialog_assets_and_liabilities_closing_not_equal:
        'Aktiva und Passiva des aktuellen Jahres stimmen nicht überein',
    aumico_reports_equality_check_dialog_assets_and_liabilities_opening_and_closing_not_equal:
        'Aktiva und Passiva des aktuellen und letzten Jahres stimmen nicht überein',
    aumico_reports_equality_check_dialog_assets_and_liabilities_opening_not_equal:
        'Aktiva und Passiva des Vorjahres stimmen nicht überein',
    aumico_reports_equality_check_dialog_cashflow_totals_closing_not_equal:
        'Die Cashflow Totale des aktuellen Jahres stimmen nicht überein',
    aumico_reports_equality_check_dialog_cashflow_totals_opening_and_closing_not_equal:
        'Die Cashflow Totale des aktuellen und letzten Jahres stimmen nicht überein',
    aumico_reports_equality_check_dialog_cashflow_totals_opening_not_equal:
        'Die Cashflow Totale des Vorjahres stimmen nicht überein',
    aumico_reports_equality_check_dialog_go_back_and_correct_it: 'Zurück und korrigieren',
    aumico_potential_impact_on_all_users_utilizing_that_template_will_occur:
        'Wenn Sie das Geschäftsmodell ändern, hat das Auswirkungen auf die Benutzer, die diese Vorlage verwenden.',
    aumico_reports_equality_check_dialog_proceed: 'Trotzdem weiter',
    aumico_reports_equality_check_dialog_profit_income_and_profit_fli_closing_not_equal:
        'Gewinne aus Bilanz und GuV des aktuellen Jahres stimmen nicht überein',
    aumico_reports_equality_check_dialog_profit_income_and_profit_fli_opening_and_closing_not_equal:
        'Gewinne aus Bilanz und GuV des aktuellen und letzten Jahres stimmen nicht überein',
    aumico_reports_equality_check_dialog_profit_income_and_profit_fli_opening_not_equal:
        'Gewinne aus Bilanz und GuV des Vorjahres stimmen nicht überein',
    aumico_reports_equality_check_dialog_total_adjustments_assets_and_total_adjustments_liabilities_closing_not_equal:
        'Die Totale der Aktiva und Passiva des aktuellen Jahres stimmen nicht überein',
    aumico_reports_equality_check_dialog_total_adjustments_assets_and_total_adjustments_liabilities_opening_and_closing_not_equal:
        'Aktiva und Passiva des aktuellen und letzten Jahres stimmen nicht überein (auf Grund der Bildung/Auflösung stiller Reserven)',
    aumico_reports_equality_check_dialog_total_adjustments_assets_and_total_adjustments_liabilities_opening_not_equal:
        'Die Totale der Aktiva und Passiva des Vorjahres stimmen nicht überein',
    aumico_reports_equality_check_dialog_total_adjustments_income_and_total_adjustments_profit_fli_closing_not_equal:
        'Jahresergebnis aus der GuV und Gewinn aus Bilanz stimmen im aktuellen Jahr nicht überein (auf Grund der Bildung/Auflösung stiller Reserven)',
    aumico_reports_equality_check_dialog_total_adjustments_income_and_total_adjustments_profit_fli_opening_and_closing_not_equal:
        'Jahresergebnis aus der GuV und Gewinn aus Bilanz stimmen im aktuellen und letzten Jahr nicht überein (auf Grund der Bildung/Auflösung stiller Reserven)',
    aumico_reports_equality_check_dialog_total_adjustments_income_and_total_adjustments_profit_fli_opening_not_equal:
        'Jahresergebnis aus der GuV und Gewinn aus Bilanz stimmen im Vorjahr nicht überein (auf Grund der Bildung/Auflösung stiller Reserven)',
    aumico_reports_equality_check_dialog_total_reclasses_assets_and_total_reclasses_liabilities_opening_and_closing_not_equal:
        'Aktiva und Passiva des aktuellen und letzten Jahres stimmen nicht überein (auf Grund von Umgliederungen)',
    aumico_reports_equality_check_dialog_total_reclasses_assets_and_total_reclasses_liabilities_closing_not_equal:
        'Aktiva und Passiva des aktuellen Jahres stimmen nicht überein (auf Grund von Umgliederungen)',
    aumico_reports_equality_check_dialog_total_reclasses_income_and_total_reclasses_profit_fli_closing_not_equal:
        'Jahresergebnis aus der GuV und Gewinn aus Bilanz stimmen im aktuellen Jahr nicht überein (auf Grund von Umgliederungen)',
    aumico_reports_equality_check_dialog_total_reclasses_income_and_total_reclasses_profit_fli_opening_and_closing_not_equal:
        'Jahresergebnis aus der GuV und Gewinn aus Bilanz stimmen im aktuellen und letzten Jahr nicht überein (auf Grund von Umgliederungen)',
    aumico_reports_equality_check_dialog_total_reclasses_income_and_total_reclasses_profit_fli_opening_not_equal:
        'Jahresergebnis aus der GuV und Gewinn aus Bilanz stimmen im Vorjahr nicht überein (auf Grund von Umgliederungen)',
    aumico_reports_equality_check_print_preview_table_adjustments: 'Stille Reserven Bilanz',
    aumico_reports_equality_check_print_preview_information_dialog_content:
        'Die abschliessende Kontrolle hilft Ihnen sicherzustellen, dass sich keine Fehler in Ihren Jahresabschluss einschleichen.',
    aumico_reports_equality_check_print_preview_table_adjustments_profit_income_equals_adjustments_profit_balance:
        'Stille Res. Ergebnis ER = Stille Res. Ergebnis Bilanz',
    aumico_reports_equality_check_dialog_total_reclasses_assets_and_total_reclasses_liabilities_opening_not_equal:
        'Aktiva und Passiva des Vorjahres stimmen nicht überein (auf Grund von Umgliederungen)',
    aumico_reports_equality_check_print_preview_table_assets_equal_liabilities: 'Aktiva = Passiva',
    aumico_reports_equality_check_print_preview_table_current_year_column: 'Aktuelles Jahr',
    aumico_reports_equality_check_print_preview_table_cashflow_statement: 'Cashflow Statement',
    aumico_reports_equality_check_print_preview_table_previous_year_row: 'Vorjahr',
    aumico_reports_equality_check_print_preview_table_profit_income_equals_profit_fli: 'Gewinn Bilanz  = Gewinn GuV',
    aumico_reports_equality_check_print_preview_table_previous_year_column: 'Vorjahr',
    aumico_reports_equality_check_print_preview_table_reclasses_profit_income_equals_reclasses_profit_balance:
        'Umglied. Ergebnis ER = Umglied. Ergebnis Bilanz',
    aumico_reports_equality_check_print_preview_table_current_year_row: 'Aktuelles Jahr',
    aumico_reports_equality_check_print_preview_table_title: 'Übersicht',
    aumico_reports_equality_check_print_preview_table_reclasses: 'Umgliederungen Bilanz',
    aumico_reports_equality_check_print_preview_title: 'Finaler Check',
    aumico_reports_required_data_not_completed: 'Einer der vorhergehenden Schritte ist noch nicht abgeschlossen.',
    aumico_reports_template_not_found:
        'Für die gewählte Kombination von Rechtsform und Rechnungslegungsstandard konnten wir keine Vorlage finden.',
    aumico_reports_error_dialog_something_went_wrong: 'Etwas ging schief',
    aumico_annual_report_print_options_label_income_ratio_reference: 'Referenzwert GuV',
    aumico_annual_report_print_options_income_ratio_reference_internal_change_warning_message:
        'Der Referenzwert für die Verhältniskennzahlen in der GuV wurde geändert da er nicht 0 sein kann.',
    aumico_annual_report_print_options_label_show_ratios: 'Verhältniskennzahlen',
    aumico_companies_notification_error_description:
        'Die Firma konnte nicht gelöscht werden, da möglicherweise eine Verknüpfung besteht.',
    aumico_reports_notification_information_title: 'Information',
    aumico_reports_notification_success_title: 'Erfolgreich aktualisiert',
    aumico_reports_default_page_header: 'Undefined',
    aumico_reports_notification_error_title: 'Etwas ist schief gelaufen',
    aumico_admin_edit_user_profile: 'Benutzerprofil bearbeiten',
    aumico_core_information_popup_default_title: 'Information',
    aumico_templates_group_form_enter_group_title_error: 'Bitte geben Sie eine Bezeichnung für die Gruppe ein',
    aumico_templates_group_form_enter_group_total_name_error:
        'Bitte geben Sie eine Bezeichnung für das Gruppentotal ein',
    aumico_templates_group_form_title: 'Bezeichnung Gruppe',
    aumico_templates_group_form_total_name: 'Bezeichnung Gruppentotal (Total ...)',
    aumico_annual_report_complementary_reports_add_report_button: 'Bericht hinzufügen',
    aumico_annual_report_complementary_reports_description:
        'Füge deinem Jahresabschluss weitere Berichte hinzu wie zum Beispiel ein Management Summary, eine Vollständigkeitserklärung und viele mehr.',
    aumico_annual_report_complementary_reports_headline: 'Ergänzende Berichte',
    aumico_annual_report_complementary_reports_report_rich_text_placeholder: 'Text einfügen',
    aumico_annual_report_complementary_reports_report_title: 'Titel des Berichts',
    aumico_annual_report_complementary_reports_title_error: 'Der Titel ist ein Pflichtfeld',
    aumico_annual_report_print_options_show_complementary_reports: 'Ergänzende Berichte',
    aumico_empty_field_error: 'Dies ist ein Pflichtfeld',
    aumico_reports_annualreport_navigation_complementary_reports: 'Ergänzende Berichte',
    aumico_users_personal_information_language_error: 'Die Sprache ist ein Pflichtfeld',
    aumico_users_personal_information_organization_label: 'Name deiner Firma',
    aumico_users_personal_information_language_section_title: 'Wähle deine Sprache',
    aumico_users_registration_email_username_placeholder: 'Mailadresse eingeben',
    aumico_users_personal_information_sub_title: 'Stelle uns bitte die folgenden Informationen zur Verfügung:',
    aumico_users_personal_information_main_title: 'Wir möchten dich kennenlernen',
    aumico_users_registration_password_label: 'Passwort',
    aumico_users_registration_password_placeholder: 'Passwort eingeben',
    aumico_users_registration_email_username_required_error: 'Geschäftliche E-Mail-Adresse ist ein Pflichtfeld',
    aumico_users_personal_information_organization_error: 'Der Name deiner Firma ist ein Pflichtfeld',
    aumico_users_reset_password_button: 'Passwort zurücksetzen',
    aumico_users_signup_continue_button: 'Weiter',
    aumico_users_signup_creating_your_account_button: 'Account erstellen',
    aumico_users_registration_read_and_agree:
        'Ich habe die Datenschutzerklärung gelesen und erkläre mich damit einverstanden:',
    aumico_users_registration_main_title: 'Starte deine 10-tägige Testphase! ',
    aumico_annual_report_ems_add_new_item_button_text: '+ Neue Zeile',
    aumico_annual_report_ems_total_equity_header_text: 'Summe Eigenkapital',
    aumico_annual_report_ems_new_total_column: 'Neue Summe',
    aumico_annual_report_ems_manual_column: 'Manuell hinzugefügte Spalte',
    aumico_annual_report_ems_row_title: 'Eigenkapital per',
    aumico_annual_report_ems_business_year: 'Geschäftsjahr',
    aumico_annual_report_ems_difference_to: 'Differenz zu Eigenkapital per',
    aumico_annual_report_ems_position_column_header: 'Position / Vorgang',
    aumico_annual_report_ems_add_column: '+ Neue Spalte',
    aumico_annual_report_ems_add_column_limit: 'Im PDF können maximal 8 Spalten dargestellt werden.',
    aumico_annual_report_ems_column_type_select_label: 'Spaltentyp wählen',
    aumico_annual_report_ems_column_type_value: 'Wertspalte',
    aumico_annual_report_ems_column_type_value_description: 'Position mit erfassbaren Werten',
    aumico_annual_report_ems_column_type_total: 'Total-Spalte',
    aumico_annual_report_ems_column_type_total_description: 'Summe ausgewählter Wertspalten',
    aumico_annual_report_ems_structure_diff_intro: 'Die Kontostruktur im Mapping hat sich geändert.',
    aumico_annual_report_ems_structure_diff_new: 'Neu hinzugekommen: {{names}}.',
    aumico_annual_report_ems_structure_diff_removed: 'Nicht mehr im Mapping: {{names}}.',
    aumico_annual_report_ems_structure_diff_apply: 'Spalten aktualisieren',
    aumico_annual_report_print_options_show_ems: 'Eigenkapitalnachweis',
    aumico_reports_annualreport_navigation_equity_movement_schedule: 'Eigenkapitalnachweis',
    aumico_reports_annualreport_navigation_fixed_assets_schedule: 'Anlagespiegel',
    aumico_reports_annualreport_navigation_reorder_report_and_print: 'In anderer Reihenfolge drucken',
    aumico_reports_equity_movement_schedule_no_table_shown_error_message:
        'Dem Eigenkapital sind keine Konten zugewiesen.',
    aumico_reports_reorder_report_cover_section_title: 'Deckblatt',
    aumico_reports_reorder_report_section_save_button: 'Speichern',
    aumico_reports_reorder_report_sections_dialog_title: 'Reihenfolge ändern',
    aumico_annual_report_ems_text_addition_above_title: 'Einleitung',
    aumico_annual_report_ems_text_addition_below_title: 'Anmerkung',
    aumico_annual_report_ems_title: 'Eigenkapitalnachweis',
    aumico_annual_report_print_preview_ems: 'Eigenkapitalnachweis',
    aumico_reports_main_navigation_organization_settings: 'Organisationseinstellungen',
    aumico_reports_main_navigation_design_settings: 'Design Einstellungen',
    aumico_reports_organization_settings_navigation_organization_profile: 'Profil',
    aumico_reports_organization_settings_navigation_text_snippets: 'Berichtsvorlagen',
    aumico_reports_organization_settings_text_snippets_title: 'Berichtsvorlagen',
    aumico_annual_report_complementary_reports_delete_icon_text: 'Löschen',
    aumico_annual_report_complementary_reports_text_snippets_decision_dialog_cancel_button: 'Abbrechen',
    aumico_annual_report_complementary_reports_prefill_with_text_snippet_icon_text: 'Berichtsvorlage einfügen',
    aumico_annual_report_complementary_reports_text_snippets_decision_dialog_description:
        'Bist du sicher? Du überschreibst das Textfeld',
    aumico_annual_report_complementary_reports_text_snippets_decision_dialog_yes_button: 'Ja',
    aumico_annual_report_complementary_reports_text_snippets_dialog_description: 'Beschrieb',
    aumico_annual_report_complementary_reports_text_snippets_dialog_insert_text_snippet_button: 'Vorlage einfügen',
    aumico_annual_report_complementary_reports_text_snippets_dialog_title: 'Vordefinierter Vorlage einfügen',
    aumico_reports_equity_movement_schedule_refresh_button_text: 'EKN aktualisieren',
    aumico_reports_organization_settings_text_snippets_add_new_button: 'Neue Berichtsvorlage erstellen',
    aumico_reports_organization_settings_text_snippets_create_dialog_title: 'Neue Vorlage hinzufügen',
    aumico_reports_organization_settings_text_snippets_form_dialog_content_field_required_error:
        'Inhalt ist erforderlich',
    aumico_reports_organization_settings_text_snippets_form_dialog_create_conflict_error_notification_description:
        'Erstellen des Textbausteins fehlgeschlagen: Beschreibung existiert bereits',
    aumico_reports_organization_settings_text_snippets_form_dialog_create_success_notification_description:
        'Textbaustein erfolgreich erstellt',
    aumico_reports_organization_settings_text_snippets_form_dialog_create_internal_server_error_description:
        'Textbaustein konnte nicht erstellt werden: Interner Serverfehler',
    aumico_reports_organization_settings_text_snippets_form_dialog_cancel_button: 'Abbrechen',
    aumico_reports_organization_settings_text_snippets_form_dialog_description_field_already_exists_error:
        'Beschreibung existiert bereits',
    aumico_reports_organization_settings_text_snippets_form_dialog_description_field_required_error:
        'Beschreibung erforderlich',
    aumico_reports_organization_settings_text_snippets_form_dialog_save_button: 'Speichern',
    aumico_reports_organization_settings_text_snippets_form_dialog_error_notification_title: 'Fehler',
    aumico_reports_organization_settings_text_snippets_form_dialog_title_field: 'Titel',
    aumico_reports_organization_settings_text_snippets_list_created_by_column_header: 'Erstellt von',
    aumico_reports_organization_settings_text_snippets_form_dialog_title_field_required_error: 'Titel erforderlich',
    aumico_reports_organization_settings_text_snippets_list_created_at_column_header: 'Erstellt am',
    aumico_reports_organization_settings_text_snippets_form_dialog_description_field: 'Beschreibung',
    aumico_reports_organization_settings_text_snippets_list_delete_error_notification_description:
        'Textbaustein konnte nicht gelöscht werden: Interner Server Fehler',
    aumico_reports_organization_settings_text_snippets_list_delete_dialog_description:
        'Bist du sicher, dass du den ausgewählten Textbaustein löschen möchtest?',
    aumico_reports_organization_settings_text_snippets_list_delete_dialog_yes_button: 'Ja',
    aumico_reports_organization_settings_text_snippets_list_delete_dialog_cancel_button: 'Abbrechen',
    aumico_reports_organization_settings_text_snippets_list_delete_success_notification_title: 'Erfolgreich',
    aumico_reports_organization_settings_text_snippets_list_last_modified_column_header: 'zuletzt bearbeitet',
    aumico_reports_organization_settings_text_snippets_form_dialog_success_notification_title: 'Erfolgreich',
    aumico_reports_organization_settings_text_snippets_list_delete_success_notification_description:
        'Textbaustein erfolgreich gelöscht',
    aumico_reports_organization_settings_text_snippets_list_description_column_header: 'Beschreibung',
    aumico_reports_organization_settings_text_snippets_list_title_column_header: 'Titel',
    aumico_reports_organization_settings_text_snippets_list_delete_button: 'Löschen',
    aumico_reports_organization_settings_text_snippets_list_delete_error_notification_title: 'Fehler',
    aumico_reports_organization_settings_text_snippets_list_modified_by_column_header: 'Bearbeitet von',
    aumico_admin_ar_template_data_not_completed_error: 'Allgemeinen Informationen müssen ausgefüllt sein',
    aumico_admin_ar_template_define_pdf_template: 'PDF Vorlage definieren',
    aumico_admin_ar_template_download_pdf_template: 'PDF Vorlage downloaden',
    aumico_admin_ar_template_general_information_accounting_bases: 'Rechnungslegungstandards',
    aumico_admin_ar_template_general_information_annual_report_steps: 'JR Navigationsschritte',
    aumico_admin_ar_template_general_information_consistency: 'Kohärenz',
    aumico_admin_ar_template_general_information_countries: 'Land',
    aumico_admin_ar_template_general_information_field_required_error: 'Dieses Feld ist erforderlich',
    aumico_admin_ar_template_general_information_legal_forms: 'Rechtsform',
    aumico_admin_ar_template_general_information_business_models: 'Business Model',
    aumico_admin_ar_template_general_information_state: 'Status',
    aumico_admin_ar_template_general_information_name: 'Name',
    aumico_admin_ar_template_list_delete_error_notification_description:
        'Fehlgeschlagen! Das Template konnte nicht gelöscht werden',
    aumico_admin_ar_template_list_delete_failed_notification_title: 'Fehler',
    aumico_admin_ar_template_list_delete_success_notification_description: 'Template wurde erfolgreich gelöscht',
    aumico_admin_ar_template_list_menu_item_delete: 'löschen',
    aumico_admin_ar_template_navigation_general_information: 'Allgemeine Informationen',
    aumico_admin_ar_template_list_delete_success_notification_title: 'Erfolgreich',
    aumico_admin_ar_template_navigation_balance_sheet_taxonomy: 'Bilanztaxonomie',
    aumico_admin_ar_template_navigation_income_statement_taxonomy: 'Gewinn- und Verlustrechnung Taxonomie',
    aumico_admin_ar_template_pdf_error_notification_description_file_too_large:
        'PDF-Vorlage kann nicht hochgeladen werden: Datei ist zu gross',
    aumico_admin_ar_template_navigation_notes: 'Anhang',
    aumico_admin_ar_template_navigation_pdf_template: 'PDF Template',
    aumico_admin_ar_template_pdf_updated_success_notification_description: 'PDF-Vorlage erfolgreich aktualisiert',
    aumico_admin_countries_label: 'Länder',
    aumico_admin_ar_template_table_actions: 'Aktion',
    aumico_admin_ar_template_specifications: 'Spezifikationen',
    aumico_admin_ar_template_pdf_error_notification_description_file_type_invalid:
        'PDF-Vorlage kann nicht hochgeladen werden: Dateityp muss .docx sein',
    aumico_admin_menu_item_demote_to_admin: 'Admin zurückstufen',
    aumico_admin_navigation_ar_templates: 'AR Templates',
    aumico_admin_menu_item_unblock_user: 'User entsperren',
    aumico_admin_menu_item_promote_to_admin: 'Als Admin definieren',
    aumico_admin_menu_item_block_user: 'User blockieren',
    aumico_admin_user_list_notification_failure_description:
        'Es ist ein Fehler aufgetreten, bitte versuchen Sie es später noch einmal oder kontaktieren Sie uns',
    aumico_admin_user_list_notification_success_title: 'Erfolgreich',
    aumico_admin_user_list_notification_success_description: 'User erfolgreich aktualisiert',
    aumico_admin_user_list_notification_failure_title: 'Fehler',
    aumico_admin_user_list_status_inactive: 'Inaktiv',
    aumico_admin_usermanagement_confirmation_modal_change_user_role: 'Do you want to change role of {email} from',
    aumico_admin_usermanagement_confirmation_modal_change_user_activity_state:
        'Möchten Sie den Status des folgenden Users {email} ändern?',
    aumico_admin_usermanagement_confirmation_modal_cancel_button: 'Abbrechen',
    aumico_admin_usermanagement_confirmation_modal_title_block_user: 'Benutzer blockieren',
    aumico_admin_usermanagement_confirmation_modal_title_promote_admin: 'Adminrechte erteilen',
    aumico_admin_usermanagement_confirmation_modal_title_unblock_user: 'User entsperren',
    aumico_admin_usermanagement_confirmation_modal_title_demote_admin: 'Adminrechte entfernen',
    aumico_admin_navigation_aumico_organization: 'aumico Organizations',
    aumico_annual_report_import_page_can_not_navigate_to_mapping_dialog_description:
        'Sie müssen zuerst Daten hochladen, um zum Schritt Mapping zu gelangen',
    aumico_annual_report_print_options_experimental_section: 'Eigenes Design erstellen',
    aumico_annual_report_print_options_experimental_section_description:
        'Passe das Layout des Jahresabschluss deinen Bedürfnissen an. Kontaktiere uns unter sales@aumico.ch. Wir melden uns so schnell wie möglich bei dir.',
    aumico_annual_report_print_options_aop: 'Gewinnverwendung',
    aumico_annual_report_print_options_fin_statement: 'Jahresabschluss',
    aumico_annual_report_print_options_hide_decimal_places_in_values: 'Dezimalstellen in den Werten ausblenden',
    aumico_annual_report_print_options_hide_decimal_places_in_ratios:
        'Dezimalstellen in den Verhältniskennzahlen ausblenden',
    aumico_annual_report_print_options_hide_empty_lines: 'Leere Zeilen entfernen',
    aumico_admin_user_list_status_active: 'Aktiv',
    aumico_annual_report_print_options_show_account_numbers: 'Kontonummer anzeigen',
    aumico_change_password_notification_success: 'Passwort erfolgreich geändert',
    aumico_change_password_notification_failed_title: 'Fehlgeschlagen!',
    aumico_change_password_relogin_title: 'Passwort geändert',
    aumico_change_password_relogin_description: 'Ihr Passwort wurde geändert. Bitte melden Sie sich erneut an.',
    aumico_change_password_relogin_failed_title: 'Erneut anmelden',
    aumico_change_password_relogin_failed_description: 'Ihr Passwort wurde nicht geändert. Bitte melden Sie sich erneut an.',
    aumico_change_password_relogin_button: 'Abmelden',
    aumico_change_password_notification_failed: 'Beim Ändern des Passworts ist ein Fehler aufgetreten',
    aumico_admin_usermanagement_confirmation_modal_confirm_button: 'Bestätigen',
    aumico_companies_form_country_has_no_legal_form: 'dieses Land enthält die von Ihnen ausgewählte Rechtsform nicht',
    aumico_editable_account_number_unique_validator: 'Kontonummer \ndarf nicht mehrmals vorkommen',
    aumico_editable_account_invalid_data_modal_title: 'ungültige Daten',
    aumico_editable_account_invalid_data_modal_content: 'Kontobezeichnung und Kontonummer sind erforderlich.',
    aumico_editable_account_placeholder_name: 'Kontobezeichnung',
    aumico_annual_report_country_has_no_legal_account_basis: 'Kein Kontenplan für das Land des Unternehmens verfügbar',
    aumico_editable_account_placeholder_opening_value: 'Vorjahr',
    aumico_general_information_autofill_date_popup_autofill_btn: 'Automatisch ausfüllen',
    aumico_editable_account_placeholder_number: 'Kontonummer',
    aumico_general_information_autofill_date_popup_no_autofill_btn: 'nicht automatisch ausfüllen',
    aumico_annual_report_print_options_experimental_section_text:
        'Bitte beachten Sie, dass die neuen Druckoptionen nur funktionieren, wenn Sie mit den neuen Button (Export PDF)  betätigen. Die Einstellungen im Testbereich werden nicht in der Vorschau angezeigt.',
    aumico_googleidp_invalid_code_error_message_title: 'Abgelaufener oder ungültiger Code',
    aumico_invitation_expired_description:
        'Es scheint, dass Ihr Einladungscode abgelaufen ist. Bitte kontaktieren Sie einen Administrator',
    aumico_notification_resend_email_failed_content:
        'E-Mail-Versand fehlgeschlagen, bitte versuchen Sie es später noch einmal',
    aumico_googleidp_invalid_code_error_message_content:
        'Ihre Bestätigungs-E-Mail ist abgelaufen. Klicken Sie hier, um die E-Mail erneut zu senden',
    aumico_notification_resend_email_success_content: 'E-Mail erfolgreich gesendet, bitte prüfen Sie Ihr E-Mail',
    aumico_notification_resend_email_success: 'Erfolgreich!',
    aumico_annual_report_print_options_notes: 'Anhang',
    aumico_reports_ar_templates_list_dialog_save_button: 'Ausgewählte Jahresbericht Vorlage speichern',
    aumico_notification_resend_email_failure: 'Fehlgeschlagen',

    aumico_reports_invitation_intro: 'Du wurdest eingeladen von {inviterName}',
    aumico_change_password_notification_success_title: 'Passwort geändert',
    aumico_reports_ar_templates_list_dialog_title: 'Jahresbericht-Vorlagen',
    aumico_reports_invite_new_users_dialog_input_placeholder: 'Add Email Address',
    aumico_reports_invite_users_email_already_exist_error_message:
        'Die folgenden E-Mails wurden nicht eingeladen, weil sie bereits in einer anderen Organisation existieren',
    aumico_reports_invite_users_cannot_invite_same_organization_users:
        'Die folgenden E-Mails wurden nicht eingeladen, weil sie bereits in deiner Organisation existieren',
    aumico_reports_organization_navigation_users: 'Benutzer',
    aumico_reports_invite_users_success_message: 'Ihre Einladung war erfolgreich',
    aumico_reports_invite_new_users_dialog_title: 'Neue User zur Organisation einladen',
    aumico_reports_invite_new_users_dialog_save_button: 'Einladen',
    aumico_reports_remove_users_success_message: 'Benutzer wurde erfolgreich entfernt',
    aumico_reports_organization_settings_text_snippets_form_dialog_update_success_notification_description:
        'Textvorlagen wurden erfolgreich aktualisiert',
    aumico_editable_account_placeholder_closing_value: 'Abschlussjahr',
    aumico_users_organization_change_organization_state_modal_confirm_no_action: 'Abbrechen',
    aumico_user_email_already_exists_error: 'Die E-Mail-Adresse wird bereits von einer anderen Organisation verwendet',
    aumico_reports_no_annualreport_template_defined:
        'Für die gewählte Rechtsform und Rechnungslegungsstandard und das angegebene Land gibt es keine Vorlage für den Jahresabschluss',
    aumico_reports_invite_users_wrong_data_error_message: 'Es wurden falsche Daten gesendet',
    aumico_general_information_autofill_date_popup_content:
        'Möchten Sie die restlichen Daten automatisch ausfüllen lassen?',
    aumico_users_organization_users_table_email_label: 'E-Mail',
    aumico_users_organization_users_remove_cancel_button: 'Abbrechen',
    aumico_reports_print_page_data_not_available: 'Kein Daten vorhanden',
    aumico_users_organization_users_table_phone_number_label: 'Telefon',
    aumico_users_organization_users_table_role_label: 'Rolle',
    aumico_reports_organization_settings_text_snippets_update_dialog_title: 'Textvorlagen aktualisieren',
    aumico_invitation_expired_title: 'Der Einladungscode ist abgelaufen',
    aumico_users_organization_change_organization_state_modal_confirm_action: 'Bestätigen',
    aumico_users_organization_change_organization_state_action: 'Status wechseln',
    aumico_reports_annualreport_navigation_print_using_pdf_tron: 'Export PDF',
    aumico_users_organization_users_remove_confirmation_button: 'Entfernen',
    aumico_users_organization_users_remove_confirmation_text:
        'Die ausgewählten Benutzer verlieren ihren Zugang zur Plattform. Bist du sicher, dass du sie entfernen möchtest?',
    aumico_reports_invite_new_users_dialog_input_label: 'E-Mail Adresse eingeben',
    aumico_users_organization_users_table_remove_users: 'Aus der Organisation entfernen',
    aumico_reports_invite_users_failure_okay_button_label: 'OK',
    aumico_reports_organization_settings_text_snippets_form_dialog_update_error_notification_description:
        'Aktualisierung des Textausschnittes fehlgeschlagen: Interner Serverfehler',
    aumico_reports_remove_users_user_removing_self_error_message: 'Sie können sich nicht selber als Benutzer entfernen',
    aumico_users_organization_change_organization_state_modal_title: 'Organisationsstatus wechseln',
    aumico_users_organization_users_table_name_label: 'Benutzer',
    aumico_admin_home_welcome_label: 'Wilkommen im Admin Interface!',
    aumico_reports_share_annual_report_dialog_text:
        'Möchte einen Finanzbericht abgeben. Möchten Sie den Anteil dieser Organisation akzeptieren?',
    aumico_reports_share_annual_report_success_notification_title: 'Shared successfully',
    aumico_reports_share_annual_report_success_notification_description: 'Your Annual Report has Shared Successfully',
    aumico_reports_share_annual_report_dialog_accept_button: 'Akzeptieren',
    aumico_reports_share_annual_report_dialog_decline_button: 'Abnehmen',
    aumico_annual_report_table_menu_option_per_row_secure_share: 'Share de-ch',
    aumico_reports_share_annual_report_dialog_title: 'Share Annual Report',
    aumico_reports_share_annual_report_dialog_content: 'You can share annual report with any email address',
    aumico_reports_invitation_dialog_validation_message_enter_valid_email: 'Please enter a valid email address',
    aumico_reports_share_annual_report_dialog_input_label: 'email',
    aumico_reports_share_annual_report_dialog_save_button: 'Share',
    aumico_reports_annualreport_footer_share_annual_report: 'Secure Share',
    aumico_reports_customer_attraction_dialog_title: 'Curious about how you can use aumico with your company ?',
    aumico_reports_customer_attraction_dialog_button_text: 'Talk to us',
    aumico_reports_customer_attraction_dialog_text_below_button: 'or call us: +12 345 67686',
    aumico_reports_customer_attraction_dialog_descriptive_text:
        'We have some great solutions for Pellentesque sem mi sapien diam sem sed porttitor. Feugiat ultrices molestie varius adipiscing vitae amet tempor amet. Pharetra vulputate sagittis bibendum. ',
    aumico_reports_share_annual_report_confirmation_dialog_message: 'Are you sure you want to share your report with: ',
    aumico_reports_share_annual_report_confirmation_go_back_cancel_button: 'Zurück',
    aumico_reports_share_annual_report_confirmation_dialog_save_button: 'Yes, Share',
    aumico_annual_report_print_only: 'Print',
    aumico_annual_reports_export_excel: 'Export Excel',
    aumico_admin_navigation_translations: 'Übersetzung',
    aumico_admin_translations_expand_all: 'Alle erweitern',
    aumico_admin_translations_collapse_all: 'Alle zuklappen',
    aumico_admin_translations_show_only_untranslated: 'Nur nicht übersetzte anzeigen',
    aumico_admin_translations_save: 'Speichern',
    aumico_admin_translations_notes_types: 'Anhangspunkte',
    aumico_admin_translations_notes_templates: 'Anhang Templates',
    aumico_admin_translations_accounting_bases: 'Rechnungslegungsstandard',
    aumico_admin_translations_tasks: 'Aufgaben',
    aumico_admin_translations_checklists: 'Checklisten',
    aumico_admin_translations_legal_forms: 'Rechtsform',
    aumico_admin_translations_financial_line_items: 'Finanzposten',
    aumico_admin_translations_groups: 'Gruppen',
    aumico_admin_translations_name_column_header: 'Name',
    aumico_reports_error_dialog_bad_request: 'Bad request',
    aumico_reports_error_dialog_bad_request_first_and_last_names_required: 'Vor- und Nachname sind erforderlich',
    aumico_reports_error_dialog_bad_request_phone_number_invalid:
        'Die Telefonnummer muss das richtige Format haben und darf nicht leer sein. Korrektes Format: +<Ländercode><Telefonnummer>',
    aumico_annual_report_print_preview_fcp: 'Prozessdokumentation',
    aumico_annual_report_print_preview_fas: 'Anlagespiegel',
    aumico_annual_report_fas_section_costs_title: 'Anschaffungs- und Herstellungskosten',
    aumico_annual_report_fas_section_depr_title: 'Abschreibungen',
    aumico_annual_report_fas_section_valAppr_title: 'Zuschreibungen',
    aumico_annual_report_fas_select_reference: 'Referenz auswählen',
    aumico_annual_report_fas_remove_group: 'Gruppe löschen',
    aumico_annual_report_fas_add_group: 'Gruppe hinzufügen',
    aumico_annual_report_fas_remove_column: 'Spalte entfernen',
    aumico_annual_report_fas_add_column: 'Spalte hinzufügen',
    aumico_annual_report_fas_costs: 'AHK',
    aumico_annual_report_fas_additions_column: 'Zugänge',
    aumico_annual_report_fas_disposals_column: 'Abgänge',
    aumico_annual_report_fas_transfers_column: 'Umbuchungen',
    aumico_annual_report_fas_depr_additions_column: 'Abschreibungen der Periode',
    aumico_annual_report_fas_depr_disposals_column: 'Abgänge',
    aumico_annual_report_fas_depr_transfers_column: 'Umbuchungen',
    aumico_annual_report_fas_depr_cumulated: 'kumulierte Abschreibungen',
    aumico_annual_report_fas_valueAppreciation: 'Zuschreibungen',
    aumico_annual_report_fas_bookvalue_current: 'Buchwert',
    aumico_annual_report_fas_bookvalue_previous: 'Buchwert',
    aumico_annual_report_fas_depreciations: 'kumulierte Abschreibungen',
    aumico_annual_report_fas_direct_assigned_accounts: 'direkt zugewiesene Konten (gruppiert)',
    aumico_annual_report_fas_file_upload_instruction_label: 'Anlagespiegel hochladen',
    aumico_annual_report_datev_error_detected:
        'Wir haben mindestens einen Fehler entdeckt! Bitte korrigieren sie die Fehler oder verwenden Sie eine andere Datei.',
    aumico_annual_report_datev_error_malformatted_file: 'Fehlerhafte Datei',
    aumico_annual_report_datev_error_wrong_asset_data: 'Aktiva können nicht interpretiert werden',
    aumico_annual_report_datev_error_wrong_liabilties_data: 'Passiva können nicht interpretiert werden',
    aumico_annual_report_datev_error_wrong_income_data: 'GuV kann nicht interpretiert werden',
    aumico_annual_report_datev_error_root_node_empty: 'Erstes Element ist leer',
    aumico_annual_report_datev_master_file_detected:
        'Wir haben einen DATEV Masterdata Import erkannt. Bitte klicke "Speichern und Weiter", falls du die Taxonmie und die Konten importieren möchtest.',
    aumico_annual_report_datev_account_file_detected:
        'Wir haben einen DATEV Konten Import erkannt. Bitte klicke "Speichern und Weiter", falls du die Konten importieren möchtest.',
    aumico_annual_report_show_settings: 'Einstellungen anzeigen',
    aumico_annual_report_hide_settings: 'Einstellungen ausblenden',
    aumico_annual_report_special_flis_form_title: 'Spezielle Finanzposten',
    aumico_annual_report_special_flis_form_intro:
        'Wählen Sie die Finanzposten aus, welche eine spezielle Funktion erfüllen.',
    aumico_annual_report_special_flis_equity_group_label: 'Eigenkapital',
    aumico_annual_report_special_flis_profit_fli_label: 'Gewinn/Verlust',
    aumico_annual_report_special_flis_uncoveredShortfallAssets_label: 'Nicht gedeckter Fehlbetrag in Aktiva',
    aumico_annual_report_special_flis_uncoveredShortfallLiabilities_label: 'Nicht gedeckter Fehlbetrag in Passiva',
    aumico_annual_report_special_flis_field_required_error: 'Eingabe ist erforderlich',
    aumico_annual_report_special_flis_please_select: 'Bitte auswählen',
    aumico_report_fas_print_subtotal: 'Summe',
    aumico_report_fas_print_section_costs_title: 'Anschaffungs- und Herstellungskosten',
    aumico_report_fas_print_section_depr_title: 'kumulierte Abschreibungen',
    aumico_report_fas_print_section_valueApr_title: 'Zuschreibungen der Periode',
    aumico_report_fas_print_section_bookvalue_current: 'Buchwert',
    aumico_report_fas_print_section_bookvalue_previous: 'Buchwert',
    aumico_report_fas_print_costs_additions: 'Zugänge Kosten',
    aumico_report_fas_print_costs_disposals: 'Abgänge Kosten',
    aumico_report_fas_print_costs_transfers: 'Übertrag Kosten',
    aumico_report_fas_print_depreciations_additions: 'Abschreibungen der Periode',
    aumico_report_fas_print_depreciations_disposals: 'Abgänge',
    aumico_report_fas_print_depreciations_transfers: 'Übertrag Abschreibungen',
    aumico_report_fas_print_value_appreciation: 'Wertzuwachs',
    aumico_annual_report_table_label_share_date: 'Geteilt am',
    aumico_annual_report_export_to_word: 'Export Word',
    aumico_annual_report_aop_profit_calculation_custom_account_name_placeholder: 'Kontobezeichnung eingeben',
    aumico_annual_report_aop_profit_calculation_account_caption_form_field_label: 'Andere Bezeichnung',
    aumico_users_edit_user_general_information_name_required: 'Der Vorname ist erforderlich',
    aumico_users_edit_user_general_information_surname_required: 'Der Nachname ist erforderlich',
    aumico_users_edit_user_general_information_phone_invalid:
        'Die Telefonnummer ist ungültig. Es sollte im Format von +<Ländercode><Telefonnummer>',
    aumico_annual_report_print_options_show_balance_account_proof: 'Kontennachweis Bilanz',
    aumico_annual_report_print_options_show_income_account_proof: 'Kontennachweis GuV',
    aumico_annual_report_print_preview_account_proof_for_balance: 'Kontennachweis Bilanz',
    aumico_annual_report_print_preview_account_proof_for_income: 'Kontennachweis Gewinn- und Verlustrechnung',
    aumico_templates_group_account_mapping_add_subtotal: 'Zwischensumme',
    aumico_templates_group_account_mapping_add_subtotal_form_group_options_label: 'Gruppe wählen',
    aumico_templates_group_account_mapping_add_subtotal_form_group_options: 'Gruppen',
    aumico_templates_group_account_mapping_add_fli: 'Posten',
    aumico_templates_fli_form_cash_flow_types: 'Geldfluss-Typ',
    aumico_templates_fli_form_cash_flow_options_label: 'Geldfluss-Typ wählen',
    aumico_templates_fli_form_fli_types: 'Posten-Typ',
    aumico_templates_fli_form_fli_type_options_label: 'Posten-Typ wählen',
    aumico_templates_fli_form_groups: 'Gruppe',
    aumico_templates_fli_form_group_options_label: 'Gruppe wählen',
    aumico_templates_group_account_mapping_cash_flow_type_none: 'Nicht relevant',
    aumico_templates_group_account_mapping_cash_flow_type_operations: 'Operativ',
    aumico_templates_group_account_mapping_cash_flow_type_networking_capital: 'Nettoumlaufvermögen',
    aumico_templates_group_account_mapping_cash_flow_type_investing: 'Investitionstätigkeit',
    aumico_templates_group_account_mapping_cash_flow_type_financing: 'Finanzierungstätitkgeit',
    aumico_templates_group_account_mapping_fli_type_assets: 'Aktiva',
    aumico_templates_group_account_mapping_fli_type_liabilities: 'Passiva',
    aumico_templates_group_account_mapping_fli_type_income: 'Einkommen',
    aumico_templates_group_account_mapping_fli_type_expenses: 'Aufwand',
    aumico_organization_settings_print_closing_value_totals_in_separate_columns: 'Summe in separaten Spalten drucken',
    aumico_organization_settings_display_assets_and_liabilities_in_same_page:
        'Aktiva und Passiva im Querformat drucken (Deutschland)',
    aumico_organization_settings_print_success_notification_title: 'Erfolgreich',
    aumico_organization_settings_print_success_notification_description:
        'Organisationseinstellungen erfolgreich gespeichert',
    aumico_templates_group_account_mapping_add_more_items_of_that_item_checkbox: 'Als Davonposten erstellen',
    aumico_templates_group_account_mapping_of_that_item_text: '{ davon }',
    aumico_annual_report_fas_accounts_select_reference_placeholder: 'Referenz auswählen',
    aumico_users_organization_upload_pdf_template_action: 'Pdf Template hochladen',
    aumico_users_organization_reset_to_default_template_action: 'Auf Standardvorlage zurücksetzen',
    aumico_users_organization_reset_to_default_template_action_success: 'Zurücksetzen auf Standardvorlage erfolgreich',
    aumico_users_organization_reset_to_default_template_action_failed:
        'Zurücksetzen auf Standardvorlage fehlgeschlagen',
    aumico_users_organization_upload_pdf_template_failure_notification_description:
        'Berichtsvorlage konnte nicht hochgeladen werden',
    aumico_users_organization_upload_pdf_template_success_notification_description:
        'Berichtsvorlage wurde erfolgreich hochgeladen',
    aumico_reports_print_page_fixed_assets_schedule_invalid_warning:
        'Anlagenspiegel ist ungültig gegenüber Mapping-Daten',
    aumico_reports_referral_invite_notification_failure_title: 'Referral Einladung',
    aumico_reports_referral_invite_notification_failure_description: 'Referral Mail konnte nicht gesendet werden',
    aumico_reports_referral_invite_notification_success_title: 'Referral Einladung',
    aumico_reports_referral_invite_notification_success_description: 'Referral Mail erfolgreich versendet',
    aumico_annual_report_complementary_reports_autofill_button: 'Autofill vom Vorjahr',
    aumico_annual_report_complementary_reports_autofill_dialog_description:
        'Bist du sicher, dass du deine ergänzenden Berichte mit denen des Vorjahres überschreiben möchtest?',
    aumico_annual_report_complementary_reports_autofill_dialog_yes: 'Ja',
    aumico_annual_report_complementary_reports_autofill_dialoh_cancel: 'Abbrechen',
    aumico_admin_ar_template_navigation_settings: 'Einstellungen',
    aumico_admin_ar_template_settings_title: 'Einstellungen definieren',
    aumico_admin_ar_template_settings_uncovered_shortfall: 'Ungedeckter Fehlbetrag',
    aumico_organization_settings_uncoveredShortfall: 'Ungedeckter Fehlbetrag',
    aumico_templates_account_mapping_form_apply_uncovered_shortfall: 'Ungedeckter Fehlbetrag einfügen',
    aumico_templates_switch_accounts_dialog_title: 'Wechselkonten definieren',
    aumico_templates_switch_accounts_dialog_initial_situation: 'Ausgangslage',
    aumico_templates_switch_accounts_dialog_preview_output: 'Vorschau Ausgabe',
    aumico_templates_switch_accounts_dialog_drop_account: 'Wohin möchtest du das Konto zuordnen?',
    aumico_templates_switch_accounts_dialog_selection_label: 'Posten oder Unterposten zuordnen',
    aumico_templates_switch_accounts_dialog_selection_placeholder: 'Posten oder Unterposten auswählen',
    aumico_templates_switch_accounts_dialog_error_mandatory_selection:
        'Du musst einen Posten oder Unterposten auswählen',
    aumico_reports_share_not_found: 'Die Aktie muss vorher zurückgezogen, abgelaufen oder abgelehnt worden sein',
    aumico_organization_settings_show_shareholder_info: 'Aktionärsinformationen anzeigen',
    aumico_annual_report_print_options_label_show_shareholderInformation: 'Aktionärsinformationen anzeigen',
    aumico_templates_fli_form_error_name_already_exists: 'Posten besteht bereits',
    aumico_templates_mapping_engine_equity_group_not_defined_title: 'Fehler ungedeckter Fehlbetrag',
    aumico_templates_mapping_engine_equity_group_not_defined_description:
        'Eigenkapital ist in der Bilanztaxonomie nicht definiert',
    aumico_templates_account_mapping_form_uncovered_shortfall_assets_fli_caption: 'Ungedeckter Fehlbetrag',
    aumico_templates_account_mapping_form_uncovered_shortfall_equity_fli_caption: 'Ungedeckter Fehlbetrag',
    aumico_templates_account_mapping_form_uncovered_shortfall_assets_account_name: 'Konto ungedeckter Fehlbetrag',
    aumico_templates_account_mapping_form_uncovered_shortfall_equity_account_name: 'Konto ungedeckter Fehlbetrag',
    aumico_templates_form_equity_group: 'Eigenkapital Gruppe wählen',
    aumico_templates_form_uncovered_shortfall_assets_fli: 'Bitte wähle den Aktiva Posten vom ungedeckten Fehlbetrag',
    aumico_templates_form_uncovered_shortfall_liabilities_fli:
        'Bitte wähle den Passiva Posten vom ungedeckten Fehlbetrag',
    aumico_templates_form_add_hidden_group: 'Gruppe einrücken',
    aumico_templates_form_create_sub_fli_or_of_that_item: 'Unterposten / Davonposten hinzufügen',
    aumico_annual_report_import_indicate_shareholder_column: 'Aktionärsspalte angeben',
    aumico_admin_ar_template_settings_show_shareholder_information: 'Aktionärsinformationen anzeigen',
    aumico_companies_form_label_tax_domicile: 'Finanzamt',
    aumico_companies_form_label_GICSCode: 'Industrie',
    aumico_reports_annualreport_navigation_balance_account_proof: 'Kontennachweis Bilanz',
    aumico_reports_annualreport_navigation_income_account_proof: 'Kontennachweis Gewinn- und Verlustrechnung',
    aumico_templates_mapping_remove_group_warning_dialog_text:
        'Das Entfernen dieser Gruppe führt dazu, dass alle anderen Schritte, die diese Gruppe oder ein Element innerhalb dieser Gruppe verwenden, zurückgesetzt werden. Bist du sicher, dass du diese entfernen willst?',
    aumico_templates_mapping_remove_item_warning_dialog_cancel_button: 'Abbrechen',
    aumico_templates_mapping_remove_item_warning_dialog_remove_button: 'Entfernen',
    aumico_templates_mapping_remove_item_warning_dialog_text:
        'Das Entfernen dieses Elements führt zum Zurücksetzen aller anderen Schritte, die es verwenden. Bist du sicher, dass du es entfernen willst?',
    aumico_reports_accept_policy_dialog_title: 'Update AGB, Datenschutz, ADV',
    aumico_reports_accept_policy_dialog_first_paragraph:
        'Am 1. September ist das revidierte Bundesgesetz über den Datenschutz (DSG) in Kraft getreten. In diesem Zusammenhang haben wir unsere ',
    aumico_reports_accept_policy_dialog_first_paragraph_the: 'die',
    aumico_reports_accept_policy_dialog_first_paragraph_as_well_as_those: 'sowie die',
    aumico_reports_accept_policy_dialog_first_paragraph_adjusted: 'angepasst',
    aumico_reports_accept_policy_dialog_second_paragraph:
        'Die überarbeiteten Versionen sind nun vollständig konform mit dem neuen Schweizer Datenschutzrecht, sowie der Europäischen Datenschutz Grundverordnung (DSGVO). Sie finden die neuen Bestimmungen unter den oben aufgeführten Links oder auf  https://aumico.io/. Die neuen Bestimmungen gelten rückwirkend auf den 1. September 2023.',
    aumico_reports_accept_policy_dialog_third_paragraph:
        'Bitte akzeptiere hier unsere neuen AGB, die Datenschutzbestimmungen, sowie die Vereinbarung zur Auftragsdatenverarbeitung, um aumico weiter nutzen zu können.',
    aumico_reports_accept_policy_dialog_privacy_policy: 'Datenschutzbestimmungen',
    aumico_reports_accept_policy_dialog_terms_and_conditions: 'Allgemeinen Geschäftsbedingungen (AGB),',
    aumico_reports_accept_policy_dialog_agreement_on_data_processing:
        'Vereinbarung zur Auftragsdatenverarbeitung (ADV)',
    aumico_reports_accept_policy_to_continue_dialog_first_paragraph:
        'Bist du sicher, dass du aumico nicht weiter nutzen möchtest?',
    aumico_reports_accept_policy_to_continue_dialog_second_paragraph:
        'Wenn du den neuen Bestimmungen nicht zustimmst, kannst du aumico nicht weiter nutzen. Alle Daten deiner Organisation werden innerhalb von 30 Tagen gelöscht.',
    aumico_reports_accept_policy_to_continue_dialog_third_paragraph: 'Bei Fragen  wende dich an ',
    aumico_reports_accept_policy_to_continue_dialog_third_paragraph_contact_email: 'privacy@aumico.ch',
    aumico_reports_accept_policy_to_continue_dialog_i_agree_button: 'Ich stimme zu',
    aumico_reports_accept_policy_to_continue_dialog_decline_policy_button: 'Mein Account löschen ',
    aumico_users_registration_privacy_policy: 'Datenschutzbestimmungen',
    aumico_users_registration_prices: 'Preise,',
    aumico_users_registration_terms_and_conditions: 'Allgemeinen Geschäftsbedingungen,',
    aumico_users_registration_text_between_links:
        'von aumico gelesen und erkläre mich damit einverstanden. Weiter habe ich die',
    aumico_users_registration_text_after_links: 'von aumico zur Kenntnis genommen',
    aumico_users_registration_agreement_on_data_processing: 'Vereinbarung zur Auftragsdatenverarbeitung',
    aumico_annual_report_account_proof_display_account_number_column_header: 'Konto',
    aumico_annual_report_account_proof_display_account_name_column_header: 'Bezeichnung',
    aumico_templates_template_account_mapping_form_show_details: 'Details anzeigen',
    aumico_templates_template_account_mapping_form_hide_details: 'Details ausblenden',
    aumico_templates_group_account_mapping_create_group: 'Gruppe',
    aumico_templates_group_account_mapping_create_group_form_fli_options_label: 'Finanzposten auswählen',
    aumico_templates_group_account_mapping_create_group_form_fli_options: 'Finanzposten auswählen',
    aumico_templates_group_account_mapping_create_group_form_name_label: 'Name der Gruppe',
    aumico_templates_group_account_mapping_create_group_form_name: 'Name der Gruppe',
    aumico_templates_group_account_mapping_create_group_form_name_required_error: 'Name der Gruppe ist zwingend',
    aumico_templates_group_account_mapping_create_group_form_name_already_exists_error:
        'Name der Gruppe existiert bereits',
    aumico_templates_group_account_mapping_create_group_form_total_name_required_error:
        'Name Gruppentotal ist zwingend',
    aumico_templates_group_account_mapping_create_group_form_total_name_label: 'Name Gruppentotal',
    aumico_templates_group_account_mapping_create_group_form_total_name: 'Name Gruppentotal',
    aumico_templates_group_account_mapping_create_group_form_button: 'Speichern',
    aumico_templates_group_account_mapping_there_is_an_empty_group_warning:
        'Es gibt eine oder mehrere Gruppen, die keine Finanzposten enthalten',
    aumico_annual_report_print_options_title_and_signature: 'Titel und Unterschrift',
    aumico_reports_equality_check_print_preview_hide_details: 'Details ausblenden',
    aumico_reports_equality_check_print_preview_show_details: 'Details anzeigen',
    aumico_templates_group_account_mapping_menu_edit: 'Bearbeiten',
    aumico_templates_group_account_mapping_switch_account: 'Wechselkonten',
    aumico_templates_group_account_mapping_add_account: 'Konto hinzufügen',
    aumico_templates_group_account_mapping_add_sub_total: 'Zwischensumme',
    aumico_templates_group_account_mapping_add_group: 'Gruppen',
    aumico_templates_group_account_mapping_add_empty_space_above: 'Abstand oben einfügen',
    aumico_templates_group_account_mapping_add_empty_space_below: 'Abstand unten einfügen',
    aumico_templates_group_account_mapping_add_header_above: 'Titel oben einfügen',
    aumico_templates_group_account_mapping_add_header_below: 'Titel unten einfügen',
    aumico_users_registration_country_placeholder: 'Land auswählen',
    aumico_users_registration_country_label: 'Standort deiner Firma',
    aumico_users_registration_country_required_error: 'Länderauswahl ist erforderlich',
    aumico_users_registration_country_tool_tip_message:
        'Die Länderauswahl ist entscheidend für die Einhaltung der Datenschutzbestimmungen deines Unternehmens.',
    aumico_templates_group_account_mapping_fli_disable_numbering: 'Nummerierung entfernen',
    aumico_templates_group_account_mapping_fli_enable_numbering: 'Nummerierung hinzufügen',
    aumico_annual_report_print_options_show_fas: 'Anlagespiegel',
    aumico_annual_report_display_current_date_column_header: 'Geschäftsperiode',
    aumico_annual_report_display_previous_date_column_header: 'Vorperiode',

    aumico_templates_account_mapping_form_transferred_surplus_account_name: 'Jahresüberschuss /-fehlbetrag',
    aumico_templates_subtotal_form_subtotal_scope: 'Bereich',
    aumico_templates_subtotal_form_subtotal_position: 'Position davor wählen',

    aumico_annual_report_special_flis_annual_surplus_fli_label: 'Jahresüberschuss',
    aumico_annual_report_general_information_select_locale: 'Berichtssprache wählen',

    aumico_templates_account_mapping_form_map_income_total_to_annual_surplus: 'Jahresergebnis aus GuV übertragen',
    aumico_annual_report_general_information_report_language: 'Berichtsprache',
    aumico_reports_annualreport_print_label_previous_year: 'Vorjahr',
    aumico_reports_annualreport_print_label_current_year: 'Geschäftsjahr',
    aumico_reports_annualreport_print_label_ratio: 'Prozent',
    aumico_reports_annualreport_print_label_taxdomicile: 'Finanzamt',
    aumico_reports_annualreport_print_label_taxid: 'Steuer-Nr.',
    aumico_reports_annualreport_print_label_assets: 'AKTIVA',
    aumico_reports_annualreport_print_label_liabilities: 'PASSIVA',
    aumico_reports_annualreport_print_label_page: 'Blatt',
    aumico_annual_report_general_information_update_company_btn_text: 'Firmendaten aktualisieren',
    aumico_reports_general_info_company_update_confirm: 'Aktualisieren',
    aumico_reports_general_info_company_update_cancel: 'Abbrechen',
    aumico_reports_general_info_company_update_confirmation_text:
        'Möchtest du die Unternehmensdaten in diesem Bericht anpassen?',
    aumico_reports_general_info_update_company_success_notification_title: 'Aktualisierung erfolgreich',
    aumico_reports_general_info_update_company_success_notification_description:
        'Unternehmensdaten wurden erfolgreich aktualisiert',
    aumico_reports_company_legal_form_update_confirmation_text:
        'Möchtest du die Unternehmensdaten aktualisieren? Eine Änderung der Rechtsform wird sich auf die Struktur der Bilanz und der GuV auswirken.',
    aumico_templates_group_account_mapping_duplicate_account: 'Konto duplizieren',
    aumico_templates_group_account_mapping_duplicate_account_form_of_that_items_options: 'Davonposten wählen',
    aumico_templates_group_account_mapping_duplicate_account_form_of_that_items_options_label: 'Davonposten wählen',
    aumico_templates_group_account_mapping_duplicate_account_form_button: 'Konto duplizieren',
    aumico_general_information_no_template_for_your_combination: 'Keine Vorlage für deine Kombination',
    aumico_general_information_no_template_for_your_combination_content_1:
        'Sorry, wir haben keine Vorlage für die Kombination aus Rechtsform und Rechnungslegungsstandard gefunden. Bitte prüfe deine Auswahl',
    aumico_general_information_no_template_for_your_combination_content_2:
        'Du kannst uns auch unter support@aumico.ch kontaktieren. Wir helfen dir gerne weiter.',
    aumico_dialog_error: 'Fehler',
    aumico_dialog_error_too_many_requests:
        'Hoppla! Es sieht so aus, als ob zu viele Anfragen auf einmal gestellt wurden. Bitte warten Sie einen Moment und laden Sie die Seite neu. Wir danken Ihnen für Ihre Geduld.',
    aumico_notes_input_options_compare_years: 'Jahre vergleichen',
    aumico_notes_input_options_text: 'Text',
    aumico_notes_input_options_data_type: 'Art der Werte auswählen',
    aumico_notes_input_options_number_of_decimal_places: 'Anzahl der Stellen nach dem Komma',
    aumico_notes_input_options_use_as_parameter: 'Verfügbar als Berichtsparameter',
    aumico_notes_input_options_parameter_name: 'Parametername eingeben',
    aumico_notes_input_options_data_type_text: 'Text',
    aumico_notes_input_options_data_type_number: 'Nummer',
    aumico_notes_input_options_data_type_currency: 'Währung',
    aumico_reports_main_navigation_company_valuation: 'Steuerwert berechnen',
    aumico_reports_company_valuation_navigation_valuation_report: 'Steuerwert',
    aumico_reports_company_valuation_report_title: 'Automatische Berechnung des Steuerwertes für deine Mandanten',
    aumico_reports_company_valuation_report_descriptive_text_1:
        'Auf der Grundlage der letzten Jahresabschlüsse deiner Mandanten.',
    aumico_reports_company_valuation_report_descriptive_text_2:
        'Erhalte innerhalb von zwei Arbeitstagen eine umfassende Steuewert-Berechnung.',
    aumico_reports_company_valuation_report_descriptive_text_3:
        'Erhalte einen 4-seitigen Bericht in deinem Posteingang, für CHF 49 pro Bericht (ohne MwSt.)',
    aumico_reports_company_valuation_report_download_button_text: 'Musterbericht herunterladen',
    aumico_reports_company_valuation_report_order_button_text: 'Bericht bestellen',
    aumico_reports_company_valuation_dialog_title: 'Steuerwert Report bestellen',
    aumico_reports_company_valuation_dialog_text:
        'Die Steuerwert-Berechnung kostet CHF 49 pro Bericht (ohne Mehrwertsteuer). Der Bericht wird innerhalb von zwei Arbeitstagen zugestellt. Mit der Auftragserteilung erklärst Du dich damit einverstanden, dass aumico die Finanzdaten des Auftraggebers für die Erstellung des Bewertungsgutachtens weiterverarbeitet.',
    aumico_reports_company_valuation_dialog_place_order_button_text: 'Bestellen',
    aumico_reports_company_valuation_confirmation_dialog_content_title: 'Bestellbestätigung',
    aumico_reports_company_valuation_confirmation_dialog_text:
        'Wir haben deine Bestellung erhalten. Du erhältst den Bericht innerhalb von zwei Arbeitstagen.',
    aumico_reports_company_valuation_confirmation_dialog_button_text: 'Fertig',
    aumico_reports_valuation_report_announcement_dialog_title: 'Steuerwert-Berechnung entdecken',
    aumico_reports_valuation_report_announcement_dialog_content_1:
        'Erstelle eine Steuerwert-Berechnung für deine Mandanten nach der Praktiker-Methode.',
    aumico_reports_valuation_report_announcement_dialog_content_2:
        'Wähle den Kunden aus, für den du den Bericht erstellen möchtest. Bestätige die Auswahl und erhalte innerhalb von 2 Arbeitstagen die Steuerwert-Berechnungen.',
    aumico_reports_valuation_report_announcement_dialog_content_3:
        'Biete deinen Mandanten einen Mehrwert und sende ihnen mit jeder Jahresrechnung eine Steuerwert-Berechnung.',
    aumico_reports_valuation_report_announcement_dialog_button_text: 'Mehr erfahren',
    aumico_annual_report_main_navigation_new: 'NEU',
    aumico_reports_company_valuation_dialog_select_company: 'Unternehmen auswählen',
    aumico_confirmation_modal_cancel_button: 'Abbrechen',
    aumico_confirmation_modal_delete_button: 'Löschen',
    aumico_edit_notes_toggle: 'Anhang bearbeiten',
    aumico_add_notes_button: 'Abschnitt hinzufügen',
    aumico_add_notes_component_button: 'Neue Komponente hinzufügen',
    aumico_new_note_placeholder: 'Neuer Anhang',
    aumico_confirmation_modal_notes_deletion:
        'Willst du diesen Abschnitt des Anhanges wirklich löschen? Dieser Abschnitt wird endgültig gelöscht.',
    aumico_confirmation_modal_notes_component_deletion:
        'Willst du diesen Teil des Anhanges wirklich löschen? Die Inhalte werden bei Bestätigung endgültig gelöscht.',
    aumico_notes_add_all_text: 'Textfeld hinzufügen',
    aumico_notes_movement_schedule: 'Spiegel',
    aumico_notes_fli_table: 'Aufriss',
    aumico_notes_simple_input: 'Einfache Eingabetabelle',
    aumico_notes_equity_table: 'Auflistung Beteiligungen',
    aumico_add_to_notes_button: 'Zum Anhang hinzufügen',
    aumico_add_to_notes_dialog_title: 'Auswahl von Anhangstypen',
    aumico_notes_extra_settings: 'Erweiterte Einstellungen',
    aumico_notes_extra_settings_title: 'Gib hier den Titel der Tabelle ein (optional)',
    aumico_notes_select_option_description: 'Beschreibung (optional)',
    aumico_notes_select_options: 'Optionen',
    aumico_notes_extra_settings_add_option: 'Zusätzlicher Dropdown Wert',
    aumico_notes_extra_settings_options: 'Dropdown Werte',
    aumico_notes_extra_settings_option: 'Dropdown Wert',
    aumico_notes_super_table_options_title: 'Titel',
    aumico_notes_super_table_options_col_type: 'Spalten Typ',
    aumico_notes_super_table_col_title: 'Spalten Titel',
    aumico_notes_super_table_options_segment_type: 'Segment Typ',
    aumico_notes_super_table_segment_title: 'Übertitel',
    aumico_notes_super_table_options_col_type_current_year: 'Aktuelles Jahr',
    aumico_notes_super_table_options_col_type_previous_year: 'Vorjahr',
    aumico_notes_super_table_options_col_type_text: 'Text',
    aumico_notes_super_table_options_col_type_number: 'Zahlen',
    aumico_notes_super_table_options_segment_type_basic: 'Basis Segment',
    aumico_notes_super_table_options_segment_type_total: 'Total Segment',
    aumico_notes_super_table_options_col_belonging_year_current: 'Aktuelles Jahr',
    aumico_notes_super_table_options_col_belonging_year_previous: 'Vorjahr',
    aumico_notes_super_table_options_col_belonging_year: 'Betreffendes Jahr',
    aumico_notes_super_table_segment_child_columns: 'Dem Übertitel zuzuordnende Spalten',
    aumico_notes_super_table_options_define_columns: 'Spalten wählen',
    aumico_notes_super_table_options_define_segments: 'Segment wählen',
    aumico_notes_super_table_add_row: 'Zeile hinzufügen',
    aumico_notes_super_table_add_row_menu_option_select_from_balance: 'Konten aus Bilanz',
    aumico_notes_super_table_add_row_menu_option_select_from_income: 'Konten aus GuV',
    aumico_notes_super_table_add_row_menu_option_add_calculation: 'Kalkulierte Zeile',
    aumico_notes_super_table_add_row_menu_option_add_title_row: 'Titelzeile',
    aumico_notes_super_table_add_row_menu_option_add_space_row: 'Leere Zwischenzeile',
    aumico_notes_super_table_add_row_menu_option_add_free_text_row: 'Zeile mit manueller Eingabe',
    aumico_notes_super_table_add_row_menu_option_add_rate: 'Kurszeile',
    aumico_notes_super_table_add_rate_row_title: 'Kurszeile hinzufügen',
    aumico_notes_super_table_add_rate_select_source: 'Welchen Kurs soll die Zeile anzeigen?',
    aumico_notes_super_table_rate_source_closing: 'Stichtagskurs',
    aumico_notes_super_table_rate_source_average: 'Durchschnittskurs',
    aumico_notes_super_table_rate_source_position: 'Kurs einer Position',
    aumico_annual_report_fx_notes_reserve_label: 'Umrechnungsreserve',
    aumico_notes_fli_currency_chip_tooltip: 'Wechselt die Währungsspalten dieser Tabelle: Funktionalwährung → beide → Darstellungswährung',
    aumico_annual_report_print_options_fx_accordion_title: 'Funktionalwährung',
    aumico_annual_report_print_options_fx_show_statement_display_columns: 'Bilanz & GuV in beiden Währungen',
    aumico_notes_super_table_add_row_menu_option_add_text_row: 'Textzeile',
    aumico_notes_super_table_add_row_menu_option_create_segments: 'Übertitel (Segment)',
    aumico_notes_super_table_current_value_placeholder: 'Wert aktuelles Jahr einfügen',
    aumico_notes_super_table_previous_value_placeholder: 'Wert Vorjahr einfügen',
    aumico_notes_super_table_numeric_value_placeholder: 'Zahl eingeben',
    aumico_notes_super_table_text_value_placeholder: 'Text eingeben',
    aumico_notes_super_table_data_selection_title: 'Zeile hinzufügen',
    aumico_notes_super_table_data_selection_label:
        'Wähle die Werte aus dem Mapping aus, die in dieser Zeile zusammengefasst werden sollen.',
    aumico_notes_super_table_create_segment_title: 'Übertitel (Segment)',
    aumico_notes_super_table_enter_here: 'Hier auswählen',
    aumico_notes_super_table_create_segment_select_columns_placeholder:
        'Wähle die Spalten, die zu einem Segment zusammengefasst werden sollen.',
    aumico_notes_super_table_create_segment_save_button: 'Übertitel (Segment) hinzufügen',
    aumico_notes_super_table_add_calculation_row_title: 'Zeile mit Kalkulation',
    aumico_notes_super_table_add_calculation_column_title: 'Spalte mit Kalkulation',
    aumico_notes_super_table_add_caclulation_select_calculation_type:
        'Wähle die Kalkulation aus, die vorgenommen werden soll:',
    aumico_notes_super_table_add_calculation_function_summation: 'Addition',
    aumico_notes_super_table_add_calculation_function_ratio: 'Verhältniskennzahl %',
    aumico_notes_super_table_add_calculation_function_subtraction: 'Subtraktion',
    aumico_notes_super_table_add_calculation_function_multiplication: 'Multiplikation',
    aumico_notes_super_table_add_calculation_title_placeholder: 'Titel',
    aumico_notes_super_table_add_calculation_button: 'Kalkulation hinzufügen',
    aumico_notes_super_table_add_calculation_select_relation_item_placeholder: 'In Relation zu',
    aumico_notes_super_table_add_calculation_select_column_placeholder:
        'Für welche Spalten möchtest Du den berechneten Wert abbilden?',
    aumico_notes_super_table_add_calculation_select_column_placeholder_SUM:
        'Wähle die Spalten, die summiert werden sollen.',
    aumico_notes_super_table_add_calculation_select_column_placeholder_MUL:
        'Wähle die Spalten, die multipliziert werden sollen.',
    aumico_notes_super_table_add_calculation_select_column_placeholder_RATIO:
        'Wähle die Spalte, für die das Verhältnis ermittelt werden soll.',
    aumico_notes_super_table_add_calculation_select_rows_placeholder_SUM:
        'Wähle die Zeilen, die summiert werden sollen.',
    aumico_notes_super_table_add_calculation_select_rows_placeholder_MUL:
        'Wähle die Zeilen, die multipliziert werden sollen.',
    aumico_notes_super_table_add_calculation_select_rows_placeholder_RATIO:
        'Wähle die Zeilen, für die das Verhältnis ermittelt werden soll.',
    aumico_notes_super_table_add_calculation_select_rows_placeholder:
        'Wähle die Zeile, für die das Verhältnis ermittelt werden soll.',
    aumico_notes_super_table_add_calculation_minuend_placeholder:
        'Wähle den Minuend, den Wert, von dem wir etwas abziehen.',
    aumico_notes_super_table_add_calculation_subtrahend_placeholder: 'Wähle den Subtrahend, den Wert den wir abziehen.',
    aumico_notes_super_table_add_column: 'Manuelle Spalte',
    aumico_notes_super_table_add_column_menu_option_add_calculation: 'Kalkulation hinzufügen',
    aumico_notes_super_table_add_column_menu_option_add_column: 'Manuelle Spalte',
    aumico_notes_super_table_add_free_column_title: 'Einstellungen manuelle Spalte',
    aumico_notes_super_table_add_free_column_title_placeholder: 'Titel der Spalte',
    aumico_notes_super_table_add_free_column_col_type: 'Formatierung',
    aumico_notes_super_table_add_free_column_belonging_year: 'Verknüpfung',
    aumico_notes_super_table_add_free_column_save_button: 'Spalte hinzufügen',
    aumico_notes_super_table_select_income_or_balance: 'Bitte wähle woher die Daten stammen:',
    aumico_core_ck_editor_add_custom_style: 'Benutzerdefinierte Formatierung hinzufügen',
    aumico_core_ck_editor_make_row_total: 'Total der Zeilen erstellen',
    aumico_core_ck_editor_make_column_total: 'Total der Spalten erstellen',
    aumico_core_ck_editor_make_column_highlight: 'Spalte hervorheben',
    aumico_core_ck_editor_make_column_number_column: 'Nummerierung der Spalte hinzufügen',
    aumico_core_ck_editor_remove_row_style: 'Formatierung der Zeile löschen',
    aumico_core_ck_editor_remove_column_style: 'Formatierung der Spalte löschen',
    aumico_core_ck_editor_align_table: 'Tabelle ausrichten',
    aumico_core_ck_editor_align_table_left: 'Tabelle links ausrichten',
    aumico_core_ck_editor_align_table_right: 'Tabelle rechts ausrichten',
    aumico_core_ck_editor_align_table_center: 'Tabelle mittig ausrichten',
    aumico_core_ck_editor_align_cell_horizontal: 'Zelle horizontal ausrichten',
    aumico_core_ck_editor_align_cell_horizontal_left: 'Zelle links ausrichten',
    aumico_core_ck_editor_align_cell_horizontal_right: 'Zelle rechts ausrichten',
    aumico_core_ck_editor_align_cell_vertical: 'Zelle vertikal ausrichten',
    aumico_core_ck_editor_align_cell_vertical_top: 'Zelle vertikal oben ausrichten',
    aumico_core_ck_editor_align_cell_vertical_bottom: 'Zelle unten ausrichten',
    aumico_core_ck_editor_table_column: 'Spalte',
    aumico_core_ck_editor_table_column_header_column: 'Überschrift',
    aumico_core_ck_editor_table_column_insert_column_left: 'Spalte links einfügen',
    aumico_core_ck_editor_table_column_insert_column_right: 'Spalte rechts einfügen',
    aumico_core_ck_editor_table_column_delete_column: 'Spalte löschen',
    aumico_core_ck_editor_table_column_select_column: 'Spalte auswählen',
    aumico_core_ck_editor_table_row: 'Zeile',
    aumico_core_ck_editor_table_row_header_row: 'Kopfzeile',
    aumico_core_ck_editor_table_row_insert_row_above: 'Zeile oberhalb einfügen',
    aumico_core_ck_editor_table_row_insert_row_below: 'Zeile unterhalb einfügen',
    aumico_core_ck_editor_table_row_delete_row: 'Zeile löschen',
    aumico_core_ck_editor_table_row_select_row: 'Zeile auswählen',
    aumico_core_ck_editor_table_merge_cells: 'Zellen zusammenführen',
    aumico_core_ck_editor_table_merge_cells_up: 'Zellen nach oben zusammenführen',
    aumico_core_ck_editor_table_merge_cells_down: 'Zellen nach unten zusammenführen',
    aumico_core_ck_editor_table_merge_cells_right: 'Zellen nach rechts zusammenführen',
    aumico_core_ck_editor_table_merge_cells_left: 'Zellen nach links zusammenführen',
    aumico_core_ck_editor_table_split_cell_vertically: 'Zelle vertikal teilen',
    aumico_core_ck_editor_table_split_cell_horizontally: 'Zelle horizontal teilen',
    aumico_core_ck_editor_enforce_page_break: 'Erzwinge Seitenumbruch',
    aumico_notes_components_list_reset_values_from_mapping: 'Werte aktualisieren',
    aumico_notes_components_list_no_content: 'Klicke auf Bearbeiten, um Inhalte hinzuzufügen',
    aumico_notes_super_table_remove_confirmation_dialog_ok: 'Okay',
    aumico_notes_super_table_remove_confirmation_dialog_cancel: 'Abbrechen',
    aumico_notes_super_table_remove_confirmation_dialog_description:
        'Du entfernst eine Spalte. Möchtest du trotzdem fortfahren?',
    aumico_notes_super_table: 'Benutzerdefiniert',
    aumico_notes_select_options_min_options: 'Wähle mindestens zwei Optionen',
    aumico_notes_super_table_options_transpose: 'Tabelle um 90 Grad drehen',
    aumico_notes_super_table_options_col_belonging_year_none: 'Permanente Spalte',
    aumico_notes_super_table_add_free_column_edit_button: 'Spalte anpassen',
    aumico_notes_super_table_reset_form_values_from_mapping_confirmation_dialog_ok: 'Ja',
    aumico_notes_super_table_reset_form_values_from_mapping_confirmation_dialog_cancel: 'Abbrechen',
    aumico_notes_super_table_reset_form_values_from_mapping_confirmation_dialog_description:
        'Bist du sicher, dass du die Tabelle aktualisieren möchtest?',
    aumico_notes_super_table_turning_on_transpose_toggle_not_allowed:
        'Es sind maximal 7 Zeilen erlaubt, um die Tabelle um 90 Grad drehen zu können.',
    aumico_notes_super_table_turning_off_transpose_toggle_not_allowed:
        'Es sind maximal 7 Spalten erlaubt, um die Tabelle um 90 Grad drehen zu können.',
    aumico_reports_main_navigation_company_profile: 'Firmenprofil',
    aumico_reports_main_navigation_person_list: 'Personen',
    aumico_reports_export_all_persons_file_name: 'alle Personen',
    aumico_reports_main_navigation_person_new: 'Neue Person',
    aumico_reports_main_navigation_person_profile: 'Profil',
    aumico_print_preview_rename_section_title_dialog_title: 'Abschnittstitel umbenennen',
    aumico_print_preview_rename_section_title_dialog_input_field_placeholder: 'Abschnittstitel eingeben',
    aumico_print_preview_rename_section_title_dialog_input_field_title: 'Abschnittstitel',
    aumico_report_save_success_notification_description: 'Speichern erfolgreich',
    aumico_report_save_failure_notification_description: 'Speichern fehlgeschlagen',
    aumico_users_registration_password_lower_case_criteria_message: 'Mindestens ein Kleinbuchstabe',
    aumico_users_registration_password_upper_case_criteria_message: 'Mindestens ein Großbuchstabe',
    aumico_users_registration_password_digits_criteria_message: 'Mindestens eine Zahl',
    aumico_annual_report_save_error_not_loaded: 'Die Berichtsdaten wurden noch nicht geladen. Bitte warten Sie einen Moment und versuchen Sie es erneut.',
    aumico_users_registration_password_special_char_criteria_message: 'Mindestens ein Sonderzeichen',
    aumico_users_registration_password_min_chars_criteria_message: 'Mindestens 8 Zeichen',
    aumico_add_referencing_in_balance_and_income_btn: 'Referenzierung hinzufügen',
    aumico_add_numbering_toggle: 'Nummerierung hinzufügen',

    aumico_notes_title: 'Title',
    aumico_notes_referencing_title: 'Referenzierung anpasssen',
    aumico_notes_referencing_sub_title: 'Mehrfachauswahl möglich:',
    aumico_notes_referencing_add_referencing: 'Auswahl bestätigen',
    aumico_admin_ar_template_general_information_caption: 'Beschreibung',
    aumico_admin_translations_ar_templates: 'Jahresberichtsvorlagen',
    aumico_annual_report_fas_unmapped_uploaded_accounts_warning:
        'Die folgenden hochgeladenen Konten sind nicht zugeordnet',
    aumico_view_notes_components_in_edit_mode_toggle: 'Abschnitte im Bearbeitungsmodus anzeigen',
    aumico_annual_report_fas_invalid_file_format_warning_text: 'Die hochgeladene Datei hat ein falsches Format',
    aumico_annual_report_complementary_reports_show_in_toc_toggle: 'Bericht im Inhaltsverzeichnis anzeigen',
    aumico_annual_report_complementary_reports_at_the_start: 'VOR der Jahresrechnung',
    aumico_annual_report_complementary_reports_at_the_end: 'NACH der Jahresrechnung',
    aumico_annual_report_complementary_reports_as_appendix: 'Als Beilage',
    aumico_annual_report_print_preview_appendix_section_title: 'Beilage',
    aumico_view_notes_components_highlight_todos_toggle: 'Hervorhebung',
    aumico_reports_organization_settings_navigation_checklists: 'Checklisten',
    aumico_copy_notes_structure_from_another_annual_report: 'Anhang kopieren',
    aumico_notes_copy_notes_structure_from_another_annual_report_confirmation_dialog_description:
        'Dadurch werden alle erstellten Notizen ersetzt. Der Vorgang kann nicht rückgängig gemacht werden. Möchtest du den Vorgang fortsetzen?',
    aumico_notes_copy_notes_structure_from_another_annual_report_confirmation_dialog_yes_button: 'Ja',
    aumico_notes_copy_notes_structure_from_another_annual_report_confirmation_dialog_yes_inclusive_data_button:
        'Ja, inklusive Daten und Referenzierungen',
    aumico_notes_copy_notes_structure_from_another_annual_report_confirmation_dialog_cancel_button: 'Abbrechen',
    aumico_notes_copy_notes_structure_fetch_error: 'Die Notizen konnten aus diesem Bericht nicht abgerufen werden.',
    aumico_users_organization_upload_or_pdf_template_action: 'OR Pdf-Vorlage hochladen',
    aumico_users_organization_upload_hgb_pdf_template_action: 'HGB Pdf-Vorlage hochladen',
    aumico_users_organization_reset_to_default_or_template_action: 'Vorlage OR auf Standard zurücksetzen',
    aumico_users_organization_reset_to_default_hgb_template_action: 'Vorlage HGB auf Standard zurücksetzen',
    aumico_reports_create_new_checklist: 'Neue Checkliste erstellen',
    aumico_admin_menu_item_change_fcp: 'Abschlussprozess Abo ändern',
    aumico_admin_menu_item_deactivate_fcp: 'Abschlussprozess deaktivieren',
    aumico_admin_change_fcpstate_select_fcp_status: 'Abschlussprozess Status',
    aumico_admin_change_fcp_statefcp_status: 'Status ändern',
    aumico_admin_change_fcpstate_cancel: 'Abbrechen',
    aumico_admin_change_fcpstate_confirm: 'Bestätigen',
    aumico_reports_main_navigation_closing_process_enabling: 'Abschlussprozess',
    aumico_reports_closing_process_request_approval: 'Für Beta-Testing anmelden',
    aumico_reports_closing_process_waiting_for_approval: 'Beta-Testing beantragt',
    aumico_reports_closing_process_cancel: 'Abo kündigen',
    aumico_reports_closing_process_benefits: 'Vorteile',
    aumico_reports_closing_process_pricing: 'Preis',
    aumico_reports_closing_process_terms_and_conditions: 'Bedingungen und Konditionen',
    aumico_confirmation_modal_activate_button: 'Aktivieren',
    aumico_confirmation_modal_cancel_subscription_button: 'Abon kündigen',
    aumico_confirmation_modal_activate_subscription_description:
        'Wenn Du auf „Aktivieren“ klicken, aktivierst Du eine 30-tägige kostenlose Testversion. Während dieses Zeitraums hast Du vollen Zugriff auf die Funktion für den Abschlussprozess. Die Testversion wird automatisch in ein bezahltes Abo umgewandelt, sobald die Testversion endet!',
    aumico_reports_closing_process_deactivate: 'Deaktivieren',

    aumico_reports_cant_activate_fcp:
        'Du kannst die Testversion von Abschlussprozess nicht aktivieren, da Du die Testphase bereits aktiviert hast. Bitte kontaktiere sales@aumico.io, um Zugang zu erhalten.',
    aumico_reports_cant_activate_fcp_ok: 'Ok',
    aumico_reports_checklist_title_label: 'Titel',
    aumico_reports_checklist_title_placeholder: 'Checklisten-Titel eingeben',
    aumico_reports_select_flis_label: 'Kontengruppe wählen',
    aumico_reports_enter_task_placeholder: 'Aufgabe eingeben',
    aumico_reports_add_more_tasks_button: 'Aufgaben hinzufügen',
    aumico_reports_cancel_button: 'Abbrechen',
    aumico_reports_save_checklist_button: 'Checkliste speichern',
    aumico_admin_user_notification_success_description: 'Daten erfolgreich gespeichert',
    aumico_reports_checklist_title: 'Checkliste',
    aumico_reports_checklist_content:
        'Hier findest du die Checklisten für deine Kontengruppen. Diese helfen dir, den Prozess zu verfolgen und sicherzustellen, dass du nichts vergisst.',

    aumico_reports_comments_title: 'Notizen',
    aumico_reports_comments_content:
        'Hier kannst du Notizen zu den Konten hinzufügen. Du kannst diese als Notizen für dich selbst und für deine Kollegen verwenden.',

    aumico_reports_docs_title: 'Dokumente',
    aumico_reports_docs_content:
        'Dokumente sind hier verfügbar. Du kannst Dokumente für die Konten hoch- und herunterladen.',
    aumico_reports_no_checklist_message: 'Wir konnten keine Checkliste für dieses Kontengruppe finden.',
    aumico_reports_create_checklist_button: 'Neue Checkliste erstellen',
    aumico_reports_or_text: 'oder',
    aumico_reports_import_checklist_button: 'Checkliste einfügen',
    aumico_reports_last_year: 'Letztes Jahr',
    aumico_reports_this_year: 'Dieses Jahr',
    aumico_reports_select_checklist: 'Checkliste auswählen',
    aumico_reports_import_checklist: 'Checkliste einfügen',
    aumico_reports_custom_checklist_creation_text:
        'Du kannst auch {{linkText}} in den Organisationseinstellungen eingeben.',
    aumico_reports_custom_checklist_creation_link_text: 'Eigene Checklisten erstellen',
    aumico_reports_closing_entries_title: 'Abschlussbuchungen',
    aumico_reports_closing_entries_content: 'Abschlussbuchungen eintragen',
    aumico_checklist_management_table_checklist_name: 'Name',
    aumico_checklist_management_table_checklist_created_at: 'Erstellt am',
    aumico_checklist_management_table_checklist_last_change: 'Letzte Änderung',
    aumico_checklist_management_table_checklist_modified_by: 'Geändert von',
    aumico_reports_annualreport_print_with_legacy_service: 'Drucken mit altem Dienst',

    aumico_reports_fcp_enable_title: 'Standardisiere deinen Jahresabschlussprozess!',
    aumico_reports_fcp_enable_subtitle: 'Intelligente Workflows und Qualitätssicherung für die Abschlusserstellung.',
    aumico_reports_fcp_teaser_1_title: 'Jahresabschlussprozess standardisieren',
    aumico_reports_fcp_teaser_1_text:
        'Verringere Abweichungen und beschleunige den Prozess mit standardisierten Checklisten.',
    aumico_reports_fcp_teaser_2_title: 'Intelligente Workflows',
    aumico_reports_fcp_teaser_2_text:
        'Automatisierte Workflows leiten dich durch den Prozess und ermöglichen nahtlose Weiterverarbeitung für Abschlussbesprechungen und interne Dokumentation.',
    aumico_reports_fcp_teaser_3_title: 'Qualitätssicherung & Einhaltung gesetzlicher Vorschriften',
    aumico_reports_fcp_teaser_3_text:
        'Stelle die Einhaltung deiner internen Qualitätsstandards und aller gesetzlichen Anforderungen sicher.',
    aumico_reports_fcp_beta_terms_title: 'Beta Information',
    aumico_reports_fcp_trial_terms_1: '30 Tage kostenlose Testphase',
    aumico_reports_fcp_trial_terms_2:
        'Konvertiert automatisch in einen zahlungspflichtigen Vertrag, sofern diese nicht gekündigt wird',
    aumico_reports_fcp_trial_terms_3: 'Jederzeit während der Testphase kündbar',
    aumico_reports_fcp_trial_info_title: 'Informationen zur Testphase',
    aumico_reports_fcp_trial_info_text: 'Du hast noch {{x}} Tage Restlaufzeit.',
    aumico_reports_fcp_subscription_info_title: 'Informationen zum Abo',
    aumico_reports_fcp_subscription_info_text: 'Du hast noch {{x}} Tage Restlaufzeit.',
    aumico_reports_fcp_trial_deactivation_title: `Wir würden gerne dein Feedback hören`,
    aumico_reports_fcp_trial_deactivation_text: `Bitte sage uns, warum du die Testphase beenden möchtest...`,
    aumico_reports_fcp_subscription_deactivation_title: `Wir würden gerne dein Feedback hören`,
    aumico_reports_fcp_subscription_deactivation_text: `Bitte teile uns mit, warum du das Abo beenden möchtest.`,
    aumico_reports_fcp_deactivation_placeholder: `Schreibe dein Feedback hier.`,
    aumico_reports_fcp_deactivation_feedback_button: `Feedback abschicken und deaktivieren`,
    aumico_reports_fcp_deactivation_confirmation_question_text: `Bist du sicher, dass du den Abschlussprozess deaktivieren möchtest?`,
    aumico_reports_fcp_deactivation_terms: `Anmerkung:`,
    aumico_reports_fcp_deactivation_term_data_storage: `Die Daten, die während der Testphase erstellt wurden, gehen verloren.`,
    aumico_reports_fcp_deactivation_term_end_date: `Die Funktion wird am {{Datum}} beendet.`,
    aumico_reports_fcp_deactivation_term_costs: `Es entstehen keine Kosten.`,
    aumico_reports_add_a_new_comment_placeholder: 'Notiz erfassen',
    aumico_reports_add_new_comments_button: 'Hinzufügen',
    aumico_reports_add_edit_comments_button: 'Ändern',
    aumico_reports_mark_comment_as: 'Markieren als:',
    aumico_reports_comments_section_description:
        'Hier kannst du Notizen zu Konten hinzufügen. Du kannst diese als Notizen für dich selbst und für deine Mitarbeitenden verwenden.',
    aumico_reports_mark_as_internal_comment: 'Intern',
    aumico_reports_mark_as_external_comment: 'Extern',
    aumico_reports_mark_as_review_comment: 'Zur Kontrolle',
    aumico_reports_mark_comment_as_pendency: 'Pendenz',
    aumico_reports_copy_comment: 'Kopieren',
    aumico_reports_delete_comment: 'Löschen',
    aumico_reports_is_internal_comment: 'Intern',
    aumico_reports_is_external_comment: 'Extern',
    aumico_reports_is_pendancy_comment: 'Pendenz',
    aumico_reports_is_review_comment: 'Kontrolle',
    aumico_reports_fcp_file_virused_error_message: 'Die hochgeladene Datei ist mit einem Virus infiziert',
    aumico_reports_fcp_file_uploaded_success_message: 'Datei erfolgreich hochgeladen',
    aumico_reports_browse_files: 'Suchen',
    aumico_reports_fcp_edit_checklist: 'Checkliste bearbeiten',
    aumico_reports_fcp_tree_adjustment_col_header: 'Angepasst',
    aumico_reports_fcp_tree_current_year_col_header: 'Aktuelles Jahr',
    aumico_reports_fcp_tree_previous_year_col_header: 'Vorjahr',
    aumico_reports_notes_search_reports: 'Suchen',
    aumico_reports_finalize_and_continue_button: 'Speichern und weiter',
    aumico_reports_preview_button_text: 'Vorschau',
    aumico_reports_export_button_text: 'Exportieren',
    aumico_reports_export_unlabeled_comment: 'Nicht kategorisierte Notizen',
    aumico_reports_export_internal_comment: 'Interne Notizen',
    aumico_reports_export_external_comment: 'Externe Notizen',
    aumico_reports_export_review_comment: 'Notizen zur Kontrolle',
    aumico_reports_export_pendency: 'Pendenzen',
    aumico_reports_export_excel: 'als Excel exportieren',
    aumico_reports_export_closing: 'Abschlussbuchungen',
    aumico_reports_closing_process_balance_navigation_tab: 'Bilanz',
    aumico_reports_closing_process_income_navigation_tab: 'GuV',
    aumico_reports_fcp_save_checklist_button: 'Speichern',
    aumico_reports_fcp_closing_edit_entry: 'Bearbeiten',
    aumico_reports_fcp_closing_delete_entry: 'Löschen',
    aumico_reports_fcp_closing_add_entry: 'Hinzufügen',
    aumico_reports_fcp_closing_save_entry: 'Speichern',
    aumico_reports_fcp_closing_enter_amount: 'Betrag eingeben',
    aumico_reports_fcp_closing_add_new_amount: 'Betrag hier eingeben',
    aumico_reports_fcp_closing_select_debit: 'Soll',
    aumico_reports_fcp_closing_add_new_debit: 'Konto auswählen',
    aumico_reports_fcp_closing_select_credit: 'Haben',
    aumico_reports_fcp_closing_add_new_credit: 'Konto auswählen',
    aumico_reports_fcp_closing_add_details: 'Buchungstext eingeben',
    aumico_reports_fcp_closing_details: 'Buchungstext',
    aumico_reports_fcp_closing_add_new_text: 'Buchungstext hier eingeben',
    aumico_reports_fcp_closing_no_closing_entries_last_year: 'Es existieren keine Abschlussbuchungen im Vorjahr',
    aumico_reports_fcp_closing_amount: 'Betrag',
    aumico_reports_fcp_closing_debit: 'Soll',
    aumico_reports_fcp_closing_credit: 'Haben',
    aumico_reports_fcp_closing_done: 'Gebucht',
    aumico_reports_fcp_no_items: 'Keine Einträge',
    aumico_reports_fcp_unknown_state: 'Unbekannter Status',
    aumico_reports_fcp_search_placeholder: 'Suchen',

    aumico_reports_fcp_closing_process_checklist_mark_all_as_done: 'Alles als erldigt markieren',
    aumico_reports_fcp_closing_process_checklist_mark_all_as_done_confirm: 'Ja',
    aumico_reports_fcp_closing_process_checklist_mark_all_as_done_cancel: 'Nein',
    aumico_reports_fcp_closing_process_checklist_mark_all_as_dont_show_again: 'Nicht mehr anzeigen',
    aumico_reports_fcp_closing_process_checklist_mark_all_as_done_text:
        'Möchtest du wirklich alle Aufgaben als erledigt markieren?',

    aumico_reports_fcp_closing_process_checklist_delete_checklist:
        'Bist du sicher, dass du die Checkliste löschen möchtest?',
    aumico_reports_confirm_delete: 'Ja, ich bin sicher',
    aumico_reports_cancel_delete: 'Nein, abbrechen',
    aumico_annual_report_mapping_load_fli_cfs_settings_warning:
        'Klicke auf die Schaltfläche "Geldfluss-Einstellungen laden“, wenn beim Bearbeiten von Posten der Geldfluss-Typ fehlt. Durch die Nutzung dieser Funktion werden die Geldfluss-Typen in allen Flis aus den Einstellungen neu geladen. Eventuell selbst hinzugefügte Geldfluss-Typen müssen erneut eingegeben werden. Dies ist eine vorübergehende Lösung!',
    aumico_annual_report_mapping_load_fli_cfs_settings_button: 'Geldfluss Einstellungen laden',
    aumico_annual_report_mapping_load_fli_cfs_settings_dialog_content:
        'Möchtest du die Geldfluss Einstellungen neu laden? Alle Geldfluss Typen in den Geldfluss Tabellen werden neu geladen. Alle von dir hinzugefügten Geldfluss Typen müssen erneut eingegeben werden. Dies ist eine temporäre Lösung!',
    aumico_annual_report_fcp_checklist_not_allow_duplicate: 'Aufgaben mit dem gleichen Namen existiert bereits',
    aumico_reports_just_now: 'jetzt',
    aumico_reports_fcp_uploading: 'hochaladen',
    aumico_reports_fcp_uploaded: 'hochgeladen',
    aumico_reports_hours_of_uploading: 'vor {{diffInHours}} Stunden',
    aumico_reports_hour_of_uploading: 'vor {{diffInHours}} Stunde',
    aumico_reports_days_of_uploading: 'vor {{diffInDays}} Tagen',
    aumico_reports_day_of_uploading: 'vor {{diffInDays}} Tag',
    aumico_reports_fcp_file_is_virused_warning_popup:
        ' In der Datei wurde Schadcode entdeckt und kann deshalb nicht verwendet werden',

    aumico_reports_fcp_file_allowed_files: 'Please upload a .xlsx or a .xls or a .pdf file',
    aumico_add_new_notes_accordion_section_title: 'Neuer Abschnitt hinzufügen',
    aumico_add_new_notes_accordion_section_note_title: 'Hier Titel eingeben',
    aumico_add_new_notes_accordion_section_note_title_input_placeholder: 'Titel',
    aumico_add_new_notes_accordion_section_select_note_component_to_add: 'Komponente wählen',
    aumico_add_new_notes_accordion_section_add_numbering_toggle: 'Nummerierung hinzufügen',
    aumico_add_new_notes_accordion_section_add_numbering_toggle_description: 'Automatisch nummerieren',
    aumico_add_new_notes_accordion_section_button: 'Hinzufügen',
    aumico_add_new_notes_component_title: 'Weitere Komponente hinzufügen',
    aumico_add_new_notes_component_button: 'Hinzufügen',
    aumico_add_new_notes_component_add_numbering_toggle: 'Nummerierung hinzufügen',
    aumico_add_new_notes_component_add_numbering_toggle_description: 'Automatisch nummerieren',
    aumico_reports_fcp_file_uploaded_by: 'von',
    aumico_support_nav_item: 'Support',
    aumico_reports_drag_files: 'Ziehen Sie Dateien hierher, um sie hochzuladeƒn',
    aumico_annual_report_aop_description: 'AOP Beschreibung',
    aumico_annual_report_investing_activities: 'Investition',
    aumico_annual_report_financing_activities: 'Finanzierung',
    aumico_annual_report_cash_flow_networking_capital: 'Nettoumlaufvermögen',
    aumico_annual_report_cash_flow_operating_activities: 'Operativer CF',
    aumico_annual_report_cash_flow_manual: 'Manuelle Eingabe',
    aumico_annual_report_delete_item_confirmation_text: 'Bist du sicher, dass du diesen Eintrag löschen möchtest?',
    aumico_annual_report_cashflow_difference_text: 'Differenzcheck',
    aumico_annual_report_cashflow_difference_should_be_zero_text: 'Muss 0 ergeben',
    aumico_reports_side_bar_organization_name: 'Organisationsname',
    aumico_reports_side_bar_help: 'Support',
    aumico_reports_fcp_drag_files: 'Ziehe Dateien hierher, um sie hochzuladen',
    aumico_core_ham_referencing_input_placeholder: 'Titel',
    aumico_notes_components_list_actions_break_page: 'Seitenumbruch',
    aumico_notes_components_list_actions_compare_years: 'Vergleichsjahr',
    aumico_notes_components_list_actions_settings: 'Einstellungen',
    aumico_notes_components_list_actions_add: 'Hinzufügen',
    aumico_notes_components_list_actions_show_previous_year: 'Vorjahr anzeigen',
    aumico_notes_components_list_actions_transpose: '90 Grad drehen',
    aumico_notes_components_list_actions_flip_signs: 'Vorzeichen wechseln',
    aumico_notes_components_list_actions_show_total: 'Summe berechnen',
    aumico_text_snippets_table_search_placeholder: 'Suchen',
    aumico_reports_organization_settings_users_add_new_button: 'Neuer Benutzer hinzufügen',
    aumico_reports_organization_settings_checklist_add_new_button: 'Neue Checkliste hinzufügen',

    admin_create_licence_package_title: 'Lizenzpaket erstellen',
    admin_create_licence_package_type: 'Pakettyp',
    admin_create_licence_package_type_required: 'Pakettyp ist erforderlich.',
    admin_create_licence_package_size: 'Paketgröße',
    admin_create_licence_package_size_required: 'Paketgröße ist erforderlich.',
    admin_create_licence_package_size_min: 'Paketgröße muss mindestens {{min}} sein.',
    admin_create_licence_package_start_date: 'Startdatum',
    admin_create_licence_package_start_date_required: 'Startdatum ist erforderlich.',
    admin_create_licence_package_end_date: 'Enddatum',
    admin_create_licence_package_end_date_required: 'Enddatum ist erforderlich.',
    admin_create_licence_package_end_date_invalid: 'Enddatum muss nach dem Startdatum liegen.',
    admin_create_licence_package_description: 'Beschreibung',
    admin_create_licence_package_price: 'Preis',
    admin_create_licence_package_price_min: 'Preis muss mindestens {{min}} betragen.',
    admin_create_licence_package_discount_amount: 'Rabattbetrag',
    admin_create_licence_package_discount_amount_min: 'Rabattbetrag muss mindestens {{min}} betragen.',
    admin_create_licence_package_discount_percent: 'Rabattprozentsatz',
    admin_create_licence_package_discount_percent_min: 'Rabattprozentsatz muss mindestens {{min}}% betragen.',
    admin_create_licence_package_discount_percent_max: 'Rabattprozentsatz darf {{max}}% nicht überschreiten.',
    admin_create_licence_package_cancel: 'Abbrechen',
    admin_create_licence_package_confirm: 'Bestätigen',
    aumico_annual_report_cashflow_unsaved_changes:
        'Nicht gespeicherte Änderungen erkannt. Die Druckdaten werden erst dann aktualisiert, wenn Du deine Änderungen bestätigst und speicherst.',
    aumico_annual_report_cash_flow_investing_add_row: 'Zeile hinzufügen',
    aumico_reports_tooltip_text_verify_data:
        'Die Werte wurden aktualisiert. Bitte überprüfe, ob der Cashflow noch korrekt ist.',

    aumico_reports_tooltip_text_verify_fcp_data:
        'Die Werte wurden aktualisiert. Bitte überprüfe, ob der Abschlusserstellung noch korrekt ist.',
    aumico_reports_aop_account_caption: 'Beschreibung',
    aumico_annual_report_print_options_label_non_breaking_hyphen_toggle: 'Reduzierte Qualität',
    aumico_annual_report_print_options_repeat_appendix_title: 'Anhang-Titel auf jeder Seite wiederholen',
    aumico_annual_report_print_options_round_to_thousands: 'Zahlen in Tausend runden',
    aumico_templates_mapping_remove_account_will_change_previous_year_values_warning:
        'Bitte beachte, dass beim Entfernen eines Kontos der Vorjahreswert ebenfalls verändert wird!',
    aumico_companies_form_assigned_users: 'Mandatsleiter',
    aumico_companies_form_assigned_on: 'Zuständig',
    aumico_admin_organization_list_package_size: 'Grösse',
    aumico_users_organization_users_table_date_added_label: 'Hinzugefügt am',
    aumico_users_organization_users_table_status_label: 'Status',
    aumico_users_organization_users_table_pending_label: 'Ausstehend',
    aumico_users_organization_users_table_active_label: 'Aktiv',
    aumico_users_organization_users_table_resend_invite: 'Erneut senden',

    aumico_users_organization_users_table_withdraw_invite_action: 'Zurückziehen',
    aumico_users_organization_users_table_resend_invite_action: 'Erneut senden',
    aumico_users_organization_users_table_withdraw_invite_modal_title: 'Einladung zurückziehen?',
    aumico_users_organization_users_table_resend_invite_modal_title: 'Einladung erneut senden?',
    aumico_users_organization_users_table_withdraw_invite_modal_body:
        'Bist du sicher, dass du diese Einladung zurückziehen willst? Der Nutzer kann der Plattform nicht mehr beitreten, es sei denn, er wird erneut eingeladen.',
    aumico_users_organization_users_table_resend_invite_modal_body:
        'Bist du sicher, dass du diese Einladung erneut versenden möchtest?',
    aumico_users_organization_users_table_invite_modal_body:
        'Eingeladene User haben Zugriff auf alle Daten der Organisation',
    aumico_admin_organization_list_package_type: 'Typ',
    aumico_admin_organization_list_package_start_date: 'Startdatum',
    aumico_admin_organization_list_package_end_date: 'Enddatum',
    aumico_admin_organization_list_actions: 'Aktion',
    aumico_admin_organization_list_add_package: 'Paket hinzufügen',
    aumico_admin_organization_list_package_delete: 'Löschen',
    aumico_admin_organization_list_package_edit: 'Bearbeiten',
    aumico_admin_delete_package_confirmation_dialog_description: 'Bist du sicher, dass du dieses Paket löschen willst?',
    aumico_admin_organization_abcp_needs_cpmm: 'Braucht CPMM',
    aumico_admin_organization_abcp_update_failed: 'ABCP konnte nicht umgeschaltet werden.',
    aumico_companies_details_text: 'Firmenangaben',
    aumico_templates_form_annual_surplus: 'Jahresüberschuss',
    aumico_companies_mandate_text: 'Mandatsmanagement',
    aumico_annual_report_cash_flow_investing_add_new_section: 'Neuer Bereich hinzufügen',
    aumico_reports_design_settings_example_subtitle: '1.1 Beispiel Untertitel',
    aumico_reports_design_settings_example_title: '1. Beispiel Titel',
    aumico_reports_design_settings_example_title_row: '1.1.1 Beispiel Tabellentitel',
    aumico_annual_report_print_options_show_notes_in_detail_in_toc: 'Detailliertes Verzeichnis',
    aumico_components_ham_styling_menu_align_left: 'Linksbündig',
    aumico_components_ham_styling_menu_align_center: 'Zentriert',
    aumico_components_ham_styling_menu_align_right: 'Rechtsbündig',
    aumico_components_ham_styling_menu_bold: 'Fett',
    aumico_components_ham_styling_menu_underlined: 'Unterstrichen',
    aumico_components_ham_styling_menu_italic: 'Kursiv',
    aumico_components_ham_styling_menu_percentage: 'Prozent',
    aumico_components_ham_styling_menu_less_decimals: 'Dezimalstelle verringern',
    aumico_components_ham_styling_menu_more_decimals: 'Dezimalstellen vergrössern',
    aumico_components_ham_styling_menu_flip_sign:
        'Vorzeichen drehen (Bezieht sich auf dargestellten Wert nicht den Effektiven)',

    aumico_reports_organization_delete_user: 'Willst du diesen Benutzer wirklich löschen?',
    aumico_reports_organization_delete: 'Löschen',
    aumico_reports_companies_upload_logo: 'Logo hochladen',
    aumico_reports_companies_upload_logo_description:
        'Das hochgeladene Logo erscheint im Unternehmensprofil und kann optional in gedruckte Dokumente eingefügt werden.',

    aumico_reports_companies_upload_file_upload_image_info: 'PNG-Logo hochladen',
    aumico_reports_companies_upload_file_upload_image_size: '(Maximum 5MB, 100x100px)',
    aumico_annual_report_print_options_advanced_title: 'Erweitert',
    aumico_annual_report_print_options_components_accordion_title: 'Bestandteile',
    aumico_annual_report_print_options_settings_accordion_title: 'Einstellung',
    aumico_annual_report_print_options_signature_accordion_title: 'Unterschrift',
    aumico_annual_report_print_options_financial_statement_components_title: 'Bilanz & GuV',
    aumico_annual_report_print_options_cash_flow_component_title: 'Kapitalflussrechnung',
    aumico_annual_report_print_options_notes_component_title: 'Anhang',
    aumico_annual_report_print_options_aop_component_title: 'Gewinnverwendung',
    aumico_annual_report_print_options_place_signature_after_income_statement: 'Nach Erfolgsrechnung',
    aumico_annual_report_file_size_error: 'Dateigröße überschreitet 5MB',
    aumico_cover_page_internal_label: 'Intern',
    aumico_annual_report_select_autofill_options: 'Wähle zu kopierende Elemente aus dieser Vorlage',
    aumico_annual_report_autofill_options_taxonamy: 'Postenstruktur',
    aumico_annual_report_autofill_options_cfs: 'Kapitalflussrechnung',
    aumico_annual_report_autofill_options_notes: 'Anhang',
    aumico_annual_report_autofill_options_aop: 'Gewinnverwendung',
    aumico_annual_report_print_options_general_accordion_title: 'Allgemein',
    aumico_notes_super_table_row_settings: 'Zeileneinstellung',
    aumico_notes_super_table_reconcile: 'Wert Abstimmen',
    aumico_notes_super_table_reconcile_dialog_description: 'Position wählen',
    aumico_notes_super_table_mapping_row_settings_description:
        'Bitte wähle einen oder mehrere Positionen für eine neue Zeile aus.',
    aumico_notes_super_table_mapping_row_settings_row_title: 'Zeilentitel ',
    aumico_notes_super_table_delete_column_confirmation_text: 'Bist du sicher, dass du diese Spalte löschen willst?',
    aumico_notes_super_table_delete_row_confirmation_text: 'Bist du sicher, dass du diese Zeile löschen willst?',
    aumico_notes_super_table_add_calculation_next: 'Weiter',
    aumico_notes_super_table_add_calculation_cancel: 'Zurück',
    aumico_notes_super_table_segmented_columns: 'Wähle die Spalten, die segmentiert werden sollen',
    aumico_notes_super_table_select_columns: 'Spalten wählen',
    aumico_admin_ar_template_list_reporting_template_name: 'Name der Pdf-Vorlage',
    aumico_admin_ar_template_reset_pdf_template_to_default_button: 'Vorlage auf Standard zurücksetzen',
    aumico_admin_ar_template_uploaded_pdf_template_name: 'UName der hochgeladenen pdf-Vorlage',
    aumico_admin_ar_template_no_custom_pdf_template_uploaded: 'Keine benutzerdefinierte Vorlage hochgeladen',
    aumico_notes_super_table_select_from_here: 'Hier auswählen',
    aumico_notes_super_table_edit_column: 'Spalte bearbeiten',
    aumico_notes_super_table_select_summation_columns_label: 'Wähle die Spalten aus, die summiert werden sollen',
    aumico_notes_super_table_select_subtraction_column_mineund: 'Mineund',
    aumico_notes_super_table_select_subtraction_column_subtrahend: 'Subtrahend',
    aumico_notes_super_table_select_multiplication_columns_label:
        'Wähle die Spalten aus, die multipliziert werden sollen',
    aumico_notes_super_table_ratio_choose_rows_for: 'Zeilen wählen',
    aumico_notes_super_table_ratio_choose_row_for: 'Zeile wählen',
    aumico_notes_super_table_ratio_choose_cell: 'Zelle für Bezug anklicken',
    aumico_notes_super_table_ratio_numerator: 'Zähler',
    aumico_notes_super_table_calculation_item_selected: 'Ausgewählte Position',
    aumico_notes_super_table_ratio_denomenator: 'Nenner',
    aumico_annual_reports_export_excel_structured: 'Export Excel',
    aumico_notes_super_table_previous_column_removal_confirmation:
        'Bist du sicher dass du die Spalte ausblenden willst? Die Daten werden durch das Ausblenden gelöscht.',
    aumico_notes_fli_component_remove_fli_confirmation_text: 'Bist du sicher, dass du diesen Aufriss entfernen willst?',
    aumico_admin_navigation_survey_management: 'Umfrage Management',
    aumico_admin_survey_management_page_title: 'Umfrage Management',
    aumico_admin_survey_management_table_creation_date: 'Erstellungsdatum',
    aumico_admin_survey_management_table_end_date: 'Enddatum',
    aumico_admin_survey_management_table_survey_status: 'Status der Umfrage',
    aumico_admin_survey_management_table_number_of_participants: 'Anzahl der Teilnehmer',
    aumico_admin_survey_management_start_new_survey_button: 'Neue Umfrage starten',
    aumico_admin_survey_management_start_new_survey_button_tooltip:
        'Eine neue Umfrage kann nur gestartet werden, wenn keine anderen Umfragen aktiv sind.',
    aumico_admin_survey_management_table_survey_status_badge_ACTIVE: 'Aktiv',
    aumico_admin_survey_management_table_survey_status_badge_INACTIVE: 'Inaktiv',
    aumico_admin_survey_management_table_menu_options_delete: 'Umfrage löschen',
    aumico_admin_survey_management_table_menu_options_stop: 'Umfrage stoppen',
    aumico_admin_survey_management_table_menu_options_download: 'CSV herunterladen',
    aumico_admin_survey_satisfaction_table_pmf_response_badge_DISAPPOINTED: 'Neutral',
    aumico_admin_survey_satisfaction_table_pmf_response_badge_NOT_DISAPPOINTED: 'Kritiker',
    aumico_admin_survey_satisfaction_table_pmf_response_badge_VERY_DISAPPOINTED: 'Promoter',
    aumico_admin_survey_satisfaction_table_pmf_response_badge_OPEN: 'Offen',
    aumico_admin_survey_satisfaction_table_user: 'USER',
    aumico_admin_survey_satisfaction_table_organization: 'Organisation',
    aumico_admin_survey_satisfaction_table_pmf_response: 'PMF-ANTWORT',
    aumico_admin_survey_satisfaction_table_question_2: 'Was ist der Hauptnutzen den du von aumico hast',
    aumico_admin_survey_satisfaction_table_question_3: 'WIE KÖNNEN WIR UNSER PRODUKT VERBESSERN ',
    aumico_admin_survey_satisfaction_table_question_4: 'WELCHE ART VON PERSON AM MEISTEN PROFITIEREN WÜRDE',
    aumico_admin_survey_satisfaction_page_pmf_score: 'PMF Score',
    aumico_admin_survey_satisfaction_page_participants: 'Teilnehmer',
    aumico_admin_survey_satisfaction_page_participants_out_of: 'von',
    aumico_admin_survey_satisfaction_page_users: 'Users',
    aumico_admin_survey_satisfaction_page_promoters: 'Promoters',
    aumico_admin_survey_satisfaction_page_neutrals: 'Neutrale',
    aumico_admin_survey_satisfaction_page_detractors: 'Kritiker',
    aumico_admin_survey_satisfaction_page_end_survey_button: 'Umfrage stoppen',
    aumico_admin_survey_satisfaction_page_download_csv_button: 'CSV herunterladen',
    aumico_admin_navigation_survey_satisfaction: 'Umfrage zur Mitarbeiterzufriedenheit',
    aumico_survey_popup_go_back_button: 'Zurück',
    aumico_survey_popup_of: 'von',
    aumico_reports_navigation_survey_give_feedback: 'Feedback geben',
    aumico_survey_popup_thank_you: 'Danke',
    aumico_survey_popup_we_value_your_feedback:
        'Wir schätzen dein Feedback sehr! Deine Erkenntnisse helfen uns, aumico noch besser zu machen. Danke, dass du dir die Zeit genommen hast, uns deine Gedanken mitzuteilen!',
    aumico_survey_popup_question_one: 'Wie würdest du dich fühlen, wenn du aumico nicht mehr nutzen könntest?',
    aumico_survey_popup_question_two: 'Was macht dir am meisten Freude bei aumico?',
    aumico_survey_popup_question_three: 'Wie können wir aumico für dich weiter verbessern?',
    aumico_survey_popup_question_four: 'Welcher Art von Person würde am meisten von aumico profitieren?',
    aumico_survey_popup_question_one_response_very_disappointed: 'Sehr enttäuscht',
    aumico_survey_popup_question_one_response_somewhat_disappointed: 'Etwas enttäuscht',
    aumico_survey_popup_question_one_response_not_disappointed: 'Nicht enttäuscht',
    aumico_survey_popup_close_button: 'Schliessen',
    aumico_survey_popup_next_button: 'Weiter',
    aumico_survey_popup_maybe_later_button: 'Vielleicht später',
    aumico_survey_popup_submit_button: 'Einreichen',
    aumico_survey_popup_placeholder: 'Hier Text schreiben',
    aumico_annual_report_complementary_reports_drag_here: 'Bericht hierher ziehen',
    aumico_complementary_reports_report_name_label: 'Berichtsname',

    aumico_complementary_reports_report_organize_reports: 'Berichte anordnen',
    aumico_complementary_reports_report_create_edit_reports: 'Berichte erstellen',
    aumico_annual_reports_export_excel_structured_tooltip: 'Neu strukturierter und visuell ansprechender Excel-Export',
    aumico_annual_report_print_seal_report_action: 'Bericht versiegeln',
    aumico_annual_report_print_seal_report_history: 'Protokoll',
    aumico_annual_report_print_seal_report_history_tooltip: 'Keine Einträge',
    aumico_annual_report_print_seal_report_history_empty: 'Kein Protokoll verfügbar',
    aumico_annual_report_confirmation_seal_dialog_title: 'Bericht versiegeln?',
    aumico_annual_report_confirmation_seal_dialog_description:
        'Alle Exporte werden ohne «Entwurf»-Kennzeichnung erstellt. Der Bericht kann jederzeit wieder entsiegelt werden.',
    aumico_annual_report_confirmation_seal_dialog_action: 'Ja, versiegeln',
    aumico_annual_report_confirmation_unseal_dialog_title: 'Bericht entsiegeln?',
    aumico_annual_report_confirmation_unseal_dialog_description:
        'Der Bericht wird wieder in den Entwurfs-Zustand versetzt. Alle neuen Exporte enthalten erneut die «Entwurf»-Kennzeichnung.',
    aumico_annual_report_confirmation_unseal_dialog_action: 'Bericht entsiegeln',
    aumico_annual_report_seal: 'Versiegelt',
    aumico_annual_report_unseal: 'Entsiegelt',
    aumico_annual_report_sealed_tag: 'Bericht versiegelt',
    aumico_annual_report_fs_overview_sealed_tag: 'Versiegelt',
    aumico_annual_report_locked: 'Gesperrter Bericht',
    aumico_annual_report_Unlock: 'Entsperren',
    aumico_annual_report_sealed_by: 'Von ',
    aumico_button_close: 'Schliessen',
    aumico_annual_report_complementary_report_name: 'Berichtsname',
    aumico_annual_report_complementary_reports_title_no_brackets: 'Der Titel darf keine eckigen Klammern [ oder ] enthalten.',
    aumico_annual_report_print_page_no_seal_history: 'Kein Protokoll verfügbar',
    aumico_annual_report_complementary_report_create_report: 'Berichte',
    aumico_annual_report_complementary_report_organize_report: 'Anordnung',
    aumico_notes_movement_schedule_component_column1_header: 'Zugänge',
    aumico_notes_movement_schedule_component_column2_header: 'Abgänge',
    aumico_notes_movement_schedule_component_column3_header: 'Abschreib.',
    aumico_notes_movement_schedule_component_column4_header: 'Über. Abschreib.',
    aumico_companies_table_label_company_assignee: 'Manager',
    aumico_companies_table_download_xls: 'Export XLS',
    aumico_reports_seal_unseal_cancel_action: 'Nein, abbrechen',
    aumico_pm_tasks_status_filter_label: 'Status',
    aumico_pm_tasks_status_open: 'Offen',
    aumico_pm_tasks_status_in_progress: 'In Bearbeitung',
    aumico_pm_tasks_status_in_review: 'Zur Prüfung',
    aumico_pm_tasks_status_done: 'Abgeschlossen',
    aumico_pm_tasks_company_filter_label: 'Unternehmen',
    aumico_pm_tasks_apply_filter: 'Anwenden',
    aumico_pm_tasks_clear_filter: 'Löschen',
    aumico_pm_tasks_assignee_filter_label: 'Manager',
    aumico_pm_tasks_due_date_filter_label: 'Fälligkeitsdatum',
    aumico_create_project_dialog_select_company_title: 'Unternehmen auswählen',
    aumico_create_project_dialog_select_company_description:
        'Um ein neues Projekt zu erstellen, wähle bitte zuerst das Unternehmen aus.',
    aumico_create_project_dialog_select_company_input_title: 'Unternehmen',
    aumico_create_project_dialog_select_company_input_placeholder: 'Unternehmen für dieses Projekt festlegen',
    aumico_create_project_dialog_cancel_button: 'Abbrechen',
    aumico_create_project_dialog_next_button: 'Weiter',
    aumico_create_project_dialog_submit_button: 'Erstellen',
    aumico_create_project_dialog_back_button: 'Zurück',
    aumico_create_project_dialog_select_balance_sheet_date_title: 'Bilanzstichtag auswählen',
    aumico_create_project_dialog_select_balance_sheet_date_description:
        'Wähle das Enddatum des Geschäftsjahres (Bilanzstichtag).',
    aumico_create_project_dialog_select_balance_sheet_date_input_title: 'Bilanzstichtag',
    aumico_create_project_dialog_select_balance_sheet_date_input_placeholder: 'Bilanzstichtag auswählen',
    aumico_create_project_dialog_select_balance_sheet_date_calendar_today: 'Heute',
    aumico_create_project_dialog_select_balance_sheet_date_calendar_clear: 'Löschen',
    aumico_create_project_dialog_select_mandate_management_title: 'Mandatsverwaltung konfigurieren',
    aumico_create_project_dialog_select_mandate_management_copy_from_previous: 'Konfiguration vom Vorjahr kopieren',
    aumico_create_project_dialog_select_mandate_management_reset_to_standard: 'Auf Standardkonfiguration zurücksetzen',
    aumico_create_project_dialog_select_closing_workflow_title: 'Abschluss-Workflow konfigurieren',
    aumico_create_project_dialog_select_closing_workflow_copy_from_previous: 'Konfiguration vom Vorjahr kopieren',
    aumico_create_project_dialog_select_closing_workflow_reset_to_standard: 'Auf Standardkonfiguration zurücksetzen',
    aumico_create_project_dialog_of: 'von',
    aumico_tasks_overview_search_tasks: 'Suchen',
    aumico_reports_organization_settings_workflow: 'Workflow',
    aumico_reports_organization_settings_mandate_management: 'Mandatsverwaltungs-Konfigurator',
    aumico_organization_settings_mandate_management_configuration_page_header: 'Mandatsverwaltungskonfiguration',
    aumico_reports_organization_settings_closing_workflow: 'Abschluss-Workflow-Konfigurator',
    aumico_closing_workflow_overview_search_configurations: 'Suchen',
    aumico_closing_workflow_overview_add_new_workflow: 'Neuen Workflow hinzufügen',
    aumico_closing_workflow_overview_add_workflow_dialog_title: 'Workflow hinzufügen',
    aumico_closing_workflow_overview_add_workflow_dialog_description:
        'Möchtest du von Grund auf neu beginnen oder eine Vorlage auswählen?',
    aumico_closing_workflow_overview_start_from_scratch: 'Von Grund auf neu beginnen',
    aumico_closing_workflow_overview_start_from_existing_workflow: 'Mit vorhandenem Workflow beginnen',
    aumico_closing_workflow_overview_select_workflow_template_dialog_title: 'Wähle einen Workflow als Vorlage aus',
    aumico_closing_workflow_overview_next_button: 'Weiter',
    aumico_closing_workflow_overview_back_button: 'Zurück',
    aumico_closing_workflow_overview_select_workflow_template_name: 'Name',
    aumico_organization_settings_closing_workflow_configuration_page_header: 'Abschluss-Workflow-Konfiguration',
    aumico_cpmm_closing_workflows_table_delete_workflow_confirmation_text:
        'Bist du sicher, dass du diesen Workflow löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.',
    aumico_cpmm_closing_workflows_table_title_label: 'TITEL',
    aumico_cpmm_closing_workflows_table_creation_date_label: 'ERSTELLUNGSDATUM',
    aumico_licence_banner_trial_active:
        'Du befindest dich in einer Testphase und kannst die Anwendung kostenlos bis am {{value}} nutzen',
    aumico_licence_banner_trial_ended:
        'Deine Testphase ist beendet. Bitte kontaktiere den Vertrieb, um deine Lizenzanzahl zu erhöhen',
    aumico_licence_banner_suspended:
        'Dein Konto ist gesperrt. Bitte kontaktiere den Vertrieb, um deine Lizenzanzahl zu erhöhen',
    aumico_licence_banner_churned:
        'Dein Konto ist gekündigt. Der Zugriff auf deine Daten ist noch bis am {{value}} möglich. Bitte kontaktiere den Vertrieb, falls du deine Lizenzen reaktivieren möchtest.',
    aumico_licence_tooltip_no_license:
        'Maximale Mandatsanzahl erreicht. Kontaktiere den Vertrieb, um deine Lizenzanzahl zu erhöhen',
    aumico_licence_banner_max_is_nearing:
        'Du hast nur noch {{value}} Lizenzen übrig. Kontaktiere den Vertrieb, um deine Lizenzanzahl zu erhöhen und Unterbrechungen zu vermeiden.',
    aumico_licence_banner_max_reached:
        'Du hast die maximale Anzahl von Mandaten in deinem Plan erreicht. Bitte kontaktiere den Vertrieb, um deine Lizenzanzahl zu erhöhen.',
    aumico_licence_banner_request_more_button: 'Zusätzliche Lizenzen anfordern',
    aumico_licence_banner_dismiss_button: 'Nicht mehr anzeigen',
    aumico_licence_banner_dialog_close_button: 'Schließen',
    aumico_licence_banner_dialog_title: 'Anfrage erhalten',
    aumico_licence_banner_dialog_text: 'Unser Team wird dich in Kürze kontaktieren',
    aumico_licence_tooltip_max_reachedt:
        'Maximale Mandatsanzahl erreicht. Kontaktiere den Vertrieb, um deine Lizenzanzahl zu erhöhen',
    aumico_reports_annual_report_navigation_mandate_management: 'Mandatsverwaltung',
    aumico_reports_annual_report_navigation_closing_workflow: 'Abschluss-Workflow',
    aumico_reports_annual_report_navigation_closing: 'Jahresabschluss',
    aumico_reports_annual_report_navigation_report: 'Bericht',
    aumico_cp_workflow_title: 'Workflow-Titel',
    aumico_cpmm_enter_title: 'Workflow-Titel eingeben',
    aumico_cp_general: 'Allgemein',
    aumico_cp_balance_sheet: 'Bilanz',
    aumico_cp_income_statement: 'GuV',
    aumico_cpmm_add_section: 'Abschnitt hinzufügen',
    aumico_cpmm_no_tasks_title: 'Noch keine Aufgaben',
    aumico_cpmm_no_tasks_subtitle: 'Füge eine Aufgabe oder einen Abschnitt hinzu, um zu beginnen',
    aumico_cpmm_set_section_name: 'Abschnittsname eingeben',
    aumico_cpmm_task_name: 'Aufgabenname',
    aumico_cpmm_task_description: 'Aufgabenbeschreibung',
    aumico_cpmm_day_title: 'Tag',
    aumico_cpmm_day_placeholder: 'TT',
    aumico_cpmm_month_title: 'Monat',
    aumico_cpmm_month_placeholder: 'MM',
    aumico_cpmm_period_title: 'Periode',
    aumico_cpmm_period_placeholder: 'Periode festlegen',
    aumico_cpmm_new_task: 'Neue Aufgabe hinzufügen',
    aumico_cpmm_max_length_notice_title: 'Maximale Anzahl an Zeichen erreicht',
    aumico_cpmm_max_length_notice_description: 'Es können maximal 50 Zeichen eingegeben werden.',
    aumico_cpmm_current_period: 'Aktuelle Periode',
    aumico_cpmm_next_period: 'Nächste Periode',
    aumico_cpmm_workflow_save_success: 'Workflow erfolgreich gespeichert',
    aumico_cpmm_workflow_update_failure: 'Workflow konnte nicht aktualisiert werden. Bitte versuche es erneut.',
    aumico_cpmm_section_update_success: 'Abschnitt erfolgreich aktualisiert',
    aumico_cpmm_section_update_failure: 'Abschnitt konnte nicht aktualisiert werden. Bitte versuche es erneut.',
    aumico_cpmm_copy_of: 'Kopie von ',
    aumico_cpmm_period_tooltip:
        'Aktuelle Periode: Jahr des ausgewählten Bilanzstichtags für das Projekt, Nächste Periode: Jahr nach dem ausgewählten Bilanzstichtag.',
    aumico_tasks_unassigned: 'Nicht zugewiesen',
    aumico_pm_tasks_company_table_header: 'Unternehmen',
    aumico_pm_tasks_due_date_table_header: 'Fälligkeitsdatum',
    aumico_pm_tasks_section_table_header: 'Bereich',
    aumico_pm_tasks_task_table_header: 'Aufgabe',
    aumico_pm_tasks_latest_comment_table_header: 'Letzter Kommentar',
    aumico_pm_tasks_status_table_header: 'Status',
    aumico_licence_tooltip_max_reached:
        'Maximale Mandatsanzahl erreicht. Kontaktiere den Vertrieb für ein Upgrade deiner Lizenzanzahl',
    aumico_pm_tasks_responsible_table_header: 'Zuständig',
    aumico_pm_tasks_select_date_today: 'Heute',
    aumico_pm_tasks_filter_clear: 'Löschen',
    aumico_pm_tasks_assignee_filter_my_tasks: 'Meine Aufgaben',
    aumico_companies_form_closing_workflow: 'Abschluss-Workflow',
    aumico_cpmm_closing_workflows_table_delete_section_confirmation_text:
        'Bist du sicher, dass du diesen Abschnitt aus dem Workflow entfernen möchtest?',
    aumico_reports_main_navigation_projects: 'Projekte',
    aumico_reports_my_projects: 'Meine Projekte',
    aumico_reports_all_projects: 'Alle Projekte',
    aumico_projects_overview_page_header: 'Projekte',
    aumico_projects_overview_search_projects: 'Suchen',
    aumico_projects_overview_add_new_project: 'Neues Projekt',
    aumico_companies_export_excel_table_header_name: 'Name',
    aumico_companies_export_excel_table_header_street_and_number: 'Straße und Hausnummer',
    aumico_companies_export_excel_table_header_addition_to_address: 'Adresszusatz',
    aumico_companies_export_excel_table_header_zip_code: 'Postleitzahl',
    aumico_companies_export_excel_table_header_city: 'Ort',
    aumico_companies_export_excel_table_header_country: 'Land',
    aumico_companies_export_excel_table_header_assigned_user: 'Zugewiesener Benutzer',
    aumico_companies_export_excel_table_header_first_name: 'Vorname',
    aumico_companies_export_excel_table_header_last_name: 'Nachname',
    aumico_companies_export_excel_table_header_email: 'E-Mail',
    aumico_companies_export_excel_table_header_phone: 'Telefon',
    aumico_companies_export_excel_table_header_uid_number: 'UID-Nummer',
    aumico_companies_export_excel_table_header_legal_form: 'Rechtsform',
    aumico_companies_export_excel_table_header_tax_domicile: 'Steuersitz',
    aumico_companies_export_excel_table_header_industry: 'Branche',
    aumico_companies_export_excel_table_header_closing_workflow: 'Abschluss-Workflow',
    aumico_reports_main_navigation_tasks: 'Aufgaben',
    aumico_reports_main_navigation_tasks_and_closing: 'Mandatsverwaltung & Abschlussprozess',
    aumico_reports_tasks_and_closing_welcome_title: '🎉 Glückwunsch zum Upgrade!',
    aumico_reports_tasks_and_closing_upgrade_prompt: 'Upgrade zur All-in-One Plattform für den Jahresabschluss',
    aumico_reports_tasks_and_closing_confirm_and_continue: 'Bestätigen und fortfahren',
    aumico_reports_tasks_and_closing_cancel: 'Aktuell nicht',
    aumico_reports_tasks_and_closing_start: 'Termin vereinbaren',
    aumico_reports_tasks_and_closing_upgrade_access_description:
        'Mit dem Upgrade zur All-in-One Plattform für den Jahresabschluss erhältst du Zugang zum Mandats- und Aufgabenmanagement sowie zum Abschlussprozess. Beachte, dass diese Funktionen kostenpflichtig sind und dein Konto bei Aktivierung belastet wird.',
    aumico_reports_tasks_and_closing_success_message:
        'Du hast erfolgreich die <b>All-in-One Plattform für den Jahresabschluss</b> aktiviert. \nAb sofort profitierst du von erweiterten Funktionen für <b>Mandantenverwaltung</b>, <b>Aufgabensteuerung</b> und den gesamten <b>Abschlussprozess</b>. \nUnser <b>Customer Success Team</b> unterstützt dich gerne beim Einrichten – melde dich einfach bei uns!',
    aumico_reports_tasks_and_closing_advertising_title: 'Entdecke die All-in-One Plattform für deinen Jahresabschluss!',
    aumico_reports_tasks_and_closing_advertising_description:
        'Verwalte Mandanten, Aufgaben und den Abschlussprozess sowie die Berichterstellung an einem Ort – kompatibel mit jeder Buchhaltungslösung. \nOptimiere jetzt deine Arbeitsabläufe!',
    aumico_reports_tasks_and_closing_advertising_mandate_management_title: 'Mandats- und Aufgabenmanagement',
    aumico_reports_tasks_and_closing_advertising_mandate_management_description:
        'Standardisiere Workflows für wiederkehrende Aufgaben wie MwSt., Lohnbuchhaltung und Steuererklärungen über alle Kunden hinweg.',
    aumico_reports_tasks_and_closing_advertising_closing_workflow_title: 'Abschlussprozess',
    aumico_reports_tasks_and_closing_advertising_closing_workflow_description:
        'Konfiguriere und verwalte End-to-End-Abschluss-Workflows sowie Dokumente und Notizen zentral an einem Ort.',
    aumico_reports_tasks_and_closing_advertising_upgrade_button: 'Upgrade',
    aumico_create_project_invalid_date:
        'Ungültiges Datum. Englisches Format ist MM/DD/YYYY, deutsches Format ist DD.MM.YYYY',
    aumico_reports_project_upload_document_title: 'Dokument hochladen',
    aumico_reports_project_upload_document_description:
        'Wähle eine Datei von deinem Gerät aus, um sie zu dieser Aufgabe hinzuzufügen. Unterstützte Formate: ',
    aumico_reports_project_upload_document_drag: 'Dateien hier hineinziehen zum Hochladen',
    aumico_reports_project_upload_document_details: '(Max. Dateigröße 25MB)',
    aumico_cpmm_workflow_configurator_empty_section_confirmation_text:
        'Bist du sicher, dass du mit leeren Abschnitten ohne Aufgaben speichern möchtest? Dies führt zur Löschung dieser Abschnitte',
    cpmm_projects_overview_empty_mandates: 'Du hast noch keine Mandate!',
    cpmm_projects_overview_empty_companies: 'Es gibt noch keine Unternehmen!',
    cpmm_projects_overview_empty_assign_instructions:
        'Beginne mit der Zuweisung von Unternehmen im Unternehmensprofil. Sie erscheinen hier, sobald sie hinzugefügt wurden!',
    cpmm_projects_overview_empty_create_instructions: 'Erstelle neue Unternehmen, um sie hier aufgelistet zu sehen.',
    cpmm_projects_overview_empty_go_to_companies_button: 'Zur Unternehmensübersicht',
    cpmm_projects_overview_empty_add_new_company_button: 'Neues Unternehmen hinzufügen',
    cpmm_projects_overview_group_mandate_management: 'Mandatsverwaltung',
    cpmm_projects_overview_group_closing_workflow: 'Abschluss-Workflow',
    cpmm_projects_overview_group_report: 'Bericht',
    cpmm_projects_overview_col_company: 'Unternehmen',
    cpmm_projects_overview_col_balance_sheet_date: 'Bilanzstichtag',
    cpmm_projects_overview_col_responsible: 'Verantwortlich',
    cpmm_projects_overview_col_status: 'Status',
    cpmm_projects_overview_action_change_status_to_done: 'Status auf Erledigt ändern',
    cpmm_projects_overview_action_change_status_to_active: 'Status auf Aktiv ändern',
    cpmm_projects_overview_action_delete_project: 'Projekt löschen',
    cpmm_projects_overview_badge_active: 'Aktiv',
    cpmm_projects_overview_header_row_abcp_closing: 'Status',
    cpmm_projects_overview_badge_closing_started: 'Gestartet',
    cpmm_projects_overview_badge_closing_not_started: 'Nicht gestartet',
    cpmm_projects_overview_badge_done: 'Erledigt',
    cpmm_projects_overview_badge_report_open: 'Offen',
    cpmm_projects_overview_badge_report_sealed: 'Versiegelt',
    cpmm_projects_overview_badge_archived: 'Archiviert',
    cpmm_projects_overview_header_row_GENERAL: 'Allgemein',
    cpmm_projects_overview_header_row_BALANCE_SHEET: 'Bilanz',
    cpmm_projects_overview_header_row_INCOME_STATEMENT: 'Gewinn- und Verlustrechnung',
    cpmm_projects_overview_empty_individual_company: 'Für diese Firma gibt es noch keine Projekte',
    cpmm_projects_overview_empty_create_instructions_individual_company:
        'Erstelle ein Projekt und bring den Abschluss ins Rollen!',
    aumico_companies_table_label_company_workflow: 'Workflow',
    cpmm_projects_overview_empty_filtered_text1: 'Keine Projekte gefunden',
    cpmm_projects_overview_empty_filtered_text2:
        'Aktuelle Filter liefern keine Projekte, bitte anpassen oder zurücksetzen.',
    tasks_empty_state_text_one_filters: 'Keine Aufgaben gefunden',
    tasks_empty_state_text_two_filters:
        'Mit den aktuellen Filtern wurden keine Aufgaben gefunden. Bitte passe sie an oder setze sie zurück.',
    aumico_reports_cpmm_tasks: 'Aufgaben',
    aumico_reports_cpmm_export_tasks: 'XLSX exportieren',
    aumico_reports_cpmm_export_tasks_open_tasks: 'Offene Aufgaben',
    aumico_reports_cpmm_export_tasks_completed_tasks: 'Abgeschlossene Aufgaben',
    aumico_reports_cpmm_export_tasks_na_tasks: 'N/A Aufgaben',
    aumico_reports_cpmm_export_tasks_include_documents_names: 'Dokumente einschließen',
    aumico_reports_cpmm_export_tasks_include_annotations: 'Anmerkungen einschließen',
    aumico_reports_cpmm_export_tasks_in_progress_tasks: 'Aufgaben in Bearbeitung',
    aumico_reports_cpmm_export_tasks_in_review_tasks: 'Aufgaben in Prüfung',
    aumico_reports_cpmm_export_documents_zip_mandate_management_documents: 'Mandatsverwaltung Dokumente',
    aumico_reports_cpmm_export_documents_zip_closing_workflow_documents: 'Abschluss-Workflow Dokumente',
    tasks_empty_state_text_one: 'Du hast noch keine Aufgaben!',
    tasks_empty_state_text_two: 'Beginne mit der Erstellung eines neuen Projekts.',
    aumico_license_book_call_text: 'Wenn du nicht warten möchtest, buche direkt einen Termin mit dem Vertriebsteam.',
    aumico_license_book_call_button: 'Termin buchen',
    aumico_reports_export_all_companies_file_name: 'Alle Unternehmen',
    aumico_cpmm_document_uploaded_success_title: 'Dokument erfolgreich hochgeladen',
    aumico_cpmm_document_uploaded_success_description: 'Das Dokument wurde erfolgreich hochgeladen',
    aumico_cpmm_document_uploaded_failure_title: 'Fehler beim Hochladen des Dokuments',
    aumico_cpmm_document_uploaded_failure_description:
        'Das Dokument konnte nicht hochgeladen werden. Bitte versuche es erneut',
    aumico_cpmm_task_bulk_update_success_title: 'Aufgaben erfolgreich aktualisiert',
    aumico_cpmm_task_bulk_update_success_description: 'Die Aufgaben wurden erfolgreich aktualisiert.',
    aumico_cpmm_task_bulk_update_failure_title: 'Fehler beim Aktualisieren der Aufgaben',
    aumico_cpmm_task_bulk_update_failure_description:
        'Die Aufgaben konnten nicht aktualisiert werden. Bitte versuche es erneut.',
    aumico_company_assignee_change_confirmation_dialog_title: 'Sachbearbeiter ändern',
    aumico_company_assignee_change_confirmation_dialog_text:
        'Du ersetzt den aktuellen Sachbearbeiter für diese Firma. Was soll mit den bestehenden Aufgaben passieren?',
    aumico_company_assignee_change_confirmation_update_tasks_assigned_to_current_user:
        'Nur Aufgaben neu zuweisen, die dem alten Sachbearbeiter zugewiesen waren',
    aumico_company_assignee_change_confirmation_update_all_tasks:
        'Alle Aufgaben neu zuweisen, auch die von anderen Benutzern',
    aumico_company_assignee_change_confirmation_option: 'Option',
    aumico_project_overview_project_deletion_confirmation_text:
        'Bist du sicher, dass du dieses Projekt löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.',
    aumico_project_overview_project_delete_success_message: 'Projekt erfolgreich gelöscht',
    aumico_cpmm_projects_bulk_delete_success_description: 'Die ausgewählten Projekte wurden erfolgreich gelöscht.',
    aumico_cpmm_projects_bulk_delete_failure_title: 'Fehler beim Löschen der Projekte',
    aumico_cpmm_projects_bulk_delete_failure_description:
        'Die ausgewählten Projekte konnten nicht gelöscht werden. Bitte versuche es erneut.',
    aumico_cpmm_projects_bulk_delete_success_title: 'Projekte erfolgreich gelöscht',
    aumico_project_overview_project_delete_error_message: 'Fehler beim Löschen des Projekts. Bitte versuche es erneut.',
    aumico_companies_form_validation_error: 'Nicht alle Pflichtfelder sind ausgefüllt',
    aumico_cpmm_sync_success_title: 'Aufgaben wurden erfolgreich synchronisiert',
    aumico_cpmm_sync_success_description: 'Die Aufgaben sind alle mit dem Konfigurator synchronisiert',
    aumico_cpmm_sync_failure_title: 'Aufgaben konnten nicht synchronisiert werden',
    aumico_cpmm_sync_failure_description:
        'Stelle sicher, dass im Firmenprofil dieser Firma ein Abschlussprozess hinterlegt ist!',
    aumico_MM_sync_banner:
        'Änderungen im Mandats Management Konfigurator erkannt. Möchtest Du die Änderungen auf dieses Projekt anwenden?',
    aumico_CP_sync_banner:
        'Änderungen im Abschlussprozess Konfigurator erkannt. Möchtest Du die Änderungen auf dieses Projekt anwenden?',
    aumico_MM_sync_dismiss_text: 'Nein, nicht anwenden',
    aumico_MM_sync_yes_text: 'Ja, anwenden',
    cpmm_workflow_tasks_empty: 'Keine Aufgaben verfügbar!',
    cpmm_workflow_tasks_empty_sync_instructions_MM:
        'Synchronisiere dein Projekt, um Aufgaben aus der Mandatsverwaltungskonfiguration zu importieren.',
    cpmm_workflow_tasks_empty_sync_instructions_CP:
        'Synchronisiere dein Projekt, um Aufgaben aus der Abschlussprozess-Konfiguration zu importieren.',
    aumico_workflow_sync: 'Workflow synchronisieren',
    aumico_company_delete_failed_because_of_conf_notification_message:
        'Fehler beim Löschen des Unternehmens aufgrund bestehender Abhängigkeiten... Du musst zuerst die bestehenden Projekte dieses Unternehmens löschen.',
    aumico_company_delete_failed_because_of_conf_notification_title: 'Fehler beim Löschen des Unternehmens',
    aumico_unknown_error:
        'Ein unbekannter Fehler ist aufgetreten. Bitte versuche es erneut oder kontaktiere den Support.',
    aumico_companies_workflow_change_title: 'Abschluss-Workflow ändern?',
    aumico_companies_workflow_change_text:
        'Die Änderung des Abschluss-Workflows betrifft nur neue Projekte. Bestehende Projekte bleiben unverändert, solange nicht manuell synchronisiert wird. Möchtest Du fortfahren?',
    aumico_companies_workflow_change_cancel: 'Abbrechen',
    aumico_companies_workflow_change_confirm: 'Bestätigen',
    aumico_projects_status_active: 'Aktiv',
    aumico_projects_status_done: 'Erledigt',
    aumico_projects_status_archived: 'Archiviert',
    aumico_project_overview_status_update_success_message: 'Projektstatus wurde erfolgreich aktualisiert.',
    aumico_project_overview_status_update_error_message:
        'Beim Aktualisieren des Projektstatus ist ein Problem aufgetreten.',
    aumico_annualreport_redo_confirmation_title: 'Jahresrechnung neu starten?',
    aumico_annualreport_redo_confirmation_description:
        'Wenn Du die Jahresrechnung neu startest, wird der aktuelle Stand gelöscht und Du kannst eine neue Jahresrechnung beginnen. Alle bisherigen Daten gehen verloren.',
    aumico_annual_report_complementary_reports_empty_state_text1: 'Noch keine ergänzenden Berichte vorhanden!',
    aumico_annual_report_complementary_reports_empty_state_text2:
        'Füge zum Beispiel eine Vollständigkeitserklärung oder das Protokoll der Generalversammlung hinzu.\n Du kannst die Berichte mit Platzhaltern wie @Firmaname oder @BalancesheetDate automatisieren.',
    aumico_annual_report_complementary_reports_empty_state_text3:
        '<b>Tipp:</b> Standardisiere deine Vorlagen in den Organisationseinstellungen, um sie bei jeder Firma wiederzuverwenden.',
    aumico_company_assignee_change_confirmation_dialog_save_button: 'Weiter',
    aumico_company_assignee_change_confirmation_update_tasks_assigned_to_current_user_description_text:
        'Alle Aufgaben, die bisher dem alten Sachbearbeiter zugewiesen waren, werden dem neuen Sachbearbeiter übertragen.',
    aumico_company_assignee_change_confirmation_update_all_tasks_description_text:
        'Alle Aufgaben werden dem neuen Sachbearbeiter zugewiesen – egal, wer vorher verantwortlich war.',
    invite_friend_modal_title: 'Tell a Friend',
    invite_friend_description:
        'Du findest aumico hilfreich und kennst jemanden, für den es ebenfalls nützlich sein könnte? Dann empfiehl uns gerne weiter – wir freuen uns über jede Empfehlung ❤️',
    invite_friend_email_label: 'E-Mail',
    invite_friend_message_label: 'Nachricht',
    invite_friend_message_placeholder: 'Füge deine persönliche Nachricht hinzu...',
    aumico_annual_report_complementary_reports_sample_empty_state_text1: 'Noch keine Berichtsvorlagen vorhanden',
    aumico_annual_report_complementary_reports_sample_empty_state_text2:
        'Erstelle hier Standard-Vorlagen für ergänzende Berichte wie Vollständigkeitserklärungen oder Generalversammlungsprotokolle. \nSo kannst du sie später direkt in jedem Mandat verwenden – ganz automatisch mit Platzhaltern wie <b>@company.name</b> oder <b>@ar.duedate</b>.',
    aumico_annual_report_complementary_reports_sample_empty_state_text3:
        '<b>Tipp:</b> Auf unserer <a href="https://aumico.freshdesk.com/support/solutions/articles/204000001667-erg%C3%A4nzende-berichte-alle-platzhalter-erkl%C3%A4rt-tabelle" target="_blank">Support Seite</a> findest du alle Platzhalter, die du verwenden kannst.',
    aumico_companies_empty_state_text1: 'Hier gibt es noch keine Firma',
    aumico_companies_empty_state_text2: 'Lege deine erste Firma an und starte mit der Projekterfassung.',
    cpmm_projects_overview_col_report_status: 'Berichtsstatus',
    cpmm_projects_overview_col_project_status: 'Projektstatus',
    aumico_organization_settings_mandate_management_configuration_info_text1:
        'Erfasse die Fälligkeitsdaten deiner Aufgaben so, <b>als ob das Geschäftsjahr immer vom 1.1. bis 31.12. geht.</b> (Bilanzstichtag 31.12.)',
    aumico_organization_settings_mandate_management_configuration_info_text2:
        'Wenn du später ein Projekt mit einem anderen Bilanzstichtag erstellst (z. B. <b>30.06.</b>), <b>werden alle Deadlines automatisch verschoben</b> – ganz ohne manuelles Anpassen.',
    aumico_organization_settings_mandate_management_configuration_info_title: 'Tipp  💡',
    aumico_organization_settings_mandate_management_configuration_info_text_example:
        '<b>Beispiel:</b> \nEine Aufgabe mit Fälligkeitsdatum <b>31.03.</b> wird bei einem Bilanzstichtag <b>30.06.</b> automatisch auf den <b>30.09.</b> gesetzt.',
    aumico_backend_errors_workflow_name_already_exists: 'Ein Workflow mit diesem Namen existiert bereits.',
    aumico_app_cpmm_documents_open: 'Vorschau',
    aumico_app_cpmm_documents_download: 'Herunterladen',
    aumico_app_cpmm_documents_wait_for_anti_virus: 'Warten auf Virenscan',
    aumico_app_cpmm_documents_preview_loading: 'Lädt...',
    aumico_app_cpmm_documents_preview_failed: 'Vorschau fehlgeschlagen',
    aumico_app_cpmm_documents_preview_not_supported: 'Vorschau nicht unterstützt',
    aumico_notes_update_banner_message:
        'Änderungen erkannt: Gruppierung, Kontenzuordnung oder Saldobilanz wurden seit dem letzten Speichern geändert. Der Anhang zeigt bereits die aktuellen Werte. Speichere ihn, damit sie auch im Druck erscheinen.',
    aumico_notes_update_banner_button: 'Änderungen anwenden',
    aumico_print_notes_outdated_banner_message:
        'Der Anhang ist nicht aktuell: Gruppierung, Kontenzuordnung oder Saldobilanz wurden seit dem letzten Speichern geändert. Öffne den Anhang und speichere ihn, damit der Druck die aktuellen Werte zeigt.',
    aumico_print_notes_outdated_banner_button: 'Anhang öffnen',
    aumico_notes_update_confirmation_success: 'Anhang wurde erfolgreich aktualisiert.',
    aumico_notes_action_palette_column_label_name: 'Spaltenbezeichnung',
    aumico_notes_action_palette_column_label_show_fiscal_year: 'Geschäftsjahr anzeigen',
    aumico_notes_action_palette_column_label_show_balance_sheet_date: 'Bilanzstichtag anzeigen',
    aumico_notes_action_palette_column_label_hide_column: 'Spalte ausblenden',
    aumico_notes_action_palette_column_label_currency: 'Währung',
    aumico_notes_super_table_show_currency: 'Währung anzeigen',
    aumico_notes_components_list_actions_table_tooltip: 'Tabelleneinstellungen',
    aumico_notes_components_list_actions_footnote_tooltip: 'Fußnoten',
    aumico_notes_components_list_actions_copy_tooltip: 'Komponente kopieren',
    aumico_notes_components_list_actions_break_page_tooltip: 'Seitenumbruch nach der Komponente einfügen',
    aumico_notes_components_list_actions_hide_component_tooltip: 'Komponente ausblenden',
    aumico_notes_components_list_actions_show_component_tooltip: 'Komponente anzeigen',
    aumico_notes_actions_hide_accordion_tooltip: 'Alle Komponenten im Akkordeon ausblenden',
    aumico_notes_actions_show_accordion_tooltip: 'Alle Komponenten im Akkordeon anzeigen',
    aumico_notes_component_hidden_badge: 'AUSGEBLENDET',
    aumico_notes_super_table_edit_row: 'Zeile bearbeiten',
    aumico_notes_super_table_remove_row: 'Zeile entfernen',
    aumico_notes_super_table_row_format: 'Zeilenformat',
    aumico_notes_super_table_column_format: 'Spaltenformat',
    aumico_notes_super_table_remove_column: 'Spalte entfernen',
    aumico_notes_super_table_current_year_column_removal_confirmation:
        'Bist du sicher dass du die Spalte ausblenden willst? Die Daten werden durch das Ausblenden gelöscht.',
    aumico_annual_report_print_page_rounding_disclaimer:
        'Alle angezeigten Werte sind aus Darstellungsgründen gerundet. Durch Rundungen kann es zu geringfügigen Abweichungen zwischen den angezeigten Summen und den tatsächlichen Gesamtwerten kommen.',
    aumico_notes_footnote_label: 'Fußnote',
    aumico_notes_footnote_placeholder: 'Füge eine Fußnote zu dieser Tabelle hinzu',
    aumico_notes_add_more_movement: 'Neuen Spiegel hinzufügen',
    aumico_notes_add_more_fli: 'Neuen Aufriss hinzufügen',
    aumico_notes_add_more_row: 'Neue Zeile hinzufügen',
    aumico_notes_add_component: 'Neue Komponente hinzufügen',
    aumico_notes_super_table_edit_reconcile: 'Wertabstimmung bearbeiten',
    aumico_add_new_notes_clipboard_title: 'Zwischenablage',
    aumico_add_new_notes_paste_from_clipboard: 'Einfügen',
    aumico_notes_component_copied_to_clipboard: 'In die Zwischenablage kopiert',
    aumico_notes_component_pasted_successfully: 'Zu den Anhängen hinzugefügt',
    aumico_notes_super_table_add_column_width: 'Spaltenbreite',
    aumico_notes_super_table_options_col_width_dynamic: 'Dynamisch',
    aumico_notes_super_table_options_col_width_small: 'Klein',
    aumico_notes_super_table_options_col_width_standard: 'Standard',
    aumico_notes_super_table_options_col_width_large: 'Gross',
    aumico_notes_empty_state_text_1: 'Gestalte deine Tabelle so, wie du sie brauchst.',
    aumico_notes_empty_state_text_2: 'Die erste Zeile bringt alles ins Rollen.',
    aumico_notes_add_row_text: 'Zeile hinzufügen',
    aumico_projects_overview_status_update_modal_title: 'Alle offenen Aufgaben abschliessen?',
    aumico_projects_overview_status_update_modal_text:
        'Möchtest du, dass alle offenen Aufgaben automatisch abgeschlossen werden?',
    aumico_projects_overview_status_update_modal_confirm: 'Ja',
    aumico_projects_overview_status_update_modal_cancel: 'Nein',
    aumico_companies_assignee_filter_my_companies: 'Meine Firmen',
    aumico_companies_filter_clear: 'Löschen',
    aumico_notes_super_table_add_row_menu_sub_title: 'Wähle, welche Art von Zeile du der Tabelle hinzufügen möchtest.',
    aumico_notes_super_table_add_column_menu_sub_title:
        'Wähle, welche Art von Spalte du der Tabelle hinzufügen möchtest.',
    aumico_notes_info_dialog_column_title: 'So verwendest du die Spaltenbreite-Einstellung richtig  💡',
    aumico_notes_info_dialog_column_text1:
        '<b>Dynamisch</b> teilt den verfügbaren Platz gleichmässig auf alle als dynamisch markierten Spalten auf.',
    aumico_notes_info_dialog_column_text2:
        '<b>Tipp:</b> Falls du beispielsweise Prozentzahlen darstellen willst, verwende <b>klein</b>. Für Textspalten bietet sich <b>dynamisch</b> an. <b>Standard</b> passt für Zahlen und ist gleich breit wie alle anderen Tabellen im PDF.',
    aumico_notes_info_dialog_column_done: 'Verstanden',
    aumico_admin_navigation_announcements: 'Ankündigungen',
    aumico_admin_announcements_message: 'Nachricht',
    aumico_admin_announcements_link_url: 'Link Url',
    aumico_admin_announcements_link_url_placeholder: 'https://example.com',
    aumico_admin_announcements_link_name: 'Link Name',
    aumico_admin_announcements_link_name_placeholder: 'Link Name',
    aumico_admin_announcements_dismissible: 'Kann verworfen werden',
    aumico_admin_announcements_date_range: 'Datumsbereich',
    aumico_admin_announcements_create_new_announcement: 'Neue Ankündigung',
    aumico_admin_announcements_edit_announcement: 'Ankündigung bearbeiten',
    aumico_admin_announcements_start_date: 'Startdatum',
    aumico_admin_announcements_end_date: 'Enddatum',
    aumico_admin_announcements_start_date_required: 'Startdatum ist erforderlich',
    aumico_admin_announcements_end_date_required: 'Enddatum ist erforderlich',
    aumico_admin_announcements_update_success: 'Ankündigung erfolgreich aktualisiert',
    aumico_admin_announcements_create_success: 'Ankündigung erfolgreich erstellt',
    aumico_admin_announcements_delete_success: 'Ankündigung erfolgreich gelöscht',
    aumico_admin_success_title: 'Erfolg',
    aumico_annual_report_complementary_reports_preview_button: 'PDF Vorschau',
    aumico_annual_report_complementary_reports_add_from_template: 'Berichtsvorlage einfügen',
    aumico_annual_report_complementary_reports_add_blank_report: 'Leeren Bericht hinzufügen',
    aumico_annual_report_complementary_reports_upload_PDF: 'PDF hochladen',
    aumico_annual_report_complementary_reports_new_title: 'Neuen Bericht hinzufügen',
    aumico_annual_report_complementary_reports_select_template: 'Vorlage auswählen',
    aumico_annual_report_complementary_reports_template_add: 'Einfügen',
    aumico_annual_report_complementary_reports_template_cancel: 'Abbrechen',
    aumico_annual_report_complementary_reports_preview_scanning_warning:
        'Beim Drucken wird statt deinem PDF eine weisse Seite eingefügt.',
    aumico_annual_report_complementary_reports_show_page_numbers_toggle: 'Seitenzahlen anzeigen',
    aumico_create_project_dialog_select_report_type: 'Berichtstyp auswählen',
    aumico_create_project_dialog_select_report_type_annual: 'Jahresabschluss',
    aumico_create_project_dialog_select_report_type_quarterly: 'Quartalsabschluss',
    aumico_create_project_dialog_select_report_type_monthly: 'Monatsabschluss',
    aumico_create_project_dialog_select_report_type_custom: 'Individueller Zwischenabschluss',
    aumico_annual_report_general_information_ar_template: 'Berichtskomponenten',
    aumico_annual_report_general_information_select_ar_template: 'Berichtskomponenten auswählen',
    aumico_annual_report_general_information_report_type: 'Berichtstyp',
    aumico_annual_report_general_information_select_report_type: 'Berichtstyp auswählen',
    aumico_company_update_banner_message:
        'Du hast die Unternehmensinformationen aktualisiert. Möchtest du die Änderungen auf dieses Projekt anwenden?',
    aumico_company_update_banner_button: 'Ja, anwenden',
    aumico_annual_report_translation_gaps_title: 'Texte ohne Übersetzung',
    aumico_annual_report_translation_gaps_text: 'Texte haben keine Übersetzung auf {{language}}.',
    aumico_annual_report_translation_gaps_reassurance: 'Die KI übersetzt sie im Stil der Übersetzungen, die in diesem Bericht schon stehen. Danach können die Übersetzungen im Review überprüft oder direkt gespeichert werden.',
    aumico_annual_report_translation_done_title: 'Übersetzung abgeschlossen',
    aumico_annual_report_translation_done_count: '{{count}} Texte wurden auf {{language}} übersetzt.',
    aumico_annual_report_translation_done_question: 'Möchten Sie die Übersetzung überprüfen oder direkt speichern?',
    aumico_annual_report_translation_done_legend_ai: 'Von der KI übersetzt',
    aumico_annual_report_translation_done_legend_mapping: 'Standardübersetzung',
    aumico_annual_report_translation_done_legend_heading: 'Im Review-Modus:',
    aumico_annual_report_translation_done_legend_unmarked: 'Nicht markierte Stellen sind nicht bearbeitbar.',
    aumico_annual_report_translation_legend_title: 'Legende',
    aumico_annual_report_translation_done_legend_user: 'Manuell bearbeitet',
    aumico_annual_report_translation_action_review: 'Review',
    aumico_annual_report_translation_action_save_now: 'Jetzt speichern',
    aumico_annual_report_translation_action_translate: 'Mit KI übersetzen',
    aumico_annual_report_translation_action_later: 'Später',
    aumico_annual_report_translation_manage_title: 'Übersetzung verwalten',
    aumico_annual_report_translation_manage_text: 'Sie können die Übersetzungen dieser Sprache im Review durchgehen und einzeln korrigieren.',
    aumico_annual_report_translation_manage_review: 'Review',
    aumico_annual_report_translation_manage_undo: 'Rückgängig',
    aumico_annual_report_translation_manage_refresh: 'Auf neue Lücken prüfen',
    aumico_annual_report_translation_manage_no_gaps: 'Keine neuen Lücken gefunden.',
    aumico_annual_report_translation_undo_title: 'Übersetzung zurücknehmen',
    aumico_annual_report_translation_undo_text: 'Alle Übersetzungen dieser Sprache werden gelöscht, samt Ihren eigenen Korrekturen.',
    aumico_annual_report_translation_undo_confirm: 'Löschen',
    aumico_annual_report_translation_part_template: 'Bilanz und Erfolgsrechnung',
    aumico_annual_report_translation_part_accounts: 'Konten',
    aumico_annual_report_translation_part_notes: 'Anhang',
    aumico_annual_report_translation_part_aop: 'Gewinnverwendung',
    aumico_annual_report_translation_part_ems: 'Eigenkapitalnachweis',
    aumico_annual_report_translation_part_cashflow: 'Geldflussrechnung',
    aumico_annual_report_translation_part_complementary: 'Zusatzberichte',
    aumico_annual_report_translation_running: '{{count}} Texte werden auf {{language}} übersetzt.',
    aumico_annual_report_translation_running_progress: '{{translated}} von {{total}} Texten übersetzt.',
    aumico_annual_report_translation_running_hint: 'Das dauert meist unter einer Minute. Bitte lassen Sie das Fenster offen.',
    aumico_annual_report_translation_failed: 'Die Übersetzung ist fehlgeschlagen. Am Bericht hat sich nichts geändert.',
    aumico_annual_report_translation_save: 'Speichern',
    aumico_annual_report_translation_edit_title: 'Übersetzung korrigieren',
    aumico_annual_report_translation_edit_source: 'Berichtssprache',
    aumico_annual_report_translation_edit_target: 'Übersetzung',
    aumico_annual_report_translation_edit_empty: 'Das Feld darf nicht leer sein.',
    aumico_annual_report_translation_manage: 'Übersetzung verwalten',
    aumico_annual_report_translation_sealed_tooltip: 'Entsiegeln Sie den Bericht, um die Übersetzung zu bearbeiten.',
    aumico_company_update_banner_sealed_tooltip: 'Entsiegle den Bericht, um die Änderungen anwenden zu können.',
    aumico_general_information_current_period: 'Aktueller Zeitraum',
    aumico_general_information_balance_sheet: 'Bilanz',
    aumico_general_information_balance_sheet_date: 'Bilanzstichtag',
    aumico_general_information_income_statement: 'Erfolgsrechnung',
    aumico_general_information_previous_period: 'Vorheriger Zeitraum',
    aumico_general_information_load_previous_data_from_aumico: 'Daten des vorherigen Zeitraums von aumico laden',
    aumico_general_information_select_report: 'Bericht auswählen',
    aumico_general_information_choose_dataset_tooltip_text:
        'Du kannst einen Datensatz eines vorhandenen Berichts auswählen',
    cpmm_projects_overview_col_report_type: 'Berichtstyp',
    aumico_annual_report_general_information_has_previous_data: 'Daten des vorherigen Zeitraums vorhanden',
    aumico_ui_no_access_title: 'Kein Zugriff',
    aumico_ui_no_access_message:
        'Du hast keinen Zugriff auf die Organisationseinstellungen. Bitte kontaktiere deinen Administrator.',
    aumico_ui_document_edit_form_title_add: 'Dokumentation hinzufügen',
    aumico_ui_document_edit_form_title_edit: 'Dokumentation bearbeiten',
    aumico_ui_document_edit_form_file_existing: 'Vorhandene Datei',
    aumico_ui_document_edit_form_file_upload_error_format:
        'Dateityp nicht unterstützt. Bitte lade eine Datei mit einer der akzeptierten Endungen hoch.',
    aumico_ui_document_edit_form_file_required_error: 'Bitte wähle eine Datei zum Hochladen aus.',
    aumico_ui_document_edit_form_link_required_error: 'Link-URL ist erforderlich.',
    aumico_ui_document_edit_form_link_validation_error:
        'Bitte gib eine gültige HTTPS-URL ein (z.B. https://www.aumico.io).',
    aumico_ui_document_edit_form_name_placeholder: 'Dokumentenname',
    aumico_ui_document_edit_form_name_label: 'Gib deinem Dokument einen Namen',
    aumico_ui_document_edit_form_set_as_permanent: 'Als dauerhaft festlegen',
    aumico_ui_document_edit_form_set_as_permanent_tooltip:
        'Du kannst eine Datei als dauerhaft festlegen und für die nächsten Perioden behalten oder ein Ablaufdatum hinzufügen.',
    aumico_ui_document_edit_form_expiration_date_label: 'Ablaufdatum (optional)',
    aumico_ui_document_edit_form_expiration_date_placeholder: 'Ablaufdatum wählen',
    aumico_ui_document_edit_form_save_changes: 'Änderungen speichern',
    aumico_ui_document_edit_form_cancel: 'Abbrechen',
    aumico_ui_document_edit_form_submit_add: 'Dokument hinzufügen',
    aumico_ui_document_edit_form_submit_add_link: 'Link hinzufügen',
    aumico_ui_document_edit_form_file_upload: 'Datei hochladen',
    aumico_ui_document_edit_form_add_link: 'Link hinzufügen',
    aumico_ui_document_edit_form_add_link_label: 'Link',
    aumico_ui_document_edit_form_add_link_tooltip:
        'Füge einen Link zu einem externen Dokument hinzu (z.B. SharePoint, Google Drive, Dropbox). Es sind nur HTTPS-Links erlaubt.',
    aumico_ui_document_edit_form_add_link_placeholder: 'https://...',
    aumico_app_cpmm_documents_delete_confirmation:
        'Bist du sicher, dass du das Dokument "{{ documentName }}" löschen möchtest?',
    aumico_session_warning_reauth_button: 'Erneut anmelden',
    aumico_session_warning_message:
        'Deine Sitzung läuft in {{timeLeft}} ab. Bitte speichere deine Arbeit und melde dich erneut an, um fortzufahren.',
    aumico_ui_document_has_expired: 'Dieses Dokument ist abgelaufen: ',
    aumico_ui_document_about_to_expire: 'Dieses Dokument läuft bald ab: ',
    aumico_app_cpmm_documents_open_link: 'Im Browser öffnen',
    aumico_app_cpmm_documents_is_permanent_tooltip: 'Dieses Dokument ist dauerhaft.',
    aumico_companies_list_filter_mandate_manager: 'Mandatsleiter',
    aumico_companies_list_filter_clerk: 'Sachbearbeiter',
    aumico_projects_overview_filter_assignee_label: 'Verantwortlich',
    aumico_tasks_overview_filter_assignee_label: 'Zuständig',
    aumico_companies_bulk_changes_saved_successfully_dialog: 'Die Firmen wurden erfolgreich aktualisiert',
    aumico_company_assignee_change_dialog_title: 'Mandatsleiter ändern?',
    aumico_company_assignee_change_dialog_title_plural: 'Mandatsleiter für {{ count }} Firmen ändern?',
    aumico_company_clerk_change_dialog_title: 'Sachbearbeiter ändern?',
    aumico_company_clerk_change_dialog_title_plural: 'Sachbearbeiter für {{ count }} Firmen ändern?',
    aumico_company_assignee_change_dialog_select_new_assignee: 'Neuen Mandatsleiter auswählen',
    aumico_company_clerk_change_dialog_select_new_clerk: 'Neuen Sachbearbeiter auswählen',
    aumico_company_assignee_change_dialog_add_assignee_for_selected_tasks: 'Mandatsleiter auswählen...',
    aumico_company_clerk_change_dialog_add_clerk_for_selected_tasks: 'Sachbearbeiter auswählen...',
    aumico_companies_bulk_edit_action_bar_selected_text: 'ausgewählt',
    aumico_bulk_edit_action_bar_max_selection_error: 'Maximal {{max}} Auswahlen für diese Aktion erlaubt',
    aumico_companies_assignee_change_action_bar: 'Mandatsleiter ändern',
    aumico_companies_clerk_change_action_bar: 'Sachbearbeiter ändern',
    aumico_companies_create_next_financial_year_action_bar: 'Nächstes Geschäftsjahr erstellen',
    aumico_companies_deactivate_action_bar: 'Firmen deaktivieren',
    aumico_companies_bulk_create_financial_year_modal_title: 'Geschäftsjahr-Erstellung Vorschau',
    aumico_companies_bulk_create_financial_year_confirm: 'Erstellen & Bestätigen',
    aumico_companies_bulk_create_financial_year_summary: '{{ready}} werden erstellt, {{attention}} mit Besonderheiten, {{skip}} übersprungen',
    aumico_companies_bulk_create_ready: 'Bereit zur Erstellung',
    aumico_companies_bulk_create_attention: 'Achtung: Abweichende Geschäftsjahre',
    aumico_companies_bulk_create_skipped: 'Übersprungen',
    aumico_companies_bulk_create_creating_year: '{{year}} erstellen',
    aumico_companies_bulk_create_clients: 'Mandanten',
    aumico_companies_bulk_create_preview_failed: 'Fehler beim Laden der Vorschau',
    aumico_companies_bulk_create_success: '{{created}} Geschäftsjahre erfolgreich erstellt, {{failed}} Fehler',
    aumico_companies_bulk_create_failed: 'Fehler beim Erstellen der Geschäftsjahre',
    aumico_companies_bulk_create_job_failed: 'Sammel-Erstellung fehlgeschlagen. Bitte erneut versuchen.',
    aumico_companies_bulk_create_processing: 'Geschäftsjahre werden verarbeitet',
    aumico_companies_bulk_create_processing_status: '{{processed}} von {{total}} Mandanten werden verarbeitet...',
    aumico_companies_bulk_create_success_count: 'Erfolgreich',
    aumico_companies_bulk_create_failure_count: 'Fehlgeschlagen',
    aumico_companies_bulk_create_reason_error_calculating_preview: 'Fehler beim Berechnen der Vorschau. Kontaktieren Sie den Support.',
    aumico_companies_bulk_create_reason_company_status_only_active:
        "Firmenstatus ist '{{status}}'. Nur aktive Firmen können Geschäftsjahre erstellen.",
    aumico_companies_bulk_create_reason_mandate_expired:
        'Mandat ist am {{mandateEndDate}} abgelaufen. Für abgelaufene Mandate kann kein Geschäftsjahr erstellt werden.',
    aumico_companies_bulk_create_reason_access_denied:
        'Zugriff verweigert: Sie haben keine Berechtigung, auf diese Firma zuzugreifen',
    aumico_companies_bulk_create_reason_error_retrieving_company_info: 'Fehler beim Abrufen der Firmeninformationen. Kontaktieren Sie den Support.',
    aumico_companies_bulk_create_reason_no_previous_project: 'Kein vorheriges Projekt gefunden',
    aumico_companies_bulk_create_reason_previous_project_no_general_info:
        'Vorheriges Projekt hat keine gespeicherten allgemeinen Informationen im Jahresbericht',
    aumico_companies_bulk_create_reason_invalid_year_range:
        'Ungültiges Jahr {{nextYear}}: muss im zulässigen Bereich liegen ({{minYear}} bis {{maxYear}})',
    aumico_companies_bulk_create_reason_invalid_date_range:
        'Ungültiger Datumsbereich: Startdatum muss vor dem Enddatum liegen',
    aumico_companies_bulk_create_reason_project_already_exists: 'Projekt für diesen Zeitraum existiert bereits',
    aumico_companies_bulk_create_reason_non_calendar_fiscal_year: 'Nicht-kalendarisches Geschäftsjahr (beginnt nicht am 1. Januar)',
    aumico_project_overview_bulk_update_status: 'Projektstatus aktualisieren?',
    aumico_project_overview_bulk_update_status_label: 'Projektstatus auswählen',
    aumico_project_overview_bulk_update_status_placeholder: 'Neuen Projektstatus auswählen...',
    aumico_project_status_change_action_bar: 'Projektstatus ändern',
    aumico_project_delete_action_bar: 'Projekte löschen',
    aumico_cpmm_project_status_bulk_update_success_title: 'Erfolgreich aktualisiert',
    aumico_cpmm_project_status_bulk_update_success_description: 'Der Projektstatus wurde erfolgreich aktualisiert.',
    aumico_tasks_overview_bulk_edit_status_title: 'Aufgabenstatus für die Aufgabe aktualisieren?',
    aumico_tasks_overview_bulk_edit_status_title_plural: 'Aufgabenstatus für {{ count }} Aufgaben aktualisieren?',
    aumico_tasks_overview_bulk_edit_status_label: 'Neuen Aufgabenstatus auswählen',
    aumico_tasks_overview_bulk_edit_status_placeholder: 'Aufgabenstatus auswählen...',
    aumico_tasks_overview_bulk_edit_assignee_title: 'Zuständige Person für die Aufgabe ändern?',
    aumico_tasks_overview_bulk_edit_assignee_title_plural: 'Zuständige Person für {{ count }} Aufgaben ändern?',
    aumico_tasks_overview_bulk_edit_assignee_label: 'Neue zuständige Person auswählen',
    aumico_tasks_overview_bulk_edit_assignee_placeholder: 'Zuständige Person auswählen...',
    aumico_tasks_overview_bulk_edit_due_date_title: 'Fälligkeitsdatum für die Aufgabe aktualisieren?',
    aumico_tasks_overview_bulk_edit_due_date_title_plural: 'Fälligkeitsdatum für {{ count }} Aufgaben aktualisieren?',
    aumico_tasks_overview_bulk_edit_status_action_bar: 'Aufgabenstatus ändern',
    aumico_tasks_overview_bulk_edit_assignee_action_bar: 'Zuständige Person ändern',
    aumico_tasks_overview_bulk_edit_due_date_action_bar: 'Fälligkeitsdatum ändern',
    aumico_tasks_overview_bulk_edit_delete_action_bar: 'Aufgaben löschen',
    aumico_MMCP_overview_bulk_edit_select_all: 'Alle auswählen',
    aumico_company_role_change_dialog_title: 'Rolle ändern?',
    aumico_company_role_change_dialog_select_new_role: 'Neue Rolle auswählen',
    aumico_company_role_change_dialog_add_role_for_selected_tasks: 'Rolle auswählen...',

    aumico_reports_organization_settings_navigation_organization_subscription: 'Abonnement',
    aumico_components_organization_settings_subscription_org_id: 'Organisations-ID:',
    aumico_create_project_dialog_select_report_type_description: 'Berichtstyp',
    aumico_create_project_dialog_select_report_type_input_placeholder: 'Wählen einen Berichtstyp aus',
    aumico_ui_billing_downgrade_title: 'Abo herabstufen?',
    aumico_ui_billing_downgrade_confirm: 'Bist du sicher, dass du dein Abo herabstufen möchtest?',
    aumico_ui_billing_downgrade_warning_features_standard:
        'Du verlierst den Zugriff auf das Aufgaben- und Mandatsmanagement',
    aumico_ui_billing_downgrade_warning_features_pro:
        'Du verlierst den Zugriff auf das Aufgaben- und Mandatsmanagement.',
    aumico_ui_billing_downgrade_warning_data_loss:
        'Deine bestehenden Daten bleiben jedoch erhalten und werden wieder sichtbar, sobald du dein Abo reaktivierst',
    aumico_ui_action_close: 'Abbrechen',
    aumico_ui_action_downgrade: 'Abo herabstufen',
    aumico_ui_billing_upgrade_title: 'Abo upgraden?',
    aumico_ui_billing_upgrade_confirm: 'Bist du sicher, dass du dein Abo upgraden willst? Die Seite wird neu geladen.',
    aumico_ui_action_upgrade: 'Abo upgraden',
    aumico_po_report_type_filter_label: 'Berichtstyp',
    aumico_po_report_type_annual: 'Jahresabschluss',
    aumico_po_report_type_quarterly: 'Quartalsabschluss',
    aumico_po_report_type_monthly: 'Monatsabschluss',
    aumico_po_report_type_custom: 'Individueller Abschluss',
    aumico_app_cpmm_annotation_delete_confirmation:
        'Bist du sicher, dass du den Kommentar "{{ comment }}" löschen möchtest?',
    aumico_app_cpmm_task_delete_confirmation: 'Bist du sicher, dass du die Aufgabe "{{ task }}" löschen möchtest?',
    aumico_app_cpmm_tasks_delete_confirmation: 'Bist du sicher, dass du die Aufgabe löschen möchtest?',
    aumico_app_cpmm_tasks_delete_confirmation_plural:
        'Bist du sicher, dass du die {{ count }} Aufgaben löschen möchtest?',
    aumico_app_cpmm_projects_delete_confirmation: 'Bist du sicher, dass du das Projekt löschen möchtest?',
    aumico_app_cpmm_projects_delete_confirmation_plural:
        'Bist du sicher, dass du die {{ count }} Projekte löschen möchtest?',
    aumico_app_cpmm_companies_disable_confirmation: 'Bist du sicher, dass du die Firma deaktivieren möchtest?',
    aumico_app_cpmm_companies_disable_confirmation_plural:
        'Bist du sicher, dass du die {{ count }} Firmen deaktivieren möchtest?',
    aumico_orga_settings_role_change_action_bar: 'Rolle ändern',
    aumico_users_organization_users_table_delete_action_bar: 'Benutzer löschen',
    aumico_backend_errors_project_deletion_due_to_dependency:
        'Dieser Bericht kann nicht gelöscht werden, da er als vorheriger Zeitraum für andere Berichte verwendet wird.',
    aumico_bulk_delete_dependency_warning_description:
        'Die folgenden Projekte werden als Vorperiode verwendet oder wurden für andere Berichte kopiert. Möchtest du sie trotzdem löschen?',
    aumico_bulk_delete_dependency_warning_proceed: 'Ja, trotzdem löschen',
    aumico_bulk_delete_dependency_warning_skip: 'Nein, diese überspringen',
    aumico_file_export_section_title: 'Bereich',
    aumico_file_export_description_title: 'Aufgabe / Konto',
    aumico_file_export_document_title: 'Dokument',
    aumico_cpmm_projects_bulk_delete_failure_title_due_to_dependency:
        'Einige Projekte konnten wegen Abhängigkeiten nicht gelöscht werden',
    aumico_backend_errors_project_deletion_due_to_dependency_multiple:
        'Einige ausgewählte Berichte können nicht gelöscht werden, weil sie als vorheriger Zeitraum für andere Berichte dienen. Bitte lösche zuerst diese aufbauenden Berichte -> ',
    aumico_organization_settings_mandate_management_configuration_mandate_and_tasks_toggle_tooltip:
        'Wenn deaktiviert, wird das Mandatsmanagement und der Abschlussworkflow deaktiviert.',
    aumico_user_notifications_title: 'Benachrichtigungen',
    aumico_user_notifications_mark_all_read: 'Alle als gelesen markieren',
    aumico_user_notifications_mark_as_read: 'Als gelesen markieren',
    aumico_user_notifications_mark_as_unread: 'Als ungelesen markieren',
    aumico_user_notifications_archive: 'Archivieren',
    aumico_user_notifications_unarchive: 'Aus Archiv entfernen',
    aumico_user_notifications_filter: 'Benachrichtigungen filtern',
    aumico_user_notifications_clear_filter: 'Zurücksetzen',
    aumico_user_notifications_empty: 'Noch keine Benachrichtigungen.',
    aumico_user_notifications_loading: 'Lädt…',
    aumico_user_notifications_filter_read: 'Gelesen',
    aumico_user_notifications_filter_unread: 'Ungelesen',
    aumico_user_notifications_filter_archived: 'Archiviert',
    aumico_user_notifications_today: 'Heute',
    aumico_user_notifications_last_week: 'Letzte Woche',
    aumico_user_notifications_older: 'Älter',
    aumico_user_notifications_task_fallback: 'Aufgabe',
    aumico_user_notifications_role_fallback: 'Rolle',
    aumico_user_notifications_someone_fallback: 'jemand',
    aumico_user_notifications_due_date_fallback: 'Fälligkeitsdatum',
    aumico_user_notifications_company_fallback: 'ein Unternehmen',
    aumico_user_notifications_message_task_assigned: 'Neue Aufgabe {{taskName}} wurde dir zugewiesen.',
    aumico_user_notifications_message_company_assigned: 'Du wurdest {{companyName}} als {{role}} zugewiesen.',
    aumico_user_notifications_message_mention: 'Du wurdest in {{taskName}}{{companyName}} von {{user}} erwähnt.',
    aumico_user_notifications_message_task_ready_review: '{{taskName}} ist bereit zur Überprüfung.',
    aumico_user_notifications_message_task_rejected:
        '{{taskName}} wurde von {{user}} zur Überarbeitung zurückgesendet.',
    aumico_user_notifications_message_deadline_approaching: '{{companyName}}: Die Frist für {{taskName}} läuft am {{dueDate}} ab',
    aumico_user_notifications_message_default: 'Benachrichtigung',
    aumico_reports_unsaved_changes_warning_dialog_discard_and_delete_project:
        'Änderungen verwerfen und Projekt löschen',
    aumico_reports_unsaved_changes_and_delete_project_warning_dialog_content:
        'Du hast ungespeicherte Änderungen in deinem Bericht. Möchtest du diese verwerfen und das Projekt löschen?',
    aumico_grouping_masking_bulk_action_sub_total_selected: 'Zwischensummen ausgewählt',
    aumico_grouping_masking_bulk_action_unhide: 'Einblenden',
    aumico_grouping_masking_bulk_action_hide: 'Ausblenden',
    cpmm_projects_overview_col_label: 'Bezeichnung',
    aumico_companies_form_label_label: 'Bezeichnung',
    aumico_companies_table_label_company_label: 'Bezeichnung',
    aumico_grouping_masking_sort_account_btn: 'Konto sortieren',
    aumico_grouping_masking_sort_account_number_based: 'Nach Kontonummer',
    aumico_grouping_masking_sort_account_name_based: 'Nach Kontoname',
    aumico_annual_report_mapping_page_can_not_navigate_to_grouping_and_masking_dialog_description:
        'Du kannst nicht zur Gruppierung und Maskierung navigieren, da die erforderlichen Daten fehlen.',
    aumico_project_reports_switch_to_automatic_transfer_of_annual_result_title:
        'Wechsel zu automatischer Übertragung der Jahresergebnisse',
    aumico_project_reports_switch_to_automatic_transfer_of_annual_result_description:
        'Das System kann nun Ihre Jahresergebnisse automatisch berechnen. Wenn Sie diese automatische Funktion aktivieren, wird Ihr manuelles Konto an dieser Stelle durch den neuen Systemwert ersetzt.',
    aumico_project_reports_switch_to_automatic_transfer_of_annual_result_info_text:
        'Ihr Konto wird nicht gelöscht, sondern nur aus diesem finanziellen Posten entfernt.',
    aumico_project_reports_switch_to_automatic_transfer_of_annual_result_confirm: 'Entfernen & aktivieren',
    aumico_project_reports_switch_to_automatic_transfer_of_annual_result_cancel: 'Nein, abbrechen',
    aumico_templates_annual_profit_account_badge_text: 'Jahresergebnis Konto',
    aumico_report_previous_annual_profit_manual_entry_title: 'Jahresergebnis Vorjahr manuell bearbeiten',
    aumico_report_previous_annual_profit_manual_entry_submit_text: 'Manuell hinzufügen',
    aumico_report_previous_annual_profit_manual_entry_description:
        'Der Gewinn zum Stichtag konnte nicht automatisch ermittelt werden - bitte geben Sie ihn manuell ein.',
    aumico_report_previous_annual_profit_manual_entry_balance_date: 'Bilanzstichtag',
    aumico_report_previous_annual_profit_manual_entry_missing_profit_period: 'Ergebnis des Zeitraums',
    aumico_report_previous_annual_profit_manual_entry_input_label: 'Wert manuell eingeben',
    aumico_report_previous_annual_profit_manual_entry_input_placeholder: 'Wert hier manuell eingeben',
    aumico_templates_group_account_mapping_menu_edit_profit_manually: 'Jahresergebnis manuell bearbeiten',
    aumico_annual_report_mapping_help_automatic_transfer_toggle_text:
        'Automatische Übertragung des Jahresergebnisses aktivieren',
    aumico_annual_report_complementary_reports_show_title_in_report_toggle: 'Berichtsname als Titel anzeigen',
    aumico_annual_report_print_options_colors_accordion_title: 'Farben',
    aumico_reports_print_color_reset_to_default_button: 'Auf Standard zurücksetzen',
    aumico_projects_release_highlights_modal_title: 'Was gibt es Neues in aumico?',
    aumico_projects_release_highlights_modal_next: 'Weiter',
    aumico_projects_release_highlights_modal_previous: 'Zurück',
    aumico_projects_release_highlights_modal_got_it: 'Verstanden',
    aumico_project_reports_switch_to_automatic_transfer_of_annual_result_confirmation_description:
        'Möchten Sie wirklich in den automatischen Modus wechseln? Ihre manuelle Zuordnung für das Jahresergebnis wird ersetzt.',
    aumico_templates_group_account_mapping_mapping_to_profit_fli_disabled_tooltip_text:
        'Wert wird automatisch aus der GuV übertragen. Es ist nicht möglich, ein anderes Konto zuzuordnen.',
    aumico_annual_report_cash_flow_system_value_tooltip: 'System',
    aumico_pm_tasks_filter_apply: 'Anwenden',
    aumico_reports_error_profit_fli_not_found: 'Das Jahresergebnis-Konto konnte nicht gefunden werden. Bitte überprüfe deine Zuordnungseinstellungen, um es festzulegen.',

    // AI Fixer Panel
    aumico_ai_fixer_panel_title: 'DATEV Hierarchie-Reparatur',
    aumico_ai_fixer_panel_description: 'Lass den KI-Agenten Strukturprobleme automatisch analysieren und beheben.',
    aumico_ai_fixer_panel_start_btn: 'KI-Korrektur starten',
    aumico_ai_fixer_panel_running_title: 'Agent arbeitet…',
    aumico_ai_fixer_panel_completed_title: 'KI-Korrektur abgeschlossen',
    aumico_ai_fixer_panel_accept_btn: 'Übernehmen',
    aumico_ai_fixer_panel_reject_btn: 'Ablehnen',
    aumico_ai_fixer_panel_failed_title: 'KI-Korrektur fehlgeschlagen',
    aumico_ai_fixer_panel_unknown_error: 'Ein unbekannter Fehler ist aufgetreten.',
    aumico_ai_fixer_panel_retry_btn: 'Erneut versuchen',
    aumico_ai_fixer_panel_cancel_btn: 'Abbrechen',

    // AI Fixer Progress
    aumico_ai_fixer_progress_step: 'Schritt',
    aumico_ai_fixer_progress_steps: 'Schritte',

    // Taxonomy Preview Dialog
    aumico_ai_taxonomy_preview_title: 'Taxonomie-Vorschau — KI-Korrektur',
    aumico_ai_taxonomy_preview_no_entries: 'Keine Einträge in diesem Abschnitt.',
    aumico_ai_taxonomy_preview_chat_placeholder: 'Frag die KI, die Taxonomiestruktur anzupassen…',
    aumico_ai_taxonomy_preview_agent_working: 'Agent arbeitet…',
    aumico_ai_taxonomy_preview_chat_you: 'Du',
    aumico_ai_taxonomy_preview_chat_ai: 'KI',
    aumico_ai_taxonomy_preview_type_message: 'Nachricht eingeben…',
    aumico_ai_taxonomy_preview_close: 'Schließen',
    aumico_ai_taxonomy_preview_send: 'Senden',
    aumico_ai_taxonomy_preview_btn_preview: '🔍 Struktur ansehen',
    aumico_ai_taxonomy_preview_tree_updated: '✓ Struktur aktualisiert',

    // Taxonomy section labels
    aumico_ai_taxonomy_section_assets: 'Bilanz — Aktiva',
    aumico_ai_taxonomy_section_liabilities: 'Bilanz — Passiva',
    aumico_ai_taxonomy_section_income: 'GuV',

    // Node classification display names
    aumico_ai_classification_fli: 'Posten',
    aumico_ai_classification_group: 'Gruppe',
    aumico_ai_classification_hidden_group: 'Einrückung',
    aumico_ai_classification_sum: 'Zwischensumme',
    aumico_ai_classification_of_that_item: 'Davon-Posten',
    aumico_ai_classification_x_fli: 'Zusatzposten',
    aumico_ai_classification_sub_fli: 'Unterposten',
    aumico_ai_classification_title: 'Titel',
    aumico_ai_classification_remove: 'Entfernen',
    aumico_ai_classification_unknown: 'Unbekannt',
    aumico_ai_fixed_badge: '✅ Mit KI korrigiert',

    aumico_cover_page_draft_label: 'Entwurf',
    aumico_seal_banner_draft_title: 'Dieser Bericht ist noch nicht versiegelt',
    aumico_seal_banner_draft_sub: 'Alle Exporte enthalten eine «Entwurf»-Kennzeichnung bis zur Versiegelung',
    aumico_seal_banner_sealed_title: 'Bericht versiegelt',
    aumico_seal_banner_sealed_sub: 'Versiegelt am {{date}} von {{user}}',
    aumico_seal_banner_audit_log: 'Protokoll',
    aumico_seal_banner_unseal: 'Entsperren',
    aumico_annual_report_unseal_warning: 'Die Entsiegelung dieses Berichts kann zu Unstimmigkeiten führen, wenn er bereits an die Stakeholder weitergegeben wurde. Möchtest du fortfahren?',

    // MFA - Setup Flow
    aumico_mfa_loading: 'Wird geladen...',
    aumico_mfa_setup_step1_title: 'Zwei-Faktor-Authentifizierung einrichten',
    aumico_mfa_setup_step1_description: 'Scannen Sie den QR-Code unten mit Ihrer Authenticator-App (z.B. Google Authenticator, Authy).',
    aumico_mfa_setup_step1_manual_key: 'Oder geben Sie diesen Schlüssel manuell ein:',
    aumico_mfa_setup_step1_countdown_label: 'Neuer Code in:',
    aumico_mfa_setup_step1_continue_button: 'Weiter',
    aumico_mfa_setup_step2_title: 'Authenticator überprüfen',
    aumico_mfa_setup_step2_description: 'Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App ein, um die Einrichtung zu bestätigen.',
    aumico_mfa_setup_step2_code_label: 'Authentifizierungscode',
    aumico_mfa_setup_step2_code_placeholder: '6-stelligen Code eingeben',
    aumico_mfa_setup_step2_verify_button: 'Weiter',
    aumico_mfa_setup_step3_title: 'Sicherungscodes speichern',
    aumico_mfa_setup_step3_description: 'Speichern Sie diese Sicherungscodes sicher. Sie können verwendet werden, um auf Ihr Konto zuzugreifen, wenn Sie Ihr Gerät verlieren.',
    aumico_mfa_setup_step3_download_button: 'Herunterladen',
    aumico_mfa_setup_step3_continue_button: 'Fortfahren',
    aumico_mfa_setup_error_initiate: '2FA-Einrichtung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    aumico_mfa_setup_error_invalid_code: 'Ungültiger Code. Bitte überprüfen Sie Ihre Authenticator-App.',
    aumico_mfa_setup_stepper_scan_qr: 'QR scannen',
    aumico_mfa_setup_stepper_verify: 'Überprüfen',
    aumico_mfa_setup_stepper_backup_codes: 'Backup-Codes',
    aumico_mfa_setup_step1_app_hint: 'Google Authenticator, Authy oder eine andere TOTP-kompatible App',
    aumico_mfa_setup_step2_back_button: 'Zurück',
    aumico_mfa_setup_step2_hint: 'Geben Sie den 6-stelligen Bestätigungscode ein',
    aumico_mfa_setup_footer: 'Ihre Organisation erfordert 2FA. Dies ist eine einmalige Einrichtung.',

    // MFA - Verify Flow (Login)
    aumico_mfa_verify_title: 'Zwei-Faktor-Authentifizierung',
    aumico_mfa_verify_description: 'Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App ein.',
    aumico_mfa_verify_code_label: 'Authentifizierungscode',
    aumico_mfa_verify_code_placeholder: '6-stelligen Code eingeben',
    aumico_mfa_verify_backup_description: 'Geben Sie einen Ihrer Sicherungscodes ein.',
    aumico_mfa_verify_backup_code_label: 'Sicherungscode',
    aumico_mfa_verify_backup_code_placeholder: 'Sicherungscode eingeben',
    aumico_mfa_verify_submit_button: 'Bestätigen',
    aumico_mfa_verify_use_backup_code: 'Sicherungscode verwenden',
    aumico_mfa_verify_use_totp_code: 'Authenticator-App verwenden',
    aumico_mfa_verify_error_invalid_code: 'Ungültiger Code. Bitte versuchen Sie es erneut.',

    aumico_zefix_search_title: 'Firma in Zefix suchen',
    aumico_zefix_search_subtitle: 'Schweizer Handelsregister · Automatischer Datenimport',
    aumico_zefix_search_placeholder: 'Firmenname oder UID eingeben (z.B. aumico oder CHE-108.814.245)…',
    aumico_zefix_uid_mode: 'UID-Modus',
    aumico_zefix_results_count: '{{count}} Ergebnis(se) im Handelsregister',
    aumico_zefix_no_results_title: 'Keine Einträge in Zefix gefunden',
    aumico_zefix_no_results_reason_1: 'Einzelunternehmen ohne HR-Eintrag',
    aumico_zefix_no_results_reason_2: 'Ausländische Firma',
    aumico_zefix_no_results_reason_3: 'Noch nicht im Handelsregister eingetragen',
    aumico_zefix_no_results_reason_4: 'Tippfehler in Name',
    aumico_zefix_manual_entry: 'Firma manuell erfassen',
    aumico_zefix_imported_banner: 'aus Zefix importiert — Felder prüfen und speichern.',
    aumico_zefix_save_button: 'Felder prüfen & Speichern',
    aumico_zefix_refresh_button: 'Aktualisieren',
    aumico_zefix_new_search: 'Neue Suche',
    aumico_zefix_badge: '✓ Zefix',
    aumico_zefix_unavailable: 'Zefix ist momentan nicht erreichbar. Bitte Felder manuell eintragen.',
    aumico_zefix_diff_title: 'Zefix Abgleich',
    aumico_zefix_diff_field: 'Feld',
    aumico_zefix_diff_current: 'Aktuell',
    aumico_zefix_diff_new: 'Zefix (neu)',
    aumico_zefix_diff_no_changes: 'Alle Daten sind aktuell — keine Änderungen gefunden.',
    aumico_zefix_diff_apply_all: 'Alle übernehmen',
    aumico_zefix_status_in_liquidation: 'In Liquidation',
    aumico_zefix_status_cancelled: 'Gelöscht',
    aumico_zefix_field_name: 'Firmenname',
    aumico_zefix_field_legalform: 'Rechtsform',
    aumico_zefix_field_street: 'Strasse',
    aumico_zefix_field_zip: 'PLZ',
    aumico_zefix_field_city: 'Ort',
    aumico_zefix_field_uid: 'UID',
    // MFA - Organization Settings
    aumico_mfa_org_toggle_title: 'Zwei-Faktor-Authentifizierung',
    aumico_mfa_org_toggle_description: 'Verlangen Sie von allen Benutzern in Ihrer Organisation, die Zwei-Faktor-Authentifizierung einzurichten.',
    aumico_mfa_org_toggle_description_detail: '2FA erhöht die Sicherheit, indem sowohl ein Passwort als auch ein zeitbasierter Verifizierungscode aus der Google Authenticator App erforderlich sind.',
    aumico_mfa_org_status_enabled: '2FA ist aktiviert',
    aumico_mfa_org_status_disabled: '2FA ist deaktiviert',
    aumico_mfa_org_enable_button: '2FA aktivieren',
    aumico_mfa_org_disable_button: '2FA deaktivieren',
    aumico_mfa_org_users_title: 'Benutzer-MFA-Status',
    aumico_mfa_org_users_col_name: 'Name',
    aumico_mfa_org_users_col_email: 'E-Mail',
    aumico_mfa_org_users_col_status: 'MFA-Status',
    aumico_mfa_org_users_col_actions: 'Aktionen',
    aumico_mfa_org_users_col_enabled_at: 'Aktiviert am',
    aumico_mfa_org_users_status_complete: 'Aktiviert',
    aumico_mfa_org_users_status_pending: 'Nicht aktiviert',
    aumico_mfa_org_users_reset_button: 'MFA zurücksetzen',
    aumico_mfa_org_notification_success_title: 'Erfolg',
    aumico_mfa_org_notification_error_title: 'Fehler',
    aumico_mfa_org_enable_success: '2FA wurde für Ihre Organisation aktiviert.',
    aumico_mfa_org_enable_error: 'Aktivierung von 2FA fehlgeschlagen. Bitte versuchen Sie es erneut.',
    aumico_mfa_org_disable_success: '2FA wurde für Ihre Organisation deaktiviert.',
    aumico_mfa_org_disable_error: 'Deaktivierung von 2FA fehlgeschlagen. Bitte versuchen Sie es erneut.',
    aumico_mfa_org_reset_user_success: 'MFA wurde für den Benutzer zurückgesetzt.',
    aumico_mfa_org_reset_user_error: 'MFA-Zurücksetzung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    aumico_mfa_org_enforce_button: 'Zwei-Faktor-Authentifizierung erzwingen',
    aumico_mfa_org_enforce_button_tooltip: 'Achtung: Sie werden direkt abgemeldet,\num die Zwei-Faktor-Authentifizierung einzurichten.',
    aumico_mfa_org_disable_toggle_tooltip: 'Beim Ausschalten wird die MFA-Einrichtung aller Benutzer zurückgesetzt.',

    // MFA - Navigation
    aumico_reports_organization_navigation_2fa: 'Zwei-Faktor-Auth',
    aumico_reports_organization_settings_navigation_ai_settings: 'KI-Einstellungen',
    aumico_ai_settings_loading: 'KI-Einstellungen werden geladen...',
    aumico_ai_settings_description: 'Schalte KI-Funktionen für deine Organisation ein oder aus.',
    aumico_ai_settings_master_title: 'KI-Funktionen aktivieren',
    aumico_ai_settings_master_description: 'Aktiviert alle KI-Funktionen für deine Organisation. Vorher stimmst du den AGB zu.',
    aumico_ai_settings_master_agb_empty: '(Noch kein AGB-Text hinterlegt. Bitte wende dich an deinen Administrator.)',
    aumico_ai_settings_daily_usage: 'Heute verbraucht',
    aumico_ai_settings_monthly_usage: 'Diesen Monat verbraucht',
    aumico_ai_settings_tokens: 'Tokens',
    aumico_ai_settings_title: 'KI-Funktionen',
    aumico_ai_settings_status_active: 'Aktiv',
    aumico_ai_settings_status_inactive: 'Inaktiv',
    aumico_ai_settings_hero_headline: 'Intelligente Hilfe für deine Buchhaltung',
    aumico_ai_settings_hero_sub: 'KI-Funktionen analysieren deine Daten direkt in der Anwendung. Sicher in der EU verarbeitet, ohne Modell-Training.',
    aumico_ai_settings_usage_title: 'Token-Verbrauch',
    aumico_ai_settings_master_short_description: 'Aktiviert alle KI-Funktionen für deine Organisation.',
    aumico_ai_settings_agents_title: 'Verfügbare KI-Funktionen',
    aumico_ai_settings_wip_label: 'In Entwicklung',
    aumico_ai_settings_wip_headline: 'Wir bauen aumico KI laufend aus',
    aumico_ai_settings_wip_text: 'Die Infrastruktur steht. Wir investieren aktuell stark in neue Funktionen.',
    aumico_ai_settings_agent_available: 'Verfügbar',
    aumico_ai_settings_agent_soon: 'In Vorbereitung',
    aumico_ai_settings_agent_more_title: 'Weitere Funktionen folgen',
    aumico_ai_settings_agent_more_text: 'Neue Funktionen erscheinen hier, sobald sie verfügbar sind. Bleib dran.',
    aumico_ai_settings_feature_closing_title: 'Abschlussprozess mit KI',
    aumico_ai_settings_feature_closing_text: 'Begleitet dich durch den Jahresabschluss: liest deine Belege, ordnet sie den Konten zu und schlägt Abstimmungen vor.',
    aumico_ai_settings_feature_translate_title: 'Bericht übersetzen',
    aumico_ai_settings_feature_translate_text: 'Übersetzt einen Bericht in eine andere Sprache.',
    aumico_ai_settings_feature_datev_title: 'DATEV-Import reparieren',
    aumico_ai_settings_feature_datev_text: 'Repariert die Kontenhierarchie eines DATEV-Imports.',
    aumico_ai_settings_resets_daily: 'Setzt sich um Mitternacht zurück',
    aumico_ai_settings_resets_monthly: 'Setzt sich am 1. des Monats zurück',
    aumico_ai_settings_info_blocked: 'Ist ein Limit erreicht, werden weitere KI-Anfragen automatisch blockiert.',
    aumico_ai_settings_info_agb: 'Werden die AGB aktualisiert, stimmst du ihnen erneut zu.',
    aumico_ai_settings_load_error: 'KI-Einstellungen konnten nicht geladen werden.',
    aumico_ai_settings_notification_success_title: 'Einstellung gespeichert',
    aumico_ai_settings_notification_enabled: 'KI-Funktionen wurden aktiviert.',
    aumico_ai_settings_notification_disabled: 'KI-Funktionen wurden deaktiviert.',
    aumico_ai_settings_notification_error_title: 'Fehler',
    aumico_ai_settings_notification_error: 'Einstellung konnte nicht gespeichert werden.',
    aumico_ai_settings_notification_version_changed: 'Die AGB wurden aktualisiert. Bitte lies und akzeptiere die neuen Bedingungen.',
    aumico_ai_settings_acceptance_intro: 'Bitte lies die folgenden Nutzungsbedingungen sorgfältig, bevor du die KI-Funktionen aktivierst:',
    aumico_ai_settings_acceptance_disclaimer: 'Mit „Akzeptieren & aktivieren“ bestätigst du, dass du die Bedingungen gelesen hast und der Datenverarbeitung zustimmst. Du kannst die KI-Funktionen jederzeit wieder deaktivieren.',
    aumico_ai_settings_acceptance_accept: 'Akzeptieren & aktivieren',
    aumico_ai_settings_acceptance_decline: 'Ablehnen',
    aumico_reports_main_navigation_company_integrations: 'Integrationen',
    aumico_companies_integrations_section_available: 'Verfügbar',
    aumico_companies_integrations_section_coming_soon: 'Demnächst',
    aumico_companies_integrations_btn_connecting: 'Verbinde...',
    aumico_companies_integrations_status_connected: 'Verbunden',
    aumico_companies_integrations_status_connected_since: 'seit',
    aumico_companies_integrations_btn_disconnect: 'Trennen',
    aumico_companies_integrations_status_expired: 'Verbindung abgelaufen',
    aumico_companies_integrations_btn_reconnect: 'Erneut verbinden',
    aumico_companies_integrations_btn_connect: 'Verbinden',
    aumico_companies_integrations_btn_sync_data: 'Daten synchronisieren',
    aumico_companies_integrations_sync_never: 'Noch nicht synchronisiert',
    aumico_companies_integrations_sync_no_matching_year: 'Kein passendes Geschäftsjahr gefunden',
    aumico_companies_integrations_sync_last: 'Zuletzt synchronisiert am',
    aumico_companies_integrations_btn_submit_request: 'Integration anfragen',
    aumico_companies_integrations_btn_request: 'Anfragen',
    aumico_companies_integrations_bexio_description: 'Importiert Kontodaten und Journalbuchungen direkt aus Bexio.',
    aumico_companies_integrations_placeholder_name: 'Mehr kommt bald',
    aumico_companies_integrations_placeholder_description: 'Wir arbeiten laufend an neuen Integrationen.',
    aumico_companies_integrations_request_modal_title: 'Integration anfragen',
    aumico_companies_integrations_request_modal_label: 'Welche Software suchen Sie?',
    aumico_companies_integrations_request_modal_message_label: 'Zusätzliche Anmerkungen (optional)',
    aumico_companies_integrations_request_modal_message_placeholder: 'Erzählen Sie uns mehr über Ihre Bedürfnisse...',
    aumico_companies_integrations_request_topal: 'Topal',
    aumico_companies_integrations_request_abacus: 'Abacus',
    aumico_companies_integrations_request_infoniqa: 'Infoniqa',
    aumico_companies_integrations_request_other: 'Andere',
    aumico_companies_integrations_leaderboard_title: 'Integrations-Rangliste',
    aumico_companies_integrations_leaderboard_subtitle: 'Stimme für die nächste Integration ab, die wir bauen sollen.',
    aumico_companies_integrations_votes_label: 'Stimmen',
    aumico_companies_integrations_btn_upvote: 'Hochvoten',
    aumico_companies_integrations_btn_voted: 'Abgestimmt',
    aumico_companies_integrations_name_bexio: 'Bexio',
    aumico_companies_integrations_name_topal: 'Topal',
    aumico_companies_integrations_name_abacus: 'Abacus',
    aumico_companies_integrations_name_accounto: 'Accounto',
    aumico_companies_integrations_name_infoniqa50: 'Infoniqa 50',
    aumico_companies_integrations_name_infoniqa200: 'Infoniqa 200',
    aumico_companies_integrations_name_xero: 'Xero',
    aumico_companies_integrations_name_klara: 'Klara',
    aumico_companies_integrations_name_banana: 'Banana',
    aumico_companies_integrations_name_atlanto: 'Atlanto',
    aumico_companies_integrations_name_proffix: 'PROFFIX',
    aumico_companies_integrations_name_infoniqaonestart: 'Infoniqa One Start',
    aumico_companies_integrations_name_odoo: 'Odoo',
    aumico_companies_integrations_name_dynamics365businesscentral: 'Dynamics 365 Business Central',
    aumico_companies_integrations_suggestion_cta_text: 'Deine Wunschintegration ist noch nicht auf der Liste? Teile sie uns mit und wir nehmen sie in die Rangliste auf.',
    aumico_companies_integrations_suggestion_cta_button: 'Wunschintegration teilen',
    aumico_companies_integrations_vote_modal_title: 'Integration hochvoten',
    aumico_companies_integrations_vote_modal_submit: 'Stimme abgeben',
    aumico_companies_integrations_vote_modal_hint: 'Bevor wir deine Stimme speichern, kannst du optional kurz begründen, warum diese Integration für dich wichtig ist. Das nutzen wir intern zur Priorisierung.',
    aumico_companies_integrations_vote_modal_label: 'Optionaler Kontext',
    aumico_companies_integrations_vote_modal_placeholder: 'Warum ist diese Integration für dein Team wichtig? (optional)',
    aumico_companies_integrations_suggestion_modal_title: 'Neue Integration vorschlagen',
    aumico_companies_integrations_suggestion_modal_hint: 'Teile deine Wunschintegration mit optionalem Kontext. Wir prüfen diese Vorschläge und nehmen sie in die Rangliste auf.',
    aumico_companies_integrations_suggestion_modal_label: 'Dein Integrationswunsch',
    aumico_companies_integrations_suggestion_modal_placeholder: 'Beispiel: Lexoffice. Optionaler Kontext: wird von den meisten unserer Kunden genutzt.',
    bexio_import_title: 'Bexio Import',
    bexio_status_connected: 'Verbunden',
    bexio_status_expired: 'Verbindung abgelaufen',
    bexio_loading_business_years: 'Geschäftsjahre werden geladen...',
    bexio_import_period: 'Zeitraum',
    bexio_no_matching_year: 'Kein passendes Geschäftsjahr für das Bilanzstichtagsdatum gefunden.',
    bexio_no_business_years: 'Keine Geschäftsjahre in Bexio gefunden.',
    bexio_import_data: 'Daten importieren',
    bexio_importing: 'Wird importiert...',
    bexio_import_manual: 'Manuell hochladen',
    bexio_import_success: 'Import erfolgreich',
    bexio_resync: 'Erneut synchronisieren',
    bexio_accounts: 'Konten',
    bexio_entries: 'Buchungen',
    bexio_import_error: 'Import fehlgeschlagen. Bitte versuche es erneut.',
    bexio_expired_nudge: 'Die Bexio-Verbindung ist abgelaufen. Bitte verbinde dich erneut im Firmenprofil.',
    bexio_connect_nudge: 'Tipp: Verbinde Bexio im Firmenprofil, um Daten automatisch zu importieren.',
    bexio_importing_title: 'Daten werden importiert',
    bexio_importing_subtitle: 'Deine Daten werden gerade abgerufen',
    bexio_importing_hint: 'Das dauert nur einen kurzen Moment',
    bexio_summary_title: 'Import-Zusammenfassung',
    bexio_summary_overview: 'Übersicht',
    bexio_summary_company: 'Firma',
    bexio_summary_period: 'Periode',
    bexio_summary_previous_period: 'Vorjahresperiode',
    bexio_summary_accounts: 'Konten',
    bexio_summary_continue: 'Weiter zur Zuordnung',
    bexio_summary_discard: 'Verwerfen',
    bexio_summary_validation_title: 'Validierung',
    bexio_summary_balance_check: 'Bilanzprüfung',
    bexio_summary_current_year: 'Aktuelles Jahr',
    bexio_summary_previous_year: 'Vorjahr',
    bexio_summary_assets: 'Aktiven',
    bexio_summary_liabilities: 'Passiven',
    bexio_summary_net_income: 'Jahresergebnis',
    d365bc_importing_title: 'Daten werden importiert',
    d365bc_importing_subtitle: 'Deine Buchhaltungsdaten werden aus Business Central abgerufen',
    d365bc_importing_hint: 'Das dauert nur einen kurzen Moment',
    d365bc_summary_title: 'Import-Zusammenfassung',
    d365bc_summary_overview: 'Übersicht',
    d365bc_summary_company: 'Firma',
    d365bc_summary_period: 'Periode',
    d365bc_summary_previous_period: 'Vorjahresperiode',
    d365bc_summary_accounts: 'Konten',
    d365bc_summary_continue: 'Weiter zur Zuordnung',
    d365bc_summary_discard: 'Verwerfen',
    d365bc_summary_validation_title: 'Validierung',
    d365bc_summary_balance_check: 'Bilanzprüfung',
    d365bc_summary_current_year: 'Aktuelles Jahr',
    d365bc_summary_previous_year: 'Vorjahr',
    d365bc_summary_assets: 'Aktiven',
    d365bc_summary_liabilities: 'Passiven',
    topal_importing_title: 'Daten werden importiert',
    topal_importing_subtitle: 'Deine Buchhaltungsdaten werden aus Topal abgerufen',
    topal_importing_hint: 'Das dauert nur einen kurzen Moment',
    topal_summary_title: 'Import-Zusammenfassung',
    topal_summary_overview: 'Übersicht',
    topal_summary_company: 'Firma',
    topal_summary_period: 'Periode',
    topal_summary_previous_period: 'Vorjahresperiode',
    topal_summary_accounts: 'Konten',
    topal_summary_continue: 'Weiter zur Zuordnung',
    topal_summary_discard: 'Verwerfen',
    topal_summary_validation_title: 'Validierung',
    topal_summary_balance_check: 'Bilanzprüfung',
    topal_summary_current_year: 'Aktuelles Jahr',
    topal_summary_previous_year: 'Vorjahr',
    topal_summary_assets: 'Aktiven',
    topal_summary_liabilities: 'Passiven',
    topal_import_failed_title: 'Import fehlgeschlagen',
    topal_import_failed_description: 'Der Topal-Import ist fehlgeschlagen. Bitte versuchen Sie es später erneut.',
    topal_import_no_fiscal_year_description:
        'Für den gewählten Berichtszeitraum sind in Topal keine Buchungsdaten vorhanden. Bitte prüfen Sie den Bilanzstichtag bzw. den Zeitraum des Berichts und versuchen Sie es erneut.',
    d365bc_summary_unmappable_accounts:
        '{{count}} Konten konnten keiner Bilanz- oder Erfolgsrechnungsposition zugeordnet werden und fehlen deshalb im Bericht: {{accounts}}.<br>Hinterlege in Business Central bei diesen Konten die Kontokategorie und synchronisiere erneut.',
    abacus_importing_title: 'Daten werden importiert',
    abacus_importing_subtitle: 'Deine Buchhaltungsdaten werden aus Abacus abgerufen',
    abacus_importing_hint: 'Das dauert nur einen kurzen Moment',
    abacus_summary_title: 'Import-Zusammenfassung',
    abacus_summary_overview: 'Übersicht',
    abacus_summary_company: 'Firma',
    abacus_summary_period: 'Periode',
    abacus_summary_previous_period: 'Vorjahresperiode',
    abacus_summary_accounts: 'Konten',
    abacus_summary_continue: 'Weiter zur Zuordnung',
    abacus_summary_discard: 'Verwerfen',
    abacus_summary_validation_title: 'Validierung',
    abacus_summary_balance_check: 'Bilanzprüfung',
    abacus_summary_current_year: 'Aktuelles Jahr',
    abacus_summary_previous_year: 'Vorjahr',
    abacus_summary_assets: 'Aktiven',
    abacus_summary_liabilities: 'Passiven',
    abacus_summary_unmappable_accounts:
        '{{count}} Konten konnten keiner Bilanz- oder Erfolgsrechnungsposition zugeordnet werden und fehlen deshalb im Bericht: {{accounts}}.<br>Hinterlege in Abacus bei diesen Konten die Kontoklasse und synchronisiere erneut.',
    aumico_bexio_connect_success_title: 'Bexio verbunden',
    aumico_bexio_connect_success_description: 'Ihr Bexio-Konto wurde erfolgreich verbunden.',
    aumico_bexio_connect_failure_title: 'Verbindung fehlgeschlagen',
    aumico_bexio_connect_failure_description: 'Ihr Bexio-Konto konnte nicht verbunden werden. Bitte versuchen Sie es erneut.',
    aumico_bexio_disconnect_success_title: 'Bexio getrennt',
    aumico_bexio_disconnect_success_description: 'Ihr Bexio-Konto wurde getrennt.',
    aumico_bexio_disconnect_failure_title: 'Trennung fehlgeschlagen',
    aumico_bexio_disconnect_failure_description: 'Ihr Bexio-Konto konnte nicht getrennt werden. Bitte versuchen Sie es erneut.',

    // CCR – Kapitaleinlagereserven (KER)
    aumico_annual_report_ccr_description: 'Kapitaleinlagereserven',
    aumico_annual_report_ccr_beginning_of_year: 'Total Kapitaleinlagereserven zu Beginn des Jahres',
    aumico_annual_report_ccr_end_of_year: 'Total Kapitaleinlagereserven am Ende des Jahres',
    aumico_annual_report_ccr_select_account: 'Eigenmittelkonto auswählen',
    aumico_annual_report_ccr_add_new_item: 'Neue Position hinzufügen',
    aumico_annual_report_ccr_enter_text: 'Text eingeben',
    aumico_annual_report_ccr_enter_value: 'Betrag eingeben',
    aumico_annual_report_ccr_toggle_show: 'Kapitaleinlagereserven anzeigen',
    aumico_annual_report_ccr_toggle_hide: 'Kapitaleinlagereserven ausblenden',
    aumico_annual_report_ccr_diff_prior: 'Differenz Vorjahr',
    aumico_annual_report_ccr_diff_cur: 'Offene Differenz aktuelles Jahr',
    aumico_annual_report_ccr_add_comment: 'Kommentar hinzufügen',
    aumico_annual_report_ccr_remove_comment_confirm: 'Möchten Sie den Kommentar wirklich entfernen? Der gesamte Fussnoteninhalt wird gelöscht.',
    aumico_reports_main_navigation_company_analytics: 'Analytics',
    aumico_analytics_empty_state_title: 'Noch keine Daten vorhanden',
    aumico_analytics_empty_state_subtitle: 'Erstelle ein Projekt für diesen Mandanten, um den Mehrjahresvergleich zu aktivieren.',
    aumico_analytics_empty_state_cta: 'Erstes Projekt erstellen',
    aumico_analytics_load_failed_message: 'Daten konnten nicht geladen werden. Bitte Seite neu laden.',
    aumico_analytics_controls_delta_pct: '% JoJ',
    aumico_analytics_controls_delta_chf: 'CHF JoJ',
    aumico_analytics_controls_scope_balance: 'Bilanz',
    aumico_analytics_controls_scope_income: 'Erfolgsrechnung',
    aumico_analytics_controls_struct_mode: 'Verhältniskennzahl',
    aumico_analytics_controls_struct_mode_tooltip: 'Anteil jeder Position am Referenzwert (Betriebsertrag / Total Aktive / Total Passive)',
    aumico_analytics_controls_struct_mode_no_reference_tooltip: 'Kein Referenzwert definiert — Strukturanalyse nicht verfügbar.',
    aumico_analytics_a11y_year_pill_toggle: 'Jahr {{year}} ein-/ausblenden',
    aumico_analytics_table_label_column: 'Bezeichnung',
    aumico_analytics_table_struct_column: '%',
    aumico_analytics_table_delta_column: 'Gesamt Δ',
    aumico_analytics_table_empty_after_filter: 'Keine Positionen vorhanden.',
    aumico_analytics_currency_mismatch_banner: 'Hinweis: Diese Mandanten-Projekte verwenden unterschiedliche Währungen ({{currencies}}). Werte werden ohne Umrechnung dargestellt.',
    aumico_pdf_my_table_delta_label: 'Gesamt Δ',
    aumico_pdf_my_export_button: 'PDF exportieren',
    aumico_pdf_my_export_button_pending: 'PDF wird erstellt …',
    aumico_pdf_my_export_failure_title: 'Export fehlgeschlagen',
    aumico_pdf_my_export_failure_description: 'Der Export konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.',
    aumico_pdf_my_export_modal_title: 'PDF exportieren',
    aumico_pdf_my_export_modal_subtitle: 'Wählen Sie aus, welche Positionen im PDF erscheinen sollen.',
    aumico_pdf_my_export_modal_select_all: 'Alle auswählen',
    aumico_pdf_my_export_modal_deselect_all: 'Alle abwählen',
    aumico_pdf_my_export_modal_select_groups: 'Alle Gruppen',
    aumico_pdf_my_export_modal_select_subtotals: 'Alle Zwischensummen',
    aumico_pdf_my_language_modal_title: 'Sprache wählen',
    aumico_pdf_my_language_modal_subtitle: 'Die Berichte dieser Firma sind in mehreren Sprachen erfasst. Für welche Sprache soll der Mehrjahresvergleich erstellt werden?',
    aumico_pdf_my_language_modal_cancel: 'Abbrechen',
    aumico_pdf_my_language_modal_confirm: 'Übernehmen',
    aumico_pdf_my_language_modal_count_singular: 'Bericht',
    aumico_pdf_my_language_modal_count_plural: 'Berichte',
    aumico_pdf_my_export_modal_cancel: 'Abbrechen',
    aumico_pdf_my_export_modal_confirm: 'Exportieren',
    aumico_ai_fixer_panel_beta_label: 'Beta',
    aumico_ai_fixer_panel_bullet_analyse: 'Analysiert die Struktur Ihrer Bilanz und Gewinn- und Verlustrechnung automatisch.',
    aumico_ai_fixer_panel_bullet_review: 'Sie behalten die Kontrolle und prüfen das Ergebnis vor der Übernahme.',
    aumico_ai_fixer_panel_bullet_revert: 'Die Änderungen können Sie jederzeit verwerfen.',
    aumico_ai_error_features_not_enabled: 'KI-Funktionen sind für Ihre Organisation nicht aktiviert. Bitte aktivieren Sie diese in den KI-Einstellungen.',
    aumico_ai_error_daily_limit_reached: 'Das tägliche Token-Limit von {{limit}} wurde erreicht. Bitte versuchen Sie es morgen erneut.',
    aumico_ai_error_monthly_limit_reached: 'Das monatliche Token-Limit von {{limit}} wurde erreicht. Bitte versuchen Sie es nächsten Monat erneut.',
    aumico_ai_error_session_not_found: 'KI-Sitzung wurde nicht gefunden.',
    aumico_ai_error_chat_in_progress: 'Es läuft bereits eine Chat-Anfrage für diese Sitzung. Bitte warten Sie, bis sie abgeschlossen ist.',
    aumico_ai_error_invalid_payload: 'Ungültige Eingabe für den KI-Agenten.',
    aumico_ai_error_agent_timeout: 'Der KI-Agent hat das Zeitlimit von {{seconds}} Sekunden überschritten.',
    aumico_ai_error_chat_processing: 'Beim Verarbeiten Ihrer Nachricht ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    aumico_ai_error_unknown: 'Unbekannter Fehler bei der KI-Verarbeitung.',
    // Flacher Schlüssel, weil das Backend ihn flach sendet (`orchestrator.handler.ts:parse()`):
    // ein abgewiesener Lauf muss SAGEN, welches Feld nicht passt — sonst bleibt nur "unbekannter Fehler".
    abcp_error_invalid_run_payload:
        'Der Lauf wurde abgewiesen: die Anfrage passt nicht zum Vertrag des Abschluss-Agenten. Betroffene Felder: {{fields}}.',
    aumico_ai_progress_section_processing: 'Abschnitt "{{sectionKey}}" wird analysiert…',
    aumico_ai_progress_section_already_valid: 'Abschnitt "{{sectionKey}}" ist bereits gültig.',
    aumico_ai_progress_section_fixed: 'Abschnitt "{{sectionKey}}" erfolgreich korrigiert.',
    aumico_ai_progress_section_with_errors: 'Abschnitt "{{sectionKey}}" abgeschlossen mit {{errorCount}} verbleibenden Fehler(n).',
    aumico_ai_progress_section_timeout: 'Abschnitt "{{sectionKey}}" hat das Zeitlimit von {{seconds}}s überschritten.',
    aumico_ai_progress_chat_started: 'Verarbeite Ihre Nachricht für {{count}} Abschnitt(e)…',
    aumico_ai_progress_chat_section_start: 'Analysiere Abschnitt "{{sectionKey}}"…',
    aumico_ai_progress_chat_section_complete: 'Abschnitt "{{sectionKey}}": {{toolCallCount}} Aktion(en), {{remainingErrors}} verbleibende Fehler.',
    aumico_ai_progress_chat_section_no_changes: 'Abschnitt "{{sectionKey}}": keine Änderungen nötig.',
    aumico_ai_progress_chat_section_timeout: 'Abschnitt "{{sectionKey}}" hat das Zeitlimit von {{seconds}}s überschritten.',
    aumico_ai_progress_tool_call: '[{{sectionKey}}] {{toolName}}',
    aumico_ai_progress_tool_call_with_errors: '[{{sectionKey}}] {{toolName}} → {{remainingErrors}} Fehler verbleibend',
    aumico_ai_chat_reply_no_output: 'Es liegt keine Ausgabe zum Bearbeiten vor. Bitte führen Sie zuerst die KI-Korrektur aus.',
    aumico_ai_chat_reply_default: 'Ich habe Ihre Anfrage verarbeitet. Bitte überprüfen Sie die aktualisierte Struktur.',
    aumico_integrations_page_title: 'Integrationen',
    aumico_integrations_section_available: 'Verfügbare Integrationen',
    aumico_reports_organization_settings_navigation_integrations: 'Integrationen',
    aumico_integration_card_btn_connect: 'Verbinden',
    aumico_integration_card_btn_disconnect: 'Trennen',
    aumico_integration_card_btn_test: 'Testen',
    aumico_integration_card_status_connected: 'Verbunden',
    aumico_integration_card_status_error: 'Fehler',
    aumico_integration_card_status_expired: 'Abgelaufen',
    aumico_integration_card_status_disconnected: 'Nicht verbunden',
    aumico_integration_card_status_connecting: 'Verbinde ...',
    aumico_integration_card_btn_reconnect: 'Neu verbinden',
    aumico_integration_d365bc_displayname: 'Dynamics 365 Business Central',
    aumico_integration_d365bc_description: 'Importiert Kontodaten und Journalbuchungen direkt aus Business Central.',
    aumico_d365bc_connect_modal_title: 'Dynamics 365 Business Central verbinden',
    aumico_d365bc_step_welcome_intro: 'Du wirst gleich zu Microsoft weitergeleitet, um aumico den Zugriff auf dein Business Central zu erlauben.',
    aumico_d365bc_step_welcome_signin_button: 'Mit Microsoft anmelden',
    aumico_d365bc_step_setup_title: 'Letzter Schritt — in deinem BC einrichten',
    aumico_d365bc_step_setup_tenant_connected: 'Mit Microsoft verbunden',
    aumico_d365bc_step_setup_step1: 'Öffne den Business Central Web-Client',
    aumico_d365bc_step_setup_step2: 'Suche nach "Microsoft Entra applications"',
    aumico_d365bc_step_setup_step3_clientid: 'Trage die Client ID ein',
    aumico_d365bc_step_setup_step4_state: 'Setze State = Enabled',
    aumico_d365bc_step_setup_step5_permission: 'Weise Permission Set "D365 READ" zu',
    aumico_d365bc_step_config_environment_label: 'BC Environment-Name',
    aumico_d365bc_step_config_environment_help: 'Meistens "production". Ändere nur falls dein BC anders benannt ist.',
    aumico_d365bc_step_config_displayname_help: 'Pflichtfeld. Hilft dir, mehrere BC-Tenants in der Übersicht zu unterscheiden.',
    aumico_d365bc_status_awaiting_consent: 'Warte auf Microsoft-Anmeldung ...',
    aumico_d365bc_status_creating: 'Verbindung wird angelegt ...',
    aumico_d365bc_status_success: 'Verbindung erfolgreich hergestellt',
    aumico_d365bc_status_success_next_mapping: 'Im nächsten Schritt ordnest du deine Firmen zu.',
    aumico_mapping_modal_title: 'Firmen zuordnen',
    aumico_mapping_currently_mapped_to: 'Aktuell verknüpft mit:',
    aumico_mapping_aumico_company_label: 'aumico Firma',
    aumico_button_change: 'Ändern',
    aumico_mapping_loading: 'Lade Vorschläge ...',
    aumico_mapping_vendor_company_label: 'BC Firma',
    aumico_mapping_search_placeholder: 'Firmenname eingeben ...',
    aumico_mapping_or: 'oder',
    aumico_mapping_search_hint_min_chars: 'Mindestens 3 Zeichen eingeben ...',
    aumico_mapping_search_loading: 'Lade Firmen ...',
    aumico_mapping_search_results_count: '{{count}} Treffer',
    aumico_mapping_search_no_results: 'Keine passende aumico-Firma gefunden.',
    aumico_mapping_search_error: 'aumico-Firmen konnten nicht geladen werden.',
    aumico_mapping_summary_title: 'Mapping abgeschlossen',
    aumico_mapping_summary_matched: '{{count}} Firmen zugeordnet',
    aumico_mapping_summary_skipped: '{{count}} übersprungen',
    aumico_mapping_summary_created: '{{count}} neue Firmen erstellt',
    aumico_mapping_summary_later_hint: 'Du kannst übersprungene Firmen jederzeit später zuordnen.',
    aumico_mapping_btn_finish: 'Fertig',
    aumico_button_retry: 'Erneut versuchen',
    aumico_integration_card_btn_manage: 'Verwalten',
    aumico_integration_card_tenants_count: '{{count}} Tenants verbunden',
    aumico_integration_card_tenants_reauth: '{{count}} brauchen neue Anmeldung',
    aumico_d365bc_manage_modal_title: 'Verbundene Tenants',
    aumico_d365bc_manage_back_to_list: 'Zurück zu Tenants',
    aumico_d365bc_manage_add_tenant: 'Neuen Tenant verbinden',
    aumico_d365bc_manage_tenant_label: 'Tenant',
    aumico_d365bc_manage_status_reauth: 'Anmeldung abgelaufen',
    aumico_d365bc_manage_companies_count: '{{count}} Firmen',
    aumico_d365bc_manage_no_mapping: '(nicht verknüpft)',
    aumico_d365bc_manage_loading_companies: 'Lade Firmen ...',
    aumico_d365bc_manage_company_column_bc: 'BC Firma',
    aumico_d365bc_manage_search_empty: 'Keine Firma gefunden.',
    aumico_d365bc_manage_btn_disconnect: 'Tenant trennen',
    aumico_d365bc_manage_btn_unlink: 'Entkoppeln',
    aumico_d365bc_automatch_running: 'Verknüpfungen werden automatisch erkannt ...',
    aumico_d365bc_automatch_success: '{{autoMatched}} automatisch erkannt · {{notMapped}} nicht verknüpft',
    aumico_d365bc_automatch_partial_errors: '({{errors}} Fehler)',
    aumico_d365bc_automatch_failed: 'Auto-Match fehlgeschlagen. Bitte Firmen manuell verknüpfen.',
    aumico_d365bc_manage_disconnect_confirm_title: 'Tenant wirklich trennen?',
    aumico_d365bc_manage_disconnect_confirm_text: 'Alle Mappings und gecachten Daten für diesen Tenant werden entfernt.',
    aumico_d365bc_manage_empty: 'Noch keine Tenants verbunden.',
    aumico_integration_topal_displayname: 'Topal',
    aumico_integration_topal_description: 'Importiert Buchhaltungsdaten direkt aus Topal.',
    aumico_topal_connect_modal_title: 'Topal verbinden',
    aumico_topal_step_welcome_intro: 'Trage die URL deines Topal Servers sowie Benutzername und Passwort ein. aumico verbindet sich direkt mit deinem Topal.',
    aumico_topal_step_config_displayname_help: 'Pflichtfeld. Hilft dir, mehrere Topal Server in der Übersicht zu unterscheiden.',
    aumico_topal_step_config_serverurl_label: 'Server URL',
    aumico_topal_step_config_serverurl_help: 'Die URL deines Topal Servers inkl. Port, z.B. https://topal.example.ch:9001',
    aumico_topal_step_config_username_label: 'Benutzername',
    aumico_topal_step_config_password_label: 'Passwort',
    aumico_topal_step_config_password_help: 'Das Passwort wird verschlüsselt gespeichert und nie wieder angezeigt.',
    aumico_topal_step_config_password_show: 'Anzeigen',
    aumico_topal_step_config_password_hide: 'Verbergen',
    aumico_topal_manage_modal_title: 'Verbundene Topal Server',
    aumico_topal_manage_empty: 'Noch keine Topal Server verbunden.',
    aumico_topal_manage_add_server: 'Neuen Server verbinden',
    aumico_topal_manage_back_to_list: 'Zurück zu Servern',
    aumico_topal_manage_status_reauth: 'Anmeldung abgelaufen',
    aumico_topal_manage_loading_companies: 'Lade Firmen ...',
    aumico_topal_manage_companies_count: '{{count}} Firmen',
    aumico_topal_manage_no_mapping: '(nicht verknüpft)',
    aumico_topal_manage_company_column_topal: 'Topal Firma',
    aumico_topal_manage_search_empty: 'Keine Firma gefunden.',
    aumico_topal_manage_btn_unlink: 'Entkoppeln',
    aumico_topal_manage_btn_disconnect: 'Server trennen',
    aumico_topal_manage_disconnect_confirm_title: 'Server wirklich trennen?',
    aumico_topal_manage_disconnect_confirm_text: 'Alle Mappings und gecachten Daten für diesen Server werden entfernt.',
    aumico_topal_automatch_running: 'Verknüpfungen werden automatisch erkannt ...',
    aumico_topal_automatch_success: '{{autoMatched}} automatisch erkannt · {{notMapped}} nicht verknüpft',
    aumico_topal_automatch_partial_errors: '({{errors}} Fehler)',
    aumico_topal_automatch_failed: 'Auto-Match fehlgeschlagen. Bitte Firmen manuell verknüpfen.',
    // ── Accounto (REV-21119) ──
    aumico_integration_accounto_displayname: 'Accounto',
    aumico_integration_accounto_description: 'Importiert Buchhaltungsdaten direkt aus Accounto.',
    aumico_accounto_connect_modal_title: 'Accounto verbinden',
    aumico_accounto_step_welcome_intro:
        'Erstelle in Accounto einen API-Schlüssel und füge ihn hier ein. Ein Treuhand-Schlüssel verbindet alle deine Mandanten, ein KMU-Schlüssel die eigene Firma. aumico liest nur Buchhaltungsdaten und schreibt nichts in dein Accounto.',
    aumico_accounto_step_config_displayname_help:
        'Pflichtfeld. Hilft dir, mehrere Accounto-Zugänge in der Übersicht zu unterscheiden.',
    aumico_accounto_step_config_apikey_label: 'API-Schlüssel',
    aumico_accounto_step_config_apikey_help:
        'Wird verschlüsselt gespeichert und nie wieder angezeigt. Der Schlüssel hat ein Ablaufdatum, aumico warnt dich 30 Tage vorher.',
    aumico_accounto_step_config_apikey_show: 'Anzeigen',
    aumico_accounto_step_config_apikey_hide: 'Verbergen',
    aumico_accounto_validation_apikey_invalid:
        'Das ist kein Accounto API-Schlüssel. Kopiere den ganzen Schlüssel aus Accounto: drei Teile, getrennt durch Punkte.',
    aumico_accounto_validation_missing_fields: 'Noch auszufüllen:',
    aumico_accounto_manage_modal_title: 'Verbundene Accounto-Zugänge',
    aumico_accounto_manage_empty: 'Noch kein Accounto-Zugang verbunden.',
    aumico_accounto_manage_add_server: 'Neuen API-Schlüssel verbinden',
    aumico_accounto_manage_back_to_list: 'Zurück zu den Zugängen',
    aumico_accounto_manage_status_reauth: 'Anmeldung fehlgeschlagen',
    aumico_accounto_manage_key_advisor: 'Treuhand-Schlüssel · Mandant {{tenantId}}',
    aumico_accounto_manage_key_client: 'KMU-Schlüssel · Mandant {{tenantId}}',
    aumico_accounto_key_valid_until: 'API-Schlüssel gültig bis {{date}}',
    aumico_accounto_key_expiring: 'API-Schlüssel läuft am {{date}} ab. Erstelle in Accounto einen neuen Schlüssel.',
    aumico_accounto_key_expired:
        'API-Schlüssel ist am {{date}} abgelaufen. Erstelle in Accounto einen neuen Schlüssel.',
    aumico_accounto_card_key_expiring: 'Schlüssel läuft ab',
    aumico_accounto_card_key_expired: 'Schlüssel abgelaufen',
    aumico_accounto_manage_loading_companies: 'Lade Mandanten ...',
    aumico_accounto_manage_companies_count: '{{count}} Mandanten',
    aumico_accounto_manage_no_mapping: '(nicht verknüpft)',
    aumico_accounto_manage_company_column_accounto: 'Accounto Mandant',
    aumico_accounto_manage_search_empty: 'Kein Mandant gefunden.',
    aumico_accounto_manage_btn_unlink: 'Entkoppeln',
    aumico_accounto_manage_btn_disconnect: 'Zugang trennen',
    aumico_accounto_manage_disconnect_confirm_title: 'Zugang wirklich trennen?',
    aumico_accounto_manage_disconnect_confirm_text:
        'Alle Mappings und gecachten Daten für diesen Zugang werden entfernt.',
    aumico_accounto_automatch_running: 'Verknüpfungen werden automatisch erkannt ...',
    aumico_accounto_automatch_success: '{{autoMatched}} automatisch erkannt · {{notMapped}} nicht verknüpft',
    aumico_accounto_automatch_partial_errors: '({{errors}} Fehler)',
    aumico_accounto_automatch_failed: 'Auto-Match fehlgeschlagen. Bitte Firmen manuell verknüpfen.',
    accounto_importing_title: 'Daten werden importiert',
    accounto_importing_subtitle: 'Deine Buchhaltungsdaten werden aus Accounto abgerufen',
    accounto_importing_hint: 'Das dauert nur einen kurzen Moment',
    accounto_summary_title: 'Import-Zusammenfassung',
    accounto_summary_overview: 'Übersicht',
    accounto_summary_company: 'Firma',
    accounto_summary_period: 'Periode',
    accounto_summary_previous_period: 'Vorjahresperiode',
    accounto_summary_accounts: 'Konten',
    accounto_summary_continue: 'Weiter zur Zuordnung',
    accounto_summary_discard: 'Verwerfen',
    accounto_summary_validation_title: 'Validierung',
    accounto_summary_balance_check: 'Bilanzprüfung',
    accounto_summary_current_year: 'Aktuelles Jahr',
    accounto_summary_previous_year: 'Vorjahr',
    accounto_summary_assets: 'Aktiven',
    accounto_summary_liabilities: 'Passiven',
    accounto_import_failed_title: 'Import fehlgeschlagen',
    accounto_import_failed_description: 'Der Accounto-Import ist fehlgeschlagen. Bitte versuche es später erneut.',
    accounto_import_key_expired_description:
        'Der Accounto API-Schlüssel ist abgelaufen. Erstelle in Accounto einen neuen Schlüssel.',
    accounto_import_invalid_key_description:
        'Der Accounto-API-Schlüssel ist ungültig oder abgelaufen. Erstelle in Accounto einen neuen Schlüssel und ersetze ihn unter Organisationseinstellungen → Integrationen.',
    accounto_import_connection_error_description:
        'Die Verbindung zu Accounto ist gestört. Teste sie unter Organisationseinstellungen → Integrationen oder ersetze dort den API-Schlüssel.',
    accounto_import_tenant_not_allowed_description:
        'Ein KMU-Schlüssel importiert nur die eigene Firma. Wähle den Mandanten dieses Schlüssels oder verbinde einen Treuhand-Schlüssel.',
    accounto_import_vendor_mismatch_description:
        'Die gewählte Verbindung ist keine Accounto-Verbindung. Wähle die Accounto-Verbindung dieser Firma.',
    accounto_import_tenant_not_mapped_description:
        'Dieser Accounto-Mandant ist dieser Firma nicht zugeordnet. Prüfe die Zuordnung unter Integrationen.',
    accounto_import_mapping_not_active_description:
        'Die Zuordnung zu diesem Accounto-Mandanten ist nicht aktiv. Aktiviere sie unter Integrationen und versuche es erneut.',
    accounto_import_unbalanced_booking_description:
        'Eine Buchung in Accounto ist nicht ausgeglichen: Soll und Haben stimmen nicht überein. Korrigiere sie in Accounto und importiere erneut.',
    accounto_import_unknown_accounting_type_description:
        'Ein bebuchtes Konto in Accounto hat einen unbekannten Kontotyp. Prüfe den Kontotyp in Accounto und importiere erneut.',
    // ── Proffix (REV-22536) ──
    aumico_integration_proffix_displayname: 'PROFFIX',
    aumico_integration_proffix_description: 'Importiert Buchhaltungsdaten direkt aus PROFFIX.',
    aumico_proffix_connect_modal_title: 'PROFFIX verbinden',
    aumico_proffix_step_welcome_intro:
        'Trage die Adresse deiner PROFFIX PxRestAPI, das REST-API-Passwort sowie deinen PROFFIX-Benutzernamen und dein Passwort ein. Die PxRestAPI muss über HTTPS erreichbar sein (z.B. über einen Reverse Proxy). aumico liest nur Buchhaltungsdaten und schreibt nichts in dein PROFFIX.',
    aumico_proffix_step_config_displayname_help: 'Pflichtfeld. Hilft dir, mehrere PROFFIX Server in der Übersicht zu unterscheiden.',
    aumico_proffix_step_config_serverurl_label: 'Server URL',
    aumico_proffix_step_config_serverurl_help:
        'Die Adresse deiner PxRestAPI inkl. Port, z.B. https://proffix.example.ch:11011 oder https://proffix.example.ch:11011/pxapi/V4',
    aumico_proffix_step_config_restapikey_label: 'REST-API-Passwort',
    aumico_proffix_step_config_restapikey_help:
        'Das Passwort der PxRestAPI (nicht dein Benutzerpasswort). Es wird verschlüsselt gespeichert und nie wieder angezeigt.',
    aumico_proffix_step_config_username_label: 'Benutzername',
    aumico_proffix_step_config_password_label: 'Passwort',
    aumico_proffix_step_config_password_help:
        'Das Passwort deines PROFFIX-Benutzers. Es wird verschlüsselt gespeichert und nie wieder angezeigt.',
    aumico_proffix_step_config_password_show: 'Anzeigen',
    aumico_proffix_step_config_password_hide: 'Verbergen',
    aumico_proffix_validation_serverurl_invalid:
        'Nur die Serveradresse mit Port eingeben, optional mit /pxapi/V4, aber ohne weiteren Pfad wie /PRO/Info. Sie beginnt mit https://.',
    aumico_proffix_validation_missing_fields: 'Noch auszufüllen:',
    aumico_proffix_manage_modal_title: 'Verbundene PROFFIX Server',
    aumico_proffix_manage_empty: 'Noch keine PROFFIX Server verbunden.',
    aumico_proffix_manage_add_server: 'Neuen Server verbinden',
    aumico_proffix_manage_back_to_list: 'Zurück zu Servern',
    aumico_proffix_manage_status_reauth: 'Anmeldung fehlgeschlagen',
    aumico_proffix_manage_loading_companies: 'Lade Mandanten ...',
    aumico_proffix_manage_companies_count: '{{count}} Mandanten',
    aumico_proffix_manage_no_mapping: '(nicht verknüpft)',
    aumico_proffix_manage_company_column_proffix: 'PROFFIX Mandant',
    aumico_proffix_manage_search_empty: 'Kein Mandant gefunden.',
    aumico_proffix_manage_btn_unlink: 'Entkoppeln',
    aumico_proffix_manage_btn_disconnect: 'Server trennen',
    aumico_proffix_manage_disconnect_confirm_title: 'Server wirklich trennen?',
    aumico_proffix_manage_disconnect_confirm_text: 'Alle Mappings und gecachten Daten für diesen Server werden entfernt.',
    aumico_proffix_automatch_running: 'Verknüpfungen werden automatisch erkannt ...',
    aumico_proffix_automatch_success: '{{autoMatched}} automatisch erkannt · {{notMapped}} nicht verknüpft',
    aumico_proffix_automatch_partial_errors: '({{errors}} Fehler)',
    aumico_proffix_automatch_failed: 'Auto-Match fehlgeschlagen. Bitte Firmen manuell verknüpfen.',
    proffix_importing_title: 'Daten werden importiert',
    proffix_importing_subtitle: 'Deine Buchhaltungsdaten werden aus PROFFIX abgerufen',
    proffix_importing_hint: 'Das dauert nur einen kurzen Moment',
    proffix_summary_title: 'Import-Zusammenfassung',
    proffix_summary_overview: 'Übersicht',
    proffix_summary_company: 'Firma',
    proffix_summary_period: 'Periode',
    proffix_summary_previous_period: 'Vorjahresperiode',
    proffix_summary_accounts: 'Konten',
    proffix_summary_continue: 'Weiter zur Zuordnung',
    proffix_summary_discard: 'Verwerfen',
    proffix_summary_validation_title: 'Validierung',
    proffix_summary_balance_check: 'Bilanzprüfung',
    proffix_summary_current_year: 'Aktuelles Jahr',
    proffix_summary_previous_year: 'Vorjahr',
    proffix_summary_assets: 'Aktiven',
    proffix_summary_liabilities: 'Passiven',
    proffix_import_failed_title: 'Import fehlgeschlagen',
    proffix_import_failed_description: 'Der PROFFIX-Import ist fehlgeschlagen. Bitte versuchen Sie es später erneut.',
    aumico_integration_abacus_displayname: 'Abacus',
    aumico_integration_abacus_description: 'Importiert Buchhaltungsdaten via AbaReport direkt aus Abacus.',
    aumico_abacus_connect_modal_title: 'Abacus verbinden',
    aumico_abacus_step_welcome_intro: 'Trage deine Abacus Server URL und die OAuth2 Zugangsdaten ein. aumico verbindet sich direkt mit deinem Abacus über AbaReport.',
    aumico_abacus_step_config_displayname_help: 'Pflichtfeld. Hilft dir, mehrere Abacus Server in der Übersicht zu unterscheiden.',
    aumico_abacus_step_config_serverurl_label: 'Server URL',
    aumico_abacus_step_config_serverurl_help: 'Die URL deines Abacus Servers, z.B. https://abaweb.example.ch',
    aumico_abacus_step_config_clientid_label: 'Client ID',
    aumico_abacus_step_config_clientsecret_label: 'Client Secret',
    aumico_abacus_step_config_clientsecret_help: 'Das Secret wird verschlüsselt gespeichert und nie wieder angezeigt.',
    aumico_abacus_step_config_clientsecret_show: 'Anzeigen',
    aumico_abacus_step_config_clientsecret_hide: 'Verbergen',
    aumico_abacus_manage_modal_title: 'Verbundene Abacus Server',
    aumico_abacus_manage_empty: 'Noch keine Abacus Server verbunden.',
    aumico_abacus_manage_add_server: 'Neuen Server verbinden',
    aumico_abacus_manage_add_mapping: 'Mapping hinzufügen',
    aumico_abacus_manage_back_to_list: 'Zurück zur Liste',
    aumico_abacus_manage_companies_section_title: 'Zugeordnete Firmen',
    aumico_abacus_manage_companies_empty: 'Noch keine Firmen zugeordnet.',
    aumico_abacus_manage_status_reauth: 'Zugangsdaten ungültig',
    aumico_abacus_manage_btn_disconnect: 'Server trennen',
    aumico_abacus_manage_disconnect_confirm_title: 'Server wirklich trennen?',
    aumico_abacus_manage_disconnect_confirm_text: 'Alle Mappings und gecachten Daten für diesen Server werden entfernt.',
    aumico_abacus_mapping_add_title: 'Mandanten ID zuordnen',
    aumico_abacus_mapping_edit_title: 'Mandanten ID bearbeiten',
    aumico_abacus_mapping_mandanten_id_placeholder: 'z.B. 1001',
    aumico_abacus_mapping_mandanten_id_help: 'Die numerische ID des Mandanten in Abacus.',
    aumico_integration_setup_displayname_label: 'Anzeigename',
    aumico_integration_setup_displayname_placeholder: 'z.B. Treuhand Firma X',
    aumico_integration_search_company_placeholder: 'Firma suchen ...',
    aumico_integration_status_error_title: 'Verbindung fehlgeschlagen',
    aumico_integration_status_testing: 'Verbindung wird getestet ...',
    aumico_integration_status_connected: 'Verbunden',
    aumico_integration_connect_button: 'Verbindung herstellen',
    aumico_integration_connect_already_exists_title: 'Server bereits verbunden',
    aumico_integration_connect_already_exists_description: 'Dieser Server ist in deiner Organisation bereits verbunden. Du findest ihn in der Übersicht.',
    aumico_integration_aumico_company_label: 'aumico Firma',
    aumico_abacus_mandanten_id_label: 'Mandanten ID',
    aumico_button_ok: 'Ok',
    aumico_integration_card_btn_info: 'Info',
    aumico_integration_card_status_action_required: 'Aktion erforderlich',
    aumico_integration_card_beta: 'BETA',
    aumico_integration_card_beta_tooltip:
        'Beta: Diese Integration validieren wir noch mit ersten Kunden. Du kannst sie bereits nutzen – dein Feedback hilft uns, sie zu verbessern.',
    aumico_company_integrations_section_connected: 'Verbunden',
    aumico_company_integration_redirect_tenant_label: 'Tenant',
    aumico_company_integration_redirect_environment_label: 'Umgebung',
    aumico_company_integration_redirect_external_company_label: 'Verknüpfte Firma',
    aumico_company_integration_redirect_broken: 'Die verknüpfte Verbindung ist nicht mehr verfügbar. Bitte prüfe sie in den Organisationseinstellungen.',
    aumico_company_integration_redirect_managed_in_org: 'Diese Integration wird in den Organisationseinstellungen verwaltet.',
    aumico_integration_managed_in_org_ask_admin: 'Bitte frag einen Admin, diese Integration in den Organisationseinstellungen einzurichten.',
    aumico_company_integration_redirect_goto_org_settings: 'Zu den Organisationseinstellungen',
    aumico_company_integration_bexio_modal_connected: 'Bexio ist mit dieser Firma verbunden. Du kannst die Verbindung hier trennen.',
    aumico_company_integration_bexio_modal_disconnected: 'Verbinde Bexio mit dieser Firma, um Kontodaten und Journalbuchungen direkt zu importieren.',
    aumico_org_integration_redirect_managed_in_company: 'Bexio wird pro Firma verwaltet. Bitte verbinde Bexio direkt in der jeweiligen Firma unter "Integrationen". Du findest dies als "Tab" neben dem Firmenprofil.',
    aumico_editable_account_unlock_prior_year_tooltip: 'Vorjahreswert entsperren',
    aumico_grouping_masking_reclass_legacy_banner: 'Umgliederungen für diesen Bericht bearbeitest du im bestehenden Tab. Die neue Funktion ist hier deaktiviert.',
    // ── REV-21964 · SharePoint sync report + upstream states ─────────────────────────────
    abcp_sync_run_status_pending: 'Wartet',
    abcp_sync_run_status_running: 'Läuft',
    abcp_sync_run_status_completed: 'Abgeschlossen',
    abcp_sync_run_status_failed: 'Fehlgeschlagen',
    abcp_sync_refused_closing_sealed: 'Der Abschluss ist versiegelt. Es werden keine Belege mehr übernommen.',
    abcp_sync_refused_already_running: 'Eine Synchronisation läuft bereits.',
    abcp_sync_refused_no_bound_folders: 'Es ist noch kein Ordner verbunden.',
    abcp_sync_started: 'Synchronisation gestartet. Du kannst weiterarbeiten.',
    abcp_sync_new_documents: '{{count}} neues Dokument',
    abcp_sync_new_documents_plural: '{{count}} neue Dokumente',
    abcp_sync_new_documents_none: 'Keine neuen Dokumente',
    abcp_sync_problem_files: '{{count}} Datei nicht übernommen',
    abcp_sync_problem_files_plural: '{{count}} Dateien nicht übernommen',
    abcp_sync_failed_folders: '{{count}} Ordner nicht lesbar',
    abcp_sync_failed_folders_plural: '{{count}} Ordner nicht lesbar',
    abcp_sync_skips_truncated: 'Weitere Dateien sind hier nicht einzeln aufgeführt. Die Zahl der neuen Dokumente ist vollständig.',
    abcp_sync_folder_failed: 'Ordner konnte nicht gelesen werden: {{folderPath}}',
    abcp_sync_never_run: 'Für diesen Abschluss wurde noch nie synchronisiert.',
    abcp_sync_skip_unsupported_type: 'Dateityp wird nicht übernommen (nur PDF, Excel und Word)',
    abcp_sync_skip_already_imported: 'Schon im Abschluss, unverändert',
    abcp_sync_skip_download_failed: 'Datei konnte nicht geladen werden',
    abcp_sync_skip_rejected_by_ingest: 'Beim Hochladen abgelehnt',
    abcp_sync_skip_listing_capped: 'Der Ordner hat mehr Dateien, als ein Durchgang liest',
    abcp_sync_skip_too_large: 'Datei ist größer als 32 MB',
    abcp_sync_skip_duplicate_content: 'Gleicher Inhalt wie ein vorhandener Beleg. Der Name ist dort vermerkt.',
    abcp_upstream_state_deleted: 'In SharePoint gelöscht',
    abcp_upstream_state_moved_out: 'Aus dem verbundenen Ordner verschoben',
    abcp_upstream_state_replaced: 'Durch eine neuere Fassung ersetzt',
    abcp_upstream_notice_assigned: 'Dieser Beleg stützt ein Konto und ist in SharePoint nicht mehr am Platz. Er bleibt im Abschluss — bitte prüfen.',
    abcp_upstream_notice_unassigned: 'In SharePoint nicht mehr am Platz.',
    abcp_upstream_notice_replaced_assigned: 'Von dieser Datei gibt es in SharePoint eine neuere Fassung. Dieser Beleg stützt ein Konto und bleibt unverändert im Abschluss — die neue Fassung liegt im Eingang und muss von Ihnen zugeordnet werden.',
    abcp_upstream_notice_replaced_unassigned: 'Von dieser Datei gibt es in SharePoint eine neuere Fassung. Sie liegt im Eingang.',
    abcp_upstream_action_not_relevant: 'Als nicht relevant markieren',
    abcp_upstream_alias_names: 'Weitere Namen in SharePoint: {{names}}',
    abcp_upstream_changed_at: 'Festgestellt am {{date}}',
    abcp_accounts_status_open: 'Offen',
    abcp_accounts_status_difference: 'Differenz',
    abcp_accounts_status_reconciled: 'Abgestimmt',
    // What started a reconciliation run, as its first trail line names it.
    abcp_trail_trigger_document_assigned: 'Beleg zugeordnet',
    abcp_trail_trigger_document_unassigned: 'Zuordnung aufgehoben',
    abcp_trail_trigger_document_removed: 'Beleg entfernt',
    abcp_trail_trigger_erp_sync: 'Buchhaltung synchronisiert',
    abcp_accounts_col_number: 'Nr.',
    abcp_accounts_col_label: 'Bezeichnung',
    abcp_accounts_col_status: 'Status',
    abcp_accounts_error: 'Kontenübersicht konnte nicht geladen werden.',
    abcp_accounts_empty: 'Keine Konten vorhanden.',
    abcp_accounts_group_reconciled_tooltip: 'Alle Konten dieser Gruppe sind abgestimmt',
    abcp_accounts_group_status_tooltip: '{{reconciled}} abgestimmt, {{difference}} mit Differenz, {{open}} offen',
    abcp_accounts_marked_tooltip: 'Markiert',
    abcp_ledger_col_date: 'Datum',
    abcp_ledger_col_text: 'Buchungstext',
    abcp_ledger_col_account: 'GK',
    abcp_ledger_col_account_label: 'GK-Bezeichnung',
    abcp_ledger_col_vat: 'USt.',
    abcp_ledger_col_debit: 'Soll',
    abcp_ledger_col_credit: 'Haben',
    abcp_ledger_col_balance: 'Saldo',
    abcp_ledger_row_opening: 'Saldovortrag',
    abcp_ledger_row_closing: 'Schlusssaldo',
    abcp_ledger_empty: 'Keine Buchungen vorhanden.',
    abcp_ledger_error: 'Buchungen konnten nicht geladen werden.',
    abcp_ledger_foreign_rate: 'Kurs',
    abcp_ledger_foreign_unavailable: 'nicht verfügbar',
    abcp_ledger_load_more: 'Mehr laden',
    abcp_ledger_mark_comment: 'Kommentieren',
    abcp_ledger_mark_todo: 'Pendenz erfassen',
    abcp_ledger_line_missing_title: 'Buchung nicht gefunden',
    abcp_ledger_line_missing_body: 'Die Buchung steht nicht mehr im Kontenblatt. Sie wurde im ERP geändert oder gelöscht.',
    abcp_settings_open: 'Einstellungen',
    abcp_closing_currency_missing: 'Für diesen Jahresabschluss ist noch keine Währung festgelegt. Lege sie in den Einstellungen fest, dann werden die Beträge angezeigt.',
    abcp_settings_title: 'Einstellungen Jahresabschluss',
    abcp_settings_loading: 'Einstellungen werden geladen …',
    abcp_settings_year: 'Aktuelles Geschäftsjahr',
    abcp_settings_period_start: 'Beginn',
    abcp_settings_period_end: 'Ende',
    abcp_settings_currency: 'Währung',
    abcp_settings_save: 'Speichern',
    abcp_settings_cancel: 'Abbrechen',
    abcp_settings_reason_order: 'Der Beginn muss vor dem Ende liegen.',
    abcp_settings_load_failed: 'Die Einstellungen konnten nicht geladen werden.',
    abcp_settings_save_failed: 'Die Einstellungen konnten nicht gespeichert werden.',

    // REV-21370 / REV-21364 / REV-21375 — Korrekturbuchungen (ADR-0015).
    //
    // FLAT keys, like `abcp_ledger_*` above: these are FE-owned and carry no dots. The nested
    // `abcp.*` form is for the DOTTED keys the backend supplies, which i18next can only resolve
    // out of an object (ADR-0015 §12).
    abcp_adjustments_filter_all: 'Alle',
    abcp_adjustments_filter_released: 'Freigegeben',
    abcp_adjustments_filter_transferred: 'Übertragen',
    abcp_adjustments_filter_booked: 'Gebucht',
        abcp_adjustments_filter_discarded: 'Verworfen',
        abcp_adjustments_restore: 'Wieder freigeben',
        abcp_adjustments_restore_hint: 'Die verworfene Korrektur wird wieder freigegeben und erscheint in den Arbeitslisten.',
        abcp_adjustments_discarded: 'Verworfen',
        abcp_adjustments_discarded_hint: 'Zurückgenommen — nicht gelöscht. Bleibt für die Nachvollziehbarkeit erhalten.',
        abcp_adjustments_edit_start: 'Bearbeiten',
        abcp_adjustments_edit_save: 'Speichern',
        abcp_adjustments_edit_cancel: 'Abbrechen',
    abcp_adjustments_fiscal_year: 'Geschäftsjahr',
    abcp_adjustments_fiscal_year_short: 'GJ',
    abcp_adjustments_fiscal_year_current: 'aktuell',
    abcp_adjustments_new: 'Neue Buchung',
    abcp_adjustments_transfer: 'Übertragen',
    abcp_adjustments_row_actions: 'Aktionen',
    abcp_adjustments_edit: 'Bearbeiten',
    abcp_adjustments_discard: 'Verwerfen',
    abcp_adjustments_retry: 'Erneut versuchen',
    abcp_adjustments_col_state: 'Status',
    abcp_adjustments_col_text: 'Buchungstext',
    abcp_adjustments_col_debit: 'Soll',
    abcp_adjustments_col_credit: 'Haben',
    abcp_adjustments_col_amount: 'Betrag',
    abcp_adjustments_col_pnl: 'P&L',
    abcp_adjustments_effect_increase: 'Erhöht Gewinn',
    abcp_adjustments_effect_decrease: 'Mindert Gewinn',
    abcp_adjustments_effect_none: 'Ohne Einfluss',
    abcp_adjustments_col_source: 'Quelle',
    abcp_adjustments_col_date: 'Datum',
    abcp_adjustments_state_released: 'Freigegeben',
        abcp_adjustments_state_proposed: 'Vorschlag',
        abcp_adjustments_state_proposed_hint: 'Von einem Agenten vorgeschlagen — noch nicht freigegeben.',
        abcp_adjustments_not_found: 'Nicht gefunden',
        abcp_adjustments_not_found_hint: 'Im importierten Journal des ERP nicht gefunden. Kein Fehler — die Buchung kann noch folgen.',
        abcp_adjustments_result_excluded: 'Nicht klassifiziert',
        abcp_adjustments_result_excluded_hint: 'Ein Konto dieser Buchung fehlt im Kontenplan. Die Buchung ist aus dem Ergebnis ausgenommen.',
        abcp_adjustments_field_date: 'Buchungsdatum',
        abcp_adjustments_field_date_hint: 'Standard ist der Bilanzstichtag. Änderbar innerhalb des Geschäftsjahres.',
        abcp_adjustments_error_date_invalid: 'Bitte ein gültiges Datum angeben.',
        abcp_adjustments_error_date_outside_year: 'Das Buchungsdatum muss im Geschäftsjahr des Abschlusses liegen.',
        abcp_adjustments_transfer_all_released: 'Alle freigegebenen übertragen',
    abcp_adjustments_state_released_hint: 'Erfasst und freigegeben — noch nicht ans ERP übertragen.',
    abcp_adjustments_state_transferred: 'Übertragen',
    abcp_adjustments_state_transferred_hint: 'Ans ERP übertragen — noch nicht im Buchungsjournal bestätigt.',
    abcp_adjustments_state_booked: 'Gebucht',
    abcp_adjustments_state_booked_hint: 'Im importierten Journal des ERP wiedergefunden.',
    abcp_adjustments_source_user: 'Benutzer',
    abcp_adjustments_source_agent: 'Agent',
    abcp_adjustments_source_prior_year: 'VJ',
    abcp_adjustments_ambiguous: 'Mehrdeutig',
    abcp_adjustments_ambiguous_hint: 'Mehrere Journalzeilen passen — es wird nicht geraten. Bitte in der Detailansicht die richtige wählen.',
    abcp_adjustments_ambiguity_title: 'Mehrdeutiger Journal-Treffer',
    abcp_adjustments_ambiguity_hint: 'Mehrere Journalzeilen stimmen in Soll, Haben, Betrag und Geschäftsjahr überein. Wählen Sie die Zeile, die diese Korrekturbuchung belegt — es wird nichts geraten.',
    abcp_adjustments_ambiguity_confirm: 'Zeile als Buchungsnachweis wählen',
    abcp_adjustments_transfer_erp: 'Direkt ans ERP senden',
    abcp_adjustments_transfer_erp_hint: 'Das Buchhaltungssystem hat eine Schreib-Schnittstelle',
    abcp_adjustments_transfer_manual: 'Als manuell gebucht markieren',
    abcp_adjustments_transfer_manual_hint: 'Wurde bereits direkt im ERP erfasst',
    abcp_adjustments_transfer_reason_no_write_api: 'Das verbundene Buchhaltungssystem hat keine Schreib-Schnittstelle. Nutzen Sie den CSV-Export.',
    abcp_adjustments_transfer_reason_not_connected: 'Für dieses Mandat ist kein Buchhaltungssystem verbunden. Nutzen Sie den CSV-Export.',
    abcp_adjustments_transfer_reason_reauth: 'Die Verbindung zum Buchhaltungssystem muss erneuert werden.',
    abcp_adjustments_transfer_reason_unavailable: 'Die Verbindung zum Buchhaltungssystem ist derzeit nicht erreichbar.',
    abcp_adjustments_transfer_reason_no_caller_context: 'Der Übertrag ans ERP ist auf diesem Weg nicht möglich. Nutzen Sie den CSV-Export.',
    abcp_adjustments_transfer_reason_vendor_rejected: 'Das Buchhaltungssystem hat diese Buchung abgelehnt.',
    abcp_adjustments_result_provisional: 'Provisorisches Jahresergebnis',
    abcp_adjustments_result_provisional_hint: '· vor Korrekturbuchungen',
    abcp_adjustments_result_after: 'Jahresergebnis nach Korrekturbuchungen',
    abcp_adjustments_result_impact: 'Einfluss ergebniswirksamer Korrekturen',
    abcp_adjustments_total: 'Total Korrekturbuchungen',
    abcp_adjustments_total_year: 'Total GJ {{year}}',
    abcp_adjustments_unclassified_note: '{{count}} Korrekturbuchung(en) betreffen ein Konto, das noch keiner Position zugeordnet ist — sie zählen in das Total, aber nicht in den Ergebnis-Einfluss.',
    abcp_adjustments_empty: 'Keine Korrekturbuchungen vorhanden.',
    abcp_adjustments_empty_year: 'Keine Korrekturbuchungen im GJ {{year}} vorhanden.',
    abcp_adjustments_no_hits: 'Keine Korrekturbuchung passt zu «{{term}}».',
    abcp_adjustments_error: 'Korrekturbuchungen konnten nicht geladen werden.',
    abcp_adjustments_search_hits: '{{count}} Treffer für «{{term}}»',
    abcp_adjustments_search_reset: 'Suche zurücksetzen',
    abcp_adjustments_modal_create_title: 'Neue Korrekturbuchung',
    abcp_adjustments_modal_edit_title: 'Korrekturbuchung bearbeiten',
    abcp_adjustments_modal_account: 'Konto',
    abcp_adjustments_modal_submit: 'Buchung erfassen',
    abcp_adjustments_modal_save: 'Speichern',
    abcp_adjustments_modal_cancel: 'Abbrechen',
    abcp_adjustments_modal_no_accounts: 'Für diesen Abschluss ist noch kein Kontenplan vorhanden. Aktualisieren Sie zuerst die Buchhaltungsdaten.',
    abcp_adjustments_field_text: 'Buchungstext',
    abcp_adjustments_field_text_placeholder: 'z. B. Bankspesen Q4',
    abcp_adjustments_field_debit: 'Soll-Konto',
    abcp_adjustments_field_credit: 'Haben-Konto',
    abcp_adjustments_field_amount: 'Betrag',
    abcp_adjustments_field_owner: 'Zuordnung (Konto)',
    abcp_adjustments_field_owner_auto: 'Automatisch (Soll)',
    abcp_adjustments_field_choose: 'Wählen',
    abcp_adjustments_field_remark: 'Bemerkungen',
    abcp_adjustments_field_remark_placeholder: 'Optionale Bemerkung zur Korrekturbuchung.',
    abcp_adjustments_field_vat: 'MWST',
    abcp_adjustments_preview: 'Buchungssatz',
    abcp_adjustments_preview_against: 'an',
    abcp_adjustments_detail_back: 'Zurück',
    abcp_adjustments_transfer_progress_title: 'ERP-Übertragung',
    abcp_adjustments_transfer_progress_connection: 'Verbindung zum ERP',
    abcp_adjustments_transfer_progress_sending: '{{count}} Korrekturbuchung(en) werden übertragen',
    abcp_adjustments_proof_pending: 'Buchungsnachweis folgt mit «ERP aktualisieren».',
    abcp_adjustments_open_count: '{{count}} offen',
    abcp_adjustments_account_empty: 'Keine Korrekturbuchungen für GJ {{year}}.',
    abcp_adjustments_error_same_accounts: 'Soll- und Haben-Konto dürfen nicht identisch sein.',
    abcp_adjustments_error_not_open: 'Nur offene Korrekturbuchungen lassen sich ändern oder verwerfen.',
    abcp_adjustments_error_not_found: 'Diese Korrekturbuchung ist nicht verfügbar.',
    abcp_adjustments_error_discarded: 'Diese Korrekturbuchung wurde verworfen.',
    abcp_adjustments_error_not_ambiguous: 'Für diese Korrekturbuchung ist keine Auswahl offen.',
    abcp_adjustments_error_candidate_unknown: 'Diese Journalzeile gehört nicht zu den gefundenen Kandidaten.',
    abcp_adjustments_error_proof_taken: 'Diese Journalzeile belegt bereits eine andere Korrekturbuchung.',
    abcp_adjustments_error_prior_year: 'Für dieses Geschäftsjahr ist keine Bearbeitung möglich.',
    abcp_adjustments_error_accounts_equal: 'Soll- und Haben-Konto dürfen nicht identisch sein.',
    abcp_adjustments_error_account_unknown: 'Dieses Konto gehört nicht zum Kontenplan des Abschlusses.',
    abcp_adjustments_error_amount: 'Der Betrag muss grösser als null sein.',
    abcp_adjustments_error_text: 'Der Buchungstext darf nicht leer sein.',
    abcp_adjustments_error_no_connection: 'Für dieses Mandat ist kein Buchhaltungssystem verbunden. Nutzen Sie den CSV-Export.',
    abcp_adjustments_error_connection_ambiguous: 'Für dieses Mandat sind mehrere Buchhaltungssysteme verbunden — der direkte Übertrag ist deshalb nicht möglich.',
    // REV-21367 — ABCP-Dokumentenhub (abcp-documents-hub).
    abcp_documents_filter_inbox: 'Eingang',
    abcp_documents_filter_assigned: 'Zugeordnet',
    abcp_documents_filter_not_relevant: 'Nicht relevant',
    abcp_documents_col_filename: 'Dokumentenname',
    abcp_documents_col_account: 'Konto',
    abcp_documents_col_confidence: 'Belegtyp',
    abcp_documents_col_confidence_hint: 'Der von der KI erkannte Belegtyp – kein Urteil über die Kontowahl.',
    abcp_documents_col_date: 'Datum',
    abcp_documents_col_source: 'Quelle',
    abcp_documents_col_status: 'Status',
    abcp_documents_status_open: 'Offen',
    abcp_documents_status_proposed: 'Vorschlag',
    abcp_documents_status_assigned: 'Zugewiesen',
    abcp_documents_source_upload: 'Upload',
    abcp_documents_source_sharepoint: 'Sharepoint',
    abcp_documents_source_email: 'E-Mail',
    abcp_documents_search_placeholder: 'Alle Dokumente durchsuchen…',
    abcp_documents_upload: 'Upload',
    abcp_documents_sync_now: 'Jetzt synchronisieren',
    abcp_documents_sync_settings: 'Einstellungen',
    abcp_documents_sync_disconnected: 'Nicht verbunden',
    abcp_documents_account_select: 'Konto auswählen',
    abcp_documents_project_file: 'Projekt-Akte',
    abcp_documents_picker_search_placeholder: 'Konto-Nr oder Bezeichnung…',
    abcp_documents_picker_project_file: 'Allgemein · Projekt-Akte',
    abcp_documents_picker_project_file_hint: 'GV-Protokoll, Vollständigkeitserklärung, Verträge',
    abcp_documents_picker_empty: 'Kein Konto gefunden',
    abcp_documents_picker_assignment: 'Zuordnung',
    abcp_documents_picker_back: 'Zurück',
    abcp_documents_validity_closing: 'Nur dieser Jahresabschluss',
    abcp_documents_validity_closing_hint: 'Beleg betrifft nur das aktuelle Geschäftsjahr',
    abcp_documents_validity_long_term_option: 'Langfristig gültig',
    abcp_documents_validity_long_term_hint: 'Verträge, Leasings, Darlehen — bleibt über mehrere Jahre aktuell',
    abcp_documents_proposal_accept: 'Bestätigen',
    abcp_documents_proposal_reject: 'Ablehnen',
    abcp_documents_not_relevant_mark: 'Für diesen Abschluss nicht relevant — das Dokument bleibt erhalten',
    abcp_documents_not_relevant_restore: 'Wieder als relevant für diesen Abschluss markieren',
    abcp_documents_drop_title: 'Dokumente hier ablegen',
    abcp_documents_drop_hint: 'Nur PDF · Mehrfach-Upload möglich',
    abcp_documents_validity_long_term: 'Dauerakte — langfristig gültig',
    abcp_documents_empty: 'Keine Dokumente in diesem Filter.',
    abcp_documents_uploading: 'Wird hochgeladen …',
    abcp_documents_error: 'Dokumente konnten nicht geladen werden.',
    abcp_documents_agent_notice_title: 'Automatisch zugewiesen.',
    abcp_documents_agent_filter: 'Automatisch zugewiesen in dieser Ansicht',
    abcp_documents_proposal_error: 'Das hat nicht geklappt — bitte nochmals versuchen.',
    abcp_documents_proposal_pending: 'Wird verarbeitet…',
    // REV-22302 — what the AI is doing with a document: the working indicator and its steps, the two
    // findings with their reasons, the picker action beside them, and the recognised Belegart.
    abcp_documents_ai_working: 'KI liest den Beleg …',
    abcp_documents_ai_step_reading: 'Text wird gelesen',
    abcp_documents_ai_step_kind: 'Belegart wird erkannt',
    abcp_documents_ai_step_scan: 'Datei wird geprüft',
    abcp_documents_ai_step_value: 'Saldo wird gelesen',
    abcp_documents_proposal_source_content: 'Vorschlag aus dem Inhalt',
    abcp_documents_proposal_source_balance: 'Vorschlag aus dem Saldo',
    abcp_documents_proposal_source_both: 'Inhalt und Saldo stimmen überein',
    abcp_documents_proposal_balance_matches: 'Saldo stimmt überein',
    abcp_documents_proposal_balance_differs: 'Saldo stimmt nicht überein',
    abcp_documents_proposal_balance_not_checked: 'Saldo nicht geprüft',
    abcp_documents_no_proposal: 'Kein Vorschlag',
    abcp_documents_not_readable: 'Nicht lesbar',
    abcp_documents_account_choose: 'Konto wählen',
    abcp_documents_refusal_no_bound_account: 'Im Kontenplan ist dieser Belegart kein Konto zugeordnet.',
    abcp_documents_refusal_accounts_unclassified: 'Die passenden Konten sind noch nicht klassifiziert.',
    abcp_documents_refusal_ambiguous: 'Mehrere Konten kommen in Frage – bitte selbst wählen.',
    abcp_documents_refusal_no_candidate: 'Kein Konto passt zum Namen auf dem Beleg – bitte selbst wählen.',
    abcp_documents_refusal_name_out_of_cut: 'Der Name auf dem Beleg weist auf ein Konto außerhalb der passenden Konten – bitte selbst wählen.',
    abcp_documents_refusal_name_unavailable: 'Der Namensvergleich konnte nicht durchgeführt werden – bitte selbst wählen.',
    abcp_documents_refusal_unclassified: 'Die KI konnte die Belegart nicht erkennen.',
    abcp_documents_refusal_no_text: 'Im Beleg wurde kein lesbarer Text gefunden.',
    abcp_documents_refusal_model_unparseable: 'Die Antwort der KI war nicht auswertbar.',
    abcp_documents_refusal_integrity_fail: 'Der Beleg konnte nicht fehlerfrei gelesen werden.',
    abcp_documents_refusal_not_extracted: 'Der Beleg war noch nicht gelesen, als die KI ein Konto suchte.',
    abcp_documents_refusal_unknown: 'Die KI hat kein Konto vorgeschlagen.',
    abcp_documents_refusal_rejected: 'Der Vorschlag der KI wurde abgelehnt.',
    abcp_documents_kind_bank_statement: 'Kontoauszug',
    abcp_documents_kind_securities_depot_statement: 'Depotauszug',
    abcp_documents_kind_open_items_list: 'OP-Liste',
    // Kinds the classifier no longer returns keep their labels above, unused.
    abcp_documents_kind_bank_interest_capital_statement: 'Zins- / Kapitalausweis',
    abcp_documents_kind_bank_confirmation: 'Bankbestätigung',
    abcp_documents_kind_bank_other: 'Sonstiger Bankbeleg',
    abcp_documents_kind_cash_closing: 'Kassenabschluss',
    abcp_documents_kind_cash_in_transit_other: 'Transitbeleg',
    abcp_documents_kind_securities_other: 'Sonstiger Wertschriftenbeleg',
    abcp_documents_kind_customer_balance_confirmation: 'Saldobestätigung Kunde',
    abcp_documents_kind_receivables_other: 'Sonstiger Debitorenbeleg',
    abcp_documents_kind_allowance_calculation: 'Delkredere-Berechnung',
    abcp_documents_date_warning: 'Achtung: Beleg per {{balanceDate}}, Abschluss per {{balanceSheetDate}}',
    // REV-21368 — ABCP-Einzeldokument (abcp-document-detail). Flache Keys wie beim
    // Schwester-Pure-View abcp_documents_*. Bewusst EIGENE Keys statt Wiederverwendung, wo der
    // Prototyp der Einzelseite anders beschriftet als der Hub: 'Akzeptieren' statt 'Bestätigen',
    // 'Klasse' statt 'Kl.', 'Nur dieser Abschluss' statt 'Nur dieser Jahresabschluss'.
    // Umkehrbar geteilt bleiben abcp_documents_not_relevant_mark/_restore und _proposal_reject.
    abcp_document_detail_close: 'Zurück',
    abcp_document_detail_not_relevant_mark: 'Nicht relevant',
    abcp_document_detail_not_relevant_restore: 'Als relevant markieren',
    abcp_document_detail_not_relevant_title: 'Dieses Dokument ist nicht relevant.',
    abcp_document_detail_not_relevant_body: 'Markiere es als relevant, damit du es einem Konto zuordnen kannst.',
    abcp_document_detail_write_error: 'Das hat nicht geklappt. Versuch es nochmal.',
    abcp_documents_dialog_close: 'Schliessen',
    abcp_document_detail_proposal_title: 'Agent-Vorschlag',
    abcp_document_detail_proposal_accept: 'Akzeptieren',
    abcp_document_detail_assigned_title: 'Zugeordnet',
    abcp_document_detail_assigned_remove: 'Zuordnung entfernen',
    abcp_document_detail_picker_title: 'Konto zuordnen',
    abcp_document_detail_picker_counter: '{{matched}} von {{total}}',
    abcp_document_detail_picker_search_placeholder: 'Konto-Nr, Bezeichnung oder Kontogruppe…',
    abcp_document_detail_picker_empty: 'Keine Konten gefunden.',
    abcp_document_detail_project_file: 'Projekt-Akte',
    abcp_document_detail_project_file_hint: 'Allgemeine Projektdokumente',
    abcp_document_detail_validity_title: 'Gültigkeit',
    abcp_document_detail_validity_closing: 'Nur dieser Abschluss',
    abcp_document_detail_validity_long_term: 'Langfristig',
    abcp_document_detail_interpretation_title: 'Belegwert',
    abcp_document_interpretation_reason_quote_not_in_document: 'Die zitierte Zeile steht so nicht im Beleg.',
    abcp_document_quote: '„{{quote}}“',
    abcp_document_quote_line: 'Seite {{page}}, Zeile {{line}}',
    abcp_document_detail_interpretation_sentence: '{{amount}} per {{asOfDate}} — aus Zeile {{asOfDate}} abgeleitet',
    abcp_document_detail_interpretation_sentence_neutral: '{{amount}} per {{asOfDate}}',
    abcp_document_detail_interpretation_interpreting: 'Deutung läuft',
    abcp_document_detail_interpretation_no_value: 'Gedeutet, kein Betrag',
    abcp_document_detail_interpretation_none: 'Nicht gedeutet',
    abcp_document_detail_interpretation_disabled: 'Deutung für diese Organisation ausgeschaltet',
    abcp_document_detail_value_balance: 'Saldo',
    abcp_document_detail_value_market_value: 'Marktwert',
    abcp_document_detail_value_cost: 'Einstandswert',
    abcp_document_detail_value_as_of: 'per {{date}}',
    abcp_document_detail_document_date: 'Belegdatum: {{date}}',
    // REV-22010 — the AI pipeline's document feedback: reading state, interpretation reason, proposal refusal, hub banner.
    abcp_document_reading_title: 'KI-Lesung',
    abcp_document_reading_read: 'Von der KI gelesen',
    abcp_document_reading_state_pending: 'Noch nicht von der KI gelesen',
    abcp_document_reading_state_reading: 'Wird von der KI gelesen',
    abcp_document_reading_state_deferred_daily_cap: 'Tageslimit erreicht – wird morgen gelesen',
    abcp_document_reading_state_failed: 'Die KI konnte den Beleg nicht lesen',
    abcp_document_reading_state_not_supported: 'Format wird von der KI nicht gelesen (nur PDF)',
    abcp_document_reading_quality_structure_fail: 'Seitenstruktur nicht vollständig erfasst',
    abcp_document_reading_quality_findings: '{{count}} Auffälligkeit(en) beim Lesen',
    abcp_document_detail_interpretation_limit_reached: 'Deutung pausiert',
    abcp_document_interpretation_reason_not_enabled: 'Die Belegdeutung ist in den KI-Einstellungen nicht eingeschaltet.',
    abcp_document_interpretation_reason_limit_reached: 'Das KI-Token-Limit der Organisation ist erreicht.',
    abcp_document_interpretation_reason_closing_has_no_balance_sheet_date: 'Der Abschluss hat noch keinen Bilanzstichtag.',
    abcp_document_interpretation_reason_reading_unusable: 'Die gelesene Fassung des Belegs ist unvollständig.',
    abcp_document_interpretation_reason_model_answer_unusable: 'Die Antwort der KI hat die Prüfung nicht bestanden.',
    abcp_document_interpretation_reason_kind_not_supported: 'Für diese Belegart gibt es keine Deutungsregel.',
    abcp_document_interpretation_reason_no_booking_owner: 'Der Beleg ist keinem Konto zugeordnet.',
    abcp_document_interpretation_reason_statement_dates_unreadable: 'Die Daten des Auszugs (Anfangs-/Schlusssaldo) sind nicht lesbar.',
    abcp_document_interpretation_reason_statement_ends_before_balance_sheet_date: 'Der Auszug endet vor dem Bilanzstichtag.',
    abcp_document_interpretation_reason_amount_unreadable: 'Betrag oder Währung sind nicht eindeutig lesbar.',
    abcp_document_proposal_refusal_title: 'Kein Kontovorschlag',
    abcp_document_proposal_refusal_no_account_for_kind: 'Im Kontenplan ist dieser Belegart kein Konto zugeordnet.',
    abcp_document_proposal_refusal_accounts_not_classified: 'Die passenden Konten sind noch nicht klassifiziert.',
    abcp_document_proposal_refusal_several_accounts_match: 'Mehrere Konten kommen in Frage – bitte selbst wählen.',
    abcp_documents_ai_disabled_mapping: 'Die KI-Belegzuordnung ist für deine Organisation nicht eingeschaltet. Belege erhalten keinen Kontovorschlag.',
    abcp_documents_ai_disabled_interpretation: 'Die KI-Belegdeutung ist für deine Organisation nicht eingeschaltet. Belege erhalten keinen Belegwert.',
    abcp_documents_ai_disabled_both: 'KI-Belegzuordnung und KI-Belegdeutung sind für deine Organisation nicht eingeschaltet.',
    abcp_documents_ai_disabled_action: 'KI-Einstellungen öffnen',
    abcp_documents_ai_disabled_contact_admin: 'Deine Administratorin oder dein Administrator kann die KI in den Organisationseinstellungen einschalten.',
    abcp_document_preview_unsupported: 'Für dieses Dateiformat gibt es keine Vorschau.',
    abcp_document_preview_unsupported_hint: 'Das Dokument ist unverändert im Abschluss abgelegt.',
    abcp_document_preview_missing: 'Vorschau noch nicht verfügbar.',
    abcp_document_preview_missing_hint: 'Das Dokument wird geprüft und ist danach hier sichtbar.',
    abcp_document_detail_error: 'Dokument konnte nicht geladen werden.',    // REV-21361 — Konto-Detail-Hülle (abcp-account-workspace)
    // REV-21363 — geteilte Vorschau (abcp-document-preview), Konto-Dokumentbereich
    // (abcp-account-documents) und geteiltes Upload-Modal (abcp-upload-modal). Flache Keys wie bei
    // den Schwester-Pure-Views. Der Augen-Tooltip des Konto-Bereichs ist bewusst KEIN eigener Key:
    // er teilt sich abcp_documents_not_relevant_mark mit Hub und Einzelseite — gleiche Handlung,
    // gleicher Satz. ⚠️ Die Modal-Copy sagt PDF, nicht "PDF oder Bild": der Ingest ist PDF-only
    // (ADR-0009 §12), der Prototyp ist an dieser Stelle überholt.
    abcp_document_preview_error: 'Vorschau konnte nicht geladen werden.',
    abcp_account_documents_error: 'Dokumente konnten nicht geladen werden.',
    abcp_account_documents_upload: 'Dokument hochladen',
    abcp_account_documents_dropzone_title: 'Hier Daten hinziehen',
    abcp_account_documents_dropzone_or: 'oder',
    abcp_account_documents_dropzone_pick: 'Dateien auswählen',
    abcp_upload_modal_title: 'Dokumente hochladen',
    abcp_upload_modal_close: 'Schließen',
    abcp_upload_modal_dropzone: 'Dateien hierhin ziehen',
    abcp_upload_modal_hint: 'Nur PDF · max. {{max}}',
    abcp_upload_modal_pick: 'Dateien auswählen',
    abcp_upload_modal_selected: 'Ausgewählte Dateien',
    abcp_upload_modal_remove: 'Aus der Auswahl entfernen',
    abcp_upload_modal_rejected_type: 'Kein PDF — wird nicht hochgeladen.',
    abcp_upload_modal_rejected_size: 'Zu groß (max. {{max}}) — wird nicht hochgeladen.',
    abcp_upload_modal_failures: 'Nicht hochgeladen',
    abcp_upload_modal_progress: 'Dokumente werden hochgeladen…',
    abcp_upload_modal_cancel: 'Abbrechen',
    abcp_upload_modal_submit: 'Dokumente hochladen',
    abcp_workspace_pane_kind_ledger: 'Kontenblatt',
    abcp_workspace_pane_kind_documents: 'Dokumente',
    abcp_workspace_pane_kind_comments: 'Kommentare',
    abcp_workspace_pane_kind_todos: 'Pendenzen',
    abcp_workspace_pane_kind_adjustments: 'Korrekturbuchungen',
    abcp_workspace_pane_kind_activity_log: 'Aktivitätslog',
    abcp_workspace_document_balance: 'Beleg',
    abcp_workspace_ai_as_of: 'per {{date}}',
    abcp_workspace_ai_refused: 'Kein Wert gelesen',
    abcp_workspace_ai_open: 'Noch kein Wert',
    abcp_workspace_ai_reconciling: 'Abgleich läuft …',
    abcp_workspace_ai_reconciling_step: 'Der Abschlusslauf prüft das Konto',
    abcp_workspace_ai_not_used: 'Beleg gelesen, für den Abschluss aber nicht verwendet',
    abcp_workspace_ai_open_missing: 'Beleg fehlt: {{kind}}',
    abcp_workspace_ai_open_date_mismatch: 'Belegdatum passt nicht: {{kind}}',
    abcp_workspace_ai_open_value_pending: 'Wert noch nicht gelesen: {{kind}}',
    // The line under the status chip on the account card.
    abcp_workspace_reason_document_missing: 'Beleg fehlt: {{kind}}',
    abcp_workspace_reason_document_being_read: 'Beleg wird gelesen …',
    abcp_workspace_reason_document_unreadable: 'Wert konnte nicht gelesen werden, bitte von Hand erfassen',
    abcp_workspace_reason_document_date_mismatch: 'Belegdatum passt nicht: {{date}} statt {{balanceSheetDate}} (Beleg {{amount}})',
    abcp_workspace_reason_proofs_contradict: 'Belege widersprechen sich: {{list}}',
    abcp_workspace_reason_transit_not_balanced: 'Geldtransit nicht ausgeglichen: {{amount}}',
    abcp_workspace_reason_reconciled_with_document: 'Abgestimmt mit {{kind}} per {{date}}',
    abcp_workspace_reason_reconciled_with_document_market_value: 'Abgestimmt mit {{kind}} per {{date}} (Marktwert)',
    abcp_workspace_reason_reconciled_with_document_cost: 'Abgestimmt mit {{kind}} per {{date}} (Einstandswert)',
    // REV-22005 — the hand-entered document balance and the account-state write refusals. TOP-level
    // on purpose: the account page translates the backend messageKey with a bare `t(key)`.
    abcp_workspace_document_balance_manual: 'von Hand erfasst',
    abcp_error_review_flag_invalid: 'Bitte einen Grund angeben (höchstens 500 Zeichen).',
    abcp_error_document_balance_invalid: 'Der Belegwert ist ungültig.',
    abcp_error_document_balance_currency_mismatch: 'Der Belegwert muss in der Währung des Jahresabschlusses erfasst werden.',
    abcp_error_closing_currency_missing: 'Für diesen Jahresabschluss ist keine Währung festgelegt. Lege sie zuerst in den Einstellungen fest.',
    abcp_error_account_state_unknown_account: 'Dieses Konto gehört nicht zu diesem Abschluss.',
    abcp_error_account_state_write_failed: 'Die Änderung konnte nicht gespeichert werden. Bitte später erneut versuchen.',
    abcp_workspace_pane_add: 'Bereich hinzufügen',
    abcp_workspace_pane_empty: 'Für diesen Bereich gibt es noch keinen Inhalt.',
    abcp_workspace_review_mark: 'Für Review markieren',
    abcp_workspace_review_marked: 'Für Review markiert',
    abcp_workspace_back: 'Zurück',
    abcp_workspace_amount: 'Betrag',
    abcp_workspace_reference: 'Referenz',
    abcp_workspace_confirm: 'Bestätigen',
    abcp_workspace_cancel: 'Abbrechen',
    abcp_workspace_error: 'Konto-Details konnten nicht geladen werden.',
    abcp_workspace_review_dialog_title: 'Für Review markieren',
    abcp_workspace_review_dialog_account: 'Konto {{number}} · {{name}}',
    abcp_workspace_review_dialog_question: 'Was soll der Reviewer prüfen?',
    abcp_workspace_review_dialog_placeholder:
        'z. B. Beleg fehlt — extern anfordern oder akzeptierbar? Bitte Position gegenzeichnen.',
    abcp_workspace_review_dialog_hint:
        'Der Kommentar erscheint beim Reviewer direkt am Konto. Der Bearbeitungsstatus bleibt unverändert.',
    abcp_workspace_review_dialog_confirm: 'Markieren',
    // REV-21366 — ABCP activity log (pure view)
    abcp_activity_count: 'Aktivität',
    abcp_activity_count_plural: 'Aktivitäten',
    abcp_activity_actor_unknown: 'Unbekannt',
    abcp_activity_load_more: 'Mehr laden',
    abcp_activity_empty: 'Keine Aktivitäten vorhanden.',
    abcp_activity_error: 'Aktivitäten konnten nicht geladen werden.',
    // REV-21360 — ABCP closing workspace header (pure view)
    aumico_abcp_header_erp_refresh: 'ERP aktualisieren',
    aumico_abcp_header_tab_accounts: 'Konten',
    aumico_abcp_header_tab_documents: 'Dokumente',
    aumico_abcp_header_tab_adjustments: 'Korrekturbuchungen',
    aumico_abcp_header_tab_open_items: 'Pendenzen',
    aumico_abcp_header_tab_comments: 'Kommentare',
    aumico_abcp_header_crumb_account: 'Konto {{number}}',
    aumico_abcp_header_search_accounts: 'Alle Konten durchsuchen…',
    aumico_abcp_header_search_documents: 'Alle Dokumente durchsuchen…',
    aumico_abcp_header_search_adjustments: 'Alle Buchungen durchsuchen…',
    aumico_abcp_header_search_open_items: 'Alle Pendenzen durchsuchen…',
    aumico_abcp_header_search_comments: 'Alle Kommentare durchsuchen…',
    aumico_abcp_header_error: 'Abschlussdaten konnten nicht geladen werden.',    // REV-21057 — SharePoint "Ordner hinzufügen" (aumico-integration-sharepoint-folders)
    // REV-21057 — SharePoint "Ordner hinzufügen" (aumico-integration-sharepoint-folders)
    aumico_integration_sharepoint_title: 'Ordner hinzufügen',
    aumico_integration_sharepoint_description:
        'Verbinde dein Microsoft 365-Konto, um Ordner aus SharePoint oder OneDrive für den Abschluss auszuwählen. aumico erhält nur Lesezugriff.',
    aumico_integration_sharepoint_connect: 'Mit Microsoft 365 verbinden',
    aumico_integration_sharepoint_connecting: 'Verbindung wird hergestellt …',
    aumico_integration_sharepoint_connected_banner: 'Verbunden',
    aumico_integration_sharepoint_read_only: 'nur Lesezugriff',
    aumico_integration_sharepoint_include_subfolders: 'inkl. Unterordner',
    aumico_integration_sharepoint_add_folder: 'Ordner hinzufügen',
    aumico_integration_sharepoint_add_folder_hint: 'Füge den Ordner hinzu, in dem die Belege für diesen Abschluss liegen.',
    aumico_integration_sharepoint_remove: 'Entfernen',
    aumico_integration_sharepoint_error: 'Die Verbindung zu Microsoft 365 ist fehlgeschlagen. Bitte versuche es erneut.',
    aumico_integration_sharepoint_no_site: 'Für dieses Microsoft-Konto wurde kein SharePoint gefunden. Prüfe, ob das Konto eine SharePoint-Lizenz hat, oder verbinde ein anderes Konto.',
    aumico_integration_sharepoint_expired: 'Die Verbindung zu Microsoft 365 ist abgelaufen. Bitte melde dich erneut an.',
    aumico_integration_sharepoint_provider_sharepoint_label: 'SharePoint',
    aumico_integration_sharepoint_provider_sharepoint_desc: 'Ordner aus SharePoint / OneDrive',
    aumico_integration_sharepoint_provider_google_drive_label: 'Google Drive',
    aumico_integration_sharepoint_provider_google_drive_desc: 'Ordner aus Google Drive',
    aumico_integration_sharepoint_provider_manual_upload_label: 'Manueller Upload',
    aumico_integration_sharepoint_provider_manual_upload_desc: 'Dateien direkt hochladen',
    // REV-21057 — in-app pre-consent card (aumico-rendered, shown before the Microsoft popup)
    aumico_integration_sharepoint_consent_heading: 'aumico möchte auf Microsoft 365 zugreifen',
    aumico_integration_sharepoint_consent_permissions_label: 'Angeforderte Berechtigung',
    aumico_integration_sharepoint_consent_permission_files_read: 'Dateien lesen',
    aumico_integration_sharepoint_consent_permission_files_read_desc:
        'aumico liest ausschließlich. Es wird nie etwas nach Microsoft 365 zurückgeschrieben, verändert oder gelöscht.',
    aumico_integration_sharepoint_consent_permission_sites_read: 'SharePoint-Seiten und Ordner lesen',
    aumico_integration_sharepoint_consent_footnote:
        'Du meldest dich im nächsten Schritt bei Microsoft an. Sichtbar sind nur Ordner, für die dein Konto ohnehin berechtigt ist.',
    aumico_integration_sharepoint_consent_allow: 'Zugriff erlauben',
    aumico_integration_sharepoint_consent_cancel: 'Abbrechen',
    // REV-21860 — SharePoint as an integration card in Org Settings -> Integrations.
    aumico_integration_sharepoint_displayname: 'SharePoint',
    aumico_integration_sharepoint_card_description: 'Dokumente aus SharePoint und OneDrive für Abschlüsse verwenden.',
    aumico_integration_sharepoint_displayname_help: 'Optional. Ohne Angabe benennt aumico die Verbindung nach dem Microsoft-Tenant.',
    aumico_integration_sharepoint_connect_modal_title: 'SharePoint verbinden',
    aumico_integration_sharepoint_connect_intro: 'Melde dich mit einem Microsoft-Geschäftskonto an, um aumico Lesezugriff auf SharePoint und OneDrive zu geben.',
    aumico_integration_sharepoint_connect_button: 'Mit Microsoft 365 verbinden',
    aumico_integration_sharepoint_awaiting_consent: 'Warten auf die Bestätigung im Microsoft-Fenster …',
    aumico_integration_sharepoint_manage_modal_title: 'SharePoint-Verbindungen',
    aumico_integration_sharepoint_manage_empty: 'Es ist keine SharePoint-Verbindung vorhanden.',
    aumico_integration_sharepoint_manage_add_button: 'Weitere Verbindung hinzufügen',
    aumico_integration_sharepoint_manage_disconnect_button: 'Verbindung trennen',
    aumico_integration_sharepoint_manage_connected_at: 'Verbunden seit',
    aumico_integration_sharepoint_manage_disconnect_confirm_title: 'SharePoint-Verbindung wirklich trennen?',
    aumico_integration_sharepoint_manage_disconnect_confirm_text: 'Die Verbindung wird gelöscht. Abschlüsse, deren Ordner auf diese Verbindung verweisen, können keine Dokumente mehr synchronisieren.',

    /**
     * ⚠️ **de-DE ist die bundesdeutsche Fassung von `de-CH.ts`, nicht eine eigene Übersetzung.**
     * Übernommen 16.09.2026 (Review-Runde 4, Befund R4-1). Geändert wurde ausschließlich die
     * Schreibung: `Schliessen` → `Schließen` und `ausserordentliches` → `außerordentliches`. Jedes
     * andere `ss` im Block steht nach kurzem Vokal (`Abschluss`, `Schlüssel`, `Klassifikation`,
     * `Flüssige`, `erfasst`) und ist in beiden Orthographien gleich — ein pauschales `ss → ß` wäre
     * hier falsch gewesen.
     *
     * ⚠️ Die 30 Positionsnamen unter `accountSurface.position` sind die Bilanz- und
     * Erfolgsrechnungsgliederung nach **OR Art. 959a**. Für Deutsch ist der Wortlaut derselbe wie in
     * der Schweiz; für `fr.ts` und `it.ts` ist er es NICHT und darf nicht übersetzt werden — dort
     * gilt der französische bzw. italienische Gesetzestext.
     */
    /**
     * REV-21960 / REV-21357 — the ABCP keys, NESTED.
     *
     * Nested rather than flat `aumico_abcp_…` because the backend stores DOTTED keys: a trail entry
     * carries `titleKey: 'abcp.trail.previewStatus'` and `trail.rules.ts` enforces that shape for ten
     * years. i18next runs with the default `keySeparator: '.'`, so a nested object is what resolves
     * those keys — a flat key containing dots would never be found.
     *
     * The trail is written by the backend and read here; interpolation params come from
     * `trailEntry.params`, which may only ever hold `string | number`.
     */
    abcp: {
        // Strukturzeilen von Bilanz und Erfolgsrechnung: Gruppenköpfe, Totale, Zwischensummen.
        statementLayout: {
            section: '{{heading}} in {{currency}}',
            incomeStatement: 'Erfolgsrechnung',
            incomeStatementSection: 'Erfolgsrechnung in {{currency}}',
            assets: 'Aktiven',
            assetsTotal: 'Total Aktiven',
            currentAssetsTotal: 'Total Umlaufvermögen',
            nonCurrentAssetsTotal: 'Total Anlagevermögen',
            liabilitiesAndEquity: 'Passiven',
            liabilitiesAndEquityTotal: 'Total Passiven',
            liabilitiesTotal: 'Total Fremdkapital',
            currentLiabilitiesTotal: 'Total kurzfristiges Fremdkapital',
            nonCurrentLiabilitiesTotal: 'Total langfristiges Fremdkapital',
            equityTotal: 'Total Eigenkapital',
            operatingRevenueTotal: 'Total Betriebsertrag',
            materialExpenseTotal: 'Total Material- und Warenaufwand',
            grossProfit: 'Bruttogewinn',
            personnelExpenseTotal: 'Total Personalaufwand',
            otherOperatingExpenseTotal: 'Total übriger betrieblicher Aufwand',
            ebitda: 'Betriebsergebnis vor Abschreibungen, Finanzerfolg und Steuern (EBITDA)',
            ebit: 'Betriebsergebnis vor Finanzerfolg und Steuern (EBIT)',
            financialResultTotal: 'Total Finanzerfolg',
            ancillaryResultTotal: 'Total betrieblicher Nebenerfolg',
            operatingResult: 'Betriebliches Ergebnis',
            nonOperatingResultTotal: 'Total betriebsfremder und außerordentlicher Erfolg',
            resultBeforeTaxes: 'Jahresergebnis vor Steuern',
            result: 'Jahresergebnis',
        },
        accountSurface: {
            position: {
                CURRENT_ASSETS_LIQUID: 'Flüssige Mittel',
                CURRENT_ASSETS_MARKETABLE_SECURITIES: 'Kurzfristig gehaltene Aktiven mit Börsenkurs',
                CURRENT_ASSETS_RECEIVABLES: 'Forderungen aus Lieferungen und Leistungen',
                CURRENT_ASSETS_OTHER_RECEIVABLES: 'Übrige kurzfristige Forderungen',
                CURRENT_ASSETS_INVENTORIES: 'Vorräte und nicht fakturierte Dienstleistungen',
                CURRENT_ASSETS_PREPAID_EXPENSES: 'Aktive Rechnungsabgrenzungen',
                NON_CURRENT_ASSETS_FINANCIAL: 'Finanzanlagen',
                NON_CURRENT_ASSETS_INVESTMENTS: 'Beteiligungen',
                NON_CURRENT_ASSETS_TANGIBLE: 'Sachanlagen',
                NON_CURRENT_ASSETS_INTANGIBLE: 'Immaterielle Werte',
                NON_CURRENT_ASSETS_UNPAID_CAPITAL: 'Nicht einbezahltes Grund-, Gesellschafter- oder Stiftungskapital',
                CURRENT_LIABILITIES_TRADE_PAYABLES: 'Verbindlichkeiten aus Lieferungen und Leistungen',
                CURRENT_LIABILITIES_INTEREST_BEARING: 'Kurzfristige verzinsliche Verbindlichkeiten',
                CURRENT_LIABILITIES_OTHER: 'Übrige kurzfristige Verbindlichkeiten',
                CURRENT_LIABILITIES_ACCRUED: 'Passive Rechnungsabgrenzungen',
                NON_CURRENT_LIABILITIES: 'Langfristige Verbindlichkeiten',
                NON_CURRENT_LIABILITIES_PROVISIONS: 'Rückstellungen',
                EQUITY_SHARE_CAPITAL: 'Aktien-, Grund-, Gesellschafter- oder Stiftungskapital',
                EQUITY_LEGAL_CAPITAL_RESERVE: 'Gesetzliche Kapitalreserve',
                EQUITY_LEGAL_RETAINED_RESERVE: 'Gesetzliche Gewinnreserve',
                EQUITY_VOLUNTARY_RETAINED_RESERVE: 'Freiwillige Gewinnreserven',
                EQUITY_RESULT_FOR_THE_YEAR: 'Jahresgewinn oder Jahresverlust',
                EQUITY_TREASURY_SHARES: 'Eigene Kapitalanteile',
                // The finer income-statement positions (KMU-Kontenrahmen).
                INCOME_STATEMENT_PRODUCTION_REVENUE: 'Produktionserlöse',
                INCOME_STATEMENT_TRADE_REVENUE: 'Handelserlöse',
                INCOME_STATEMENT_SERVICE_REVENUE: 'Dienstleistungserlöse',
                INCOME_STATEMENT_OTHER_REVENUE: 'Übrige Erlöse aus Lieferungen und Leistungen',
                INCOME_STATEMENT_OWN_WORK_CAPITALISED: 'Eigenleistungen und Eigenverbrauch',
                INCOME_STATEMENT_REVENUE_DEDUCTIONS: 'Erlösminderungen',
                INCOME_STATEMENT_INVENTORY_CHANGES: 'Bestandesänderungen unfertige und fertige Erzeugnisse sowie nicht fakturierte Dienstleistungen',
                INCOME_STATEMENT_MATERIAL_EXPENSE: 'Materialaufwand',
                INCOME_STATEMENT_GOODS_EXPENSE: 'Handelswarenaufwand',
                INCOME_STATEMENT_THIRD_PARTY_SERVICES: 'Aufwand für bezogene Dienstleistungen',
                INCOME_STATEMENT_PRODUCTION_ENERGY: 'Energieaufwand zur Leistungserstellung',
                INCOME_STATEMENT_PURCHASE_DEDUCTIONS: 'Aufwandminderungen',
                INCOME_STATEMENT_WAGES: 'Lohnaufwand',
                INCOME_STATEMENT_SOCIAL_SECURITY: 'Sozialversicherungsaufwand',
                INCOME_STATEMENT_OTHER_PERSONNEL: 'Übriger Personalaufwand',
                INCOME_STATEMENT_TEMPORARY_STAFF: 'Arbeitsleistungen Dritter',
                INCOME_STATEMENT_PREMISES: 'Raumaufwand',
                INCOME_STATEMENT_MAINTENANCE: 'Unterhalt, Reparaturen, Ersatz, Leasing mobile Sachanlagen',
                INCOME_STATEMENT_VEHICLES: 'Fahrzeug- und Transportaufwand',
                INCOME_STATEMENT_INSURANCE_FEES: 'Sachversicherungen, Abgaben, Gebühren, Bewilligungen',
                INCOME_STATEMENT_ENERGY_DISPOSAL: 'Energie- und Entsorgungsaufwand',
                INCOME_STATEMENT_ADMINISTRATION: 'Verwaltungsaufwand',
                INCOME_STATEMENT_IT: 'Informatikaufwand',
                INCOME_STATEMENT_ADVERTISING: 'Werbeaufwand',
                INCOME_STATEMENT_OTHER_OPERATING: 'Sonstiger betrieblicher Aufwand',
                INCOME_STATEMENT_DEPRECIATION: 'Abschreibungen und Wertberichtigungen auf Positionen des Anlagevermögens',
                INCOME_STATEMENT_FINANCIAL_EXPENSE: 'Finanzaufwand',
                INCOME_STATEMENT_FINANCIAL_INCOME: 'Finanzertrag',
                INCOME_STATEMENT_ANCILLARY_OPERATIONS: 'Erfolg aus Nebenbetrieben',
                INCOME_STATEMENT_OPERATING_PROPERTY: 'Erfolg aus betrieblicher Liegenschaft',
                INCOME_STATEMENT_NON_OPERATING: 'Betriebsfremder Aufwand und Ertrag',
                INCOME_STATEMENT_EXTRAORDINARY: 'Außerordentlicher, einmaliger oder periodenfremder Aufwand und Ertrag',
                INCOME_STATEMENT_DIRECT_TAXES: 'Direkte Steuern',
                // Old class keys, still sent by a backend without the finer positions.
                INCOME_STATEMENT_OPERATING_REVENUE: 'Betriebsertrag',
                INCOME_STATEMENT_COST_OF_MATERIALS: 'Material- und Warenaufwand',
                INCOME_STATEMENT_PERSONNEL_EXPENSE: 'Personalaufwand',
                INCOME_STATEMENT_OTHER_OPERATING_EXPENSE: 'Übriger Betriebsaufwand',
                INCOME_STATEMENT_ANCILLARY_RESULT: 'Betriebliches Nebenergebnis',
                INCOME_STATEMENT_NON_OPERATING_AND_TAX: 'Betriebsfremdes, außerordentliches Ergebnis und Steuern',
                INCOME_STATEMENT_CLOSING: 'Abschlusskonten',
            },
            navBalanceSheet: 'Bilanzkonten abstimmen',
            navIncomeStatement: 'Erfolgsrechnung plausibilisieren',
            syncCompaniesNotLoaded: 'Die Firmendaten sind noch nicht geladen. Bitte kurz warten und erneut versuchen.',
            syncNoConnection: 'Für diesen Mandanten ist keine aktive ERP-Verbindung hinterlegt.',
            syncNoContext: 'Kein Mandant oder kein Projekt im Kontext — der ERP-Zug kann nicht starten.',
            PROJECT_PERIOD_MISSING: 'Das Projekt hat keine Periode und keinen Bilanzstichtag, aus dem sie folgen könnte.',
            PROJECT_NOT_FOUND: 'Dieses Projekt ist nicht auffindbar.',
            CONNECTION_REQUIRED: 'Für diesen Anbieter fehlen Verbindung und Vendor-Firma.',
            VENDOR_PERIOD_NOT_FOUND: 'Der Anbieter kennt kein Geschäftsjahr zu dieser Periode.',
            erpRightsMissing: 'Das ERP verweigert den Zugriff auf Währungs- oder USt.-Daten. Bitte die Leserechte der aumico-App im ERP prüfen — die ERP-Verbindung selbst bleibt aktiv.',
            abcp_error_mandate_data_unavailable: 'Der Abruf ist fehlgeschlagen. Bitte später erneut versuchen.',
            abcp_error_account_binding_invalid: 'Die Zuordnung wurde abgewiesen.',
            abcp_error_mandate_not_found: 'Dieser Abschluss ist nicht auffindbar.',
            columnPercent: '%',
            columnDeltaAbsolute: 'Δ absolut',
            chip: {
                zeroAccounts: 'Nullkonten',
                all: 'Alle',
                open: 'Offen',
                marked: 'Markiert',
                reconciled: 'Abgestimmt',
                difference: 'Differenz',
            },
            columnCurrentPlain: 'Saldo',
            columnPriorPlain: 'Vorjahr',
            syncRunningTitle: 'Daten werden geladen',
            syncRunningSubtitle: 'Buchungen und Konten werden aus dem ERP geladen.',
            syncRunningHint: 'Das kann bei mehreren Perioden etwas dauern. Bitte das Fenster offen lassen.',
            syncDoneTitle: 'Sync abgeschlossen',
            syncDoneAll: 'Fertig — alle angeforderten Perioden sind geladen.',
            syncDonePartly: 'Fertig, aber eine Vergleichsperiode konnte nicht geladen werden.',
            syncDoneClose: 'Schließen',
            syncDonePeriod: 'Periode',
            syncDoneAccounts: 'Konten im ERP',
            syncDoneJournalOnly: 'Nur im Journal',
            syncDoneStatesCreated: 'Neu angelegt',
            syncDoneVatUnreadable: 'Bei {{count}} Beleg(en) fehlt der USt.-Code: Das ERP gab den Beleg nicht heraus (gelöscht oder für die aumico-App nicht lesbar). Alle übrigen Daten sind geladen.',
            syncDoneComparisons: 'Vergleichsperioden',
            syncTitle: 'ERP-Sync',
            syncIntro: 'Lädt die Buchungen dieses Abschlusses aus dem ERP.',
            syncOwnHeading: 'Laufende Periode',
            syncOwnPeriod: 'Dieses Geschäftsjahr: {{range}}',
            syncHeldHeading: 'Bereits vorhanden',
            syncHeldHint:
                'Diese Perioden sind schon abgelegt und werden nicht erneut geladen — sie können zu einem abgeschlossenen Projekt gehören.',
            syncFetchHeading: 'Vorjahre laden',
            syncTagWillFetch: 'wird aktualisiert',
            syncTagHeld: 'vorhanden',
            syncMaxPeriodsReached:
                'Fünf Perioden sind abgelegt — mehr zeigt die Erfolgsrechnung nicht. Es gibt nichts nachzuladen.',
            syncNothingHeldYet:
                'Beim ersten Sync wird nur die laufende Periode geladen. Vergleichsperioden können danach ergänzt werden.',
            syncNoRowsChosen: 'Keine Vergleichsperiode gewählt.',
            syncFrom: 'Von',
            syncTo: 'Bis',
            syncAddPeriod: 'Periode hinzufügen',
            syncMaxRowsReached: 'Es sind höchstens fünf Geschäftsjahre möglich, dieses eingeschlossen.',
            syncRemovePeriod: 'Entfernen',
            syncIncompleteRow: 'Bitte bei jeder Periode Von und Bis angeben.',
            syncStart: 'Sync starten',
            syncCancel: 'Abbrechen',
            syncOutcome: {
                FILLED: 'geladen',
                ALREADY_PRESENT: 'war schon vorhanden',
                FAILED: 'fehlgeschlagen',
            },
            comparisonYears: 'Weitere Jahre:',
            comparisonPeriodMissing:
                'Für {{periods}} ist noch kein Journal vorhanden. Starte den ERP-Sync, um die Periode nachzuladen.',
            unpositionedNotice:
                'Diese Konten haben noch keine Position und werden nicht angezeigt: {{accounts}}. Ordne sie im Kontenplan zu, um sie anzuzeigen.',
            zeroAccountsLocked: 'Ordne zuerst die {{n}} Nullkonten im Kontenplan zu.',
            toggle: {
                percentOfRevenue: '% vom Betriebsertrag',
                priorYearComparison: 'Vorjahresvergleich',
            },
            unassignedGroup: 'Ohne Position',
            unassignedBanner: '{{count}} Konten sind keiner Position zugeordnet',
            classificationRunning: 'Die KI ordnet die Konten dieses Abschlusses zu — {{open}} von {{total}} noch offen',
            classificationOverdue:
                'Die Zuordnung ist seit über zehn Minuten ausstehend. Bitte den ERP-Sync erneut starten.',
            classificationDone: 'Zuordnung abgeschlossen — alle Konten sind einer Position zugeordnet',
            unassignedBannerAction: 'Jetzt zuordnen',
            assignTitle: 'Konto zuordnen',
            assignPositionLabel: 'Position',
            assignPositionPlaceholder: 'Position wählen',
            assignSkip: 'Überspringen',
            assignSave: 'Speichern',
            assignProgress: 'Konto {{index}} von {{total}}',
            assignDone: 'Alle Konten sind zugeordnet.',
            columnCurrent: 'Saldo {{year}}',
            columnPrior: 'Saldo {{year}}',
            columnDelta: 'Δ%',
        },
        /**
         * REV-21378 — die MENSCHLICHE Hälfte des Aktivitätslogs (`abcp_closing_activity`).
         *
         * Eigener Namensraum neben `trail:` und kein Zusatz dazu: der Trail trägt die Schlüssel, die
         * der LAUF sendet, dieser Block die, die ein Schreibpfad von `aumico-be` sendet. Zwei Quellen,
         * zwei Vokabulare — im Log stehen sie nebeneinander, aber sie gehören verschiedenen Diensten.
         */
        activity: {
            // REV-22005 — review flag and hand-entered document balance (N-2.2, N-3.5).
            reviewFlagged: 'Für Review markiert',
            reviewUnflagged: 'Review-Markierung entfernt',
            documentBalanceEntered: 'Belegwert von Hand erfasst',
            documentBalanceCleared: 'Belegwert entfernt',
            documentBalanceConflict: 'Von Hand erfasster Belegwert beibehalten – der KI-Lauf hat ihn nicht überschrieben',
            evidenceAssigned: '{{count}} Beleg(e) zugeordnet',
            evidenceAssignedDetail: 'Zuordnung durch eine Person vorgenommen',
            evidenceUnassigned: 'Zuordnung aufgehoben',
            classificationChanged: 'Kontozuordnung geändert',
            classificationChangedDetail: 'Neue Gruppe: {{group}}',
            statusChanged: 'Status geändert',
            statusChangedDetail: 'Neuer Status: {{to}}',
            erpSynced: 'ERP-Abgleich hat dieses Konto berührt',
            // REV-21375/REV-21378 — die Korrekturbuchung, auf beiden berührten Konten.
            adjustmentBooked: 'Korrekturbuchung erfasst',
            adjustmentDiscarded: 'Korrekturbuchung verworfen',
            adjustmentTransferred: 'Korrekturbuchung ans ERP übertragen',
            adjustmentEdited: 'Korrekturbuchung geändert',
            orComplianceChecked: 'OR-Compliance geprüft',
        },
        trail: {
            // The lines a per-account run writes.
            runStarted: 'Abstimmung gestartet: {{trigger}}',
            documentRead: '{{kind}} gelesen: {{amount}} per {{date}}',
            documentUnreadable: '{{kind}}: Wert konnte nicht gelesen werden',
            compared: 'Mit der Buchhaltung verglichen: {{outcome}}',
            runFailed: 'Abstimmung fehlgeschlagen, nichts geändert',
            // REV-22005 — a run found hand-entered document balances and kept them (N-3.5).
            manualDocumentBalanceKept: '{{count}} von Hand erfasste(r) Belegwert(e) beibehalten',
            runPlanned: '{{units}} Arbeitseinheiten über {{positions}} Position(en) geplant',
            unitBlocked: 'Schritt blockiert: {{code}}',
            // REV-21960 — the fixture mode says so in the trail itself (E5), not only in the banner.
            fixtureMode: 'ACHTUNG Fixture-Modus ({{mode}}): der Lauf rechnet auf erfundenen Testdaten, nicht auf Mandatsdaten',
            positionStarted: 'Position {{positionId}} gestartet (Regelpaket {{rulePackId}} {{version}})',
            // REV-21869 (#165, A-C4) — derselbe Schlüssel, den der Lauf wirklich sendet
            // (`position.executor.ts:222`); erweitert um den Demo-Skript-Wortlaut (#157 §1 Schritt 6).
            journalAnalysed: 'Kontoblatt analysiert: {{accounts}} Konten gelesen',
            evidenceAssigned: '{{documents}} Belege zugeordnet ({{perAccount}} je Konto)',
            engineDispatched: 'Engine {{entry}} aufgerufen',
            differenceDetected: 'Differenz auf {{accountName}} festgestellt',
            findingIdentified: 'Ursache auf {{accountName}} eingeordnet',
            proposalsGenerated: '{{proposals}} Buchungsvorschlag/-vorschläge für {{accountName}} erstellt',
            // A PREVIEW, never a status: the chip is folded in memory and nothing is written (E6).
            previewStatus: 'Vorschau für {{accountName}}',
            // REV-21869 (#165, #159/S5) — fester Schlüssel und `amount 0` sind dort gepinnt, der
            // Wortlaut gehört diesem Ticket: der Demo-Skript-Satz (#157 §1 Schritt 6).
            reconciled: 'Beleg gegen Saldo abgestimmt: {{accountName}}',
            // REV-21869 (#165, Runde 2 / S2) — #159 R8: `position.executor.ts:183`, ohne Konto.
            baseCurrencyDefaulted: 'Basiswährung als Standard angenommen ({{currency}})',
            // REV-21869 (#165, Runde 2 / S2) — #159 R8: `position.executor.ts:261`, MIT Konto.
            accountStateWriteFailed: 'Kontostatus konnte nicht zurückgeschrieben werden',
            // REV-21869 (#165, Runde 3 / SRR F4) — `position.executor.ts:120,166,197`, ohne Konto.
            runAborted: 'Lauf abgebrochen: {{reason}}',
            // REV-21378 — the three steps the action catalogue names that no executor emits YET
            // (`ACTIVITY_ACTIONS.pendingWritePath`). Translated ahead of the write path on purpose: a
            // key that arrives before its text renders as itself, on screen, and the run that first
            // emits it is not the place to discover that.
            trusteeAsked: 'Rückfrage an die Treuhänderin gestellt',
            orComplianceChecked: 'OR-Compliance geprüft',
            statusChanged: 'Status geändert: {{status}}',
            // REV-21869 (#165, Runde 3 / SRR F4) — `position.executor.ts:144`, ohne Konto.
            positionNotImplemented: 'Für Position {{positionId}} gibt es noch kein Regelpaket',
            /**
             * REV-21869 (#165, Runde 7) — die Marke, die eine ABGELEHNTE Protokollzeile an ihrer
             * Stelle hinterlässt (#159 R12/13, `orchestrator/run-trail.writer.ts:172`).
             *
             * Der Eintrag trägt genau einen Parameter, `codes` — die Namen der verletzten
             * Prüfregeln (z. B. `DETAIL_NOT_A_KEY`). Der Satz setzt ihn BEWUSST nicht ein: das
             * sind Bezeichner aus dem Quelltext und keine Auskunft für eine Treuhänderin. Die
             * Diagnose bleibt für Entwickler im `params`-Feld des Eintrags und im ai-Log; den
             * freien Text der abgelehnten Zeile reicht die ai-Seite gar nicht erst weiter.
             */
            entryRefused: 'Ein Protokolleintrag konnte an dieser Stelle nicht gespeichert werden',
            detail: {
                unbookedBankCharges: 'Nicht gebuchte Bankspesen',
            },
        },
        block: {
            unresolvedAccountGroup: 'Für Position {{positionId}} lässt sich kein Konto auflösen — die ABCP-Kontenfläche existiert noch nicht',
            fixtureRunBlocked: 'Der Fixture-Lauf wurde blockiert ({{code}})',
            noFixturePosition: 'Für Position {{positionId}} gibt es keinen Fixture-Satz',
        },
        catalog: {
            engineReconciliation: 'Abstimmung',
            engineValuation: 'Bewertung',
            toolBalanceAggregation: 'Saldo-Aggregation',
            toolOpenItemMatching: 'OP-Abgleich',
            toolMateriality: 'Wesentlichkeit',
            toolFxBazg: 'Fremdwährungskurse (BAZG)',
            toolAgingBuckets: 'Fälligkeitsklassen',
            toolDerivationBuilder: 'Herleitung',
            toolBookingProposalBuilder: 'Buchungsvorschlag',
            genaiAccountGroupClassifier: 'Kontengruppen-Klassifikation',
            genaiRootCauseAnalysis: 'Ursachenanalyse',
            gateFinal: 'Abschlussprüfung',
        },
    },
    // Outbound Partner-API clients (REV-21638)
    aumico_outbound_api_section_title: 'Outbound API Integration',
    aumico_outbound_api_section_description: 'Erstelle Zugangsdaten, mit denen externe Tools Daten aus aumico abrufen können. Das Secret wird nur einmal angezeigt — bewahre es sicher auf.',
    aumico_outbound_api_create_button: 'Neue Zugangsdaten erstellen',
    aumico_outbound_api_status_revoked: 'Widerrufen',
    aumico_outbound_api_scopes_label_long: 'Berechtigungen (Scopes)',
    aumico_outbound_api_scope_read_organization: 'Organisation und Benutzer lesen',
    aumico_outbound_api_scope_read_companies: 'Firmen lesen',
    aumico_outbound_api_scope_read_financials: 'Bilanzen und Erfolgsrechnungen lesen',
    aumico_outbound_api_scope_write_mappings: 'Mandats-Zuordnungen schreiben',
    aumico_outbound_api_create_modal_title: 'Neue API-Zugangsdaten',
    aumico_outbound_api_name_label: 'Name',
    aumico_outbound_api_name_placeholder: 'z. B. PowerBI Export',
    aumico_outbound_api_create_submit: 'Erstellen',
    aumico_outbound_api_secret_modal_title: 'Deine Zugangsdaten',
    aumico_outbound_api_secret_warning: 'Das Client Secret wird nur jetzt angezeigt und kann später nicht mehr abgerufen werden. Kopiere es und bewahre es sicher auf.',
    aumico_outbound_api_client_id_label: 'Client ID',
    aumico_outbound_api_client_secret_label: 'Client Secret',
    aumico_outbound_api_copy: 'Kopieren',
    aumico_outbound_api_copied: 'Kopiert',
    aumico_outbound_api_done: 'Fertig',
    aumico_outbound_api_created_label: 'Erstellt am',
    aumico_outbound_api_rotated_label: 'Secret zuletzt erneuert',
    aumico_outbound_api_rotate_button: 'Secret erneuern',
    aumico_outbound_api_revoke_button: 'Widerrufen',
    aumico_outbound_api_revoke_confirm_title: 'Zugangsdaten widerrufen?',
    aumico_outbound_api_revoke_confirm_text: 'Der Zugriff wird sofort beendet: alle mit diesen Zugangsdaten ausgestellten Tokens werden ungültig. Das kann nicht rückgängig gemacht werden.',
    aumico_outbound_api_revoke_confirm_button: 'Endgültig widerrufen',
    aumico_outbound_api_error_generic: 'Das hat leider nicht geklappt. Versuche es noch einmal.',
    aumico_partner_connect_section_title: 'Partner-Apps',
    aumico_partner_connect_section_description:
        'Verbinde aumico mit Partner-Apps. Die Verbindung gilt für die ganze Organisation und kann hier jederzeit getrennt werden.',
    aumico_partner_connect_status_connected: 'Verbunden',
    aumico_partner_connect_status_not_connected: 'Nicht verbunden',
    aumico_partner_connect_connect_button: 'Mit {{partner}} verbinden',
    aumico_partner_connect_disconnect_button: 'Trennen',
    aumico_partner_connect_disconnect_confirm_text:
        'Der Zugriff wird sofort beendet: alle Tokens dieser Verbindung werden ungültig. Bestehende Mandats-Zuordnungen bleiben erhalten.',
    aumico_partner_connect_disconnect_confirm_button: 'Endgültig trennen',
    aumico_oauth_authorize_loading: 'Anfrage wird geprüft …',
    aumico_oauth_authorize_redirecting: 'Du wirst weitergeleitet …',
    aumico_oauth_authorize_consent_title: '{{clientName}} verbinden',
    aumico_oauth_authorize_consent_extension_title: '{{clientName}} benötigt zusätzliche Berechtigungen',
    aumico_oauth_authorize_consent_text:
        '{{clientName}} erhält für deine gesamte Organisation Zugriff auf:',
    aumico_oauth_authorize_approve_button: 'Zulassen',
    aumico_oauth_authorize_deny_button: 'Ablehnen',
    aumico_oauth_authorize_not_admin_title: 'Administratorrechte erforderlich',
    aumico_oauth_authorize_not_admin_text:
        'Nur ein Administrator deiner Organisation kann {{clientName}} verbinden. Bitte deinen Administrator, die Verbindung herzustellen.',
    aumico_oauth_authorize_error_title: 'Verbindung nicht möglich',
    aumico_oauth_authorize_error_invalid_request: 'Die Anfrage ist unvollständig oder ungültig. Starte die Verbindung in der Partner-App neu.',
    aumico_oauth_authorize_error_unknown_client: 'Diese App ist aumico nicht bekannt. Die Verbindung wurde nicht hergestellt.',
    aumico_oauth_authorize_error_redirect_uri: 'Die Rücksprungadresse der App ist nicht registriert. Die Verbindung wurde nicht hergestellt.',
    aumico_oauth_authorize_error_invalid_scope: 'Die App verlangt Berechtigungen, die ihr nicht zustehen. Die Verbindung wurde nicht hergestellt.',
    aumico_oauth_authorize_error_generic: 'Das hat leider nicht geklappt. Starte die Verbindung in der Partner-App neu.',
    aumico_oauth_authorize_footnote: 'Du wirst nach der Bestätigung zur Partner-App zurückgeleitet. Die Verbindung kann jederzeit unter Organisationseinstellungen → Integrationen getrennt werden.',
    aumico_partner_connect_card_description: 'Partner-App mit organisationsweitem Zugriff über die aumico Partner API.',
    aumico_partner_connect_card_description_aprivo:
        'Aprivo gleicht Mandate mit aumico ab und bezieht Bilanzen und Erfolgsrechnungen direkt aus deinen Jahresabschlüssen.',
    aumico_partner_connect_modal_status_label: 'Status',
    aumico_partner_connect_modal_text:
        '{{partner}} erhält über die Partner API Zugriff auf deine Organisation — im Umfang der folgenden Berechtigungen. Die Verbindung kann hier jederzeit getrennt werden.',
    aumico_partner_connect_modal_text_aprivo:
        'Aprivo erhält Zugriff auf deine Organisation, um Mandate mit aumico abzugleichen und Bilanzen sowie Erfolgsrechnungen direkt aus deinen Jahresabschlüssen zu beziehen — im Umfang der folgenden Berechtigungen. Die Verbindung kann hier jederzeit getrennt werden.',
    aumico_partner_connect_disconnect_confirm_title: 'Verbindung trennen?',
    aumico_outbound_api_card_description: 'API-Zugangsdaten, mit denen ein externes Tool Daten aus aumico abruft.',
};
